export default {
  "12313": "",
  "123123": "",
  "77777777": "",
  "language.name": "Українська Мова",
  "system.dataScreen": "Дані",
  "product.PleaseEnter": "请输入产品名称",
  "product.PleaseEnterTheProductSerialNumber": "请输入产品序列号",
  "product.PleaseEnterSubmodelNumber": "请输入子型号",
  "product.PleaseenterTheSubmodelSerialNumber": "请输入子型号序列号",
  "product.PleaseSelectTheDeviceType": "请选择设备类型",
  "product.PleaseSelectDevelopmentType": "请选择研发类型",
  "product.management": "Продукт",
  "product.name": "Серія продуктів",
  "product.reset": "Скинути",
  "product.search": "Пошук",
  "product.ApplicationList": "应用列表",
  "product.newProduct": "新建产品",
  "product.editName": "编辑产品",
  "product.DetailSetting": "详情设置",
  "product.delete": "删除",
  "product.serialNumber": "产品序列号",
  "product.deviceType": "Тип пристрою",
  "product.RandDtype": "研发类型",
  "product.subType": "子型号",
  "product.subTypeNumber": "子序列号",
  "product.updateTime": "Час оновлення",
  "product.operation": "操作",
  "product.shippingMarket": "Ринок відвантаження",
  "product.deviceList": "设备清单(出货日志)",
  "product.parameterManagement": "参数管理",
  "product.updataManagement": "升级管理",
  "product.ParentDevice": "父设备",
  "product.AssociatedPowerStationState": "关联电站状态",
  "product.ImportDeviceList": "导入设备清单",
  "product.PlantDetails": "Деталі електростанції",
  "product.OwningPowerStation": "所属电站",
  "product.parameterName": "参数名称",
  "product.ParameterClass": "参数类别",
  "product.ParameterSettingType": "参数设置类型",
  "product.ParameterOperationType": "参数操作类型",
  "product.ImportParameter": "导入参数",
  "product.OwningUpperLevelParameterCategory": "所属上级参数分类",
  "product.WhetherYoSupportBatchRead": "是否支持批量读",
  "product.value": "值",
  "product.scope": "范围",
  "product.unit": "单位",
  "product.explain": "说明",
  "product.remark": "备注",
  "product.fileName": "Назва файлу",
  "product.fileAddress": "Адреса файлу",
  "product.versionNumber": "版本号",
  "product.ProductOfOwnership": "所属产品",
  "product.ProductDetailsSettings": "阳台1.0 - 产品详情设置",
  "product.QueryResultList": "查询结果列表",
  "product.AddFirmware": "添加固件",
  "product.NewParameter": "新增参数",
  "product.datalog": "采集器",
  "product.Inverter": "逆变器",
  "product.storage": "储能",
  "product.battery": "电池",
  "product.socket": "插座",
  "product.DownloadTemplate": "Звантажити шаблон",
  "product.nation": "країна",
  "product.agent": "агент",
  "product.expirationDate": "період гарантії якості",
  "product.UpdateTime": "Час оновлення",
  "product.LastWeek": "Минулого тижня",
  "product.LastMonth": "Минулого місяця",
  "product.LastThreeMonths": "За останні три місяці",
  "product.parameterType": "Тип параметра",
  "product.ProtocolAddress": "Адреса у протоколі параметрів",
  "product.stepSize": "крок",
  "product.PleaseEnterAParameterName": "Будь ласка, введіть назву параметра",
  "product.parameterCoding": "Кодування параметрів",
  "product.PleaseEnterTheParameterCode": "Будь ласка, введіть код параметрів",
  "product.ParameterDataType": "Тип даних параметра",
  "product.PleaseEnterTheAddressInTheParameterProtocol": "Будь ласка, введіть адресу у протокол параметрів",
  "product.blockEncoding": "Кодування групи",
  "product.PleaseEnterABlockCode": "Будь ласка, введіть код групи",
  "product.GroupName": "Назва групи",
  "product.PleaseEnterAGroupName": "Будь ласка, введіть назву групи",
  "product.PleaseEnterTheUnit": "Будь ласка, введіть мінімальне значення",
  "product.decimalPoint": "десяткова точка",
  "product.PleaseEnterTheDecimalPoint": "Будь ласка, введіть десяткову точку",
  "product.leastValue": "мінімальне значення",
  "product.maximumValue": "Максимальне значення",
  "product.PleaseEnterTheMaximumValue": "Будь ласка, введіть максимальне значення",
  "product.PleaseEnterTheStepSize": "Будь ласка, введіть розмір кроку",
  "product.addEquipment": "Додати нове обладнання",
  "product.equipment": "обладнання",
  "product.remove": "вилучити",
  "product.sort": "sort",
  "product.PleaseEnterTheOrder": "Будь ласка, введіть впорядкування",
  "product.PleaseEnterTheParameterSettingType": "Будь ласка, введіть тип параметрів",
  "product.PleaseSelectAFolderPath": "Будь ласка, виберіть шлях до теки",
  "product.ReturnToSuperior": "Повернутися до верхнього",
  "product.PleaseEnterTheVersionNumber": "Будь ласка, введіть номер версії",
  "product.firmwareSpecification": "Опис фірми",
  "product.PleaseEnterFirmwareDescription": "Будь ласка, введіть опис прошивки",
  "product.FileName": "назва файла",
  "product.DeviceType": "Тип пристрою",
  "product.FileAddress": "Адреса файла",
  "product.time": "service time",
  "sidebar.default": "Сторінка навігації",
  "sidebar.home": "Перегляд даних",
  "sidebar.endbenutzer": "Користувач",
  "sidebar.plant": "Керування сценами",
  "sidebar.plant_plant": "Електростанція",
  "sidebar.device": "Обладнання",
  "sidebar.datalog": "Список збірників",
  "sidebar.inverter": "Список інверторів",
  "sidebar.sotrage": "Список зберігання енергії",
  "sidebar.socket": "Список сокетів",
  "sidebar.battery": "Список батареї",
  "sidebar.agent": "Керування агентами",
  "sidebar.systematicSupply": "Журнал відправлення",
  "sidebar.firmware": "Список компаній",
  "sidebar.firmware_up": "Вивантаження",
  "sidebar.firmware_log": "Оновити запис",
  "sidebar.system": "Журнал",
  "sidebar.system_datalog_log": "Журнал збірки",
  "sidebar.system_log": "Журнал операцій",
  "sidebar.system_tongxun": "Журнал комунікації",
  "sidebar.system_app": "Версія програми",
  "sidebar.personal": "Інформація про користувача",
  "sidebar.logout": "Вийти з рахунка",
  "sidebar.organizationalManagement": "Організація",
  "sidebar.auth_manage": "Доступ",
  "sidebar.workorder": "Робоче замовлення",
  "shipment.shippingManagement": "Відправлення",
  "shipment.shippingManagementTemplage": "Шаблон імпорту управління відвантаженнями",
  "login.email": "поштова скринька",
  "login.password": "пароль",
  "login.remember": "Запам’ ятати електронну пошту і пароль",
  "login.rememberAccount": "Запам'ятати акаунт та пароль",
  "login.enteremail": "Будь ласка, введіть вашу адресу електронної пошти",
  "login.enterpassword": "Будь ласка, введіть пароль",
  "login.enterAccount": "Введіть електронну пошту або номер телефону",
  "login.correctAccount": "Введіть правильну електронну пошту або номер телефону",
  "login.accountPlaceholder": "Введіть електронну пошту або номер телефону",
  "login.accountNumber": "номер рахунка",
  "login.system": "Система інтелектуального керування енергією волосся",
  "login.read": "Читати і погодитися",
  "login.userAgreement": "Домова користувача",
  "login.privacyPolicy": "Політика приватності",
  "login.temporarilyDisagree": "Тимчасово не згоден",
  "login.agreeAndAccept": "Погоджуюсь та приймаю",
  "login.retrievePassword": "Отримати пароль",
  "login.verCode": "Код перевірки",
  "login.newPassword": "Новий пароль",
  "login.sendverCode": "Надіслати код перевірки",
  "login.greenLife": "Впроваджуйте інновації в чисту енергію та будуйте зелене життя",
  "login.welcome": "Ласкаво просимо до Haier Energy Cloud",
  "login.downloadApp": "Завантажити застосунок",
  "login.sure": "Підтвердити",
  "home.echarts1.title": "Реєстрований користувач",
  "home.echarts1.subhead": "Сьогодні додано загальну кількість нових/користувачів",
  "home.echarts2.title": "журнал користувача",
  "home.echarts2.subhead": "Сьогодні вход до системи / загальна кількість користувачів",
  "home.echarts3.title": "Додати агент",
  "home.echarts3.subhead": "Сьогодні вход до системи / загальна кількість агентів",
  "home.echarts4.title": "Додати сцену",
  "home.echarts4.subhead": "Нові сцени/загальна кількість доданих сцен",
  "home.echarts4.title_plant": "Додати електростанцію",
  "home.echarts4.subhead_plant": "Нові додані електростанції/загальна кількість електростанцій",
  "home.echarts5.title": "Додати колекціонер",
  "home.echarts5.subhead": "Додати нові збирачі/загальну кількість збирачів",
  "home.echarts6.title": "Додати пристрій",
  "home.echarts6.subhead": "Нові додані пристрої/загальна кількість пристроїв",
  "End_user.input_email": "Будь ласка, введіть адресу електронної пошти користувача",
  "End_user.btn_search": "пошук",
  "End_user.btn_add": "додати до",
  "End_user.btn_delete": "вилучити",
  "End_user.btn_binding": "зв’ язок",
  "End_user.add_station": "Додати сцену",
  "End_user.lable_StationName": "Назва сцени",
  "End_user.lable_StationType": "Тип сцени",
  "End_user.lable_PVCapacity": "Можливість сонячних клітин",
  "End_user.lable_InstalltionDate": "встановити дату",
  "End_user.lable_Country": "країна",
  "End_user.lable_City": "місто",
  "End_user.lable_Address": "адреса",
  "End_user.lable_TimeZone": "часова зона",
  "End_user.lable_Energyprice": "Ціна енергії одиниці",
  "End_user.lable_IncomeUnit": "Одиниця прибутків",
  "End_user.input_StationName": "Будь ласка, введіть назву сцени",
  "End_user.input_StationType": "Будь ласка, виберіть тип",
  "End_user.input_PVCapacity": "Будь ласка, введіть потужність батареї",
  "End_user.input_InstalltionDate": "Будь ласка, виберіть дату встановлення",
  "End_user.input_Country": "Будь ласка, виберіть країну",
  "End_user.input_City": "Будь ласка, виберіть місто",
  "End_user.input_Address": "Будь ласка, введіть адресу",
  "End_user.input_TimeZone": "Будь ласка, виберіть часову зону",
  "End_user.input_Energyprice": "Будь ласка, введіть ціну одиниці",
  "End_user.input_IncomeUnit": "Виберіть одиницю доходу",
  "End_user.max_20": "Максимальна кількість символів не може перевищити 20",
  "End_user.max_5": "Максимальна кількість символів не може перевищити 5",
  "End_user.max_8": "Максимальна кількість символів не може перевищити 8",
  "End_user.format": "Будь ласка, введіть правильний формат",
  "End_user.close": "закрити",
  "End_user.submit": "Передати",
  "End_user.title_delete": "Вилучити?",
  "End_user.no": "ні",
  "End_user.yes": "так",
  "End_user.Bingding_Agent": "Агент зв’ язки",
  "End_user.Agent_Code": "агент:",
  "End_user.please_select": "Будь ласка, виберіть",
  "plant.input_email": "Будь ласка, введіть адресу електронної пошти користувача",
  "plant.search": "пошук",
  "plant.edit": "редагувати",
  "plant.delete": "вилучити",
  "plant.edit_plant": "Редагувати сцену",
  "plant.input_station": "Будь ласка, введіть назву сцени",
  "plant.lable_StationName": "Назва сцени",
  "plant.lable_StationType": "Тип сцени",
  "plant.lable_PVCapacity": "Можливість сонячних клітин",
  "plant.lable_InstalltionDate": "встановити дату",
  "plant.lable_Country": "країна",
  "plant.lable_City": "місто",
  "plant.lable_Address": "адреса",
  "plant.lable_TimeZone": "часова зона",
  "plant.lable_Energyprice": "Ціна енергії одиниці",
  "plant.lable_IncomeUnit": "Одиниця прибутків",
  "plant.input_StationName": "Будь ласка, введіть назву сцени",
  "plant.input_StationType": "Будь ласка, виберіть тип",
  "plant.input_PVCapacity": "Будь ласка, введіть потужність батареї",
  "plant.input_InstalltionDate": "Будь ласка, виберіть дату встановлення",
  "plant.input_Country": "Будь ласка, виберіть країну",
  "plant.input_City": "Будь ласка, виберіть місто",
  "plant.input_Address": "Будь ласка, введіть адресу",
  "plant.input_TimeZone": "Будь ласка, виберіть часову зону",
  "plant.input_Energyprice": "Будь ласка, введіть ціну одиниці",
  "plant.input_IncomeUnit": "Виберіть одиницю доходу",
  "plant.max_20": "Максимальна кількість символів не може перевищити 20",
  "plant.max_5": "Максимальна кількість символів не може перевищити 5",
  "plant.max_8": "Максимальна кількість символів не може перевищити 8",
  "plant.format": "Будь ласка, введіть правильний формат",
  "plant.close": "закрити",
  "plant.submit": "Передати",
  "plant.title_delete": "Вилучити?",
  "plant.no": "ні",
  "plant.yes": "так",
  "plant.powerGeneration": "Выработка электроэнергии",
  "plant.powerConsumption": "Потребление электроэнергии",
  "plant.spontaneousSelfUse": "Самообеспечение",
  "plant.selfSufficient": "Автономность",
  "plant.photovoltaicPowerGeneration": "Мощность фотоэлектрической системы",
  "plant.electricPowerConsumption": "Потребляемая мощность",
  "plant.spontaneousSelfUsePower": "Мощность самообеспечения",
  "plant.buyPowers": "Мощность покупки электроэнергии",
  "plant.sellPowers": "Мощность продажи электроэнергии",
  "plant.selfSufficientPower": "Мощность автономности",
  "plant.batterySOC": "SOC аккумулятора",
  "plant.storageChargingPower": "Мощность зарядки аккумулятора",
  "plant.storageDischargePower": "Мощность разрядки аккумулятора",
  "plant.co2emissionReduction": "Сокращение выбросов CO2",
  "plant.plantPowerGeneration": "Накопичена генерація електроенергії станції",
  "plant.equivalentTreePlanting": "Эквивалентное количество посаженных деревьев",
  "plant.saveStandardCoal": "Экономия стандартного угля",
  "plant.today": "За сегодня",
  "plant.month": "За текущий месяц",
  "plant.year": "Текущий год",
  "plant.total": "Кумулятивная",
  "datalog.email": "Будь ласка, введіть вашу адресу електронної пошти",
  "datalog.datalogSn": "Будь ласка, введіть серійний номер збирача",
  "datalog.search": "пошук",
  "datalog.Version": "Номер версії",
  "datalog.setting": "встановлено",
  "datalog.upgrade": "оновлення",
  "datalog.delete": "вилучити",
  "datalog.title_datalog": "Параметри збірки",
  "datalog.span_info": "інформація",
  "datalog.span_datalog": "Серійний номер збірки:",
  "datalog.span_name": "Імя:",
  "datalog.span_time": "Час оновлення:",
  "datalog.span_firmware": "Версія сигналу/фірмової роботи:",
  "datalog.span_order": "команда",
  "datalog.span_settingdns": "Встановити назву домену",
  "datalog.span_inputsetting": "Будь ласка, введіть назву домену",
  "datalog.span_upgrade": "Оновлення збірки",
  "datalog.span_reset": "Перезапустити колекціонер",
  "datalog.span_setup": "додаткове встановлення",
  "datalog.span_param": "параметр",
  "datalog.span_value": "значення",
  "datalog.btn_setup": "додаткове встановлення",
  "datalog.btn_setting": "встановлено",
  "datalog.btn_settingdns": "Встановити назву домену",
  "datalog.btn_upgrade": "оновлення",
  "datalog.btn_reset": "перезапустити",
  "datalog.btn_read": "читати",
  "datalog.btn_close": "Скасувати",
  "datalog.methods_version": "Виявляє оновлення версії?",
  "datalog.no": "ні",
  "datalog.yes": "так",
  "datalog.methods_delete": "Вилучити?",
  "datalog.methods_rereset": "Перезапустити?",
  "datalog.methodes_inputDns": "Будь ласка, введіть назву домену",
  "datalog.methodes_DNS": "Ви бажаєте встановити цю назву домену",
  "sotrage.select": "Будь ласка, виберіть",
  "sotrage.email": "Будь ласка, введіть вашу адресу електронної пошти",
  "sotrage.datalogSn": "Будь ласка, введіть серійний номер збирача",
  "sotrage.deviceSn": "Будь ласка, введіть серійний номер пристрою",
  "sotrage.search": "пошук",
  "sotrage.sotrage": "Параметри зберігання енергії",
  "device.select": "Будь ласка, виберіть",
  "device.email": "Будь ласка, введіть вашу адресу електронної пошти",
  "device.datalogSn": "Будь ласка, введіть серійний номер збирача",
  "device.deviceSn": "Будь ласка, введіть серійний номер пристрою",
  "device.search": "пошук",
  "device.title": "Параметри інвертора",
  "device.setting": "встановлено",
  "device.setting_inverte": "Встановити параметри інвертера",
  "device.input_start_address": "Запуск адреси реєстру",
  "device.input_ent_address": "Завершити адресу реєстру",
  "device.input_setting_value": "Будь ласка, введіть значення параметра",
  "device.read_data": "Прочитати дані реєстру:",
  "device.input_start_read": "Запуск адреси реєстру",
  "device.input_end_read": "Завершити адресу реєстру",
  "device.btn_address": "Встановити адресу",
  "device.btn_value": "Встановити параметри",
  "device.btn_read": "читати",
  "device.btn_close": "повернути",
  "device.selet_data": "Виберіть дату",
  "device.workMode": "Режим работы",
  "device.alarmInfo": "Информация о тревогах",
  "device.countryStandard": "Государственные стандарты",
  "device.runningStatus": "Stan robi",
  "device.inverterTemp": "Температура инвертора(℃)",
  "device.dcdcTemp": "Температура батареї (℃)",
  "device.mpptTemp": "Температура MPPT(℃)",
  "device.drmStatus": "Статус DRM",
  "device.version": "Версия",
  "device.communicationEquipment": "Оборудование связи",
  "device.basicInfo": "Основная информация",
  "device.productName": "Название продукта",
  "device.productType": "Тип продукта",
  "device.productModel": "Модель продукта",
  "device.softVersion": "Версия программного обеспечения",
  "device.softUpdateTime": "Время обновления программного обеспечения",
  "device.plant": "Электростанция",
  "device.installer": "Установщик",
  "device.installPerson": "Монтажник",
  "device.deviceRegisterDate": "Дата регистрации оборудования",
  "device.ownerEmail": "Електронна пошта власника",
  "device.ownerReceiveTime": "Час отримання власником",
  "device.ownerFamily": "Сім'я власника",
  "device.versionInfo": "Інформація про версію",
  "device.searchSn": "Будь ласка, введіть серійний номер для пошуку",
  "device.user": "Пользователь",
  "device.userReceiveDate": "Дата получения пользователем",
  "device.yuan": "Источник: Фотоэлектрическая система",
  "device.totalPower": "Общая мощность",
  "device.todayPowerGeneration": "Виробництво електроенергії сьогодні",
  "device.dataGateway": "Шлюз данных",
  "device.optimizer": "Оптимизатор",
  "device.chu": "Накопитель: Аккумулятор",
  "device.power": "Мощность",
  "device.todayChargingCapacity": "Зарядка за сегодня",
  "device.todayDischargingCapacity": "Разрядка за сегодня",
  "device.he": "Нагрузка: Потребление электроэнергии",
  "device.todayElectricityConsumption": "Потребление электроэнергии за сегодня",
  "device.totalElectricityConsumption": "Кумулятивное потребление электроэнергии",
  "device.wang": "Сеть: Сторона сети",
  "device.totalFrequency": "Общая частота",
  "device.buyPowers": "Покупка электроэнергии",
  "device.sellPowers": "Продажа электроэнергии",
  "device.more": "Больше",
  "device.readWrite": "Инструмент прямого чтения/записи",
  "device.chargeAndDisChargeSetting": "Настройки зарядки/разрядки",
  "device.mutipleSave": "Массовая отправка",
  "device.mutipleRead": "Групове читання",
  "device.deviceSnisExist": "Пожалуйста, подтвердите наличие SN устройства",
  "device.saveSuccess": "Команду параметрів надіслано. Будь ласка, оновіть сторінку або натисніть кнопку [Читати], щоб підтвердити, чи параметри набрали чинності.",
  "device.saveFail": "Отправка параметров не удалась",
  "device.getParamsSuccess": "Получение параметров успешно",
  "device.getParamsFail": "Получение параметров не удалось",
  "device.operationalDataAnalysis": "Анализ данных о работе",
  "device.pleaseSelect": "Пожалуйста, выберите пункт данных слева",
  "device.maxFour": "Единиц не может быть более 4",
  "device.maxFourOrTwenty": "Дозволено не більше 4 або 20 параметрів",
  "device.protocolDirectives": "Команда протокола",
  "device.dateRangeError": "Диапазон дат должен быть в течение 3 дней",
  "device.noDeviceDetail": "Информация об оборудовании отсутствует",
  "device.address": "Адреса регістру",
  "device.faultClearing": "Скидання несправностей",
  "battery.select": "Будь ласка, виберіть",
  "battery.email": "Будь ласка, введіть вашу адресу електронної пошти",
  "battery.datalogSn": "Будь ласка, введіть серійний номер збирача",
  "battery.deviceSn": "Будь ласка, введіть серійний номер пристрою",
  "battery.search": "пошук",
  "socket.title": "налаштування сокета",
  "socket.setting": "встановлено",
  "socket.span": "Встановлено декілька адрес регістру, а також потрібно встановити декілька значень. Встановити значення, які слід розділити, наприклад (1, 2, 3)",
  "socket.setting_device": "Встановити параметри інвертера:",
  "socket.startaddress": "Запуск адреси реєстру",
  "socket.stopaddress": "Завершити адресу реєстру",
  "socket.value": "Будь ласка, введіть значення параметра",
  "socket.readdata": "Прочитати дані реєстру:",
  "socket.setting_address": "Встановити адресу",
  "socket.setting_value": "Встановити параметри",
  "socket.read": "читати",
  "socket.return": "повернути",
  "agent.close": "Скасувати",
  "agent.submit": "Передати",
  "agent.input_email": "Будь ласка, введіть вашу адресу електронної пошти",
  "agent.search": "пошук",
  "agent.add_agent": "Додати агент",
  "agent.import_device": "Імпортувати пристрої",
  "agent.edit": "редагувати",
  "agent.title": "Додати агент",
  "agent.email": "поштова скринька",
  "agent.password": "пароль",
  "agent.phone": "номер телефону",
  "agent.company": "компанія",
  "agent.language": "мова",
  "agent.address": "адреса",
  "agent.input_password": "Будь ласка, введіть пароль",
  "agent.input_phone": "Будь ласка, введіть ваш номер телефону",
  "agent.input_company": "Будь ласка, виберіть компанію",
  "agent.input_language": "Будь ласка, введіть мову",
  "agent.input_address": "Будь ласка, введіть адресу",
  "agent.relus_email": "Будь ласка, введіть коректну адресу електронної пошти",
  "agent.title_edit": "Редагувати агент",
  "agent.title_device": "вивантажити",
  "agent.span": "Приклад: Виключива форма",
  "agent.btn_upload": "вивантажити",
  "agent.delete": "вилучити",
  "agent.agent_delete": "Вилучити агент?",
  "ship.starttime": "початковий час",
  "ship.endtime": "Час завершення",
  "ship.deviceSn": "Будь ласка, введіть серійний номер пристрою",
  "ship.select": "Будь ласка, виберіть компанію",
  "ship.search": "пошук",
  "Firmware.file_name": "Будь ласка, введіть назву файла",
  "Firmware.search": "пошук",
  "Firmware.add": "додати до",
  "Firmware.delete": "вилучити",
  "Firmware.title": "Вивантаження",
  "Firmware.select_folder": "Виберіть теку:",
  "Firmware.select_folder_type": "Будь ласка, виберіть тип теки",
  "Firmware.craete_folder": "Створити нову теку",
  "Firmware.folder_path": "Шлях до теки:",
  "Firmware.folder_name": "Назва файла:",
  "Firmware.input_folder_name": "Введіть назву файла",
  "Firmware.create": "створити теку",
  "Firmware.listed_files": "Список файлів:",
  "Firmware.import_folder": "Імпортувати файл",
  "Firmware.uplad_folder": "Вивантажити файли",
  "Firmware.close": "повернути",
  "Upgrade.starttime": "початковий час",
  "Upgrade.endtime": "Час завершення",
  "Upgrade.deviceSn": "Будь ласка, введіть серійний номер пристрою",
  "Upgrade.type": "Будь ласка, оберіть тип",
  "Upgrade.search": "пошук",
  "Upgrade.datalog": "колекціонер",
  "Upgrade.Inverter": "інвертер",
  "Upgrade.Control": "контролер",
  "datalogs_logs.starttime": "початковий час",
  "datalogs_logs.endtime": "Час завершення",
  "datalogs_logs.deviceSn": "Будь ласка, введіть серійний номер пристрою",
  "datalogs_logs.Version": "Будь ласка, введіть версію",
  "datalogs_logs.search": "пошук",
  "Logs.starttime": "початковий час",
  "Logs.endtime": "Час завершення",
  "Logs.deviceSn": "Будь ласка, введіть серійний номер пристрою",
  "Logs.type": "Будь ласка, виберіть тип",
  "Logs.search": "пошук",
  "Special.starttime": "початковий час",
  "Special.endtime": "Час завершення",
  "Special.deviceSn": "Будь ласка, введіть серійний номер пристрою",
  "Special.datalogSn": "Будь ласка, введіть серійний номер збирача",
  "Special.type": "Будь ласка, виберіть тип",
  "Special.search": "пошук",
  "Special.save": "збереження",
  "Special.Examples": "Приклад: (2305210230,2305210139)",
  "App.System_Config": "системні налаштування",
  "App.APP_Version": "Випуск версії програми",
  "App.Android_Version": "Версія Android:",
  "App.IOS_Version": "Версія IOS:",
  "App.APP_Type": "Тип програми:",
  "App.New_Version": "Нова версія",
  "App.update_content": "Обновити опис: (поділено на \"/n\")",
  "App.Whether_update": "Чи обов'язково оновлювати",
  "App.no": "ні",
  "App.yes": "так",
  "App.submit": "Передати",
  "Tips.app_submit": "Ви впевнені, що змінити інформацію?",
  "Tips.firmware_delete": "Ви впевнені вилучити?",
  "Tips.firmware_deleteCDN": "Вилучити файли з CDN?",
  "Tips.yes": "так",
  "Tips.no": "ні",
  "global.DataDetails": "Подробиці даних",
  "global.device": "Параметри інвертора",
  "global.device_data": "Встановити параметри інвертера:",
  "global.storage": "Параметри зберігання енергії",
  "global.storage_data": "Встановити параметри зберігання енергії",
  "global.battery": "Параметри батареї",
  "global.battery_data": "Встановити параметри батареї",
  "global.socket": "налаштування сокета",
  "global.socket_data": "Встановити параметри сокету",
  "btn.setting_address": "Встановити адресу",
  "btn.close": "повернути",
  "btn.submit": "Передати",
  "btn.Setting_parameters": "Встановити параметри",
  "btn.Reading": "читати",
  "btn.search": "пошук",
  "btn.add": "додати до",
  "btn.import": "Імпортувати",
  "btn.download": "Приклад звантаження",
  "btn.edit": "редагувати",
  "btn.login": "Підписатися",
  "btn.export": "експортувати",
  "form.addShip": "Додати надсилання",
  "form.editShip": "Редагувати пристрій доставки",
  "form.import": "Імпортувати інформацію про пристрій",
  "form.shipSN": "Серійний номер відправлення",
  "form.agent": "агент",
  "form.networkCall": "Чи виконати зворотні виклики мережі дистрибутиву",
  "form.warrantyPeriod": "Період гарантії",
  "form.shiptime": "Час доставки",
  "form.shiptype": "Тип доставки",
  "form.classify": "класифікація",
  "form.file": "Перетягніть файл сюди або натисніть на вивантаження",
  "form.edit_plant": "Редагувати сцену",
  "form.input_station": "Будь ласка, введіть назву сцени",
  "form.lable_StationName": "Назва сцени",
  "form.lable_StationType": "Тип сцени",
  "form.input_StationName": "Будь ласка, введіть назву сцени",
  "form.edit_plant_plant": "Редагувати електростанцію",
  "form.input_station_plant": "Будь ласка, введіть назву електроенергії",
  "form.lable_StationName_plant": "Назва електроенергії",
  "form.lable_StationType_plant": "Тип електроенергії",
  "form.input_StationName_plant": "Будь ласка, введіть назву електроенергії",
  "placeholder.select": "Будь ласка, виберіть",
  "placeholder.choiceCountry": "Будь ласка, виберіть країну",
  "placeholder.choiceTimezone": "Будь ласка, виберіть часову зону",
  "placeholder.enterEmail": "Будь ласка, введіть вашу адресу електронної пошти",
  "placeholder.enterPhone": "Будь ласка, введіть ваш номер телефону",
  "placeholder.verificationCode": "Будь ласка, введіть код перевірки",
  "placeholder.enterPassword": "Будь ласка, введіть пароль з 6- 20 цифр",
  "placeholder.confirmPassword": "Будь ласка, підтверджуйте пароль",
  "placeholder.readAndAgree": "Я читав і погодився",
  "placeholder.search": "пошук",
  "placeholder.searchPlantName": "Пошук назви електростанції",
  "placeholder.searchDeviceName": "Пошук назви пристрою",
  "placeholder.searchDataloggerName": "Пошук назви збірника",
  "placeholder.enterPlantName": "Будь ласка, введіть назву електроенергії",
  "placeholder.enterPlantType": "Будь ласка, введіть тип електроенергії",
  "placeholder.enterPVCapacity": "Будь ласка, введіть потужність PV",
  "placeholder.choiceInstallationDate": "Будь ласка, виберіть дату встановлення",
  "placeholder.enterPlantAddress": "Будь ласка, введіть адресу електроенергії",
  "placeholder.enterOldPassword": "Будь ласка, введіть старий пароль",
  "placeholder.enterNewPassword": "Будь ласка, введіть новий пароль",
  "placeholder.enterConfirmPassword": "Будь ласка, підтверджуйте новий пароль",
  "placeholder.enter": "Будь ласка, введіть {scope}",
  "placeholder.country": "країна",
  "placeholder.city": "місто",
  "placeholder.scanCodeAddPlant": "Будь ласка, скануйте код, щоб додати електростанцію!",
  "placeholder.currentNoPlant": "У даний момент немає електростанцій, будь ласка, натисніть, щоб додати!",
  "placeholder.selectRepeatTime": "Будь ласка, виберіть час повторення",
  "placeholder.enterDatalogger": "Будь ласка, введіть серійний номер збирача",
  "placeholder.enterDeviceSN": "Будь ласка, введіть серійний номер пристрою",
  "setting.general.needGreat": "Потрібно бути більшим, ніж",
  "setting.general.needSmall": "Потрібно бути менше, ніж",
  "setting.general.gapScope": "Інтервал між вхідними параметрами",
  "setting.general.valScope": "Діапазон вхідних параметрів є",
  "setting.socket.switchStatus": "Контактор сокета",
  "setting.socket.repetition": "Час повторення",
  "setting.socket.enableOrNot": "Чи увімкнено",
  "setting.socket.monday": "понеділок",
  "setting.socket.tuesday": "Второк",
  "setting.socket.wednesday": "Середа",
  "setting.socket.thursday": "Четвер",
  "setting.socket.friday": "Пятниця",
  "setting.socket.saturday": "Субота",
  "setting.socket.sunday": "Недела",
  "setting.type3.dischargeScheduleMode": "Часовий режим виводу",
  "setting.type3.timeDischarge": "Часовий вивод",
  "setting.type3.workingDay": "день тижня",
  "setting.type3.weekend": "вихідний",
  "setting.type3.pureLightControlMode": "Режим керування чистим світлом",
  "setting.type3.stopDischarge": "Значення параметра виводу низького кінця SOC",
  "setting.type3.chargeTransferDischarge": "Повне завантаження SOC для виводу встановленого значення",
  "setting.type3.batterySOCSetting": "Параметри SOC батарії",
  "setting.type3.lowBatteryAlam": "Значення встановлення низького кінця нагадування для SOC батареї",
  "setting.type3.lowBatteryShutdown": "Встановлення значення низької кінцевої зупинки виводу для SOC батареї",
  "setting.type3.systemSetting": "Системні параметри",
  "setting.type3.systemWorkMode": "Системний робочий режим",
  "setting.type3.restoreFactory": "Відновити параметри заводу",
  "setting.type3.loadMode": "Режим завантаження",
  "setting.type3.timingDischarge": "Часовий режим виводу",
  "setting.type3.DCOutputNormallyClosed": "Вивід DC зазвичай закритий режим",
  "setting.type3.DCOutputNormallyOpen": "Вивід DC зазвичай відкритий режим",
  "setting.type3.ForcedPowerProtection": "Примусовий режим захисту енергії",
  "setting.type3.mode": "шаблон",
  "setting.type3.startTime": "початковий час",
  "setting.type3.stopTime": "Час завершення",
  "setting.type3.onlyAddThree": "Додати до 21 таймерів",
  "setting.type3.startCompareEnd": "Час початку таймера може бути лише меншим за кінцевий час",
  "setting.type3.confirmClose": "Ви впевнені, що хочете вимкнути?",
  "setting.type6.countryCode": "Код країни",
  "setting.type6.poweradjppm": "Швидкість регуляції енергії інвертора",
  "setting.type6.enaINVTR": "Віддалена енергія увімкнена/вимкнена",
  "setting.type6.enaSysProtIF_selfCheck": "Самотест інтерфейсу системи захисту",
  "setting.type6.enaRestoretodefault": "Відновити типові значення",
  "setting.type6.UV_resopnseTime": "Час відповіді піднапруги рівня {num}",
  "setting.type6.UF_resopnseTime": "Час відповіді на низьку частоту рівня {num}",
  "setting.type6.OV_resopnseTime": "Час відповіді наднапруги рівня {num}",
  "setting.type6.OF_resopnseTime": "Час відповіді перегодування рівня {num}",
  "setting.type6.open": "відкрити",
  "setting.type6.recover": "відновлення",
  "setting.type6.noHave": "нічого",
  "setting.type6.activePowerSwitch": "Активний вимикач енергії",
  "setting.type6.activePowerPermillage": "Процент активної сили на тисяч",
  "setting.type7.paramterSetting": "Параметри параметрів",
  "setting.type7.batteryVoltage": "Навага батареї",
  "setting.type7.batteryCapacity": "Можливість батареї",
  "setting.type7.PVChargingCurrent": "Фотопольтичний струм завантаження",
  "setting.type7.overVoltage": "Занаднапруга",
  "setting.type7.chargingLimitVoltage": "Обмежена напруга завантаження",
  "setting.type7.increaseChargeReturnVoltage": "Збільшити напругу повернення завантаження",
  "setting.type7.overDischargeVoltage": "Занадвищення напруги",
  "setting.type7.stopchangeCurrent": "Припинити завантаження поточного",
  "setting.type7.inverter485Address": "Адреса 485",
  "setting.type7.passwordValue": "Пароль користувача",
  "setting.type7.inputPassword": "Вхід пароля",
  "setting.type7.recordFaultCodes": "Записати коди помилок",
  "setting.type7.isOpen": "Контроль увімкнення/вимкнення",
  "setting.type7.equalizingChargeCmd": "Негайно завантажити і збалансувати",
  "setting.type7.reset": "Відновити керування",
  "setting.type7.factory": "Відновити параметри заводу",
  "setting.type7.clearAlarm": "Очистити поточний нагадування@ info: whatsthis",
  "setting.type7.clearHistory": "Очистити історію",
  "setting.type7.generatorSwitchCmd": "Перемикання генератора",
  "setting.type7.nowTimeStr": "поточний час",
  "setting.type7.setVal.reset": "reset",
  "setting.type7.setVal.recover": "відновлення",
  "setting.type7.setVal.clearAlarm": "вилучити попередження",
  "setting.type7.setVal.clearHistory": "Очистити історію",
  "setting.type7.setVal.toggle": "перемикати",
  "setting.type8.systemSwitch": "Системний перемикач",
  "setting.type10.modeSelect": "шаблон",
  "setting.type10.standbyMode": "Режим резервної копії",
  "setting.type10.PureOffGrid": "Вимкнути режим запуску мережі",
  "setting.type10.energyNet": "Параметри виводу з’ єднаного з мережею",
  "setting.type10.inverter0": "Інвертор для додавання енергії до локального завантаження",
  "setting.type10.inverter1": "Інвертор для створення електрики для електричної мережі",
  "setting.type10.inverter2": "Інвертувати до локального завантаження за допомогою CT",
  "setting.type10.inverter3": "Інвертувати до локального завантаження або розумного сокета та розумного метра",
  "setting.type10.chargePriority": "Пріоритет завантаження",
  "setting.type10.PVPriority": "Пріоритет фотовольтики",
  "setting.type10.utilityPriority": "Пріоритет електроенергії",
  "setting.type10.hybridModel": "Змішане завантаження",
  "setting.type10.PVOnly": "Лише фотовольтичне завантаження",
  "setting.type10.batteryLowAlarm": "Низька точка попередження батареї",
  "setting.type10.batteryLowShutdown": "Низька точка вимкнення батареї",
  "setting.type10.batteryFull": "Повно завантажена точка вимкнення батареї",
  "setting.type10.ACCharging": "Час завантаження",
  "setting.type10.startTime": "Час початку",
  "setting.type10.endTime": "Час завершення",
  "setting.type10.forcedDischarge": "Час вивантаження",
  "setting.type10.phaseGridSide": "Біг сітки",
  "setting.type10.power": "Фаза активної сили",
  "setting.type10.current": "Фаза поточної",
  "setting.type10.gridConnectionStandard": "Стандартна сітка",
  "setting.type10.baudRate": "485 баудів",
  "setting.type10.disable": "Не увімкнути",
  "setting.type10.enable": "Увімкнути",
  "setting.type10.ApprovalStandards": "Стандарди сертифікації",
  "setting.type10.antiRefluxPower": "Сила проти зворотнього потоку",
  "setting.type10.antiRefluxSet": "Увімкнути проти зворотнього потоку",
  "setting.type10.batFullSocSet": "Значення оцінки насиченості батареї (%)",
  "setting.type10.auxSourceSet": "Додатковий вимикач джерела",
  "setting.type10.timeSharingGridConnectedDischarge": "Випуск з’ єднаної мережі часу ділення",
  "setting.type10.timeSharingGridConnection": "Встановлення спільного часу з’ єднання з мережею",
  "setting.type10.outputPower": "вихідна сила",
  "setting.type10.onlyAddThree": "Додати до {номер} таймерів",
  "setting.type10.productModelNumber": "Модель продукту",
  "setting.type10.PleaseTurnOnThe_PCS_switchFirst": "Будь ласка, вмикайте спочатку вимикач",
  "setting.type10.ThereIs_a_conflictInTheChargingAndDischargingTime": "Існує конфлікт у часі завантаження і звантаження",
  "setting.type10.ChargeDischargeTimeSetting": "Встановлення часу завантаження і звантаження",
  "setting.type11.switchPCS": "Контроль увімкнення/вимкнення",
  "setting.type11.functionSwitch": "Перемикач функцій",
  "setting.type11.maxChargeVol": "Максимальна напруга завантаження (V)",
  "setting.type11.onGridMinDischargeVol": "Мінімальний напруг випуску для з’ єднання з мережею (V)",
  "setting.type11.offGridOutputVol": "Навага виходу з мережі (V)",
  "setting.type11.maxChargeCur": "Максимальна потужність завантаження",
  "setting.type11.onGridMaxDischargeCur": "Максимальний струм виводу для з’ єднання з мережею (A)",
  "setting.type11.offGridMaxDisChargeCur": "Максимальний струм вилучення з сітки (A)",
  "setting.type11.minSocBMS": "Мінімальний SOC BMS (%)",
  "setting.type11.minSocDischarge": "Мінімальний SOC (%) для розумного випуску",
  "setting.type11.maxSocDischarge": "Максимальний SOC для розумного випуску (%)",
  "setting.type11.timeStr": "Час опреми",
  "setting.type11.timerSetting": "Встановлення таймера {номер}",
  "setting.type11.chargeStartTime1": "Час завантаження 1",
  "setting.type11.chargeLongTime1": "Тривалість завантаження 1",
  "setting.type11.chargeTimeMaxSOC1": "Максимальний SOC (%) під час періоду завантаження 1",
  "setting.type11.chargeTimeCurrent1": "Період завантаження 1 Завантаження поточного (A)",
  "setting.type11.dischargeStartTime1": "Час виводу 1",
  "setting.type11.dischargeLongTime1": "Тривалість звільнення 1",
  "setting.type11.dischargeTimeMaxSOC1": "Мінімальний SOC (%) під час періоду випуску 1",
  "setting.type11.dischargeTimeCurrent1": "Період звантаження 1 Період звантаження Поточний (A)",
  "setting.type11.chargeStartTime2": "Час завантаження 2",
  "setting.type11.chargeLongTime2": "Тривалість завантаження 2",
  "setting.type11.chargeTimeMaxSOC2": "Максимальний SOC під час періоду завантаження 2 (%)",
  "setting.type11.chargeTimeCurrent2": "Період завантаження 2 Завантаження поточного (A)",
  "setting.type11.dischargeStartTime2": "Час виводу 2",
  "setting.type11.dischargeLongTime2": "Тривалість вивантаження 2",
  "setting.type11.dischargeTimeMaxSOC2": "Мінімальний SOC (%) під час періоду випуску 2",
  "setting.type11.dischargeTimeCurrent2": "Період звантаження 2 Період звантаження поточний (A)",
  "setting.type11.chargeStartTime3": "Час завантаження 3",
  "setting.type11.chargeLongTime3": "Тривалість завантаження 3",
  "setting.type11.chargeTimeMaxSOC3": "Максимальний SOC під час періоду зарядження 3 (%)",
  "setting.type11.chargeTimeCurrent3": "Період завантаження 3 Завантаження поточного (A)",
  "setting.type11.dischargeStartTime3": "Час виводу 3",
  "setting.type11.dischargeLongTime3": "Тривалість вивантаження 3",
  "setting.type11.dischargeTimeMaxSOC3": "Мінімальний SOC (%) під час періоду випуску 3",
  "setting.type11.dischargeTimeCurrent3": "Період вивантаження 3 поточний вивантаження (A)",
  "setting.type11.chargeStartTime4": "Час завантаження 4",
  "setting.type11.chargeLongTime4": "Тривалість завантаження 4",
  "setting.type11.chargeTimeMaxSOC4": "Максимальний SOC під час періоду зарядження 4 (%)",
  "setting.type11.chargeTimeCurrent4": "Період завантаження 4 Завантаження поточного (A)",
  "setting.type11.dischargeStartTime4": "Час виводу 4",
  "setting.type11.dischargeLongTime4": "Тривалість звільнення 4",
  "setting.type11.dischargeTimeMaxSOC4": "Мінімальний SOC (%) під час періоду випуску 4",
  "setting.type11.dischargeTimeCurrent4": "Період звантаження 4 Період звантаження поточний (A)",
  "setting.type11.functionSwitchObj.val1": "Розумний режим",
  "setting.type11.functionSwitchObj.val2": "Режим таймера",
  "setting.type11.functionSwitchObj.val3": "Спонтанний режим самостійного використання",
  "setting.type12.LEDSwitch": "Замикач LED",
  "setting.type12.LEDSpeed": "Швидкість LED",
  "setting.type12.LEDEffect": "Ефект LED",
  "setting.type12.LEDBrightness": "Яскравість LED",
  "setting.type12.dataColor": "Відтворення кольорів даних",
  "setting.type12.LED1Color": "Колір LED1",
  "setting.type12.LED2Color": "Колір LED2",
  "setting.type12.LED3Color": "Колір LED3",
  "setting.type12.buzzerAlarm": "Нагадування",
  "setting.type12.overLoadToBypass": "Перезавантаження для обійпроходу",
  "setting.type12.lcdRestartPage": "LCD без головного інтерфейсу відновлення операції",
  "setting.type12.overloadReset": "Перезавантажити перезапуск",
  "setting.type12.overloadTemperature": "Під час перезапуску температури",
  "setting.type12.backLightOn": "LCD без фонового світла операції",
  "setting.type12.inputSourceChangeAlarm": "Нагадування про зміну джерела вводу",
  "setting.type12.faultCodeRecord": "Запис помилок програмного забезпечення комунікації",
  "setting.type12.solarFeedToGird": "З’ єднання з неактивною мережею сонячної енергії",
  "setting.type12.switchOptions": "Параметри перемикання",
  "setting.type12.batteryParam": "Параметри батареї",
  "setting.type12.outputParam": "Параметри виводу",
  "setting.type12.ratedOutputVol": "Обчислена напруга виводу",
  "setting.type12.ratedOutputFreq": "Частота виводу",
  "setting.type12.inputVolRange": "Діапазон напруги вводу",
  "setting.type12.outPutSourcePriority": "Пріоритет джерела виводу",
  "setting.type12.batType": "Тип батареї",
  "setting.type12.batUnderVol": "Пенсія вилучення батареї",
  "setting.type12.batBulkVol": "Константне напруги завантаження батареї",
  "setting.type12.batFloatVol": "Пенсія завантаження плаваючої батареї",
  "setting.type12.maxChargingCur": "Максимальний поточний заряд",
  "setting.type12.maxAcChargingCur": "Максимальний поточний заряд AC",
  "setting.type12.chargeSourcePriority": "Пріоритет джерела завантаження",
  "setting.type12.batReChargeVol": "Відновити напругу завантаження",
  "setting.type12.batFullRestoreDischargeVol": "Відновити напругу випуску",
  "setting.type12.solarSupplyPriority": "Пріоритет надано сонячному застосуванню енергії",
  "setting.type12.resetPvStorage": "Відновити дані статистики PV",
  "setting.type12.countryRegulations": "Національні правила",
  "setting.type12.acChargeStartTime": "Час запуску операції завантаження комунікації",
  "setting.type12.acChargeEndTime": "Час зупинки операції завантаження комунікації",
  "setting.type12.acSupplyStartTime": "Час запуску пропозиції електроенергії AC",
  "setting.type12.acSupplyEndTime": "Час зупинки пропозиції електроенергії AC",
  "setting.type12.restoreFactorySet": "Відновити параметри заводу",
  "setting.type12.parallelMode": "Паралельний режим",
  "setting.type12.bulkChargeVol": "Навага завантаження CV",
  "setting.type12.batEquSet": "Функція рівняння батареї",
  "setting.type12.batEquTime": "Середній час завантаження батареї (хв.)",
  "setting.type12.batEquDay": "Середній інтервал завантаження батареї (d)",
  "setting.type12.batEquChargeVol": "Середня напруга завантаження батареї (V)",
  "setting.type12.batEquTimeout": "Часовий час рівняння батареї (хв.)",
  "setting.type12.equInfoSet": "Встановлення балансованої інформації",
  "setting.type12.val.slow": "повільно",
  "setting.type12.val.medium": "в",
  "setting.type12.val.fast": "швидкий",
  "setting.type12.val.low": "низький",
  "setting.type12.val.high": "високий",
  "setting.type12.val.powerCycle": "Цикл енергії",
  "setting.type12.val.powerRotation": "Обертання енергії",
  "setting.type12.val.additionalPower": "Додаткова сила",
  "setting.type12.val.powerUnchanged": "Сила залишається незмінною",
  "setting.type12.val.solarPowerInput": "Сонцева вхідна сила",
  "setting.type12.val.batteryCapacity": "Відсотки потужності батареї",
  "setting.type12.val.percentageLoad": "Процент завантаження",
  "setting.type12.val.energySource": "Вихід енергії",
  "setting.type12.val.batteryStatus": "Стан завантаження і звантаження батареї",
  "setting.type12.val.blue": "синій",
  "setting.type12.val.cyan": "Синій колір",
  "setting.type12.val.green": "зелений",
  "setting.type12.val.pink": "Рожевий",
  "setting.type12.val.purple": "Виолетовий;",
  "setting.type12.val.orange": "оранжевий",
  "setting.type12.val.yellow": "жовтий",
  "setting.type12.val.white": "білий",
  "setting.type12.val.inputOvlRange1": "Режим APL (90- 280V)",
  "setting.type12.val.inputOvlRange2": "Режим UPS (170- 280V)",
  "setting.type12.val.outputSource1": "Сонячна енергія ->Публіка ->Батерія",
  "setting.type12.val.outputSource2": "Сонячна енергія ->Батерія ->Публічне використання",
  "setting.type12.val.chargeSourcePriority1": "Пріоритет фотовольтики",
  "setting.type12.val.chargeSourcePriority2": "Фотопольтична та мережева енергія",
  "setting.type12.val.chargeSourcePriority3": "Только фотовольтичный",
  "setting.type12.val.solarSupplyPriority1": "Інструмент завантаження батареї",
  "setting.type12.val.solarSupplyPriority2": "Завантажити — батарея — Інструмент",
  "setting.type12.val.countryRegulations1": "Індія",
  "setting.type12.val.countryRegulations2": "НімеччинаName",
  "setting.type12.val.countryRegulations3": "Південна Америка",
  "setting.type12.val.parallelMode1": "Без паралельної машини",
  "setting.type12.val.parallelMode2": "Паралельна операція однієї фази",
  "setting.type12.val.outPutSourcePriority1": "Пріоритет електроенергії",
  "setting.type12.val.outPutSourcePriority2": "Пріоритет для сонячної енергії",
  "setting.type12.val.outPutSourcePriority3": "Сонячна енергія ->батарея ->мережева енергія",
  "setting.ops15.invSwitch": "Перемикач інвертування",
  "setting.ops15.workMode": "Робочий режим",
  "setting.ops15.workMode1": "Пріоритет мережі подач",
  "setting.ops15.workMode2": "Режим вимкнення мережі",
  "setting.ops15.workMode3": "Спонтанне власне використання",
  "setting.ops15.invTime": "Час інвертування",
  "setting.ops15.batType": "Тип батареї",
  "setting.ops15.batType1": "Без батареї",
  "setting.ops15.batType2": "Універсальна батарея літія",
  "setting.ops15.batType3": "Батерія лінової кислоти",
  "setting.ops15.batType4": "батарея літія",
  "setting.ops15.timingTime": "Час",
  "setting.ops15.offGirdSoc": "Під час випуску SOC (%)",
  "setting.ops15.optimizeRevenue": "Оптимізувати дохід",
  "setting.type19.totalActivePower": "Активна сила",
  "setting.type19.offgridSettings": "Встановлення вимкненої мережі",
  "setting.type19.gridConnectedControlMode": "Керування з’ єднаними з мережею",
  "setting.type19.offGridControlMode": "Керування вимкненим з мережі",
  "setting.type19.offgrid.gridNet": "З’ єднання з мережею",
  "setting.type19.offgrid.offNet": "Вимкнути мережу",
  "setting.type22.parameterScope": "Діапазон параметрів",
  "setting.type22.ACStartVoltage": "Встановлення напруги/частоти запуску",
  "setting.type22.highVoltage": "Висока напруга запуску AC",
  "setting.type22.lowVoltage": "Запуск AC низького напругу",
  "setting.type22.pvStartLowVol": "PV запуск низького напругу",
  "setting.type22.acUnderVol1": "Првий порядок піднапруги AC (V)",
  "setting.type22.acOverVol1": "Перший порядок перенапруги AC (V)",
  "setting.type22.acUnderVolTime1": "Поднапруга AC першого порядку (с)",
  "setting.type22.acOverVolTime1": "Перенапруга AC першого порядку (с)",
  "setting.type22.acUnderVol2": "Другий порядок піднапруги AC (V)",
  "setting.type22.acOverVol2": "Вторий порядок перенапруги AC (V)",
  "setting.type22.acUnderVolTime2": "Вторий порядок піднапруги AC (с)",
  "setting.type22.acOverVolTime2": "Перенапруга ВК у другому порядку (с)",
  "setting.type22.startDelayTime": "Час запуску затримки",
  "setting.type22.restartDelayTime": "Перезапустити час затримки",
  "setting.type22.ACStartFrequency": "Встановлення наднапруги/піднапруги/частоти",
  "setting.type22.highFrequency": "Висока частота запуску AC",
  "setting.type22.lowFrequency": "Запуск AC низька частота",
  "setting.type22.acUnderFrequency1": "Првий порядок недочастоти AC (Hz)",
  "setting.type22.acOverFrequency1": "Перший порядок перечастоти AC (Hz)",
  "setting.type22.acUnderFrequencyTime1": "Нечастота першого порядку AC (с)",
  "setting.type22.acOverFrequencyTime1": "Звичайна частота першого порядку (с)",
  "setting.type22.acUnderFrequency2": "Другий порядок недочастоти AC (Hz)",
  "setting.type22.acOverFrequency2": "Другий порядок перечастоти AC (Hz)",
  "setting.type22.acUnderFrequencyTime2": "Час секундного порядку (с)",
  "setting.type22.acOverFrequencyTime2": "Звичайна частота второго порядку (с)",
  "setting.type22.systemSetting": "Параметри інформації про пристрій",
  "setting.type22.SNset": "Встановлення серійних номерів",
  "setting.type22.reactiveControlMode": "Режим реактивного керування енергією",
  "setting.type22.inputMode": "Режим вводу",
  "setting.type22.startSolpe": "Початковий нахил",
  "setting.type22.restartSolpe": "Перезапустити нахил",
  "setting.type22.reactivePercentage": "Процент реактивної сили",
  "setting.type22.activePercentage": "Процент заслуг",
  "setting.type22.shutdown": "Віддалений перемикач",
  "setting.type22.functionSelect": "Вибір функцій",
  "setting.type22.manufacturer": "виробник",
  "setting.type22.setFunctionSelect.val1": "заборонити",
  "setting.type22.setFunctionSelect.val2": "Увімкнути виміри проти зворотнього потоку",
  "setting.type22.setManufacturer.val1": "Інгвейтенгvietnam. kgm",
  "setting.type22.setManufacturer.val2": "Skyworth",
  "setting.type22.reactiveControlModeChoice.val1": "Керування електрофакторами",
  "setting.type22.reactiveControlModeChoice.val2": "Керування відсотками реактивної сили",
  "setting.type22.reactiveControlModeChoice.val3": "Керування кривою QV",
  "setting.type22.inputModeChoice.val1": "Незалежний режим вводу",
  "setting.type22.inputModeChoice.val2": "Вхідний паралельний режим",
  "setting.type22.inputModeChoice.val3": "Режим джерела DC",
  "title.login": "Підписатися",
  "title.vistorLogin": "Вход до туристики",
  "title.createAccount": "Створити рахунок",
  "title.retrievePassword": "Отримати пароль",
  "title.userAgreement": "Домова користувача",
  "title.privacyPolicy": "Договор про приватність",
  "title.phone": "Телефон",
  "title.addPlant": "Додати електростанцію",
  "title.editPlant": "Редагувати електростанцію",
  "title.accountInfo": "Інформація про рахунок",
  "title.changePassword": "Змінити пароль",
  "title.message": "Повідомлення",
  "title.systemMessage": "Системне повідомлення",
  "title.faultMessage": "Помилкове повідомлення",
  "title.deviceMessage": "Повідомлення пристрою",
  "title.aboutUs": "про",
  "title.device": "обладнання",
  "title.datalogger": "колекціонер",
  "title.setting": "встановлено",
  "title.socketSetting": "налаштування сокета",
  "title.addSchedule": "Додати таймер",
  "title.editSchedule": "Редагувати таймер",
  "title.repetitionTime": "Час повторення",
  "title.addDatalogger": "Додати пристрій",
  "title.connectWifi": "Маршрут з’ єднання",
  "title.distributionNetworkStatus": "Стан мережі розподілу",
  "title.language": "мова",
  "title.selectCountry": "Виберіть країну",
  "title.selectCity": "Виберіть місто",
  "bar.home": "домашня сторінка",
  "bar.energy": "аналіз",
  "bar.plant": "електростанція",
  "bar.user": "користувач",
  "bar.endpoint": "термінал",
  "bar.mine": "мій",
  "bar.my": "мій",
  "button.logOut": "виписати",
  "button.rememberMe": "Запам’ ятати пароль рахунка",
  "button.forgetPassword": "Забудував пароль",
  "button.register": "реєструвати",
  "button.ok": "Підтвердити",
  "button.send": "надіслати",
  "button.auto": "автоматичний",
  "button.cancle": "Скасувати",
  "button.yes": "так",
  "button.close": "закрити",
  "button.refresh": "Оновити",
  "button.next": "наступний крок",
  "button.redistributionNetwork": "Переорганізувати мережу дистрибутиву",
  "button.upload": "вивантажити",
  "button.confirm": "Підтвердити",
  "button.edit": "редагувати",
  "button.delete": "вилучити",
  "button.save": "збереження",
  "button.allReady": "Всі прочитані",
  "button.selectAll": "Вибрати всі",
  "button.deselectAll": "Скасувати всі вибрані",
  "button.unsubscribe": "Скасувати рахунок",
  "button.later": "Пізніше",
  "button.upgrade": "оновлювати",
  "button.unfollow": "Скасувати слід",
  "button.add": "додати до",
  "subtitle.NeedMoreHelp": "Довідка",
  "subtitle.VisitSupportCenter": "Перегляньте офіційний веб-сайт для більшої допомоги",
  "subtitle.energyFlowDiagram": "Діаграма енергетичного потоку",
  "subtitle.selectTimezone": "Виберіть часову зону",
  "subtitle.selectPlantType": "Виберіть тип електростанції",
  "subtitle.selectInstallationDate": "Виберіть дату встановлення",
  "subtitle.selectCurrency": "Виберіть валюту",
  "subtitle.selectDateType": "Виберіть тип дати",
  "subtitle.selectDeviceType": "Виберіть тип пристрою",
  "subtitle.socketBluetooth": "Сокет Bluetooth",
  "subtitle.log": "журнал",
  "subtitle.all": "цілий",
  "subtitle.online": "онлайн",
  "subtitle.offline": "вимкнено",
  "subtitle.normal": "звичайний",
  "subtitle.abnormal": "abnormal",
  "subtitle.on": "відкрити",
  "subtitle.off": "закрити",
  "subtitle.todayEnergy": "Сьогодні споживання електрики",
  "subtitle.totalEnergy": "Загальне споживання електрики",
  "subtitle.totalRevenue": "Загальний дохід",
  "subtitle.plantImage": "Зображення електростанції",
  "subtitle.plantName": "Назва електроенергії",
  "subtitle.plantType": "Тип електроенергії",
  "subtitle.PVCapacity": "PV потужність",
  "subtitle.installationDate": "встановити дату",
  "subtitle.plantAddress": "Адреса електростанції",
  "subtitle.revenue": "прибуток",
  "subtitle.timeZone": "часова зона",
  "subtitle.updatePhone": "Оновити номер телефону",
  "subtitle.solar": "фотоволтаїчний",
  "subtitle.grid": "сітка енергії",
  "subtitle.battery": "Батерія",
  "subtitle.home": "завантажити",
  "subtitle.load": "завантажити",
  "subtitle.socket": "Сокет",
  "subtitle.today": "день",
  "subtitle.day": "день",
  "subtitle.month": "місяць",
  "subtitle.year": "рік",
  "subtitle.total": "загально",
  "subtitle.time": "час",
  "subtitle.Co2": "вуглецевий диоксид",
  "subtitle.coal": "Уголь",
  "subtitle.deforestation": "Дерева",
  "subtitle.parameter": "параметр",
  "subtitle.schedule": "таймер",
  "subtitle.countdown": "лічити вниз",
  "subtitle.socketSwitch": "Контактор сокета",
  "subtitle.currency": "валюта",
  "subtitle.energyPrice": "Ціна електрики",
  "subtitle.storagePlant": "Енергетична станція зберігання енергії",
  "subtitle.on-GridPlant": "З’ єднана сітка електростанція",
  "subtitle.photo": "головний портрет",
  "subtitle.email": "поштова скринька",
  "subtitle.account": "рахунок",
  "subtitle.version": "редагування",
  "subtitle.officalWebsite": "Офіційна веб-сайт",
  "subtitle.SN": "серійний номер",
  "subtitle.wifiSignal": "Сигнал WiFi",
  "subtitle.lastSync": "Нарешті синхронізовано",
  "subtitle.switch": "перемикати",
  "subtitle.happening": "У прогресі",
  "subtitle.restored": "Знову",
  "subtitle.details": "деталі",
  "subtitle.warn": "надати нагадування",
  "subtitle.fault": "помилка",
  "subtitle.status": "стан",
  "subtitle.level": "Градус",
  "subtitle.deviceType": "Тип пристрою",
  "subtitle.alarmStartTime": "Час запуску нагадування@ info: whatsthis",
  "subtitle.alarmEndTime": "Час завершення нагадування@ info: whatsthis",
  "subtitle.solution": "розв’ язання",
  "subtitle.noSolution": "Будь ласка, зверніться до посібника користувача для усунення несправностей або зверніться до служби післяпродажного обслуговування.",
  "subtitle.loginIn": "Входження до системи",
  "subtitle.checkVersion": "Перевірити оновлення",
  "subtitle.versionUpgrade": "Оновлення версії",
  "subtitle.alarmName": "Назва тривоги",
  "subtitle.messageDetail": "Подробиці повідомлення",
  "subtitle.todayConsumption": "Сьогодні споживання енергії",
  "subtitle.totalConsumption": "Поживання енергії",
  "subtitle.dataloggerSN": "Серійний номер збірки",
  "subtitle.configurationGuidance": "Налаштування",
  "subtitle.guideVideo": "Відео підказки",
  "subtitle.manualInstuction": "Підручник",
  "subtitle.manualInstuction4G": "Підручника 4G",
  "subtitle.manualInstuctionMasterControl": "Головний підручник керування",
  "subtitle.masterControlConfiguration": "Головна мережа дистрибутиву керування",
  "subtitle.defaultConfiguration": "Типова мережа дистрибутиву",
  "subtitle.findEmail": "Отримання електронної пошти",
  "subtitle.findPhone": "Отримання мобільного телефону",
  "subtitle.family": "сім’ я",
  "subtitle.agent": "агент",
  "subtitle.endUsers": "кінцевий користувач",
  "subtitle.deviceManagement": "Обладнання",
  "subtitle.deviceSN": "Серійний номер опреми",
  "subtitle.firmwareVersion": "Версія Firmware",
  "subtitle.alias": "alias",
  "subtitle.information": "інформація",
  "subtitle.domainName": "domain name",
  "subtitle.restartdatalogger": "Перезапустити колекціонер",
  "subtitle.value": "значення",
  "subtitle.customizable": "нетиповий",
  "subtitle.ready": "читати",
  "subtitle.deviceDetails": "деталі пристрою",
  "subtitle.startAddress": "Запуск адреси реєстру",
  "subtitle.endAddress": "Завершити адресу реєстру",
  "subtitle.settingParam": "Встановити параметри",
  "subtitle.tariffType": "Тип ціни електрики",
  "subtitle.fixed": "фіксовано",
  "subtitle.timeshare": "Ділення часу",
  "subtitle.addTime": "Додати час",
  "subtitle.notAllDay": "Не весь день",
  "subtitle.dealer": "дистрибутор",
  "subtitle.dealerNumber": "ІД дилера",
  "subtitle.toggle": "перемикати",
  "subtitle.environmentalBenefit": "екологічні переваги",
  "subtitle.basicParam": "Основні параметри",
  "subtitle.realTimeParam": "Параметри реального часу",
  "subtitle.export": "експортувати",
  "subtitle.localDebug": "Близько кінця зневаджування",
  "subtitle.mode": "режим",
  "subtitle.manuallyAdd": "Додати вручну",
  "subtitle.AttachTheDevice": "Висіяння обладнання",
  "subtitle.ammeter": "ват- годинний метр",
  "subtitle.FeederPowerOnTheSameDay": "Щоденний постачальник енергії в мережу",
  "subtitle.BatterySOC": "SOC батарії",
  "subtitle.DailyChargingCapacityOfTheBattery": "Щодня потужність завантаження батареї",
  "subtitle.DailyPowerConsumption": "Кожного дня споживання енергії",
  "subtitle.CumulativePowerGeneration": "Загальне створення енергії",
  "subtitle.total2": "загально",
  "subtitle.run": "функція",
  "subtitle.StopIt": "зупинити",
  "subtitle.Optimizer": "оптимізатор",
  "subtitle.DataGateways": "ворота даних",
  "subtitle.dataType": "тип даних",
  "subtitle.Model": "модель",
  "subtitle.TheAmountOfElectricityGeneratedToday": "Виробництво електроенергії сьогодні",
  "subtitle.CurrentPower": "Поточна сила",
  "subtitle.AllOptimizerWorkingStatus": "Всі робочі стани оптимізатора",
  "subtitle.WhenClosedAllOptimizersStopWorking": "Після вимкнення всі оптимізатори перестануть працювати",
  "subtitle.TheDataGatewayRestarts": "Перезапуск ворота даних",
  "subtitle.Reboot": "перезапустити",
  "subtitle.Restarting": "Перезапуск у програмі",
  "subtitle.HardwareVersionNumber": "Номер версії обладнання",
  "subtitle.SoftwareVersionNumber": "Номер версії програмного забезпечення",
  "subtitle.OutputPower": "вихідна сила",
  "subtitle.OutputVoltage": "напруга виводу",
  "subtitle.OutputCurrent": "Поточний вихід",
  "subtitle.InputPower": "Вхідна сила",
  "subtitle.InputVoltage": "напруга вводу",
  "subtitle.InputCurrent": "Вхідний поточний",
  "subtitle.OperationalStatus": "Stan robi",
  "subtitle.temperature": "температура(℃)",
  "subtitle.DeviceAddress": "Адреса обладнання",
  "subtitle.FeederMode": "Режим мережі подач",
  "subtitle.StandbyMode": "Режим резервної копії",
  "subtitle.Off-gridMode": "Режим вимкнення мережі",
  "subtitle.TimedChargingAndDischarging": "Часове завантаження і звантаження",
  "subtitle.WorkingModeSettings": "Встановлення робочого режиму",
  "subtitle.DeviceInformation": "Інформація про пристрій",
  "subtitle.HMISoftwareVersion": "Версія програмного забезпечення HMI",
  "subtitle.DSPSoftwareVersion": "Версія програмного забезпечення DSP",
  "subtitle.ChargeAndDischargeTimePeriodSetting": "Встановлення періоду завантаження і звантаження",
  "subtitle.ChargingPeriod": "Період завантаження",
  "subtitle.DischargeTimePeriod": "Часовий період звільнення",
  "subtitle.BatteryMinimumSOC(%)": "Мінімальний SOC батареї (%)",
  "subtitle.BatteryOvervoltageMethod(V)": "Значення методу перенапруги батареї (V)",
  "subtitle.BatteryUndervoltageThreshold(A)": "Праг піднапруги батареї (A)",
  "subtitle.ChargingCurrentLimit(A)": "Завантаження поточної межі (A)",
  "subtitle.DischargeCurrentLimit(A)": "Вилучити поточну межу (A)",
  "subtitle.Off-GridDischargeMinimumSOC(%)": "Мінімальний SOC (%) для вилучення з мережі",
  "subtitle.Off-Grid-2-DischargeMinmumSOC(%)": "Мінімальний SOC виводу з мережі 2 (%)",
  "subtitle.Off-grid-2-DischargeMinimumBatteryVoltage(V)": "Мінімальний напруг батареї для виходу з мережі 2 (V)",
  "subtitle.Auto-replenishment": "Автоматичне відновлення енергії",
  "subtitle.BatteryBMSActivationCommand": "Команда активації BMS батареї",
  "subtitle.ForcedFullCharge": "Примусове повне завантаження",
  "subtitle.ForceCharge2": "Примусове завантаження 2",
  "subtitle.ForceCharge1": "Примусове завантаження 1",
  "subtitle.DischargeEnabled": "Увімкнути вивантаження",
  "subtitle.ChargingEnabled": "Завантаження увімкнено",
  "subtitle.NumberOfOptimizers": "Кількість оптимізаторів",
  "subtitle.TheNameOfTheDevice": "Назва пристрою",
  "subtitle.GeneralSettings": "Загальні параметри",
  "subtitle.Anti-backflowSwitch": "Перемикач проти зворотного потоку",
  "subtitle.ReflowPowerLimit(W)": "Обмеження енергії рефлуксу (W)",
  "subtitle.OptimizerNumber": "Номер оптимізатора",
  "subtitle.reset": "Відновити",
  "subtitle.areYouSure": "Ви впевнені, що бажаєте перевстановити",
  "subtitle.PhysicalView": "Фізичний перегляд",
  "subtitle.LogicalView": "Логічний перегляд",
  "subtitle.LayoutDrawing": "Розклад",
  "tip.noData": "На даний момент немає даних",
  "tip.base.maxDistance": "найдалеко",
  "tip.base.minDistance": "останнім часом",
  "tip.base.maxSize": "максимально",
  "tip.base.minSize": "мінімум",
  "tip.request.loading": "Завантаження у програмі",
  "tip.request.netWork": "Спроба з’ єднання з мережею зазнала невдачі, будь ласка, перевірте мережу",
  "tip.request.connectServerFail": "Неможливо з’ єднатися з сервером",
  "tip.request.requestTimeout": "час перерви запиту",
  "tip.validate.choiceCountry": "Будь ласка, спочатку виберіть країну",
  "tip.validate.country": "Країна не може бути порожньою, будь ласка, виберіть країну",
  "tip.validate.timeZone": "Часова зона не може бути порожня, будь ласка, виберіть часову зону",
  "tip.validate.email": "Помилка формату електронної пошти, будь ласка, введіть правильну адресу електронної пошти",
  "tip.validate.verification": "Будь ласка, спочатку надсилайте код перевірки",
  "tip.validate.verificationError": "Помилка коду перевірки, будь ласка, введіть коректний код перевірки",
  "tip.validate.passwordFormTip": "Будь ласка, введіть пароль з 6- 20 цифр чисел і літер",
  "tip.validate.passwordError": "Помилка формату пароля, будь ласка, введіть пароль з 6- 20 цифр чисел і літер",
  "tip.validate.passwordError2": "Будь ласка, введіть коректний пароль (пароль не повинен включити жодних особливих символів, символів або пробілів)",
  "tip.validate.validatePassword": "Два паролі, які ви ввели, не відповідають. Будь ласка, перевірте і введіть знову",
  "tip.validate.confirmAgreement": "Будь ласка, спочатку прочитайте і погодитеся з договором про приватність",
  "tip.validate.plantName": "Назва електростанції не може бути порожньою. Будь ласка, введіть назву електростанції",
  "tip.validate.plantType": "Тип електростанції не може бути порожнім, будь ласка, виберіть тип електростанції",
  "tip.validate.pvCapacity": "Можливість сонячних клітин не може бути порожньою, будь ласка, введіть можливість батареї",
  "tip.validate.installationDate": "Дата встановлення не може бути порожньою, будь ласка, виберіть дату встановлення",
  "tip.validate.city": "місто не може бути порожнє, будь ласка, виберіть місто",
  "tip.validate.incomeunit": "Монета не може бути порожньою, будь ласка, виберіть валюту",
  "tip.validate.energyPrice": "Ціна електрики не може бути порожньою, будь ласка, введіть ціну електрики",
  "tip.validate.firstChoiceCountry": "Будь ласка, спочатку виберіть країну",
  "tip.validate.oldPassword": "Старий пароль не може бути порожнім, будь ласка, введіть старий пароль",
  "tip.validate.newPassword": "Новий пароль не може бути порожнім, будь ласка, введіть новий пароль",
  "tip.validate.confirmPassword": "Потверджувати пароль не може бути порожнім, будь ласка, підтверджуйте пароль",
  "tip.validate.passwordNotMatch": "Два вхідні паролі не сумісні. Будь ласка, перевірте і підтвердите перед надсиланням",
  "tip.validate.SN1": "Серійне число не може бути порожнім",
  "tip.validate.SN2": "Серійне число має бути довгим 10 цифр",
  "tip.validate.noSocketTimer": "Зараз немає таймера сокета. Будь ласка, натисніть, щоб додати його",
  "tip.validate.cameraPermission": "За допомогою програми потрібні дозволи фотоапарата для сканування і додавання збірників",
  "tip.validate.searchingState": "Пошук Bluetooth, будь ласка, більше не натисніть",
  "tip.validate.notInTheScope": "Вхідних параметрів не знаходяться у вказаному діапазоні",
  "tip.validate.enterDecimal": "Потрібно ввести десяткові або цілі цифри {номер}",
  "tip.validate.integer": "Мабуть, ціле число",
  "tip.validate.phone": "Номер мобільного телефону підтримує лише китайську державу, будь ласка, використовуйте електронну пошту для отримання інших",
  "tip.validate.can`tEmpty": "{param} не може бути порожнім",
  "tip.validate.dealerSope": "Діапазон номерів дилера 6-8 цифр",
  "tip.validate.firstChoicePlant": "Будь ласка, спочатку виберіть електростанцію",
  "tip.log.permissionOpen": "Перевірити, чи можна увімкнути розташування і права доступу до Bluetooth",
  "tip.log.openBluetoothSystem": "Відкрити параметри Bluetooth",
  "tip.log.openIosBtSystem": "Будь ласка, перезапустити перемикач Bluetooth",
  "tip.log.openLocationSystem": "Відкрити параметри розташування",
  "tip.log.bluetoothAuthorization": "Авторизація APP Bluetooth не увімкнена",
  "tip.log.locationAuthorization": "Авторізація розташування APP не увімкнена",
  "tip.log.searchSurroundingDevicesPermission": "Неавторизований пошук близьких пристроїв",
  "tip.log.bluetoothNotPermission": "Bluetooth не увімкнено",
  "tip.log.locationNotPermission": "Розташування не увімкнено",
  "tip.log.bluetoothPermission": "Bluetooth увімкнено",
  "tip.log.locationPermission": "Позиціонування увімкнено",
  "tip.log.bluetoothException": "Ненормальне роз’ єднання Bluetooth, будь ласка, підтверджуйте, що Bluetooth пристрою увімкнено, а потім повторно з’ єднано",
  "tip.log.listeningFailure": "Спроба спостереження за змінами значень можливостей зазнала невдачі, будь ласка, перез’ єднайтеся з Bluetooth",
  "tip.log.communicationException": "Зв’ язок з Bluetooth не є нормальним, будь ласка, перез’ єднайтеся з Bluetooth",
  "tip.log.reconnect": "Повторне з’ єднання Bluetooth",
  "tip.log.connectFail": "Спроба з’ єднання Bluetooth зазнала невдачі",
  "tip.log.connect": "З’ єднати Bluetooth",
  "tip.log.bluetoothService": "Будь ласка, увімкніть службу Bluetooth",
  "tip.log.locationService": "Будь ласка, увімкніть служби розташування",
  "tip.log.notsupport": "Поточна платформа підтримує виклик функції Bluetooth",
  "tip.log.locationNotTurnOn": "Адреса не увімкнена, не вдалося шукати Bluetooth",
  "tip.log.init": "Ініціалізація Bluetooth",
  "tip.log.searching": "Пошук Bluetooth навколо",
  "tip.log.searchFail": "Не знайдено пристроїв навколо, будь ласка, переконайтеся, що Bluetooth пристрою буде увімкнено, а потім натисніть на оновлення",
  "tip.log.stopSearch": "Припинити пошук навколо Bluetooth",
  "tip.log.stopSearchFail": "Спроба пошуку навколо Bluetooth зазнала невдачі",
  "tip.log.connectSuccess": "З’ єднання з Bluetooth успішно",
  "tip.log.setMTUsSuccess": "Успішно встановити максимальну одиницю передачі",
  "tip.log.setMTUsFail": "Не вдалося встановити максимальну одиницю передачі",
  "tip.log.closeSuccess": "З’ єднання Bluetooth відключено",
  "tip.log.closeFail": "Не вдалося відключити з’ єднання Bluetooth",
  "tip.log.wifiLoadFail": "Спроба завантаження списку WiFi зазнала невдачі, будь ласка, введіть вручну",
  "tip.log.bluetoothAbnormal": "Ненормальне з’ єднання Bluetooth, спроба перез’ єднання",
  "tip.log.getBluetoothServiceSuccess": "Успішно отримана служба пристрою Bluetooth",
  "tip.log.getBluetoothServiceFail": "Не вдалося отримати службу пристрою Bluetooth",
  "tip.log.getFeatureValuesSucess": "Успішно отримано всі значення можливостей у вказаній службі пристрою Bluetooth",
  "tip.log.getFeatureValuesFail": "Не вдалося отримати всі значення можливостей з вказаної служби пристрою Bluetooth",
  "tip.log.subscriptionEigenvalueSuccess": "Увімкнено функцію повідомлення про зміни значень низької потужності пристрою Bluetooth, підписатися на значення",
  "tip.log.subscriptionEigenvalueFail": "Увімкнути функцію повідомлення, якщо значення можливостей низьких пристроїв Bluetooth змінюється, значення можливостей підпису зазнала невдачі",
  "tip.log.monitoringSuccess": "Успішно спостережено за подією зміни значень можливостей приладів Bluetooth з низькою потужністю",
  "tip.log.monitoringFail": "Не вдалося спостерігати за подією зміни значень можливостей приладів Bluetooth з низькою потужністю",
  "tip.log.CRC": "Спроба перевірки CRC зазнала невдачі",
  "tip.log.queryWiFi": "Список WiFi з успішним запитом",
  "tip.log.queryWiFiState": "Успішно видано команду запиту у списку WiFi",
  "tip.log.wifiConenct": "Запит статусу з’ єднання з маршрутом",
  "tip.log.wifiFail": "Будь ласка, перевірте рахунок і пароль маршрутизації і спробуйте повторно з’ єднатися",
  "tip.log.connectWiFiSuccess": "З’ єднання з маршрутом успішно",
  "tip.log.connectWiFiFail": "Спроба з’ єднання з маршрутом зазнала невдачі",
  "tip.log.routerAccount": "Помилка рахунка маршрутника",
  "tip.log.routerPassword": "Помилка пароля маршрутика",
  "tip.log.gettingIP": "Отримання IP адреси рутера",
  "tip.log.getIPFail": "Не вдалося отримати IP рутера",
  "tip.log.queryServerState": "Успішно видали команду для запиту на стан взаємодії між пристроєм і сервером",
  "tip.log.server03": "Існує 03 обміни даними",
  "tip.log.server04": "Існує 04 обмін даними",
  "tip.log.heartbeat": "Інтеракція даних про серцевий ритм",
  "tip.log.noInteraction": "Немає взаємодії з даними",
  "tip.log.bluetoothCommunication": "Було встановлено спілкування з Bluetooth",
  "tip.log.connectWiFi": "З’ єднати WiFi",
  "tip.log.getWiFiList": "Запит списку WiFi",
  "tip.log.wifiName": "Назва WiFi не може бути порожньою, будь ласка, виберіть або введіть 2. 4WiFi",
  "tip.log.wifiPasword": "WiFi не може бути порожнім, будь ласка, введіть пароль",
  "tip.log.wifiPasswordError": "Пароль WiFi не може містити особливих символів ([UNK]ǐò•♢ ∝ [UNK]℉, т. д.)",
  "tip.log.masterControlId": "Головний ідентифікатор керування не може бути порожнім, будь ласка, введіть ідентифікатор",
  "tip.addDatalogger.noSearchDevice": "Не вдалося знайти пристрій, будь ласка, переконайтеся, що Bluetooth пристрою буде увімкнено",
  "tip.addDatalogger.searchAroundBluetooth": "Доступна мережа навколо Bluetooth",
  "tip.addDatalogger.scan": "Скануйте код QR або вручну введіть серійний номер збирача під кодом QR.",
  "tip.addDatalogger.connectBluetoothFail": "Спроба з’ єднання Bluetooth зазнала невдачі, будь ласка, перевірте код QR або вручну введіть серійний номер збірника під кодом QR перед перез’ єднанням.",
  "tip.connectWifi.tip1": "Налаштувати пристрої для приєднання до мережі",
  "tip.connectWifi.tip": "Будь ласка, виберіть WiFi 2. 4G",
  "tip.connectWifi.devicePower": "Сила опреми",
  "tip.connectWifi.enterSSID": "Будь ласка, введіть рахунок руйтера",
  "tip.connectWifi.enterPassword": "Будь ласка, введіть пароль маршрутизації",
  "tip.connectWifi.masterId": "Будь ласка, введіть головний ідентифікатор керування",
  "tip.connectWifi.commandSetFail": "Не вдалося встановити команду, будь ласка, перез’ єднайтеся з збірником",
  "tip.configurationState.connecting": "З’ єднання у процесі",
  "tip.configurationState.connectFail": "не вдалося з’ єднатися",
  "tip.configurationState.connectSuccess": "З’ єднання успішно",
  "tip.configurationState.wait": "Хвилинку, будь ласка.",
  "tip.configurationState.addDeviceSuccess": "Пристрій успішно додано",
  "tip.home.today": "Щоденне виробництво електрики",
  "tip.home.month": "Місячне виробництво електрики",
  "tip.home.year": "Рочне виробництво енергії",
  "tip.home.total": "Загальне виробництво енергії",
  "tip.home.homePower": "Загальна загальна зарядка домашніх будинків",
  "tip.home.socketPower": "Завантаження сокета",
  "tip.home.off-gridPower": "Завантаження з мережі",
  "tip.home.acPower": "Головна сила",
  "tip.home.on-gridPower": "З’ єднана сітка",
  "tip.home.others": "інший",
  "tip.home.latestVersion": "Це вже остання версія",
  "tip.home.frontEndLoad": "Перша кінцева завантаження",
  "tip.home.backEndLoad": "Завантаження з мережі",
  "tip.energy.choiceDate": "Поточні дані доступні лише",
  "tip.energy.explain": "пояснити",
  "tip.energy.tip1.load": "Енергія споживана завантаженням",
  "tip.energy.tip1.solar": "Перетворити сонячну енергію в електричну енергію для завантаження батарейки або завантаження енергії",
  "tip.energy.tip1.grid": "Зокупована енергія продавана електроенергійній мережі",
  "tip.energy.tip1.battery": "Згрупована електрична енергія, використана для завантаження батареї",
  "tip.energy.tip2": "# NAME?",
  "tip.energy.tip3.title": "Стандарди обчислення соціального внеску",
  "tip.energy.tip3.title2": "1kWh дорівнює:",
  "tip.energy.tip3.Co2": "Зменшити викиди вуглецевого диоксиду:",
  "tip.energy.tip3.coal": "Зберегти використання стандартного вугілля:",
  "tip.energy.tip3.deforestation": "Захист дерев:",
  "tip.plant.comprehensive": "Загальне впорядкування",
  "tip.plant.totalEnergyMax": "Найвищий загальний споживання енергії",
  "tip.plant.totalEnergyMin": "Найнижче загальне споживання енергії",
  "tip.plant.realTimePower": "Сила реального часу",
  "tip.plant.pvcapacityMax": "Найвища фотоапаратна потужність",
  "tip.plant.pvcapacityMin": "Найнижча потужність PV",
  "tip.plant.installationDateMax": "Найдалекою датою встановлення",
  "tip.plant.installationDateMin": "Остання дата встановлення",
  "tip.plant.paramChoice": "Вибір параметрів",
  "tip.plant.filter": "екран",
  "tip.plant.addVisitor": "Додати відвідувача",
  "tip.plant.tip": "Підказки",
  "tip.plant.visitorTip": "Можна поділитися лише з реєстрованими користувачами",
  "tip.plant.name": "назва",
  "tip.plant.permission": "суддія",
  "tip.plant.read-write": "Читати і записати",
  "tip.plant.onlyread": "лише читання",
  "tip.plant.visitor": "відвідувач",
  "tip.plant.unfollow": "Ви впевнені, що хочете відкрити цю електроенергію?",
  "tip.device.power": "сила",
  "tip.device.type": "тип",
  "tip.device.updateTime": "Час оновлення",
  "tip.device.powerOnTime": "Вчасна енергія",
  "tip.device.todayEnergy": "Сьогодні споживання електрики",
  "tip.device.signal": "інтенсивність сигналу",
  "tip.device.deliveryWarning": "Вибачте, цей пристрій було доставлено кінцевим користувачам і не може бути видалений. Ви можете спочатку перейти до управління електростанцією, скасувати доставку, а потім видалити пристрій.",
  "common.ok": "OK",
  "tip.delDevice": "Ви впевнені, що бажаєте вилучити цей {пристрій}?",
  "tip.currentNoDevice": "Зараз пристроїв немає",
  "tip.currentNoDatalog": "Зараз не існує збирача",
  "tip.messageInfo.storage": "Збереження енергії",
  "tip.messageInfo.inverter": "інвертер",
  "tip.messageInfo.microInverter": "Мікро- зворотній",
  "tip.ops.setDomainName": "Ви впевнені, що бажаєте встановити цю назву домену?",
  "tip.ops.restartDatalogger": "Ви впевнені, що хочете перезапустити колекціонер?",
  "tip.opsLog.addUser": "Додати кінцевих користувачів",
  "tip.opsLog.bindSuccess": "Прив’ язка успішна",
  "tip.opsLog.selectDate": "Виберіть дату",
  "tip.opsLog.start": "початок",
  "tip.opsLog.end": "кінець",
  "tip.opsLog.upgrade": "оновлення",
  "tip.opsLog.operation": "операція",
  "tip.opsLog.communication": "спілкування",
  "tip.opsLog.type": "тип",
  "tip.opsLog.content": "вміст",
  "tip.opsLog.control": "контролер",
  "tip.opsLog.command": "Тип команди",
  "tip.opsLog.reset": "Відновити",
  "tip.opsLog.serverTime": "Час сервера",
  "tip.opsLog.inverter": "інтервал",
  "tip.opsLog.bindAgent": "Ділер зв’ язків",
  "tip.opsLog.deleteDeviceSN": "Будь ласка, підтвердите, чи бажаєте ви його вилучити?",
  "tip.opsLog.recordLog": "Пристрій, які потребують запису журналу",
  "tip.userLocation": "Розташування користувача",
  "tip.setting.productModelNumberRelevancyOn-gridPower": "Активна енергія з’ єднана з мережею не може перевищити максимальну енергію вибраної моделі продукту",
  "productEquipment.productModelNumber": "Модель продукту",
  "productEquipment.warnMessage": "Інформація про нагадування@ info: whatsthis",
  "productEquipment.customInstruction": "Нетипові інструкції",
  "productEquipment.firmwareUpdate": "Оновлення фірми",
  "productEquipment.historicalData": "історичні дані",
  "productEquipment.linkageInformation": "Інформація про з’ єднання",
  "systemAuthority.systemSettings": "Системні параметри",
  "systemAuthority.authorityManagement": "Доступ",
  "systemAuthority.accountManagement": "Роль",
  "systemAuthority.Disabled": "Вимкнути",
  "systemAuthority.enable": "Увімкнути",
  "org.ChangeSupplier": "Змінити постачальника",
  "weather.clearSky": "Ясне небо",
  "weather.fewClouds": "Деякі хмари",
  "weather.scatteredClouds": "Розкидані хмари",
  "weather.brokenClouds": "Хмарно",
  "weather.overcastClouds": "Похмуро",
  "weather.lightRain": "Легкий дощ",
  "weather.moderateRain": "Помірний дощ",
  "weather.heavyRain": "Сильний дощ",
  "weather.thunderstormWithLightRain": "Гроза з легким дощем",
  "weather.thunderstormWithRain": "Гроза з дощем",
  "weather.thunderstormWithHeavyRain": "Гроза з сильним дощем",
  "weather.lightSnow": "Легкий сніг",
  "weather.snow": "Сніг",
  "weather.heavySnow": "Сильний сніг",
  "weather.sleet": "Зливи",
  "weather.showerRain": "Зливи дощу",
  "weather.lightShowerRain": "Легкі зливи дощу",
  "weather.heavyShowerRain": "Сильні зливи дощу",
  "weather.mist": "Туман",
  "weather.smoke": "Дим",
  "weather.haze": "Мгла",
  "weather.dust": "Пил",
  "weather.fog": "Туман",
  "weather.sand": "Пісок",
  "weather.ash": "Пепел",
  "weather.squall": "Шквал",
  "weather.tornado": "Торнадо",
  "zh-CN": "Китайська",
  "en-US": "Англійська",
  "de-DE": "Німецька",
  "fr-FR": "Французька",
  "it-IT": "Італійська",
  "uk-UA": "Українська",
  "th-TH": "Тайська",
  "nl-NL": "Нідерландська",
  "language.management": "Багатомовність",
  "sidebar.roleManagement": "Роль",
  "user.userEmail": "Електронна пошта користувача",
  "user.agentCode": "Код агента",
  "user.phoneModel": "Модель телефону",
  "user.phoneOs": "Операційна система телефону",
  "user.appVersion": "Версія додатка",
  "user.country": "Країна",
  "user.createTime": "Час створення",
  "user.loginTime": "Час входу",
  "shipment.MdmCode": "Код MDM",
  "product.createProduct": "Створити продукт",
  "shipment.MaterialCode": "Код матеріалу MDM",
  "product.deviceSubclass": "Підклас пристрою",
  "shipment.supplier": "Постачальник",
  "product.networkingMode": "Режим мережевого підключення",
  "product.productImage": "Зображення продукту",
  "product.bluetoothIcon": "Значок Bluetooth",
  "product.uploadOneBluetoothIcon": "Можна завантажити лише один значок Bluetooth",
  "product.UploadUpTo9Photos": "Завантажити до 9 фото",
  "product.PleaseUploadNoBackground": "Будь ласка, завантажуйте зображення пристроїв без фону",
  "product.havePublished": "Опубліковано",
  "product.inDevelopment": "В розробці",
  "shipment.haierSn": "Haier SN",
  "shipment.category": "Категорія",
  "shipment.devType": "Тип розробки",
  "log.operationEmail": "Операційна електронна пошта",
  "log.deviceSn": "Серійний номер пристрою",
  "log.opType": "Тип операції",
  "log.opTime": "Час операції",
  "log.operator": "Оператор",
  "log.operationDescription": "Опис операції",
  "log.content": "Зміст операції",
  "log.params": "Параметри",
  "bTerminal.correlationDeleteTheDevice": "Якщо цей пристрій буде видалено, пов'язані з ним пристрої також будуть видалені одночасно. Ви впевнені, що хочете видалити?",
  "role.action": "Дія",
  "role.add.select.menu": "Будь ласка, виберіть ресурси меню",
  "role.addRole": "Додати роль",
  "role.addTip": "Підтримує налаштування дозволів для користувачів Web та B-сторонніх додатків, але не для користувачів C-сторонніх додатків.",
  "role.applySuccess": "Успішно надіслано",
  "role.appPermissions": "Дозволи меню додатку",
  "role.base": "Основна інформація",
  "role.edit": "Редагувати",
  "role.exist": "The character already exists",
  "role.info": "Деталі",
  "role.name": "Назва ролі",
  "role.no": "Номер ролі",
  "role.not.empty": "Інформація про роль не може бути порожньою",
  "role.per.user": "Кожного користувача можна призначити лише одну роль",
  "role.permissions": "Дозволи на дані",
  "role.status": "Статус ролі",
  "role.submit": "Надіслати",
  "role.type": "Тип ролі",
  "role.typeTip": "Адміністратор установки: Роль за замовчуванням для керівника організації установки, у всій платформі є лише одна. Роль установки: Ролі, які керівник організації установки може призначати співробітникам, їх може бути кілька. Роль платформи: Ролі, які можуть використовувати всі, крім установників.",
  "role.updateTime": "Час оновлення",
  "role.webPermissions": "Дозволи веб-меню",
  "shipment.PleaseEnterMaterialCode": "Будь ласка, введіть MDM-код матеріалу",
  "product.PleaseEnterSupplier": "Будь ласка, введіть постачальника",
  "common.reset": "Відновити",
  "common.confirm": "Підтвердити",
  "common.cancel": "Скасувати",
  "common.save": "збереження",
  "common.delete": "вилучити",
  "common.add": "Новододаний",
  "common.edit": "редагувати",
  "common.update": "Обновление",
  "common.submit": "Передати",
  "common.tip": "нагадування",
  "common.success": "успіх",
  "common.fail": "невдачі",
  "common.password": "пароль",
  "common.handleFail": "операція зазнала невдачі",
  "common.required": "Потрібно",
  "common.environmentChange": "Изменение среды аккаунта, подтвердите обновление аккаунта или повторный вход",
  "common.noPermissions": "Ще немає вмісту, зв'яжіться з адміністратором для налаштування~",
  "plant.plantName": "Название электростанции",
  "plant.country": "Страна/Регион",
  "plant.installer": "Установщик",
  "plant.installPerson": "Монтажник",
  "plant.plantOverview": "Обзор электростанции",
  "plant.deviceList": "Список оборудования",
  "device.operationMonitoring": "Моніторинг роботи",
  "device.parameterControl": "Контроль параметрів",
  "device.Fault&Alarm": "Відлучення та попередження",
  "device.dynamicPriceTip": "Режим ШІ для цього пристрою увімкнено власником будинку, ви не можете зберегти цей параметр.",
  "device.paramRangeErrorDefault": "Помилка діапазону параметра, діапазон введення має бути ",
  "device.paramRangeError": "Помилка діапазону параметра",
  "plant.dataUpdate": "Оновлення даних",
  "plant.pleaseSelectDate": "Будь ласка, виберіть дату",
  "validate.requiredFormat": "Будь ласка, введіть у прикладі формату",
  "plant.addStation": "Додати рослину",
  "product.ProtocolCode": "Ідентифікатор продукту IoT",
  "product.IoIDandPlatformSource": "Ідентифікатор продукту IoT та джерело платформи",
  "product.productIdCannotRepeat": "Ідентифікатор продукту не може бути дубльованим",
  "product.deviceTypeAccess.maxAddRows": "Можна додати не більше 2 записів",
  "product.accessPlatformCannotRepeat": "Джерело платформи не може повторюватися",
  "product.productId": "ID продукту",
  "product.powerType": "Тип живлення",
  "product.power": "Номінальна потужність kW",
  "system.taskCenter": "Центр завдань",
  "task.name": "Назва завдання",
  "task.type": "Тип завдання",
  "task.status": "Статус",
  "task.createDate": "Дата створення",
  "task.progress": "Прогрес",
  "task.view": "Переглянути",
  "task.stop": "Зупинити",
  "task.stopConfirm": "Ви впевнені, що хочете зупинити завдання?",
  "task.stopSuccess": "Завдання успішно зупинено",
  "task.stopFail": "Не вдалося зупинити завдання",
  "task.confirm": "Підтвердити",
  "task.cancel": "Скасувати",
  "task.mutipleSearch": "Масовий пошук",
  "task.mutipleSend": "Масове надсилання",
  "task.taskDetail": "Деталі завдання",
  "task.equipmentList": "Список обладнання",
  "task.fileLimit": "Можна завантажувати лише файли xls/xlsx",
  "task.reChoose": "Очистити список і обрати знову",
  "task.tip": "Перетягніть файл сюди, або",
  "task.upload": "Натисніть для завантаження",
  "task.templateDownload": "Завантажити шаблон",
  "task.mutipleHandleParams": "Параметри масової обробки",
  "common.previousStep": "Попередній крок",
  "task.requiredProductModel": "Виберіть модель продукту",
  "task.requiredEquipmentList": "Завантажте список обладнання",
  "task.equipmentListTip": "Дані таблиці порожні або завантаження не вдалося, будь ласка, перевірте",
  "task.requiredParameter": "Виберіть параметр",
  "task.writeValue": "Значення запису",
  "task.progressRate": "Рівень завершення",
  "task.readTime": "Час читання",
  "task.sendTime": "Час надсилання",
  "task.mutipleSearchTemplate": "Шаблон масового пошуку",
  "task.mutipleSendTemplate": "Шаблон масового надсилання",
  "task.uploadSuccess": "Успішно завантажено",
  "task.sendSuccess": "Завдання успішно створено",
  "task.inProgress": "Виконується",
  "task.completed": "Завершено",
  "task.failed": "Не вдалося",
  "task.success": "Успішно",
  "device.chargeSetting": "Налаштування зарядки",
  "device.dischargeSetting": "Налаштування розрядки",
  "system.configureImport": "Імпорт конфігурації",
  "product.DeviceHlepInstructions": "Інструкції для допомоги з пристроєм",
  "product.addDeviceHlepInstructions": "Додати інструкції для допомоги з пристроєм",
  "product.deviceInstallationGuideFirst": "Будь ласка, завантажте зображення керівництва з установки пристрою, щоб крок за кроком направляти монтажників через установку та операції додатку.",
  "product.deviceInstallationGuideSecond": "Рекомендується включити інструкції для входу в режим мережевої конфігурації пристрою, розташування QR-коду SN, створення сайту, додавання пристрою, операції Bluetooth, швидку конфігурацію тощо.",
  "product.mdnTip": "Перші 9 цифр SN Haier",
  "common.copySuccess": "Копіювання успішне",
  "bTerminal.ModifyTheNameOfTheDevice": "Змінити назву пристрою",
  "bTerminal.changeFailed": "Зміна невдалася",
  "bTerminal.OnlyWithin100Characters": "Обмежено 100 символами або менше китайською, англійською мовою та цифрами",
  "bTerminal.OnlyWithin30Characters": "Обмежено 30 символами або менше китайською, англійською мовою та цифрами",
  "bTerminal.rename": "Перейменувати",
  "sidebar.prefill": "Оцінки та відгуки",
  "paramters.basicInformation": "Основна Інформація",
  "paramters.DCSide": "Côté DC",
  "paramters.ACSide": "Côté AC",
  "paramters.stringCurrent": "Courant de Chaîne",
  "paramters.moreParamters": "Plus d'Informations",
  "paramters.debugInformation": "Informations de Débogage",
  "paramters.current": "Courant",
  "paramters.voltage": "Tension",
  "paramters.power": "Puissance",
  "paramters.init": "Initialisation",
  "paramters.wait": "En Attente",
  "paramters.normal": "Normal",
  "paramters.abnormal": "Défaut",
  "paramters.burn": "Brûlage",
  "system.reportCenter": "Центр звітності",
  "system.reportMonth": "Щомісячний звіт",
  "system.reportYear": "Річний звіт",
  "system.selfServiceReport": "Самообслуговування",
  "system.selfServiceReport.hour": "Година",
  "system.selfServiceReport.selectPlant": "Будь ласка, виберіть електростанцію",
  "system.selfServiceReport.selectYear": "Виберіть рік",
  "system.selfServiceReport.metricSelection": "Вибір показників",
  "system.selfServiceReport.required": "Обов'язково",
  "system.selfServiceReport.startTimeCannotBeLater": "Час початку не може бути пізнішим за час завершення",
  "system.selfServiceReport.fieldIsRequired": "{field} є обовʼязковим",
  "system.selfServiceReport.hourTimeTooltipLine1": "Година означає 1-годинний період, що починається з цієї повної години",
  "system.selfServiceReport.hourTimeTooltipLine2": "(напр. 15:00 = 15:00–15:59)",
  "report.exportAll": "Експортувати все",
  "report.installedCapacity": "Установлена потужність",
  "report.capacityErrorTip": "Діапазон фільтрації встановленої потужності є некоректним",
  "report.exportFailed": "Не вдалося експортувати, будь ласка, спробуйте пізніше",
  "report.firstChoiceTime": "Спочатку виберіть дату, а потім експортуйте",
  "placeholder.selectScope": "Просимо обрати {scope}",
  "register.accountVerification": "Верифікація облікового запису",
  "register.companyRegistration": "Реєстрація компанії",
  "register.staffRegistration": "Реєстрація співробітника",
  "register.companyInfo": "Надайте інформацію про компанію нижче",
  "register.companyFullName": "Повна назва компанії",
  "register.installationCountryNotice": "Будь ласка, уважно оберіть країну, де зареєстрований інсталятор. Ви не зможете встановити систему за межами зони реєстрації.",
  "register.detailAddress": "Детальна адреса",
  "register.postalCode": "Поштовий індекс",
  "register.contactName": "Ім'я контакту",
  "register.contactInfo": "Телефон або електронна пошта контакту",
  "register.applyJoinCompany": "Подати заявку на приєднання до компанії",
  "register.companyCodeInfo": "Будь ласка, заповніть код компанії та особисту інформацію, щоб приєднатися до зареєстрованого підприємства",
  "register.registrationCode": "Код реєстрації компанії",
  "register.codeHint": "Код можна отримати, зв'язавшись з адміністратором підприємства",
  "register.realName": "Імʼя",
  "register.accountVerificationInfo": "Оберіть один з наступних способів для завершення реєстрації облікового запису",
  "register.emailRegistration": "Реєстрація електронною поштою",
  "register.sixDigitCode": "6-значний код підтвердження",
  "register.getVerificationCode": "Отримати код підтвердження",
  "register.resendAfterSeconds": "Надіслати повторно через {seconds}с",
  "register.resendAfterMinutes": "Надіслати повторно через {minutes}хв",
  "register.resendAfterMinutesSeconds": "Надіслати повторно через {minutes}хв{seconds}с",
  "register.password6to20": "Пароль 6-20 символів",
  "register.password8to20": "Пароль 8-20 символів",
  "register.phoneNumber": "Номер телефону",
  "register.phoneRegistration": "Реєстрація за номером телефону",
  "register.optionalEmail": "Необов'язково: Адреса електронної пошти",
  "register.previousPage": "Попередня сторінка",
  "register.goToLogin": "Перейти до входу",
  "register.completeRegistration": "Завершити реєстрацію",
  "register.accountAlreadyRegistered": "Цю електронну адресу або номер телефону вже зареєстровано. Увійдіть або вкажіть інші дані.",
  "register.emailAlreadyRegistered": "Цю електронну адресу вже зареєстровано. Увійдіть безпосередньо або використайте інший обліковий запис.",
  "register.phoneAlreadyRegistered": "Цей номер телефону вже зареєстровано. Увійдіть безпосередньо або використайте інший обліковий запис.",
  "register.companyAlreadyRegistered": "Компанія '{companyName}' вже зареєстрована",
  "register.companyExistOptions": "Ви можете повернутися, щоб змінити назву компанії, або подати заявку на приєднання до цієї компанії",
  "register.returnToModify": "Повернутися до зміни",
  "register.companyRegisteredApplyJoin": "Подати заявку на приєднання",
  "register.companyRegisteredApplyJoinFull": "Компанію вже зареєстровано? Подати заявку на приєднання",
  "register.validation.selectCountry": "Будь ласка, оберіть країну/регіон",
  "register.validation.selectCity": "Будь ласка, оберіть місто",
  "register.validation.enterDetailAddress": "Будь ласка, введіть детальну адресу",
  "register.validation.enterCorrectPostalCode": "Будь ласка, введіть правильний формат поштового індексу",
  "register.validation.enterContactName": "Будь ласка, введіть ім'я контактної особи",
  "register.validation.enterRegistrationCode": "Будь ласка, введіть код реєстрації компанії",
  "register.validation.enterYourName": "Будь ласка, введіть своє ім'я",
  "register.validation.enterPassword": "Будь ласка, введіть пароль",
  "register.validation.passwordLength": "Довжина пароля повинна бути 6-20 символів",
  "register.validation.passwordLength8to20": "Довжина пароля повинна бути 8-20 символів",
  "register.validation.passwordComplexity": "Пароль повинен містити принаймні три різні типи символів (цифри, великі літери, малі літери, спеціальні символи)",
  "register.validation.enterPasswordAgain": "Будь ласка, введіть пароль ще раз",
  "register.validation.passwordMismatch": "Два паролі не співпадають",
  "register.validation.correctPhoneFormat": "Будь ласка, введіть правильний формат номера телефону",
  "register.validation.correctPhoneOrEmailFormat": "Будь ласка, введіть правильний формат номера телефону або електронної пошти",
  "register.validation.correctEmailFormat": "Будь ласка, введіть правильний формат електронної пошти",
  "register.validation.enterVerificationCode": "Будь ласка, введіть код підтвердження",
  "register.validation.sixDigitNumber": "Код підтвердження повинен складатися з 6 цифр",
  "register.validation.enterCompanyName": "Будь ласка, введіть назву компанії",
  "register.validation.companyRegisteredChooseAction": "Компанія вже зареєстрована, будь ласка, оберіть дію",
  "register.message.searchCompanyFailed": "Пошук компанії не вдався",
  "register.message.checkCompanyStatusFailed": "Перевірка статусу компанії не вдався",
  "register.message.getCityListFailed": "Отримання списку міст не вдався",
  "register.message.companyRegisteredChooseAction": "Компанія вже зареєстрована, будь ласка, оберіть дію",
  "register.message.completeCompanyInfo": "Будь ласка, заповніть інформацію про компанію",
  "register.message.completeStaffInfo": "Будь ласка, заповніть інформацію про співробітника",
  "register.message.enterEmailFirst": "Будь ласка, спочатку введіть адресу електронної пошти",
  "register.message.correctEmailFormat": "Будь ласка, введіть правильний формат електронної пошти",
  "register.message.verificationCodeSent": "Код підтвердження надіслано на: {contact}",
  "register.message.sendVerificationCodeFailed": "Надсилання коду підтвердження не вдався",
  "register.message.enterPhoneFirst": "Будь ласка, спочатку введіть номер телефону",
  "register.message.correctPhoneFormat": "Будь ласка, введіть правильний формат номера телефону",
  "register.message.completeAccountInfoAndFixErrors": "Будь ласка, заповніть інформацію про обліковий запис та виправте помилки",
  "register.message.companyRegistrationSuccess": "Реєстрація компанії успішна!",
  "register.message.companyRegistrationFailed": "Реєстрація компанії не вдався",
  "register.message.staffRegistrationSuccess": "Реєстрація співробітника успішна!",
  "register.message.staffRegistrationFailed": "Реєстрація співробітника не вдався",
  "register.message.phoneRegistrationNotAvailable": "Реєстрація через номер телефону наразі недоступна. Будь ласка, стежте за оновленнями.",
  "register.tooltip.title": "Як знайти код реєстрації компанії?",
  "register.tooltip.appPathTitle": "1. У додатку",
  "register.tooltip.appPathDesc": "Перейдіть до Користувач -> торкніться аватара -> Інформація про обліковий запис, щоб переглянути код реєстрації компанії.",
  "register.tooltip.webPathTitle": "2. У веб-консолі",
  "register.tooltip.webPathDesc": "Перейдіть до Керування організацією -> Інформація про організацію, щоб переглянути код реєстрації компанії.",
  "registerAccomplish.applicationComplete": "Заявка завершена",
  "registerAccomplish.congratulations": "Вітаємо, ви завершили реєстрацію.",
  "registerAccomplish.companyRegisterCodeIs": "Ваш корпоративний код реєстрації:",
  "registerAccomplish.certificationRequired": "Вам потрібно продовжити до центру сертифікації для аутентифікації, інакше ви не зможете активувати пристрої.",
  "registerAccomplish.greenChannelInfo": "Для особливих надзвичайних ситуацій у відділах, щоб не затримувати встановлення на місці, ви можете обрати зелений канал, щоб отримати тимчасовий дозвіл на активацію пристроїв на 2 місяці.",
  "registerAccomplish.certificationCenter": "Центр сертифікації",
  "registerAccomplish.greenChannel": "Зелений канал",
  "registerAccomplish.returnToLogin": "Повернутися на сторінку входу",
  "registerAccomplish.useHaierEnergyApp": "Ви можете використовувати додаток Haier Energy для додавання пристроїв.",
  "registerAccomplish.applyingGreenChannel": "Ви подаєте заявку на зелений канал",
  "registerAccomplish.greenChannelDescription1": "Цей канал призначений лише для деяких особливих надзвичайних ситуацій, щоб уникнути затримки встановлення на місці, для активації пристроїв.",
  "registerAccomplish.greenChannelDescription2": "Дозволи облікового запису, отримані через цей канал, є тимчасовими дозволами, і термін дії для активації пристроїв становить 2 місяці.",
  "registerAccomplish.greenChannelDescription3": "Вам потрібно звернутися до центру сертифікації протягом 2 місяців, щоб завершити аутентифікацію та отримати постійний дозвіл на активацію пристроїв.",
  "registerAccomplish.confirmSubmit": "Підтвердити надсилання",
  "registerAccomplish.returnToPrevious": "Повернутися на попередню сторінку",
  "registerAccomplish.applicationSubmittedSuccessfully": "Вашу заявку успішно надіслано!",
  "registerAccomplish.missingAgentIdParameter": "Відсутній параметр agentId, неможливо подати заявку на зелений канал",
  "registerAccomplish.greenChannelApplicationSuccess": "Заявка на зелений канал успішна!",
  "registerAccomplish.greenChannelApplicationFailed": "Заявка на зелений канал не вдався",
  "registerAccomplish.enterSystem": "Увійти в систему",
  "registerAccomplish.pleaseLoginFirst": "Будь ласка, спочатку увійдіть в систему",
  "org.phoneNumber": "Номер телефону",
  "org.certificationStatus": "Статус сертифікації",
  "org.permission": "Дозвіл",
  "org.accountSource": "Джерело облікового запису",
  "org.certificationStatusTip": "Наразі доступно лише для дозволу на додавання пристроїв у додатку Haier Energy",
  "org.unauthenticated": "Не автентифіковано",
  "org.authenticated": "Автентифіковано",
  "org.noNeedToAuthenticate": "Автентифікація не потрібна",
  "org.unauthorized": "Не авторизовано",
  "org.authorized": "Авторизовано",
  "org.temporaryAuthorization": "Тимчасова авторизація",
  "org.remainingDays": "Залишилось днів: {scope} днів",
  "org.allocated": "Розподілено",
  "org.registered": "Зареєстровано",
  "org.authorization": "Авторизація",
  "org.addressDetail": "Детальна адреса",
  "org.postalCode": "Поштовий індекс",
  "org.accountSwitch": "Зміна облікового запису",
  "org.viewAccountInfo": "Переглянути інформацію про обліковий запис",
  "org.baseInfo": "Основна інформація",
  "org.certificationInfo": "Інформація про сертифікацію",
  "org.restDays": "Залишилось днів",
  "org.applyTime": "Час подання заявки",
  "org.certificationTime": "Час сертифікації",
  "org.registerCode": "Код реєстрації",
  "org.registrationTip": "Під час реєстрації можна ввести код реєстрації компанії, щоб подати заявку на приєднання до компанії.",
  "org.authenticationTip": "Цей обліковий запис вимкнено, авторизація неможлива.",
  "org.authenticationTip2": "Цей обліковий запис вже авторизовано або тимчасова авторизація ще не закінчилася — повторну авторизацію виконати не можна.",
  "org.temporaryAuthorizationTip": "Авторизація є тимчасовою, за замовчуванням діє 3 місяці.",
  "org.temporaryAuthorizationSuccess": "Авторизацію успішно виконано",
  "report.allSelect": "Вибрати все",
  "report.compare": "Порівняти",
  "report.energy": "Активна потужність",
  "report.ipv": "Постійний струм",
  "report.vpv": "Постійна напруга",
  "report.fac": "Частота змінного струму",
  "report.vac": "Напруга змінного струму",
  "report.iac": "Струм змінного струму",
  "report.temperature": "Внутрішня температура",
  "report.str_cur": "Струм ланцюга",
  "report.inverterCompare": "Порівняння інверторів",
  "report.inverterCompareTip": "Вже додано до списку, не додавайте повторно",
  "report.pleaseChooseInverter": "Будь ласка, виберіть інвертор",
  "report.pleaseChooseCompare": "Будь ласка, виберіть елементи для порівняння",
  "report.compareItem": "Елементи порівняння",
  "system.inverterCompare": "Порівняння параметрів інверторів",
  "shipment.deviceSource": "Джерело відвантаження",
  "shipment.shippingCustomer": "Клієнт відвантаження",
  "shipment.customerContact": "Контакт клієнта",
  "shipment.tag": "Мітка",
  "shipment.addTag": "Додати мітку",
  "shipment.editTag": "Редагувати мітку",
  "shipment.tagContent": "Вміст мітки",
  "shipment.tagColor": "Колір мітки",
  "placeholder.selectShippingCustomer": "Будь ласка, виберіть клієнта відвантаження",
  "placeholder.enterCustomerContact": "Будь ласка, введіть контакт клієнта",
  "placeholder.selectTag": "Будь ласка, виберіть мітку",
  "placeholder.enterTagContent": "Будь ласка, введіть вміст мітки",
  "placeholder.noResult": "Немає відповідних міток",
  "validation.enterTagContent": "Будь ласка, введіть вміст мітки",
  "validation.selectTagColor": "Будь ласка, виберіть колір мітки",
  "shipment.operationRecordTitle": "Журнал операцій",
  "shipment.boundUserWarning": "Цей пристрій вже прив'язано до користувача, клієнта відвантаження змінити неможливо.",
  "shipment.batchBoundUserWarning": "Вибачте, вибрані пристрої містять пристрої, які вже прив'язані до користувачів, клієнта відвантаження неможливо оновити масово.",
  "shipment.uploadEquipmentListRequired": "Будь ласка, завантажте файл зі списком обладнання",
  "shipment.errorDataTipTitle": "Нагадування про некоректні дані",
  "shipment.downloadImportResult": "Завантажити результат імпорту",
  "shipment.downloading": "Завантаження...",
  "shipment.noFailedDataToDownload": "Немає невдалих даних для завантаження",
  "shipment.deleteTagConfirm": "Ви впевнені, що хочете видалити мітку \"{tagName}\"?",
  "common.addSuccess": "Успішно додано",
  "common.editSuccess": "Успішно змінено",
  "product.basicProperties": "Базові властивості",
  "product.specialProperties": "Спеціальні властивості",
  "product.platformRelated": "Пов'язано з платформою",
  "product.maxPvChannels": "Максимальна кількість підтримуваних PV-стрінгів",
  "product.componentManufacturer": "Виробник модуля",
  "product.componentType": "Тип модуля",
  "product.ratedPower": "Номінальна потужність",
  "product.mppVoltage": "Напруга MPP",
  "product.mppCurrent": "Струм MPP",
  "product.openCircuitVoltage": "Напруга холостого ходу",
  "product.shortCircuitCurrent": "Струм короткого замикання",
  "product.maxPowerTempCoeff": "Темп. коефіцієнт макс. потужності",
  "product.openVoltageTempCoeff": "Темп. коефіцієнт напруги хол. ходу",
  "product.shortCurrentTempCoeff": "Темп. коефіцієнт струму к.з.",
  "product.componentEfficiency": "Номінальний ККД модуля",
  "product.firstYearDegradation": "Деградація за перший рік",
  "product.annualDegradation": "Щорічна деградація",
  "product.fillFactor": "Коефіцієнт заповнення",
  "product.placeholder.range_0_9999_2dp": "0-9999, до двох знаків після коми",
  "product.placeholder.range_0_99_2dp": "0-99, до двох знаків після коми",
  "product.placeholder.range_0_999_2dp": "0-999, до двох знаків після коми",
  "product.placeholder.range_neg1_1_2dp": "-1-1, до двох знаків після коми",
  "product.rule.range_0_9999_2dp": "Введіть число 0-9999, не більше двох десяткових",
  "product.rule.range_0_99_2dp": "Введіть число 0-99, не більше двох десяткових",
  "product.rule.range_0_999_2dp": "Введіть число 0-999, не більше двох десяткових",
  "product.rule.range_neg1_1_2dp": "Введіть число -1-1, не більше двох десяткових",
  "product.ivScanSupport": "Підтримка сканування IV-кривої",
  "system.intelligentDiagnosis": "Інтелектуальна діагностика",
  "system.ivline": "IV-крива",
  "subtitle.ivlineCreate": "Завдання сканування",
  "diagnosis.diagnosisTime": "Час діагностики",
  "diagnosis.faultQuantity": "Кількість несправностей",
  "diagnosis.scanCompleteTime": "Час завершення сканування",
  "diagnosis.scanProgress": "Прогрес сканування",
  "diagnosis.newTask": "Створити завдання",
  "diagnosis.deleteTask": "Видалити завдання",
  "diagnosis.deleteTaskSuccess": "Завдання успішно видалено",
  "diagnosis.closeAll": "Очистити все",
  "diagnosis.startScan": "Почати сканування",
  "diagnosis.pleaseChooseInverter": "Будь ласка, виберіть інвертор",
  "diagnosis.stringSetting": "Налаштування ланцюга",
  "diagnosis.taskSetting": "Налаштування завдання",
  "diagnosis.batchComponentSetting": "Пакетне налаштування компонентів",
  "diagnosis.componentType": "Тип компонента",
  "diagnosis.maxPower": "Максимальна потужність (Pmax)",
  "diagnosis.bestWorkingVoltage": "Оптимальна робоча напруга (Vmpp)",
  "diagnosis.bestWorkingCurrent": "Оптимальний робочий струм (Impp)",
  "diagnosis.openCircuitVoltage": "Напруга холостого ходу (Voc)",
  "diagnosis.shortCircuitCurrent": "Струм короткого замикання (Isc)",
  "diagnosis.maxPowerTemperatureCoefficient": "Температурний коефіцієнт максимальної потужності",
  "diagnosis.openCircuitVoltageTemperatureCoefficient": "Температурний коефіцієнт напруги холостого ходу",
  "diagnosis.shortCircuitCurrentTemperatureCoefficient": "Температурний коефіцієнт струму короткого замикання",
  "diagnosis.nominalComponentConversionEfficiency": "Номінальний ККД перетворення компонента",
  "diagnosis.firstYearDecayRate": "Річне зниження потужності (перший рік)",
  "diagnosis.yearlyDecayRate": "Щорічне зниження потужності",
  "diagnosis.fillFactor": "Коефіцієнт заповнення",
  "diagnosis.componentManufacturer": "Виробник компонента",
  "diagnosis.componentAmount": "Кількість компонентів",
  "diagnosis.capacity": "Потужність ланцюга",
  "diagnosis.stringAmount": "Кількість ланцюгів (шт.)",
  "diagnosis.inverterSerialNumber": "Серійний номер інвертора",
  "diagnosis.totalCapacity": "Загальна потужність ланцюгів",
  "diagnosis.pleaseFillInAllItems": "Не всі поля заповнені, перевірте",
  "diagnosis.moreParamters": "Інші параметри",
  "diagnosis.envParam": "Параметри навколишнього середовища",
  "diagnosis.startTask": "Почати завдання",
  "diagnosis.startTaskSuccess": "Завдання успішно запущено",
  "diagnosis.start": "Почати",
  "diagnosis.noDevice": "Пристрій не знайдено",
  "register.contactAdminForCode": "Будь ласка, зверніться до адміністратора компанії, щоб отримати код реєстрації компанії",
  "register.provideCompanyInfoBelow": "Будь ласка, надайте інформацію про компанію нижче",
  "login.success": "Вход успішно",
  "flowData.existingInvTip": "Увага:\nЯкщо існуючий INV > 0, сонячна енергія виробляє електрику;\nЯкщо існуючий INV < 0, інвертор споживає електрику.",
  "flowData.alert": "Поточне значення INV < 0 вказує на те, що зовнішній інвертор споживає електроенергію.",
  "dialog.confirm": "Зрозуміло",
  "paramters.deviceTotalInformation": "Загальна інформація про пристрій",
  "paramters.innerInverter": "Внутрішній інвертор",
  "paramters.outerInverter": "Зовнішній інвертор",
  "paramters.outerInverterFromPvSide": "Від лічильника з боку PV",
  "paramters.activePower": "Активна потужність",
  "paramters.apparentPower": "Повна потужність",
  "paramters.reactivePower": "Реактивна потужність",
  "paramters.powerFactor": "Коефіцієнт потужності",
  "paramters.phaseA": "Фаза A",
  "paramters.phaseB": "Фаза B",
  "paramters.phaseC": "Фаза C",
  "paramters.charge": "Зарядка",
  "paramters.discharge": "Розрядка",
  "paramters.sell": "Продаж електроенергії",
  "paramters.buy": "Покупка електроенергії",
  "bw_param_ctrl_group_WorkMode": "Режим збою",
  "bw_param_ctrl_name_GRID_Meter_negate": "GRID_Meter_negate",
  "bw_param_ctrl_name_GridBreake": "Перерив мережі",
  "bw_param_ctrl_name_BBSOC_lx1": "SOC для відключення живлення L1",
  "bw_param_ctrl_name_BBSOC_lx2": "SOC для відключення живлення L2",
  "bw_param_ctrl_name_BBSOC_lx3": "SOC для відключення живлення L3",
  "bw_param_ctrl_option_ON": "На",
  "bw_param_ctrl_name_Systemmode": "Системний режим",
  "bw_param_ctrl_name_UPSReserveSoc": "UPS резервний Soc",
  "bw_param_ctrl_option_OFF": "Вимкнути",
  "bw_param_ctrl_option_B5": "Однофазна модель 5Kw",
  "bw_param_ctrl_name_DispatchActivepower": "Диспетч Активна потужність",
  "bw_param_ctrl_option_withoutBattery": "Без батареї",
  "bw_param_ctrl_name_InvSub": "Inv суб",
  "bw_param_ctrl_name_MAXFeedintogridpercent": "Відсоток подачі в мережу MAX",
  "bw_param_ctrl_option_T4": "Тріхфазна модель 4Kw",
  "bw_param_ctrl_option_T5": "Трифазна модель 5Kw",
  "bw_param_ctrl_option_T6": "Трифазна модель 6Kw",
  "bw_param_ctrl_option_T8": "Трифазна модель 8Kw",
  "bw_param_ctrl_option_S3": "Модель однофазного зберігання енергії 3Kw",
  "bw_param_ctrl_option_S5": "Модель однофазного зберігання енергії 5Kw",
  "bw_param_ctrl_option_S6": "Модель однофазного зберігання енергії 6Kw",
  "bw_param_ctrl_option_S8": "Модель однофазного зберігання енергії 8 кВт",
  "bw_param_ctrl_option_Grid&PV useCT": "Використання КТ для мережі та фотоенергії",
  "bw_param_ctrl_note_MAXFeedintogridpercent": "Співвідношення максимальної потужності подачі до встановленої фотоенергетичної потужності (включаючи всю фотоенергетичну потужність, підключену до фотоенергетичного інвертора та інвертора зберігання енергії)",
  "bw_param_ctrl_option_Grid&PVUseMeter": "Grid&PVuse лічильник",
  "bw_param_ctrl_note_PVCapacityofGridInverter": "Загальна встановлена фотоенергетична потужність, підключена до інвертора зберігання енергії",
  "bw_param_ctrl_option_T10": "Трифазна модель 10 кВт",
  "bw_param_ctrl_name_DispatchReactivepower": "Диспетчерська реактивна потужність",
  "bw_param_ctrl_name_Grid_Regulation": "Регулювання сітки",
  "bw_param_ctrl_option_Enablecharge&dischargeTimePeriodControl": "Увімкнути контроль періоду зарядження та розряду",
  "bw_param_ctrl_name_Timeperiodcontrolflag": "Прапор контролю періоду часу",
  "bw_param_ctrl_note_BatteryReady": "Підключення батареї за замовчуванням є \"з батареєю\". Якщо батарея не підключена (тобто інвертор підключений до фотоелектричного, але не до будь-яких модулів батареї), виберіть \"без батареї\", або пристрій пошукає батарею, яка не присутня, і перейде в режим несправності.",
  "bw_param_ctrl_option_withBattery": "з батареєю",
  "bw_param_ctrl_name_PV_Meter_negate": "PV_Meter_негати",
  "bw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "Тільки увімкнути контроль періоду розряду",
  "bw_param_ctrl_name_EMSReset": "Скінчити Ems",
  "bw_param_ctrl_name_FactoryReset": "Фабричне перезавантаження",
  "bw_param_ctrl_name_DSPReset": "Скінчити Dsp",
  "bw_param_ctrl_group_RemoteReset": "Віддалене відновлення",
  "bw_param_ctrl_option_FactoryReset": "Скінчити",
  "bw_param_ctrl_option_DSPReset": "Скінчити",
  "bw_param_ctrl_option_EMSReset": "Скінчити",
  "bw_param_ctrl_group_BackupBox": "Backup Box",
  "bw_param_ctrl_name_BBPrio_lx1": "Приоритет стратегії L1",
  "bw_param_ctrl_name_BBPrio_lx2": "Приоритет стратегії L2",
  "bw_param_ctrl_name_BBPrio_lx3": "Приоритет стратегії L3",
  "bw_param_ctrl_note_BBSOC_lx3": "SOC пріоритету 3 повинен бути вищим, ніж SOC пріоритету 1 і SOC пріоритету 2.",
  "bw_param_ctrl_note_BBSOC_lx1": "SOC пріоритету 1 повинен бути мінімальним SOC L1, L2 та L3.",
  "bw_param_ctrl_note_BBSOC_lx2": "SOC з пріоритетом 2 повинен бути вищим, ніж SOC з пріоритетом 1.",
  "bw_param_ctrl_option_1": "1",
  "bw_param_ctrl_option_3": "3",
  "bw_param_ctrl_option_2": "2",
  "bw_param_ctrl_name_BBLoadEnable": "Включити резервну скриньку",
  "bw_param_ctrl_name_MeterCTSelect": "Метр КТ Виберіть",
  "bw_param_ctrl_option_GridUse CT&PVUseMeter": "Використання мережі CT、PV використання лічильника",
  "bw_param_ctrl_name_ChargeCutSoc": "Зарядження Cut Soc",
  "bw_param_ctrl_option_HybridMode": "Гібридний режим",
  "bw_param_ctrl_name_PVCapacityStorage": "Зберігання PV потужності",
  "bw_param_ctrl_name_DispatchTime": "Час відправки",
  "bw_param_ctrl_name_DispatchStart": "Початок відправки",
  "bw_param_ctrl_name_UPSreserveenable": "Включити резерв UPS",
  "bw_param_ctrl_option_selfuse": "Самостійне використання",
  "bw_param_ctrl_option_DCMode": "Режим постійного струму",
  "bw_param_ctrl_name_PVCapacityofGridInverter": "ФВ потужність мережевого інвертора",
  "bw_param_ctrl_name_RTC": "RTC",
  "bw_param_ctrl_option_Normal": "Нормальний",
  "bw_param_ctrl_group_SystemInfo": "Інформація про систему",
  "bw_param_ctrl_note_Systemmode": "DC: 1. Ново встановлена фотоелектрична система з гібридним інвертором зберігання енергії, який безпосередньо підключається до фотоелектричних панелей. 2. Система батареї без фотоелектричного інвертора, який безпосередньо підключається до мережі і заряджається тільки з мережі\n\nAC: модернізація фотоелектричної системи, яка включає фотоелектричний інвертор, який підключається до фотоелектричних панелей та мережі. Панелі не можуть безпосередньо підключатися до гібридного інвертора зберігання енергії.\n\nГібридний: Вся система включає в себе фотоелектричний інвертор, який підключається до мережі, і гібридний інвертор зберігання енергії, який підключається безпосередньо до фотоелектричних панелей",
  "bw_param_ctrl_group_GridMeterSettings": "Параметри мережевого лічильника",
  "bw_param_ctrl_option_Forced charging and discharging": "Примусова зарядка та розрядка",
  "bw_param_ctrl_note_ChargeCutSoc": "Верхня межа заряду SOC батареї.",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiod control": "Включити лише керування періодом зарядки",
  "bw_param_ctrl_option_Disable": "Вимкнути",
  "bw_param_ctrl_group_BatterySettings": "Параметри батареї",
  "bw_param_ctrl_name_BatteryReady": "Батарея готова",
  "bw_param_ctrl_option_GridUse Meter&PVUseCT": "Використання мережі Лічильник, використання фотоелектричного струму CT",
  "bw_param_ctrl_name_DispatchSOC": "Відправка SOC",
  "bw_param_ctrl_option_Disable TimePeriodControl": "Виключити керування періодом часу",
  "bw_param_ctrl_option_Enable": "Ввімкнути",
  "bw_param_ctrl_option_TOU": "Умови використання",
  "bw_param_ctrl_name_ChargeTimeSlot1": "Слот часу зарядки 1",
  "bw_param_ctrl_name_ChargeTimeSlot2": "Слот часу зарядки 2",
  "bw_param_ctrl_note_Timeperiodcontrolflag": "Параметри зарядки та розрядки набувають чинності тільки тоді, коли обраний режим \"TOU\".",
  "bw_param_ctrl_group_GridSafetyConfig": "Налаштування безпеки мережі",
  "bw_param_ctrl_group_SystemConfig": "Налаштування системи",
  "bw_param_ctrl_option_ACMode": "Режим змінного струму",
  "bw_param_ctrl_option_Reverse": "Звернутися",
  "bw_param_ctrl_option_NotEnabledChargeSetting": "Функція заряду/розряду не ввімкнена",
  "bw_param_ctrl_group_Charge&DischargeSettings": "Параметри заряду та розряду",
  "bw_param_ctrl_name_DispatchMode": "Режим відправки",
  "bw_param_ctrl_note_GridBreake": "Будь ласка, виберіть відповідно до фактичних специфікацій вимикача на стороні сітки інвертора. Якщо специфікація неправильно заповнена, це може призвести до виконання вимикача.",
  "bw_param_ctrl_note_PVCapacityStorage": "Загальна встановлена фотоенергетична потужність, підключена до фотоенергетичного інвертора",
  "bw_param_ctrl_name_DischargeTimeSlot2": "Слот часу розряду 2",
  "bw_param_ctrl_name_DischargeTimeSlot1": "Слот часу розряду 1",
  "bw_param_ctrl_group_GridDispatch": "Сітка диспетчера",
  "jl_param_ctrl_group_OnOff": "Ввімкнути/вимкнути інвертор",
  "jl_param_ctrl_name_OnOff": "Ввімкнути/вимкнути інвертор",
  "jl_param_ctrl_option_PowerOFF": "Вимкнути",
  "jl_param_ctrl_option_PowerON": "Увімкнути",
  "product.multipleLanguage": "Багатомовні налаштування моделі пристрою",
  "product.multipleLanguageNote": "Багатомовна бібліотека термінів моделі пристрою",
  "product.entryCode": "Код терміну",
  "product.entryValue": "Значення терміну",
  "product.endpoint": "Кінцева точка",
  "product.module": "Модуль",
  "product.tag": "Тег",
  "product.editLanguage": "Редагувати багатомовність",
  "product.addLanguage": "Додати багатомовність",
  "product.maintainInfo": "Інформація про обслуговування",
  "product.statusChangeSuccess": "Статус успішно змінено",
  "product.statusChangeFail": "Не вдалося змінити статус",
  "product.syncIotI18n": "Синхронізувати записи моделі IoT Qingluo",
  "product.confirmSyncIotI18n": "Ви впевнені, що хочете синхронізувати записи моделі IoT Qingluo?",
  "button.sync": "Синхронізувати багатомовний пакет",
  "plant.withdrawDelivery": "Скасувати доставку",
  "plant.deliverUser": "Передати користувачеві",
  "plant.withdrawDeliveryTip": "Після скасування доставки кінцевий користувач не зможе керувати цією станцією. Дійте обережно.",
  "plant.undelivered": "Не доставлено",
  "plant.deliverManage": "Керування доставкою",
  "plant.email_format_error": "Неправильний формат електронної пошти",
  "plant.deliverUserTip": "Примітка: користувачі можуть увійти в Haier Energy за допомогою електронної пошти та через додаток контролювати встановлені вами пристрої.",
  "plant.enterUserAccount": "Введіть обліковий запис користувача",
  "plant.deliverUserTipUnified": "Примітка: користувачі можуть увійти в Haier Energy за номером телефону або електронною поштою та через додаток керувати встановленими пристроями.",
  "plant.placeholderPhoneOrEmail": "Введіть номер телефону або email",
  "plant.phoneOrEmailFormatError": "Введіть коректний номер телефону або email",
  "plant.deliverSuccess": "Доставлено успішно",
  "plant.known": "Зрозуміло",
  "plant.notRegistered": "Не зареєстровано",
  "plant.noPermission": "Ви не маєте прав скасовувати доставку. Це можуть зробити лише суперадміністратор платформи або адміністратор монтажника.",
  "plant.scanQRCode": "Будь ласка, попросіть власника відсканувати QR-код нижче",
  "plant.qrCodeExpireTip": "Після успішного отримання цей код авторизації стане недійсним.",
  "plant.transferMethod": "Спосіб передачі",
  "plant.transferRecord": "Записи передачі",
  "plant.operationTime": "Час операції",
  "plant.operator": "Оператор",
  "plant.transferType": "Тип передачі",
  "plant.userIdentifier": "Ідентифікатор користувача",
  "plant.transferResult": "Результат передачі",
  "plant.totalRecordCount": "Всього {count} записів",
  "device.Yield": "Yield",
  "device.ExistingINV": "Existing INV",
  "sidebar.dictManage": "Управління словником",
  "subtitle.dictData": "Дані словника",
  "dict.dictname": "Мітка словника",
  "dict.dictnameen": "Ключ словника",
  "dict.dictdataname": "Мітка даних",
  "dict.dictdatavalue": "Значення даних",
  "dict.i18nCode": "Код мови",
  "dict.dictsort": "Сортування",
  "dict.addDict": "Додати словник",
  "dict.addDictData": "Додати запис словника",
  "dict.editDict": "Редагувати словник",
  "dict.editDictData": "Редагувати запис словника",
  "device.otaTabTip": "Підказка: після завершення оновлення пристрій тимчасово відключиться. Будь ласка, перезавантажте пристрій.",
  "product.accessPlatform": "Джерело доступу",
  "product.valueFilter": "Порожнє значення терміну",
  "setting.type22.restrictCounterCurrent.val1": "Обмежити загальну потужність трифазного струму",
  "setting.type22.restrictCounterCurrent.val2": "Обмежити потужність однофазного струму",
  "setting.type22.disable": "Вимкнути",
  "setting.type22.enable": "Увімкнути",
  "setting.type22.meterSelect.str": "Лічильник Stonray",
  "setting.type22.meterSelect.df": "Лічильник Dongfan",
  "setting.type22.meterSelect.dh": "Лічильник Donghong",
  "setting.type22.meterSelect.zt": "Лічильник Chint",
  "setting.type22.meterSelect.yb": "Yeebon",
  "setting.type22.meterSelect.yz": "Ingeteam",
  "setting.type22.meterSelect.nky": "Розумний лічильник Nengkongyun",
  "workorder.searchCreateTime": "Час створення",
  "workorder.statusAll": "Всі",
  "workorder.statusPending": "Очікуючі",
  "workorder.statusCompleted": "Виконані",
  "workorder.statusClosed": "Закриті",
  "workorder.no": "Номер робочого замовлення",
  "workorder.tableDescription": "Опис",
  "workorder.plant": "Завод",
  "workorder.device": "Пристрій",
  "workorder.tableStatus": "Статус",
  "workorder.owner": "Відповідальна особа",
  "workorder.handler": "Виконавець",
  "workorder.handledTime": "Час обробки",
  "workorder.creator": "Створювач",
  "workorder.createTime": "Час створення",
  "workorder.timeTooltip": "Час у часовому поясі заводу",
  "workorder.tableAction": "Дія",
  "workorder.actionDetails": "Деталі",
  "workorder.actionHandle": "Обробити",
  "workorder.actionCancel": "Скасувати",
  "workorder.createTitle": "Створити робоче замовлення",
  "workorder.description": "Опис несправності",
  "workorder.images": "Зображення несправності",
  "workorder.handleTitle": "Обробити робоче замовлення",
  "workorder.group": "Інформація про обробку",
  "workorder.feedback": "Зворотний зв'язок щодо обробки",
  "workorder.handleimages": "Зображення процесу обробки",
  "workorder.detailsTitle": "Деталі робочого замовлення",
  "workorder.detailsGroup": "Інформація про робоче замовлення",
  "workorder.uploadSuccess": "Успішно завантажено",
  "workorder.uploadNums": "Дозволено максимум 3 зображення",
  "workorder.uploadFormatTip": "Недійсний формат файлу. Завантажте файли у форматах JPG, JPEG або PNG",
  "workorder.uploadFormat": "Завантажуйте файли розміром не більше 5 МБ у форматах PNG/JPG/JPEG",
  "workorder.uploadImage": "Завантажити",
  "workorder.cancelTip": "Скасування цього робочого замовлення автоматично закриє його. Продовжити?",
  "workorder.basicInformation": "Базова інформація",
  "common.networkUnstable": "З’єднання з мережею втрачено, перевірте налаштування мережі",
  "common.networkFull": "Інтернет знову повний, як сонце",
  "common.networkSlow": "Поточна мережа повільна, зачекайте терпляче або перевірте налаштування мережі",
  "common.requestTimeout": "Час очікування запиту минув, перевірте мережу або повторіть спробу пізніше",
  "priceConfig.currentEffectivePrice": "Поточний діючий тариф",
  "priceConfig.currencyUnitLabel": "Валюта:",
  "priceConfig.addPrice": "Додати тариф",
  "priceConfig.effectiveTimeLabel": "Період дії",
  "priceConfig.powerPrice": "Тариф на енергію",
  "priceConfig.additionalFees": "Додаткові збори",
  "priceConfig.lastUpdateTime": "Останнє оновлення",
  "priceConfig.lastUpdateTimeLabel": "Останнє оновлення",
  "priceConfig.emptyCurrent": "Немає діючого тарифу. Натисніть кнопку, щоб налаштувати.",
  "priceConfig.emptyUpcoming": "Немає майбутніх тарифів",
  "priceConfig.upcomingTitle": "Майбутній тариф",
  "priceConfig.copyPriceTitle": "Копіювати тариф",
  "priceConfig.deletePriceTitle": "Видалити тариф",
  "priceConfig.deleteConfirmText": "Підтвердіть видалення наведеного нижче тарифу",
  "priceConfig.otherPrice": "Інші збори",
  "priceConfig.deleteWarning": "Якщо цей тариф зараз діє, це вплине на розрахунок доходу та виконання AI-стратегії.",
  "priceConfig.priceTypeLabel": "Тип тарифу",
  "priceConfig.timeOfUse": "Погодинний",
  "priceConfig.dynamic": "Динамічний",
  "priceConfig.timeOfUsePrice": "Погодинний тариф",
  "priceConfig.dynamicPrice": "Динамічний тариф",
  "priceConfig.effectiveDatePlaceholder": "Виберіть дату початку дії",
  "priceConfig.copyEffectiveDatePlaceholder": "Виберіть дату початку дії",
  "priceConfig.nextStep": "Далі",
  "priceConfig.buyPriceTitle": "Тариф на купівлю",
  "priceConfig.feedInPriceTitle": "Тариф на відпуск в мережу",
  "priceConfig.addTimePeriod": "Додати інтервал",
  "priceConfig.electricitySurchargeTitle": "Надбавка за енергію",
  "priceConfig.electricitySurchargeTooltip": "Додаткова плата за кожну придбану кВт·год.",
  "priceConfig.fixedFeeTitle": "Фіксована плата",
  "priceConfig.fixedFeeTooltip": "Фіксований базовий платіж за розрахунковий період, який не залежить від споживання чи потужності.",
  "priceConfig.hasFeeYes": "Так",
  "priceConfig.countryLabel": "Країна",
  "priceConfig.secondaryRegionLabel": "Регіон (2 рівень)",
  "priceConfig.secondaryRegionPlaceholder": "Виберіть регіон (2 рівень)",
  "priceConfig.currencyUnitPlaceholder": "Виберіть валюту",
  "priceConfig.powerMarketLabel": "Енергоринок",
  "priceConfig.powerMarketPlaceholder": "Виберіть енергоринок",
  "priceConfig.electricitySurchargePlaceholder": "До 7 цифр цілої частини, 8 знаків після коми, ≥ 0",
  "priceConfig.fixedFeePlaceholder": "До 7 цифр цілої частини, 8 знаків після коми, ≥ 0",
  "priceConfig.priceInputPlaceholder": "Введіть ціну електроенергії (до 7 цифр цілої частини, 8 знаків після коми, ≥ 0)",
  "priceConfig.timePlaceholder": "Оберіть час",
  "priceConfig.selectEffectiveTimeTip": "Виберіть період дії",
  "priceConfig.selectPriceTypeTip": "Виберіть тип тарифу",
  "priceConfig.selectCountryTip": "Виберіть країну",
  "priceConfig.selectSecondaryRegionTip": "Виберіть регіон (2 рівень)",
  "priceConfig.selectCurrencyUnitTip": "Виберіть валюту",
  "priceConfig.selectPowerMarketTip": "Виберіть енергоринок",
  "priceConfig.electricitySurchargeInputTip": "Введіть надбавку за енергію (до 7 цифр цілої частини, 8 знаків після коми, ≥ 0)",
  "priceConfig.electricitySurchargeRangeTip": "Надбавка за енергію: не більше 7 цифр у цілій частині, 8 знаків після коми, ≥ 0",
  "priceConfig.fixedFeeInputTip": "Введіть фіксовану плату (до 7 цифр цілої частини, 8 знаків після коми, ≥ 0)",
  "priceConfig.fixedFeeRangeTip": "Фіксована плата: не більше 7 цифр у цілій частині, 8 знаків після коми, ≥ 0",
  "priceConfig.buyTimeFullDayTip": "Інтервали тарифу на купівлю мають покривати 24 години",
  "priceConfig.feedInTimeFullDayTip": "Інтервали тарифу на відпуск в мережу мають покривати 24 години",
  "priceConfig.buyTimeNoOverlapTip": "Інтервали тарифу на купівлю не можуть перетинатися",
  "priceConfig.feedInTimeNoOverlapTip": "Інтервали тарифу на відпуск в мережу не можуть перетинатися",
  "priceConfig.loadFail": "Не вдалося завантажити дані тарифу",
  "priceConfig.copySelectPriceTip": "Тариф не вибрано, копіювання неможливе",
  "priceConfig.copyMissingPlantTip": "Відсутня інформація про станцію, неможливо копіювати тариф",
  "priceConfig.copySuccess": "Успішно скопійовано",
  "priceConfig.copyFail": "Не вдалося скопіювати",
  "priceConfig.networkTimeout": "Таймаут сети. Повторіть спробу після відновлення з'єднання.",
  "priceConfig.copyUnsupportedTip": "Копіювання цього типу тарифу не підтримується",
  "priceConfig.deleteSelectPriceTip": "Тариф не вибрано",
  "priceConfig.deleteIdMissingTip": "Не вдалося отримати ідентифікатор тарифу, видалення не вдалося",
  "priceConfig.deleteSuccess": "Успішно видалено",
  "priceConfig.deleteFail": "Не вдалося видалити",
  "priceConfig.missingPlantInfoTip": "Відсутня інформація про станцію",
  "priceConfig.confirmGiveUpCreateTip": "Дійсно скасувати створення цього тарифу?",
  "priceConfig.confirmGiveUpEditTip": "Дійсно скасувати редагування цього тарифу?",
  "priceConfig.pageTitleAdd": "Створити тариф",
  "priceConfig.pageTitleEdit": "Редагувати тариф",
  "priceConfig.pageTitleView": "Переглянути тариф",
  "priceConfig.createSuccess": "Успішно створено",
  "priceConfig.editSuccess": "Успішно відредаговано",
  "priceConfig.saveFail": "Не вдалося зберегти",
  "priceConfig.dateRangePermanent": "{start} — безстроково",
  "priceConfig.dateRange": "{start} — {end}",
  "priceConfig.routeTitle": "Тариф на електроенергію",
  "priceConfig.priceLabel": "Тариф",
  "priceConfig.surchargeLabel": "Націнка",
  "priceConfig.fixedFeeLabel": "Фіксована плата",
  "button.copy": "Копіювати",
  "common.view": "Переглянути",
  "screen.platform": "Платформа управління енергією",
  "plantScreen.title": "Управління станцією",
  "plantScreen.DailyElectricityGenerated": "Щоденна вироблена електроенергія",
  "plantScreen.DailyElectricityUsed": "Щоденна спожита електроенергія",
  "plantScreen.DailyElectricityPurchased": "Щоденна куплена електроенергія",
  "plantScreen.DailyElectricitySold": "Щоденна продана електроенергія",
  "plantScreen.ChargingStatus": "Статус зарядки",
  "plantScreen.BatteryLevel": "Рівень заряду акумулятора",
  "plantScreen.PhotovoltaicStatus": "Статус фотоелектрики",
  "plantScreen.GridStatus": "Статус мережі",
  "plantScreen.Charging": "Заряджання",
  "plantScreen.Discharging": "Розряджання",
  "plantScreen.Generating": "Вироблення",
  "plantScreen.Idle": "Без дії",
  "plantScreen.pvIDLE": "Не виробляє",
  "plantScreen.BuyingElectricity": "Купівля електроенергії",
  "plantScreen.SellingElectricity": "Продаж електроенергії",
  "plantScreen.netdead": "Автономний режим",
  "plantScreen.day": "День",
  "plantScreen.month": "Місяць",
  "plantScreen.year": "Рік",
  "plantScreen.life": "Накопичено",
  "plantScreen.BatterySOC": "SOC акумулятора",
  "plantScreen.PowerAnalysis": "Аналіз потужності",
  "plantScreen.EquivalentRevenue": "Еквівалентний дохід",
  "plantScreen.EnergyAnalysis": "Аналіз енергії",
  "plantScreen.SocialContribution": "Суспільний внесок",
  "plantScreen.Photovoltaic": "Фотоелектрика",
  "plantScreen.Grid": "Мережа",
  "plantScreen.Battery": "Акумулятор",
  "plantScreen.Load": "Навантаження",
  "plantScreen.Daily": "Щоденно",
  "plantScreen.Monthly": "Щомісяця",
  "plantScreen.Yearly": "Щороку",
  "plantScreen.Cumulative": "Накопичений",
  "plantScreen.Unit": "Одиниця",
  "plantScreen.ElectricityGeneration": "Виробництво електроенергії",
  "plantScreen.ElectricityConsumption": "Споживання електроенергії",
  "plantScreen.ChartSet.explain": "Примітка: Потужність > 0 = Розряд; Потужність < 0 = Заряд.",
  "plantScreen.ChartSet.Self-consumption": "Самоспоживання",
  "plantScreen.ChartSet.GridElectricity": "Експорт в мережу",
  "plantScreen.ChartSet.Self-Sufficiency": "Самодостатність",
  "plantScreen.ChartSet.PurchasedElectricity": "Куплена електроенергія",
  "plantScreen.ChartSet.PVPower": "Потужність фотоелектрики",
  "plantScreen.ChartSet.ConsumptionPower": "Споживана потужність",
  "plantScreen.ChartSet.BatterySOC": "SOC акумулятора",
  "plantScreen.ChartSet.BatteryChargingPower": "Потужність заряджання акумулятора",
  "plantScreen.ChartSet.BatteryDischargingPower": "Потужність розряджання акумулятора",
  "plantScreen.ProtectedForest": "Захищений ліс",
  "plantScreen.CO2Emission": "Викиди CO2",
  "plantScreen.Media": "Вугілля",
  "plant.EquivalentBenefit.GridView": "Еквівалентний дохід = Самоспоживання * Тариф купівлі + Експорт в мережу * Тариф продажу",
  "plant.MonitoringScreen": "Моніторний екран",
  "plantScreen.ChartSet.explainPower": "Примітка: Потужність мережі > 0 = Продаж електроенергії; Потужність мережі < 0 = Купівля електроенергії.",
  "cookie.necessary": "Строго необхідні файли cookie",
  "cookie.performance": "Продуктивність файлів cookie",
  "cookie.functional": "Функціональні файли cookie",
  "cookie.targeting": "Таргетовані файли cookie",
  "cookie.necessaryExplain": "Ці файли cookie суворо необхідні для функціонування веб-сайту і не можуть бути вимкнені в наших системах. Вони зазвичай встановлюються лише у відповідь на ваші дії, які є запитом на послуги, наприклад, встановлення налаштувань конфіденційності, вхід в систему або заповнення форм. Ви можете налаштувати свій браузер на блокування або сповіщення про ці файли cookie, але тоді деякі частини сайту можуть не працювати. Ці файли cookie не зберігають жодної особистої інформації.",
  "cookie.performanceExplain": "Ці файли cookie дозволяють нам підраховувати відвідування та джерела трафіку, щоб ми могли оцінювати та покращувати продуктивність нашого сайту. Вони допомагають нам дізнатися, які сторінки є найбільш та найменш популярними, і побачити, як відвідувачі переміщуються сайтом. Уся інформація, яку збирають ці файли cookie, є агрегованою, а отже, анонімною. Якщо ви не дозволите ці файли cookie, ми не знатимемо, коли ви відвідали наш сайт, і не зможемо відстежувати його продуктивність.",
  "cookie.functionalExplain": "Ці файли cookie дозволяють веб-сайту забезпечувати розширену функціональність та персоналізацію. Вони можуть встановлюватися нами або сторонніми постачальниками послуг, які ми додали на наші сторінки. Якщо ви не дозволите ці файли cookie, деякі або всі ці послуги можуть працювати неправильно.",
  "cookie.targetingExplain": "Ці файли cookie можуть встановлюватися на нашому сайті нашими рекламними партнерами. Вони можуть використовуватися цими компаніями для створення профілю ваших інтересів та показу вам відповідної реклами на інших сайтах. Вони не зберігають безпосередньо особисту інформацію, а базуються на унікальній ідентифікації вашого браузера та інтернет-пристрою. Якщо ви не дозволите ці файли cookie, ви отримуватимете менше цільової реклами.",
  "cookie.necessaryAccount": "Ідентифікаційна верифікація",
  "cookie.necessaryAccountExplain": "Використовується для підтримки статусу входу користувача, це основна функція автентифікації веб-сайту та керування сеансами. Без цього файлу cookie облікові записи користувачів можуть відображатися неправильно на відвідуваних сторінках.",
  "cookie.sessionManagement": "Керування сеансами",
  "cookie.sessionManagementExplain": "Використовується для унікальної ідентифікації сеансів користувача, підтримуючи такі ключові функції, як статус входу користувача, вміст кошика для покупок та дані форм.",
  "cookie.userInfo": "Інформація про користувача",
  "cookie.userInfoExplain": "Використовується для відстеження бізнес-показників, таких як перегляди сторінок (PV) та унікальні відвідувачі (UV), аналізу системного трафіку та залучення користувачів, щоб оптимізувати пріоритетність функцій та відповідність основним потребам.",
  "cookie.deviceInfo": "Інформація про пристрій",
  "cookie.deviceInfoExplain": "На основі різних операційних систем, моделей пристроїв та типів браузерів вирішує проблеми макету та сумісності на різних пристроях, оптимізуючи функції адаптації для різних пристроїв.",
  "cookie.pageInfo": "Інформація про сторінку",
  "cookie.pageInfoExplain": "Записує шляхи доступу до сторінок, API-запити та час завантаження ресурсів для виявлення вузьких місць продуктивності, збоїв запитів та помилок коду, допомагаючи команді розробників швидко вирішувати проблеми.",
  "cookie.networkInfo": "Мережева інформація",
  "cookie.networkInfoExplain": "Аналізує географічне розташування та мережі інтернет-провайдерів (ISP) для виявлення шкідливого доступу та аномального трафіку, оптимізуючи ефективність доставки контенту для постачальників хмарних послуг.",
  "cookie.userPreference": "Налаштування інтерфейсу",
  "cookie.userPreferenceExplain": "Використовується лише для запису налаштувань інтерфейсу користувача для покращення досвіду користувача, це не основна функція, необхідна для роботи веб-сайту.",
  "cookie.longTerm": "Довгостроковий",
  "cookie.duration180": "180 днів",
  "cookie.durationSession": "Сеанс",
  "cookie.bannerExplain": "Щоб оптимізувати ваш досвід перегляду, ми використовуємо файли cookie в основному для запису статусу входу, запам'ятовування ваших налаштувань та адаптації до ваших звичок перегляду. Натискаючи 'Прийняти все', ви погоджуєтеся з нашою Політикою використання файлів cookie.",
  "cookie.acceptNecessary": "Тільки необхідні",
  "cookie.openPreferences": "Налаштування",
  "cookie.acceptAll": "Прийняти все",
  "cookie.cookieSet": "Налаштування файлів cookie",
  "cookie.cookieSetExplain": "Для отримання додаткової інформації див.",
  "cookie.cookiePolicy": "Політика використання файлів cookie",
  "cookie.cookieCategory": "Категорія файлів cookie",
  "cookie.cookieName": "Назва файлу cookie",
  "cookie.cookieDescription": "Призначення",
  "cookie.cookieDuration": "Термін дії",
  "cookie.cookieSwitch": "Перемикач",
  "cookie.savePreferences": "Зберегти налаштування",
  "cookie.preferencesTitle": "Налаштування файлів cookie",
  "cookie.cookiePolicyText": "Політика файлів cookie",
  "common.currentVersion": "Поточна версія",
  "common.versionUpdateNotice": "Увага! Є нова версія програми. Бажаєте оновити?",
  "common.later": "Пізніше",
  "common.immediateUpdate": "Оновити зараз",
  "sidebar.policyConfig": "Налаштування політики",
  "common.addScope": "Додати {scope}",
  "editor.header.title": "Заголовок",
  "editor.header.text": "Абзац",
  "editor.fontSize.title": "Розмір шрифту",
  "editor.fontSize.default": "Розмір шрифту за замовчуванням",
  "editor.fontFamily.title": "Шрифт",
  "editor.fontFamily.default": "Шрифт за замовчуванням",
  "editor.bold": "Жирний",
  "editor.italic": "Курсив",
  "editor.underline": "Підкреслений",
  "editor.through": "Закреслений",
  "editor.code": "Вбудований код",
  "editor.sub": "Індекс унизу",
  "editor.sup": "Індекс зверху",
  "editor.clearStyle": "Очистити форматування",
  "editor.color.color": "Колір тексту",
  "editor.color.bgColor": "Колір фону",
  "editor.color.default": "Колір за замовчуванням",
  "editor.color.clear": "Очистити колір",
  "editor.bulletedList": "Маркований список",
  "editor.numberedList": "Нумерований список",
  "editor.todo": "Список завдань",
  "editor.todo.title": "Завдання",
  "editor.emotion.title": "Емодзі",
  "editor.justifyLeft": "Вирівняти по лівому краю",
  "editor.justifyRight": "Вирівняти по правому краю",
  "editor.justifyCenter": "Вирівняти по центру",
  "editor.justifyJustify": "По ширині",
  "editor.indent": "Збільшити відступ",
  "editor.delIndent": "Зменшити відступ",
  "editor.lineHeight.title": "Міжрядковий інтервал",
  "editor.lineHeight.default": "Міжрядковий інтервал за замовчуванням",
  "editor.blockquote": "Цитата",
  "editor.link.insert": "Вставити посилання",
  "editor.link.text": "Текст посилання",
  "editor.link.url": "URL посилання",
  "editor.link.unLink": "Видалити посилання",
  "editor.link.edit": "Редагувати посилання",
  "editor.link.view": "Переглянути посилання",
  "editor.image.netImage": "Вебзображення",
  "editor.image.delete": "Видалити зображення",
  "editor.image.edit": "Редагувати зображення",
  "editor.image.viewLink": "Переглянути посилання",
  "editor.image.src": "URL зображення",
  "editor.image.desc": "Опис зображення",
  "editor.image.link": "Посилання на зображення",
  "editor.video.insert": "Вставити відео",
  "editor.video.delete": "Видалити відео",
  "editor.video.uploadVideo": "Завантажити відео",
  "editor.video.insertVideo": "Вставити відео",
  "editor.video.videoSrc": "URL відео",
  "editor.video.videoSrcPlaceHolder": "Будь ласка, введіть URL відео",
  "editor.video.videoPoster": "Обкладинка відео",
  "editor.video.videoPosterPlaceHolder": "Будь ласка, введіть URL обкладинки",
  "editor.video.ok": "Гаразд",
  "editor.video.editSize": "Змінити розмір",
  "editor.video.width": "Ширина",
  "editor.video.height": "Висота",
  "editor.table.header": "Таблиця",
  "editor.table.insertTable": "Вставити таблицю",
  "editor.table.deleteTable": "Видалити таблицю",
  "editor.table.insertRow": "Вставити рядок",
  "editor.table.deleteRow": "Видалити рядок",
  "editor.table.insertCol": "Вставити стовпець",
  "editor.table.deleteCol": "Видалити стовпець",
  "editor.table.widthAuto": "Автоширина",
  "editor.table.widthFixed": "Фіксована ширина",
  "editor.codeBlock.title": "Блок коду",
  "editor.divider": "Лінія розділення",
  "editor.emotion": "Емодзі",
  "editor.insertFormula": "Вставити формулу",
  "editor.fullScreen": "На весь екран",
  "editor.undo": "Скасувати",
  "editor.redo": "Повторити",
  "editor.delete": "Видалити",
  "editor.enter": "Ввід",
  "editor.ok": "Гаразд",
  "editor.cancel": "Скасувати",
  "editor.uploadImgMaxSize": "Макс. розмір зображення",
  "editor.uploadImgMaxSizeErr": "Розмір зображення перевищує ліміт",
  "editor.uploadImgMaxLength": "Макс. кількість зображень",
  "editor.uploadImgMaxLengthErr": "Кількість зображень перевищує ліміт",
  "editor.uploadVideoMaxSize": "Макс. розмір відео",
  "editor.uploadVideoMaxSizeErr": "Розмір відео перевищує ліміт",
  "editor.placeholder": "Будь ласка, введіть вміст...",
  "UserHome.plantFlow.load": "Навантаження",
  "UserHome.plantFlow.grid": "Мережа",
  "UserHome.plantFlow.battery": "Акумулятор",
  "UserHome.plantFlow.pv": "PV",
  "plant.running.status.alarm": "Повідомлення",
  "end.web": "веб",
  "test.label_G_P_C_L2": "генерації L2 Power",
  "device.offline": "Пристрій офлайн",
  "solid.snake.msf.test": "",
  "bigboss.shaed.test": "",
  "ywt.60419.AllowCounterCurrentPower": "Potenza di ritorno consentita",
  "ywt.60419.internalharderror0": "Немає аномалій",
  "ywt.60419.loadDropMode": "Режим зниження навантаження",
  "ywt.60419.loadDropMode11": "Dérating anti-retour de puissance pour machine unique",
  "ywt.60419.meterCommQuality": "Kommunikationsqualität des Stromzählers",
  "ywt.60419.meterRPower": "Leistung des Stromzählers Phase R",
  "ywt.60419.meterSelect": "Selezione del contatore elettrico",
  "ywt.60419.meterSPower": "Leistung des Stromzählers Phase S",
  "ywt.60419.meterTPower": "Потужність фази T лічильника",
  "ywt.60419.multiReverseFlowEnable": "Abilitazione della protezione contro il ritorno per più dispositivi",
  "ywt.60419.restrictCounterCurrent": "Modalità di limitazione del ritorno",
  "ywt.60419.singleReverseFlowEnable": "Abilitazione della protezione contro il ritorno per un solo dispositivo",
  "bw_param_ctrl_group_ParallelSetting": "Паралельні налаштування",
  "bw_param_ctrl_group_SpecialSetting": "Спеціальні налаштування",
  "bw_param_ctrl_name_PhaseOrderResume": "Відновлення порядку фаз",
  "bw_param_ctrl_note_ParallelModeSetting": "Встановити, чи є інвертор ведучим чи підлеглим пристроєм у паралельній роботі.",
  "bw_param_ctrl_option_host": "Ведучий у паралельному режимі",
  "bw_param_ctrl_option_PhaseOrderResume": "Скинути",
  "bw_param_ctrl_option_single": "Не паралельний режим (Одиночний режим)",
  "bw_param_ctrl_option_Slave": "Ведений у паралельному режимі",
  "0X3809-F-0607": "Несправність захисту від перегріву клем PV",
  "0X3809-F-1103": "Аномалія самоперевірки реле",
  "0X3809-F-3112": "Несправність фазової синхронізації напруги мережі",
  "0X3809-F-3113": "Аномалія чергування фаз мережі",
  "0X3809-S-0101": "1. Перевірте, чи з'єднання фотоелектричних модулів справні, чи модулі пошкоджені, мають пил на поверхні або загородження.\n2. Перевірте, чи правильно підключені фотоелектричні модулі, чи їхні характеристики напруги вищі за робочий діапазон напруги інвертора.\n3. Перевірте, чи є коротке замикання у фотоелектричних модулях.",
  "0X3809-S-0102": "1. Перевірте, чи з'єднання фотоелектричних модулів справні, чи модулі пошкоджені, мають пил на поверхні або загородження.\n2. Перевірте, чи правильно підключені фотоелектричні модулі, чи їхні характеристики напруги вищі за робочий діапазон напруги інвертора.\n3. Перевірте, чи є коротке замикання у фотоелектричних модулях.",
  "0X3809-S-0103": "1. Перевірте, чи з'єднання фотоелектричних модулів справні, чи модулі пошкоджені, мають пил на поверхні або загородження.\n2. Перевірте, чи правильно підключені фотоелектричні модулі, чи їхні характеристики напруги вищі за робочий діапазон напруги інвертора.\n3. Перевірте, чи є коротке замикання у фотоелектричних модулях.",
  "0X3809-S-0301": "1. Часто виникає рано вранці; будь ласка, перевірте чистоту поверхні фотоелектричної панелі.\n2. Перевірте, чи правильно підключені фотоелектричні панелі, і чи перевищують їхні характеристики напруги робочий діапазон напруги інвертора.\n3. Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0302": "1. Часто виникає рано вранці; будь ласка, перевірте чистоту поверхні фотоелектричної панелі.\n2. Перевірте, чи правильно підключені фотоелектричні панелі, і чи перевищують їхні характеристики напруги робочий діапазон напруги інвертора.\n3. Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0303": "1. Часто виникає рано вранці; будь ласка, перевірте чистоту поверхні фотоелектричної панелі.\n2. Перевірте, чи правильно підключені фотоелектричні панелі, і чи перевищують їхні характеристики напруги робочий діапазон напруги інвертора.\n3. Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0304": "1. Часто виникає рано вранці; будь ласка, перевірте чистоту поверхні фотоелектричної панелі.\n2. Перевірте, чи правильно підключені фотоелектричні панелі, і чи перевищують їхні характеристики напруги робочий діапазон напруги інвертора.\n3. Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0501": "Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0502": "Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0503": "Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0504": "Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0505": "Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0506": "Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0507": "Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0508": "Будь ласка, перезавантажте інвертор. Якщо несправність не зникне, зверніться до свого дилера.",
  "0X3809-S-0601": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи не заблокований повітряний канал радіатора\n3. Перезавантажте інвертор після охолодження. Якщо відновлення не відбувається, зверніться до дилера",
  "0X3809-S-0602": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи не заблокований повітряний канал радіатора\n3. Перезавантажте інвертор після охолодження. Якщо відновлення не відбувається, зверніться до дилера",
  "0X3809-S-0603": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи не заблокований повітряний канал радіатора\n3. Перезавантажте інвертор після охолодження. Якщо відновлення не відбувається, зверніться до дилера",
  "0X3809-S-0604": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи не заблокований повітряний канал радіатора\n3. Перезавантажте інвертор після охолодження. Якщо відновлення не відбувається, зверніться до дилера",
  "0X3809-S-0605": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи не заблокований повітряний канал радіатора\n3. Перезавантажте інвертор після охолодження. Якщо відновлення не відбувається, зверніться до дилера",
  "0X3809-S-0606": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи не заблокований повітряний канал радіатора\n3. Перезавантажте інвертор після охолодження. Якщо відновлення не відбувається, зверніться до дилера",
  "0X3809-S-0607": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи не заблокований повітряний канал радіатора\n3. Перезавантажте інвертор після охолодження. Якщо відновлення не відбувається, зверніться до дилера",
  "0X3809-S-0701": "1. Перевірте, чи є замикання на землю в модулі.\n2. Перевірте наявність ненадійних з'єднань у ланцюзі постійного струму.\n3. Якщо проблем у ланцюзі постійного струму не виявлено, вимкніть живлення на 5 хвилин, а потім відновіть його. Якщо проблема не зникає, зверніться до дилера.",
  "0X3809-S-0801": "1. Несправність схеми керування.\n2. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера.",
  "0X3809-S-0901": "1. Несправність плати управління\n2. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера",
  "0X3809-S-0902": "1. Несправність плати управління\n2. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера",
  "0X3809-S-0903": "1. Несправність плати управління\n2. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера",
  "0X3809-S-0904": "1. Несправність плати управління\n2. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера",
  "0X3809-S-0905": "1. Несправність плати управління\n2. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера",
  "0X3809-S-0906": "1. Несправність плати управління\n2. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера",
  "0X3809-S-0907": "1. Несправність плати управління\n2. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера",
  "0X3809-S-1001": "1. Якщо це трапляється випадково, це може бути спричинено випадковими аномаліями зовнішньої лінії. Перезавантаження інвертора відновить нормальну роботу.\n2. Якщо це відбувається часто або не може бути відновлено протягом тривалого часу, перевірте, чи надійне заземлення фотоелектричної струнки.",
  "0X3809-S-1002": "1. Якщо це трапляється випадково, це може бути спричинено випадковими аномаліями зовнішньої лінії. Перезавантаження інвертора відновить нормальну роботу.\n2. Якщо це відбувається часто або не може бути відновлено протягом тривалого часу, перевірте, чи надійне заземлення фотоелектричної струнки.",
  "0X3809-S-1003": "1. Якщо це трапляється випадково, це може бути спричинено випадковими аномаліями зовнішньої лінії. Перезавантаження інвертора відновить нормальну роботу.\n2. Якщо це відбувається часто або не може бути відновлено протягом тривалого часу, перевірте, чи надійне заземлення фотоелектричної струнки.",
  "0X3809-S-1004": "1. Якщо це трапляється випадково, це може бути спричинено випадковими аномаліями зовнішньої лінії. Перезавантаження інвертора відновить нормальну роботу.\n2. Якщо це відбувається часто або не може бути відновлено протягом тривалого часу, перевірте, чи надійне заземлення фотоелектричної струнки.",
  "0X3809-S-1101": "1. Перевірте, чи знаходиться заземлювальний провід змінного струму під напругою.\n2. Внутрішня несправність реле.\n3. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера.",
  "0X3809-S-1102": "1. Перевірте, чи знаходиться заземлювальний провід змінного струму під напругою.\n2. Внутрішня несправність реле.\n3. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера.",
  "0X3809-S-1103": "1. Перевірте, чи знаходиться заземлювальний провід змінного струму під напругою.\n2. Внутрішня несправність реле.\n3. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера.",
  "0X3809-S-1201": "1. Внутрішній вентилятор пошкоджений\n2. Несправність схеми виявлення вентилятора\n3. Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера",
  "0X3809-S-1901": "Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера.",
  "0X3809-S-1902": "Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера.",
  "0X3809-S-1903": "Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера.",
  "0X3809-S-1904": "Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера.",
  "0X3809-S-1905": "Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера.",
  "0X3809-S-1906": "Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера.",
  "0X3809-S-1907": "Вимкніть живлення та перезавантажте інвертор. Якщо відновлення неможливе, зверніться до дилера.",
  "0X3809-S-3101": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3102": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3103": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3104": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3105": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3106": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3107": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3108": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3109": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3110": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3111": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3112": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3113": "1. Перевірте, чи вимкнувся автоматичний вимикач у розподільчій коробці.\n2. Виміряйте, чи перевищує фактична напруга діапазон інвертора.\n3. Якщо напруга виходить за межі діапазону, ви можете налаштувати значення захисту від перенапруги та недостатньої напруги інвертора.",
  "0X3809-S-3301": "1. Перевірте наявність ненадійних з'єднань в електричній мережі.\n2. Налаштуйте діапазон частоти відповідним чином.",
  "0X3809-S-3302": "1. Перевірте наявність ненадійних з'єднань в електричній мережі.\n2. Налаштуйте діапазон частоти відповідним чином.",
  "0X3809-S-3303": "1. Перевірте наявність ненадійних з'єднань в електричній мережі.\n2. Налаштуйте діапазон частоти відповідним чином.",
  "0X3809-S-3304": "1. Перевірте наявність ненадійних з'єднань в електричній мережі.\n2. Налаштуйте діапазон частоти відповідним чином.",
  "0X3809-S-3305": "1. Перевірте наявність ненадійних з'єднань в електричній мережі.\n2. Налаштуйте діапазон частоти відповідним чином.",
  "0X3809-S-3306": "1. Перевірте наявність ненадійних з'єднань в електричній мережі.\n2. Налаштуйте діапазон частоти відповідним чином.",
  "0X3809-S-3701": "Перевірте, чи не було інвертор вимкнено вручну.",
  "0X3809-S-3801": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3802": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3803": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3804": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3805": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3806": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3807": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3808": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3809": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3810": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3811": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3812": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3813": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3814": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3815": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3816": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3817": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3818": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3819": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3820": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3901": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3902": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3903": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3904": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3905": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3906": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3907": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3908": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3909": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3910": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3911": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3912": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3913": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3914": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3915": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3916": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3917": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3918": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3919": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-3920": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-4101": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-4201": "Перевірити, чи є аномальна напруга N-PE",
  "0X3809-S-4301": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3809-S-4401": "Будь ласка, вимкніть інвертор та від’єднайте вхідні/вихідні вимикачі. Перезавантажте інвертор через 5 хвилин. Якщо несправність не усунута, зверніться до дилера.",
  "0X3807-F-02": "Сигнал про коротке замикання PV2",
  "0X3807-F-03": "Сигнал про низьку напругу PV",
  "0X3807-S-0101": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи обертається вентилятор нормально\n3. Перезавантажте інвертор; якщо відновлення неможливе, замініть вентилятор",
  "0X3807-S-0102": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи обертається вентилятор нормально\n3. Перезавантажте інвертор; якщо відновлення неможливе, замініть вентилятор",
  "0X3807-S-0103": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи обертається вентилятор нормально\n3. Перезавантажте інвертор; якщо відновлення неможливе, замініть вентилятор",
  "0X3807-S-0104": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи обертається вентилятор нормально\n3. Перезавантажте інвертор; якщо відновлення неможливе, замініть вентилятор",
  "0X3807-S-0105": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи обертається вентилятор нормально\n3. Перезавантажте інвертор; якщо відновлення неможливе, замініть вентилятор",
  "0X3807-S-0106": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи обертається вентилятор нормально\n3. Перезавантажте інвертор; якщо відновлення неможливе, замініть вентилятор",
  "0X3807-S-0107": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи обертається вентилятор нормально\n3. Перезавантажте інвертор; якщо відновлення неможливе, замініть вентилятор",
  "0X3807-S-0108": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи обертається вентилятор нормально\n3. Перезавантажте інвертор; якщо відновлення неможливе, замініть вентилятор",
  "0X3807-S-0109": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи обертається вентилятор нормально\n3. Перезавантажте інвертор; якщо відновлення неможливе, замініть вентилятор",
  "0X3807-S-0110": "1. Перевірте, чи не заблокований вентилятор сторонніми предметами\n2. Перевірте, чи обертається вентилятор нормально\n3. Перезавантажте інвертор; якщо відновлення неможливе, замініть вентилятор",
  "0X3807-S-0401": "Перевірте, чи правильне підключення лічильника.",
  "0X3807-S-0402": "Перевірте, чи правильне підключення лічильника.",
  "0X3807-S-0404": "Перевірте, чи правильне підключення лічильника.",
  "0X3807-S-0408": "Перевірте, чи правильне підключення лічильника.",
  "0X3807-S-0416": "Перевірте, чи правильне підключення лічильника.",
  "0X3807-S-0500": "1. Якщо це трапляється випадково, це може бути через тимчасову аномалію мережі. Інвертор відновить нормальну роботу після повернення мережі до нормального стану.\n2. Якщо ця несправність сповіщається часто, перевірте, чи аномальна мережа.",
  "0X3807-S-0601": "Після вимкнення перевірте, чи нормальна напруга модуля. Якщо перезавантаження не усуває проблему, це вказує на внутрішню несправність інвертора.",
  "0X3807-S-02": "Після вимкнення перевірте, чи нормальна напруга модуля. Якщо перезавантаження не усуває проблему, це вказує на внутрішню несправність інвертора.",
  "0X3807-S-03": "Після вимкнення перевірте, чи нормальна напруга модуля. Якщо перезавантаження не усуває проблему, це вказує на внутрішню несправність інвертора.",
  "In Alarm": "У сигналі тривоги",
  "device.category.energyStorageCabinet": "Шафа для зберігання енергії",
  "device.category.commercialRobot": "Робот для промисловості та бізнесу",
  "device.category.pvinverter": "Фотоелектричний інвертор",
  "collector.upgrade.progress": "Прогрес оновлення колекціонера",
  "device.upgrade.progress": "Прогрес оновлення пристрою",
  "failed.to.obtain.firmware": "Не вдалося отримати прошивку",
  "file.CRC.check.failed": "Не вдалася перевірка CRC файлу",
  "burning.timed.out": "Перевищено час запису",
  "burning.failed": "Помилка запису",
  "shujvabng": "Датальний стік (Bumai)",
  "paramSet.select.dataError.tip": "Варіант не є оптимальним, будь ласка, скиньте його.",
  "ywt.60419.pbusVol": "Електрична напруга PBUS ",
  "bw_param_qqq": "Налаштування паралельного режиму",
  "paramSet.dateTime.title.month": "M",
  "ywt.60419.invRTemp": "Температура модуля R інвертора INV(℃)",
  "ywt.60419.rGridPower": "Puissance raccordée au réseau de phase R",
  "ywt.60419.sGridVol": "Фазова електрична напруга електричної мережі S",
  "paramSet.dateTime.title.year": "A",
  "50500_0x7572-C-15": "Несправність при високій температурі радіатора",
  "50500_0x7572-C-14": "Несправність ARC",
  "ywt.60419.btDspDebugInfo8": "Інформація про налагодження BT DSP (процесора обробки цифрових сигналів з «блютусом») 8",
  "ywt.60419.btDspDebugInfo7": "Інформація про налагодження BT DSP (процесора обробки цифрових сигналів з «блютусом») 7",
  "ywt.60419.btDspDebugInfo6": "Інформація про налагодження BT DSP (процесора обробки цифрових сигналів з «блютусом») 6",
  "ywt.60419.sPhaseDci": "Несправність фазового DCI S ",
  "50500_0x756F-S-6": "Несправність плавного пуску постійного струму\n1. Перевірте запобіжник акумулятора;\n2. Перезавантажте пристрій і перевірте, чи він у нормі;\n3. Зверніться до нас за допомогою, якщо не можете повернутися до ноармального стану»\n\n",
  "50500_0x756F-S-7": "INV Relay Fault 1.Confirm that the wiring between each device is correct\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-4": "EEPROM Read Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-5": "EEPROM Write Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.internalharderror1": "Anomalie du FLASH externe",
  "ywt.60419.internalharderror3": "Anomalie d'écriture de l'EEPROM",
  "50500_0x756F-S-8": "Auxiliary power supply failure\n1. Wait for minutes then check;\n2. Remove wifi plug or other communicator;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.internalharderror2": "Anomalie de lecture de l'EEPROM（",
  "50500_0x756F-S-9": "Вихід з ладу допоміжного джерела живлення\n1. Зачекайте кілька хвилин, а потім перевірте;\n2. Від'єднайте штекер Wi-Fi або інший комунікатор;\n3. Зверніться до нас за допомогою, якщо не можете повернутися до ноармального стану»",
  "ywt.60419.armDebugInfo7": "Інформація про налагодження контролера ARM 7",
  "ywt.60419.internalharderror4": "Échec du test automatique du GFCI",
  "ywt.60419.armDebugInfo5": "Інформація про налагодження контролера ARM 5",
  "ywt.60419.armDebugInfo6": "Інформація про налагодження контролера ARM 6",
  "50500_0x756F-S-2": "GFCI Device Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.armDebugInfo3": "Інформація про налагодження контролера ARM 3",
  "ywt.60419.armDebugInfo4": "Інформація про налагодження контролера ARM 4",
  "ywt.60419.armDebugInfo1": "Інформація про налагодження контролера ARM 1",
  "ywt.60419.armDebugInfo2": "Інформація про налагодження контролера ARM 2",
  "50500_0x756F-C-6": "Постійний струм/DC_Softsart_Fault",
  "50500_0x756F-C-9": "AuxPowerBoard_Failure",
  "ywt.60419.deratedPower": "Знижена потужність ",
  "50500_0x7570-F-14": "Soft_Start_Failed",
  "50500_0x7570-F-12": "Parallel_CANBus_Fault",
  "50500_0x756F-C-13": "Зміна режиму роботи",
  "ywt.60419.todayPvEnergy": "Об’єм генерації електроенергії за поточну добу",
  "ywt.60419.btDspDebugInfo1": "Інформація про налагодження BT DSP (процесора обробки цифрових сигналів з «блютусом») 1",
  "ywt.60419.invSTemp": "Температура модуля S інвертора INV(℃)",
  "ywt.60419.btDspDebugInfo5": "Інформація про налагодження BT DSP (процесора обробки цифрових сигналів з «блютусом») 5",
  "ywt.60419.btDspDebugInfo4": "Інформація про налагодження BT DSP (процесора обробки цифрових сигналів з «блютусом») 4",
  "ywt.60419.btDspDebugInfo3": "Інформація про налагодження BT DSP (процесора обробки цифрових сигналів з «блютусом») 3",
  "ywt.60419.btDspDebugInfo2": "Інформація про налагодження BT DSP (процесора обробки цифрових сигналів з «блютусом») 2",
  "ywt.60419.dcInsulationImpedance": "Опір ізоляції постійного струму",
  "test.label_G_P_C_L1": "генерації L1 Power",
  "ywt.60419.internalHardwareError": "Внутрішня апаратна несправність пристрою",
  "ywt.60419.versionStr": "Номер версії",
  "test.label_G_P_C_L5": "напруга Gen L2",
  "common.50500.xnl_RTparam_name_G_P_V_L2": "напруга Gen L2",
  "test.label_G_P_C_L4": "напруга Gen L1",
  "common.50500.xnl_RTparam_name_G_P_V_L3": "напруга Gen L3",
  "test.label_G_P_C_L3": "генерації L3 Power",
  "common.50500.xnl_RTparam_name_G_P_V_L1": "напруга Gen L1",
  "test.label_G_P_C_L6": "напруга Gen L3",
  "ywt.60419.envTemp": "Температура навколишнього середовища(℃)",
  "bw_param_ctrl_name_ParallelSetting": "Паралельний статус",
  "ywt.60419.rGridVol": "Фазова електрична напруга електричної мережі R ",
  "ywt.60419.scanStatus": "Стан сканування I/V ",
  "ywt.60419.groupStrCurrent1": "Електричний струм групового каскаду 1",
  "ywt.60419.invTTemp": "Температура модуля T інвертора INV(℃)",
  "ywt.60419.groupStrCurrent2": "Електричний струм групового каскаду 2",
  "ywt.60419.groupStrCurrent5": "Електричний струм групового каскаду 5",
  "ywt.60419.groupStrCurrent6": "Електричний струм групового каскаду 6",
  "ywt.60419.groupStrCurrent3": "Електричний струм групового каскаду 3",
  "ywt.60419.groupStrCurrent4": "Електричний струм групового каскаду 4",
  "ywt.60419.groupStrCurrent9": "Електричний струм групового каскаду 9",
  "ywt.60419.groupStrCurrent7": "Електричний струм групового каскаду 7",
  "ywt.60419.groupStrCurrent8": "Електричний струм групового каскаду 8",
  "ywt.60419.pvInputVol2": "Електрична напруга вводу PV2",
  "ywt.60419.pvInputVol1": "Електрична напруга вводу PV1",
  "ywt.60419.pvPower2": "Сумарний об’єм генерації електроенергії PV1",
  "ywt.60419.pvPower1": "Ввідний електричний струм PV1",
  "ywt.60419.pvPower8": "Сумарний об’єм генерації електроенергії PV2",
  "ywt.60419.pvPower7": "Ввідний електричний струм PV2",
  "ywt.60419.pvPower9": "Недостатня напруга вводу 3 фотогальванічної напруги PV",
  "50500_0x7571-S-10": "1.Confirm that the wiring between each device is correct\n2. Check the AC voltage is in the range of standard voltage in specification;\n3.Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower4": "Перевищена напруга вводу 2 фотогальванічної напруги PV",
  "50500_0x7571-S-15": "«Частота мережі виходить за межі допустимого діапазону1. Перевірте, чи знаходиться частота в діапазоні специфікації чи ні;2. Перевірте, чи надійно та правильно підключені кабелі змінного струму;3. Зверніться до нас за допомогою, якщо не можете повернутися до нормального стану».",
  "ywt.60419.pvPower3": "Недостатня напруга вводу 2 фотогальванічної напруги PV",
  "ywt.60419.pvPower6": "Ввідна електрична напруга PV2",
  "50500_0x7571-S-13": "Несправність резервного акумулятора.1. Перевірте ємність акумулятора;2. Перевірте з'єднання між акумуляторами та інверторами;3. Якщо інвертор не може повернутися до нормального стану після зниження навантаження, зверніться до нас за допомогою»",
  "ywt.60419.pvPower5": "Резервний стан 2",
  "50500_0x7571-S-14": "«Частота мережі виходить за межі допустимого діапазону1. Перевірте, чи знаходиться частота в діапазоні специфікації чи ні;2. Перевірте, чи надійно та правильно підключені кабелі змінного струму;3. Зверніться до нас за допомогою, якщо не можете повернутися до нормального стану».",
  "50500_0x7570-C-14": "Soft_Start_Failed",
  "50500_0x7570-C-12": "Parallel_CANBus_Fault",
  "ywt.60419.pvInputVol9": "Електрична напруга вводу PV9",
  "ywt.60419.pvInputVol8": "Електрична напруга вводу PV8",
  "ywt.60419.pvInputVol7": "Електрична напруга вводу PV7",
  "ywt.60419.pvInputVol6": "Електрична напруга вводу PV6",
  "ywt.60419.pvInputVol5": "Електрична напруга вводу PV5",
  "ywt.60419.pvInputVol4": "Електрична напруга вводу PV4",
  "ywt.60419.pvInputVol3": "Електрична напруга вводу PV3",
  "ywt.60419.pvChargeTime": "Час генерації електроенергії ",
  "ywt.60419.invDspDebugInfo1": "Інформація про налагодження INV DSP (інверторного процесора обробки цифрових сигналів) 1",
  "ywt.60419.invDspDebugInfo2": "Інформація про налагодження INV DSP (інверторного процесора обробки цифрових сигналів) 2",
  "ywt.60419.invDspDebugInfo3": "Інформація про налагодження INV DSP (інверторного процесора обробки цифрових сигналів) 3",
  "ywt.60419.invDspDebugInfo4": "Інформація про налагодження INV DSP (інверторного процесора обробки цифрових сигналів) 4",
  "ywt.60419.invDspDebugInfo5": "Інформація про налагодження INV DSP (інверторного процесора обробки цифрових сигналів) 5",
  "ywt.60419.invDspDebugInfo6": "Інформація про налагодження INV DSP (інверторного процесора обробки цифрових сигналів) 6",
  "ywt.60419.invDspDebugInfo7": "Інформація про налагодження INV DSP (інверторного процесора обробки цифрових сигналів) 7",
  "ywt.60419.invDspDebugInfo8": "Інформація про налагодження INV DSP (інверторного процесора обробки цифрових сигналів) 8",
  "ywt.60419.workStatus0": "Initialization",
  "ywt.60419.workStatus1": "Waiting",
  "ywt.60419.workStatus2": "Grid Connection",
  "ywt.60419.workStatus3": "Failure",
  "ywt.60419.workStatus4": "Programming",
  "ywt.60419.workStatus5": "Off-grid",
  "ywt.60419.rPhaseDci": "Несправність фазового DCI R ",
  "50500_0x756F-F-13": "Зміна режиму роботи",
  "50500_0x756F-F-12": "Batt Mode Changed",
  "common.50500.xnl_RTparam_name_G_P_C_L2": "генерації L2 Power",
  "common.50500.xnl_RTparam_name_G_P_C_L1": "генерації L1 Power",
  "common.50500.xnl_RTparam_name_G_P_C_L3": "генерації L3 Power",
  "paramSet.dateTime.title.hour": "H",
  "ywt.60419.tOnGridCurrent": "Електричний струм фазового підключення до мережі T",
  "ywt.60419.tGridPower": "Puissance raccordée au réseau de phase T",
  "ywt.60419.trGridVol": "Електрична напруга у лінії електричної мережі TR ",
  "paramSet.dateTime.title.minute": "Min",
  "ywt.60419.loadPower": "Lastleistung",
  "50500_0x7572-S-15": "«Температура радіатора занадто висока1. Перевірте, чи не занадто висока температура робочого середовища;2. Вимкніть інвертор на 10 хвилин і перезапустіть;3. Зверніться до нас за допомогою, якщо не можете повернутися до нормального стану».",
  "50500_0x7572-S-14": "«1. Виявлення несправностей ARC призначене лише для ринку США;\n2. Перевірте підключення кабелю фотоелектричного модуля та усуньте несправність;\n3. Зверніться до нас за допомогою, якщо не можете повернутися до нормального стану».",
  "ywt.60419.tPhaseDci": "Несправність фазового DCI T ",
  "50500_0x7572-S-13": "1.Confirm that the load is appropriate\n2.Ensure sufficient PV energy and Reduce the load appropriately\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-12": "1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower11": "Резервний стан 3",
  "50500_0x7572-S-11": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower10": "Перевищена напруга вводу 3 фотогальванічної напруги PV",
  "50500_0x7572-S-10": "Batt Shutdown Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-F-8": "AC_Active_Batt_Fault",
  "50500_0x7570-F-9": "Шина постійного струму незбалансована",
  "ywt.60419.reactivePower": "Реактивна потужність ",
  "50500_0x7570-F-0": "Active_Battery_Hold",
  "50500_0x7570-F-1": "Несправність обладнання змінного струму по струму",
  "50500_0x7570-F-3": "Несправність апаратного забезпечення постійного струму по струму",
  "50500_0x7570-F-5": "Tz_EmergSStop_Fault",
  "50500_0x7570-F-6": "Струм витоку змінного струму є перехідним по струму",
  "50500_0x7570-F-7": "Порушення опору ізоляції постійного струму",
  "ywt.60419.rsGirdVol": "Електрична напруга у лінії електричної мережі RS",
  "ywt.60419.rOnGridCurrent": "Електричний струм фазового підключення до мережі R ",
  "ywt.60419.pvInputVol11": "Електрична напруга вводу PV11",
  "ywt.60419.pvInputVol10": "Електрична напруга вводу PV10",
  "ywt.60419.pvInputVol12": "Електрична напруга вводу PV12",
  "50500_0x7571-F-13": "Bcakup_Battery_Fault",
  "50500_0x7571-F-14": "Перевищення частоти змінного струму",
  "50500_0x7571-F-15": "Нижня частота змінного струму",
  "50500_0x7570-S-3": "Замикання з боку постійного струму по струму\n1. Перевірте підключення фотоелектричного модуля та акумулятора;\n2. Вимкніть вимикач постійного струму та вимикач змінного струму, а потім зачекайте одну хвилину, а потім знову увімкніть перемикач постійного струму/змінного струму;\n3. Звернутися до нас за допомогою, якщо не виходить повернутися до нормального стану.",
  "50500_0x7570-S-5": "Зверніться за допомогою до нас,Така невдача навряд чи трапляється.",
  "50500_0x7570-S-6": "\nНесправність струму витоку\n1. Перевірте кабель фотоелектричного модуля та інвертора;\n2. Перезапустіть інвертор;\n3. Звернутися до нас за допомогою, якщо не виходить повернутися до нормального стану.",
  "50500_0x7570-S-7": "Опір ізоляції фотоелектричних модулів занадто низький\n1. Перевірте надійність і правильність підключення фотоелектричних панелей та інвертора;\n2. Перевірте, чи підключено PE-кабель інвертора до заземлення;\n3. Звернутися до нас за допомогою, якщо не виходить повернутися до нормального стану.",
  "50500_0x7570-S-8": "AC_Active_Batt_Fault\n1.Check the battery fuse;\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-9": "1. Будь ласка, зачекайте деякий час і перевірте, чи це нормально;\n2. Якщо все ще те саме, вимкніть вимикач постійного струму та вимикач змінного струму та зачекайте одну хвилину, а потім увімкніть перемикач DC/AC;\n3. Звернутися до нас за допомогою, якщо не виходить повернутися до нормального стану.",
  "ywt.60419.totalPvEnergy": "Загальна об’єм генерації електроенергії",
  "50500_0x7570-S-0": "1.Check  insulation in the battery pack.\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-1": "Замикання на стороні змінного струму\n1. Будь ласка, перевірте, чи знаходиться резервне живлення навантаження та загальна потужність навантаження в межах діапазону;\n2. Перезавантажте пристрій і перевірте, чи він у нормі;\n3. Звернутися до нас за допомогою, якщо не виходить повернутися до нормального стану.",
  "50500_0x7570-C-3": "Несправність апаратного забезпечення постійного струму по струму",
  "50500_0x7570-C-5": "Tz_EmergSStop_Fault",
  "50500_0x7570-C-6": "Струм витоку змінного струму є перехідним по струму",
  "50500_0x7570-C-7": "Порушення опору ізоляції постійного струму",
  "50500_0x7570-C-8": "AC_Active_Batt_Fault",
  "50500_0x7570-C-9": "Шина постійного струму незбалансована",
  "50500_0x7571-C-8": "Parallel_system_Stop",
  "50500_0x7571-C-9": "Лінія змінного струму низької напруги",
  "50500_0x7571-C-6": "DCLLC_Over_Current",
  "50500_0x7571-C-7": "Batt_Over_Current",
  "50500_0x756F-S-12": "Batt Mode Changed\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-C-4": "DCLLC_Soft_Over_Cur",
  "50500_0x7571-C-5": "Battery OV ",
  "50500_0x7570-C-0": "Active_Battery_Hold",
  "50500_0x756F-S-14": "INV OCP \n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-C-1": "Несправність обладнання змінного струму по струму",
  "50500_0x7571-C-2": "Немає мережі змінного струму",
  "50500_0x756F-S-13": "Змінено режим роботи інвертора\n1. почекати хвилину і перевірити;\n2. Зверніться до нас за допомогою, якщо не можете повернутися до нормального стану.",
  "paramSet.dateTime.title.second": "S",
  "50500_0x7571-S-8": "У паралельній системі, через інші несправності інвертора.1. Зачекайте кілька хвилин, а потім перевірте всі інвертори в цій паралельній системі;2. Якщо інвертор не може повернутися до нормального стану, запишіть коди несправностей усіх інверторів, а потім зверніться до нас за допомогою».",
  "50500_0x7571-S-7": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-6": "1.Confirm that the wiring between each device is correct\n2.Confirm that the PV voltage is not too low\n3.Confirm that the load is appropriate\n4.Confirm that the device parameter settings are correct\n5.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-5": "1.Confirm if the battery specifications match our device\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-4": "DCLLC_Soft_Over_Cur\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-2": "Ніякої користі\n1. Будь ласка, підтвердьте, що сітка втрачена чи ні;\n2. Перевірте, чи хороше підключення до електромережі;\n3. Перевірте, чи ввімкнено перемикач між інвертором і мережею;\n4. Зверніться до нас за допомогою, якщо не можете повернутися до нормального стану».",
  "ywt.60419.groupStrCurrent23": "Електричний струм групового каскаду 23",
  "ywt.60419.groupStrCurrent22": "Електричний струм групового каскаду 22",
  "ywt.60419.groupStrCurrent21": "Електричний струм групового каскаду 21",
  "ywt.60419.groupStrCurrent20": "Електричний струм групового каскаду 20",
  "ywt.60419.pvInputCurrent9": "Електричний струм вводу PV9",
  "ywt.60419.stGirdVol": "Електрична напруга у лінії електричної мережі ST ",
  "ywt.60419.sGridPower": "Puissance raccordée au réseau de phase S",
  "50500_0x7571-F-5": "Battery OV ",
  "50500_0x7571-F-6": "DCLLC_Over_Current",
  "50500_0x7571-F-4": "DCLLC_Soft_Over_Cur",
  "ywt.60419.groupStrCurrent19": "Електричний струм групового каскаду 19",
  "ywt.60419.groupStrCurrent18": "Електричний струм групового каскаду 18",
  "50500_0x7571-F-2": "Немає мережі змінного струму",
  "ywt.60419.groupStrCurrent17": "Електричний струм групового каскаду 17",
  "ywt.60419.groupStrCurrent16": "Електричний струм групового каскаду 16",
  "ywt.60419.groupStrCurrent15": "Електричний струм групового каскаду 15",
  "ywt.60419.groupStrCurrent14": "Електричний струм групового каскаду 14",
  "ywt.60419.groupStrCurrent13": "Електричний струм групового каскаду 13",
  "ywt.60419.groupStrCurrent12": "Електричний струм групового каскаду 12",
  "ywt.60419.groupStrCurrent11": "Електричний струм групового каскаду 11",
  "50500_0x7571-F-9": "Лінія змінного струму низької напруги",
  "ywt.60419.groupStrCurrent10": "Електричний струм групового каскаду 10",
  "50500_0x7571-F-7": "Batt_Over_Current",
  "50500_0x7571-F-8": "Parallel_system_Stop",
  "ywt.60419.pvInputCurrent7": "Електричний струм вводу PV7",
  "ywt.60419.leakCurrent": "Електричний струм витоку ",
  "ywt.60419.pvInputCurrent8": "Електричний струм вводу PV8",
  "ywt.60419.pvInputCurrent5": "Електричний струм вводу PV5",
  "ywt.60419.pvInputCurrent6": "Електричний струм вводу PV6",
  "ywt.60419.pvInputCurrent3": "Електричний струм вводу PV3",
  "ywt.60419.pvInputCurrent4": "Електричний струм вводу PV4",
  "ywt.60419.pvInputCurrent1": "Електричний струм вводу PV1",
  "ywt.60419.pvInputCurrent2": "Електричний струм вводу PV2",
  "ywt.60419.scanPercentage": "Процентне відношення сканування I/V",
  "ywt.60419.powerFactor": "Фактор потужності ",
  "ywt.60419.loadDropMode10": "Dérating d'ajustement ATE",
  "ywt.60419.loadDropMode12": "Dérating anti-retour de puissance pour machines multiples",
  "ywt.60419.loadDropMode13": "Dérating à surfréquence",
  "ywt.60419.onGridCountdown": "Зворотній відлік часу при паралельному підключенні до мережі",
  "50500_0x7572-S-6": "PV Volt High Fault \n1. Check whether PV voltage is normal;\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-5": "DC Volt Low Fault\n1.Check whether PV voltage is normal;\n2.Check whether battery voltage is normal;\n3.Confirm that the wiring between each device is correct\n4. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-8": "Batt Over Load Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-7": "«Низька напруга акумулятора1. Перевірте, чи не занадто низька напруга акумулятора;2. Якщо напруга акумулятора занадто низька, використовуйте фотоелектричну енергію або мережу для заряджання акумулятора;3. Зверніться до нас за допомогою, якщо не можете повернутися до нормального стану».",
  "50500_0x7572-S-2": "GFCI Consistent Frault",
  "50500_0x7572-S-1": "Grid Volt Consistent Fault\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-3": "Inter Comm Fault\n1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-9": "1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.radiatorTemp": "Температура радіатора(℃)",
  "50500_0x7572-C-7": "Напруга шини постійного струму занадто низька",
  "ywt.60419.rsGridFrequency": "Частота мережі RS",
  "50500_0x7572-S-0": "INV Volt Consistent Fauit\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-C-9": "Несправність зв'язку BMSBMS",
  "ywt.60419.loadDropMode3": "Dérating de l'onduleur",
  "ywt.60419.loadDropMode2": "Dérating BST à haute température",
  "ywt.60419.loadDropMode1": "Dérating sous haute tension",
  "ywt.60419.loadDropMode0": "Pas de dérating",
  "50500_0x756F-F-9": "AuxPowerBoard_Failure",
  "ywt.60419.loadDropMode9": "Dérating AC sous haute tension",
  "ywt.60419.loadDropMode8": "Dérating de pente de charge",
  "ywt.60419.loadDropMode7": "Dérating de puissance réactive",
  "ywt.60419.loadDropMode6": "Dérating de réinitialisation MPPT",
  "ywt.60419.loadDropMode5": "Dérating PF",
  "ywt.60419.loadDropMode4": "Dérating à température ambiante",
  "50500_0x756F-F-2": "GFCI Device Fault",
  "50500_0x7570-S-12": "«Цей ault тільки для інверторів, що працюють в паралельному режимі1. Перевірте паралельне налаштування відповідно до інструкції;2. Перевірте підключення CANBus;3. Зверніться до нас за допомогою»",
  "50500_0x756F-F-4": "EEPROM Read Fault",
  "50500_0x7570-S-14": "Soft_Start_Failed\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3.Confirm that the battery level is not too low\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-F-6": "Постійний струм/DC_Softsart_Fault",
  "50500_0x756F-F-5": "EEPROM Write Fault",
  "50500_0x7571-C-15": "Нижня частота змінного струму",
  "ywt.60419.activePower": "Активна потужність ",
  "50500_0x7570-S-11": "Parallel Set Faut \n1.Confirm that the device parameter settings are correct\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-C-14": "Перевищення частоти змінного струму",
  "50500_0x7570-S-10": "Bus Volt unbanlence\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-F-7": "INV Relay Fault",
  "50500_0x7571-C-13": "Bcakup_Battery_Fault",
  "paramSet.dateTime.title.day": "G",
  "50500_0x7572-F-14": "Несправність ARC",
  "50500_0x7572-F-15": "Несправність при високій температурі радіатора",
  "50500_0x7572-F-7": "Напруга шини постійного струму занадто низька",
  "50500_0x7572-F-9": "Несправність зв'язку BMSBMS",
  "ywt.60419.meterPower": "Gesamtleistung des Stromzählers",
  "paramSet.input.dataError.tip": "Значення не входить до розумного діапазону, будь ласка, скиньте його.",
  "ywt.60419.workStatus": "Робочий стан інвертора",
  "ywt.60419.tGridVol": "Фазова електрична напруга електричної мережі T",
  "ywt.60419.sOnGridCurrent": "Електричний струм фазового підключення до мережі S",
  "ywt.60419.nbusVol": "Електрична напруга NBUS ",
  "ywt.60419.pvInputCurrent10": "Електричний струм вводу PV10",
  "ywt.60419.pvInputCurrent11": "Електричний струм вводу PV11",
  "ywt.60419.pvInputCurrent12": "Електричний струм вводу PV12",
  "current.collector.upgrade.progress": "Поточний прогрес оновлення збірника становить",
  "CSP Plant": "Сонячно-теплова електростанція",
  "platformType.android": "Android",
  "platformType.ios": "IOS",
  "NC2022": "New Caledonia_NC2022",
  "EN50549_IE": "EU_EN50549_IE",
  "PR_240VAC": "PR_240VAC",
  "VDE0126_GR": "France_VDE0126_GR",
  "PPDS": "Czechia_PPDS",
  "NCRFG": "Poland_NCRFG",
  "NF50549_1": "France_NF50549_1",
  "RESERVE_SFAY_E": "China_NBT32004",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable": "Увімкнення зворотного режиму Grid CT",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable": "Увімкнення зворотного режиму PV CT",
  "50901.ctrl_ESS_Advanced_Config-System.grid_meter_ratio": "Налаштування коефіцієнта перетворення лічильника Grid CT",
  "50901.ctrl_ESS_Advanced_Config-System.pv_meter_ratio": "Налаштування коефіцієнта перетворення лічильника PV CT",
  "50901.ctrl_Config-Grid Profile.country": "Країна / Країна стандарту підключення до мережі",
  "50901.ctrl_Device.meterConfiguration": "Конфігурація лічильника",
  "50901.ctrl_WorkMode.workMode": "Режим роботи EMS",
  "50901.ctrl_ESS_Advanced_Config-System": "Розширена конфігурація - Система",
  "50901.ctrl_Config-Grid Profile": "Конфігурація - Параметри мережі",
  "50901.ctrl_Device": "Керування_Пристрій",
  "50901.ctrl_WorkMode": "Робочий Режим",
  "connect.type.wifi": "Бездротова сеть",
  "connect.type.lan": "LAN",
  "50901.ctrl_WorkModeSetting": "Налаштування режиму роботи",
  "50901.ctrl_WorkMode-Backup": "Режим роботи - Резервний",
  "50901.ctrl_WorkMode-economic": "Режим роботи - Економічний",
  "50901.ctrl_WorkMode-forceCharge": "Режим роботи - Примусовий заряд",
  "50901.ctrl_WorkMode-forceDischarge": "Режим роботи - Примусова розрядка",
  "50901.ctrl_WorkMode-peakMeter": "Режим роботи - Лічильник пікових навантажень",
  "50901.ctrl_WorkMode-Selfuse": "Режим роботи - Власне використання",
  "50901.ctrl_WorkMode-TOU": "Режим роботи - TOU",
  "50901.ctrl_WorkMode-TOU.touModeReserveSoc.desc": "Режим TOU - Резервований SOC",
  "50901.ctrl_Device.meterConfiguration.desc": "Опис конфігурації лічильника",
  "50901.ctrl_Config-Grid Profile.country.desc": "Опис країни / країни стандарту підключення до мережі",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.0": "Дезактивувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.1": "Актимувати",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.0": "Дезактивувати",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.1": "Актимувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.0": "Дезактивувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.1": "Актимувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.0": "Дезактивувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.1": "Актимувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.0": "Дезактивувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.1": "Актимувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.0": "Дезактивувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.1": "Актимувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.0": "Дезактивувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.1": "Актимувати",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.1": "Актимувати",
  "50901.ctrl_Device.meterConfiguration.0": "Ні тип лічильника",
  "50901.ctrl_Device.meterConfiguration.1": "Конфігурувати лічильник з боку мережі",
  "50901.ctrl_Device.meterConfiguration.2": "Конфігурувати PV-лічильник",
  "50901.ctrl_Device.meterConfiguration.3": "Конфігурувати лічильник з боку мережі + PV",
  "Do_not_connect": "Не підключати",
  "connect.type.Do.not.connect": "Не підключати",
  "platformType.web": "Web",
  "50901.Selfuse": "Самоспоживання",
  "50901.TOU": "Тариф, Диференційований За Періодами Часу",
  "50901.ctrl_Config.Device.meterConfiguration.desc": "Опис конфігурації лічильника.",
  "50901.ctrl_Config.Grid Profile.country.desc": "Опис країни / країни стандарту підключення до мережі",
  "50901.ctrl_Config.Device.meterConfiguration.0": "Немає Типу Лічильника",
  "50901.ctrl_Config.Device.meterConfiguration.1": "Налаштовано Мережевий Лічильник",
  "50901.ctrl_Config.Device.meterConfiguration.2": "Налаштовано Фотоелектричний Лічильник",
  "50901.ctrl_Config.Device.meterConfiguration.3": "Налаштовано Мережевий Та Фотоелектричний Лічильники",
  "50901.ctrl_WorkMode.Switch.workMode.0": "Самоспоживання",
  "50901.ctrl_WorkMode.Switch.workMode.1": "Економний Режим",
  "50901.ctrl_WorkMode.Switch.workMode.2": "Резервний Режим",
  "50901.ctrl_WorkMode.Switch.workMode.3": "Офлайн-Режим",
  "50901.ctrl_WorkMode.Switch.workMode.4": "Режим Примусового Заряду",
  "50901.ctrl_WorkMode.Switch.workMode.5": "Режим Примусового Розряду",
  "50901.ctrl_WorkMode.Switch.workMode.6": "Режим Обмеження Піків",
  "50901.ctrl_WorkMode.Switch.workMode.7": "Режим TOU",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.0": "Вимкнути",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.1": "Увімкнути",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.0": "Вимкнути",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.1": "Увімкнути",
  "50901.ctrl_Config.Device.meterConfiguration": "Конфігурація Лічильника",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable": "Реверс Мережевого Струмового Трансформатора Увімкнено",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio": "Налаштування Коефіцієнта Трансформації Мережевого Струмового Трансформатора",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable": "Реверс Фотоелектричного Струмового Трансформатора Увімкнено",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio": "Налаштування Коефіцієнта Трансформації Фотоелектричного Струмового Трансформатора",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH": "Година Початку Заряду Період Використання 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH": "Година Початку Розряду Період Використання 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH": "Година Початку Заряду Період Використання 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH": "Година Початку Розряду Період Використання 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH": "Година Початку Заряду Період Використання 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH": "Година Початку Розряду Період Використання 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH": "Година Початку Заряду Період Використання 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH": "Година Початку Розряду Період Використання 4",
  "50901.ctrl_Config.Grid Profile.country.0": "UE EN_EN50549",
  "50901.ctrl_Config.Grid Profile.country.1": "En_En50549 (За Замовчуванням)",
  "50901.ctrl_Config.Grid Profile.country.10": "Australia AU AS 4777 AZ",
  "50901.ctrl_Config.Grid Profile.country.11": "Filippine PH",
  "50901.ctrl_Config.Grid Profile.country.12": "Brasile BR_Inmetro_220V",
  "50901.ctrl_Config.Grid Profile.country.13": "Pakistan PAK_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.14": "Thailandia THA-PEA",
  "50901.ctrl_Config.Grid Profile.country.15": "Italia IT_CEIO-21",
  "50901.ctrl_Config.Grid Profile.country.17": "Colombia CNO_1862_240V",
  "50901.ctrl_Config.Grid Profile.country.19": "Regno Unito UK_G98/G99",
  "50901.ctrl_Config.Grid Profile.country.2": "Australia AU_AS4777_A",
  "50901.ctrl_Config.Grid Profile.country.20": "Regno Unito UK_G98NI/G99NI",
  "50901.ctrl_Config.Grid Profile.country.21": "Ecuador EC_IEEE1547",
  "50901.ctrl_Config.Grid Profile.country.22": "Slovenia SI_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.23": "Francia FR_VFR 2019",
  "50901.ctrl_Config.Grid Profile.country.24": "Spagna ES_RD1699",
  "50901.ctrl_Config.Grid Profile.country.25": "Spagna ES_RD647",
  "50901.ctrl_Config.Grid Profile.country.26": "Lituania LT_EN50549",
  "50901.ctrl_Config.Grid Profile.country.27": "Ieee1547_208 (Сша)",
  "50901.ctrl_Config.Grid Profile.country.28": "Thailandia THA-EMA",
  "50901.ctrl_Config.Grid Profile.country.3": "Austria AT_TOR",
  "50901.ctrl_Config.Grid Profile.country.30": "Ieee1547_220 (Сша)",
  "50901.ctrl_Config.Grid Profile.country.31": "Regno Unito UK_G98",
  "50901.ctrl_Config.Grid Profile.country.32": "Regno Unito UK_G99",
  "50901.ctrl_Config.Grid Profile.country.33": "Regno Unito UK_G98NI",
  "50901.ctrl_Config.Grid Profile.country.34": "Regno Unito UK_G99NI",
  "50901.ctrl_Config.Grid Profile.country.35": "Vietnam VN_CCDE",
  "50901.ctrl_Config.Grid Profile.country.36": "Panama PA_GRID_240V",
  "50901.ctrl_Config.Grid Profile.country.37": "Brasile BR_Inmetro_220V_US",
  "50901.ctrl_Config.Grid Profile.country.38": "Porto Rico LUMAPR-2024_208V",
  "50901.ctrl_Config.Grid Profile.country.39": "Porto Rico LUMAPR-2024_240V",
  "50901.ctrl_Config.Grid Profile.country.4": "Polonia PL_EN50549",
  "50901.ctrl_Config.Grid Profile.country.40": "India IND_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.41": "Romania RO_Ordinul208_2018",
  "50901.ctrl_Config.Grid Profile.country.42": "Cina CN_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.43": "Iraq IRAQ_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.44": "Us_Miso_208V (Сша)",
  "50901.ctrl_Config.Grid Profile.country.45": "Us_Miso_240V (Сша)",
  "50901.ctrl_Config.Grid Profile.country.46": "Arabia Saudita SA_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.47": "Sri Lanka LK_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.48": "Repubblica Ceca CZ_PPDS2020",
  "50901.ctrl_Config.Grid Profile.country.49": "Belgio BE_C10_26",
  "50901.ctrl_Config.Grid Profile.country.5": "Estonia EE_EVS_EN50549",
  "50901.ctrl_Config.Grid Profile.country.50": "Paesi Bassi NL_NEN_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.51": "Ucraina UA_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.52": "Canada CA_IEEE1547_240V",
  "50901.ctrl_Config.Grid Profile.country.53": "Canada CA_IEEE1547_208V",
  "50901.ctrl_Config.Grid Profile.country.54": "Malesia MY_CODE",
  "50901.ctrl_Config.Grid Profile.country.55": "Indonesia ID_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.56": "Sudafrica ZA_NRS097_2024",
  "50901.ctrl_Config.Grid Profile.country.57": "Svezia SE_SS-EN 50549",
  "50901.ctrl_Config.Grid Profile.country.58": "Grecia GR_VDE0126",
  "50901.ctrl_Config.Grid Profile.country.59": "Lussemburgo LU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.6": "Ungheria HU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.60": "Irlanda IE_EN50438",
  "50901.ctrl_Config.Grid Profile.country.61": "Zambia ZAM_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.62": "Generatore GEN_GRID_50Hz",
  "50901.ctrl_Config.Grid Profile.country.63": "Generatore GEN_GRID_60Hz",
  "50901.ctrl_Config.Grid Profile.country.64": "Arabia Saudita SA_GRID_2025_265V",
  "50901.ctrl_Config.Grid Profile.country.65": "Serbia SRB_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.66": "Svizzera CH_NAEEA_NE7",
  "50901.ctrl_Config.Grid Profile.country.67": "Libano LB_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.68": "Cile CL_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.69": "Siria SYR_GRID_2026",
  "50901.ctrl_Config.Grid Profile.country.7": "Australia AU_AS4777_B",
  "50901.ctrl_Config.Grid Profile.country.8": "Australia AU_AS4777_C",
  "50901.ctrl_Config.Grid Profile.country.9": "Us_Ieee1547 (Сша)",
  "50901.ctrl_Config.Grid Profile.country.18": "Stati Uniti USHECO_Rule14 (Hawaii)",
  "50901.ctrl_Config.Grid Profile.country.29": "Test USA LX_US_50Hz",
  "alarm.trigger.condition": "викликаний пристроєм",
  "alarm.iot": "IoT травма",
  "module.alarmInfo": "Інформація про тривогу",
  "edit.failed": "Не вдалося відредагувати",
  "tag_test_3": "tag_test_3",
  "Transit_Warehouse": "Транзитний склад",
  "bw_Param_strl_option_GridUseMeter": "Електромережа використовує електролічильники",
  "bw_Param_strl_option_GridUseCT": "Електромережа використовує CT",
  "50901.fault.dSPSAFcomparatorFault": "Несправність Компаратора",
  "50901.fault.dSPPWRfanFault": "Несправність Вентилятора",
  "50901.fault.dSPPWRgridRelayProtection": "Спрацювання захисту реле мережі",
  "50901.fault.dSPPWRmachineTypeMismatch": "Невідповідність Типу Машини",
  "50901.fault.dSPSAFbatteryFault": "Несправність Батареї",
  "50901.fault.dSPSAFfanFault": "Несправність Вентилятора",
  "50901.fault.dSPSAFgridRelayProtection": "Спрацювання Захисту Мережевого Реле",
  "50901.fault.dSPPWRbatteryFault": "Несправність Сторони Батареї",
  "50901.fault.dSPPWRcomparatorFault": "Несправність компаратора",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality": "Аномалія Допоміжного Живлення",
  "50901.fault.dSPSAFmachineTypeMismatch": "Невідповідність Типу Машини",
  "50901.fault.dSPSAFsamplingBiasAbnormality": "Аномалія Зміщення Вибірки",
  "50901.fault.canCommunicationTimeout": "Тайм-Аут Зв’язку Can",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality": "Допоміжне живлення аномальне",
  "50901.fault.dSPSAFarmCommunicationFault": "Несправність Зв’язку Arm",
  "50901.fault.dSPSAFspiCommunicationFault": "Несправність Зв’язку Spi",
  "50901.fault.dSPSAFversionMismatch": "Невідповідність Версій",
  "50901.fault.dSPPWRarmCommunicationFault": "Несправність Зв’язку Arm",
  "50901.fault.dSPPWRsamplingBiasAbnormality": "Аномалія Зміщення Вибірки",
  "50901.fault.dSPPWRspiCommunicationFault": "Несправність Зв’язку Spi",
  "50901.fault.dSPPWRversionMismatch": "Невідповідність Версій (Невідповідність Версій Програмного/Апаратного Забезпечення)",
  "50901.fault.hardwareProtection": "Спрацювання Апаратного Захисту",
  "50901.fault.lowBatteryEnergy": "Низький Рівень Енергії Батареї",
  "50901.fault.dSPPWRgridRelayProtection.0": "Вимкнути",
  "50901.fault.dSPPWRgridRelayProtection.1": "Увімкнути",
  "50901.fault.dSPPWRmachineTypeMismatch.0": "Вимкнути",
  "50901.fault.dSPPWRmachineTypeMismatch.1": "Увімкнути",
  "50901.fault.dSPPWRsamplingBiasAbnormality.0": "Вимкнути",
  "50901.fault.dSPPWRbatteryFault.1": "Увімкнути",
  "50901.fault.dSPPWRcomparatorFault.0": "Вимкнути",
  "50901.fault.dSPPWRcomparatorFault.1": "Увімкнути",
  "50901.fault.dSPPWRfanFault.0": "Вимкнути",
  "50901.fault.dSPPWRfanFault.1": "Увімкнути",
  "50901.fault.canCommunicationTimeout.1": "Увімкнути",
  "50901.fault.dSPPWRarmCommunicationFault.0": "Вимкнути",
  "50901.fault.dSPPWRarmCommunicationFault.1": "Увімкнути",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.0": "Вимкнути",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.1": "Увімкнути",
  "50901.fault.dSPPWRbatteryFault.0": "Вимкнути",
  "50901.fault.canCommunicationTimeout.0": "Вимкнути",
  "50901.fault.dSPPWRsamplingBiasAbnormality.1": "Увімкнути",
  "50901.fault.hardwareProtection.1": "Увімкнути",
  "50901.fault.lowBatteryEnergy.0": "Вимкнути",
  "50901.fault.lowBatteryEnergy.1": "Увімкнути",
  "50901.fault.dSPSAFsamplingBiasAbnormality.1": "Увімкнути",
  "50901.fault.dSPSAFspiCommunicationFault.0": "Вимкнути",
  "50901.fault.dSPSAFspiCommunicationFault.1": "Увімкнути",
  "50901.fault.dSPSAFversionMismatch.0": "Вимкнути",
  "50901.fault.dSPSAFversionMismatch.1": "Увімкнути",
  "50901.fault.hardwareProtection.0": "Вимкнути",
  "50901.fault.dSPSAFarmCommunicationFault.0": "Вимкнути",
  "50901.fault.dSPSAFgridRelayProtection.1": "Увімкнути",
  "50901.fault.dSPSAFmachineTypeMismatch.0": "Вимкнути",
  "50901.fault.dSPSAFmachineTypeMismatch.1": "Увімкнути",
  "50901.fault.dSPSAFsamplingBiasAbnormality.0": "Вимкнути",
  "50901.fault.dSPSAFbatteryFault.0": "Вимкнути",
  "50901.fault.dSPSAFbatteryFault.1": "Увімкнути",
  "50901.fault.dSPSAFcomparatorFault.0": "Вимкнути",
  "50901.fault.dSPSAFcomparatorFault.1": "Увімкнути",
  "50901.fault.dSPSAFfanFault.0": "Вимкнути",
  "50901.fault.dSPSAFfanFault.1": "Увімкнути",
  "50901.fault.dSPPWRversionMismatch.0": "Вимкнути",
  "50901.fault.dSPPWRversionMismatch.1": "Увімкнути",
  "50901.fault.dSPSAFarmCommunicationFault.1": "Увімкнути",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.0": "Вимкнути",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.1": "Увімкнути",
  "50901.fault.dSPPWRspiCommunicationFault.0": "Вимкнути",
  "50901.fault.dSPPWRspiCommunicationFault.1": "Увімкнути",
  "50901.fault.dSPSAFgridRelayProtection.0": "Вимкнути",
  "50901..数据分析_电网功率.tag": "електроенергія мережі",
  "50901.real_time.数据分析_AC光伏功率.tag": "Потужність Фотоелектрики Змінного Струму",
  "50901.real_time.数据分析_AC光伏有功功率.tag": "Активна Потужність Фотоелектрики Змінного Струму",
  "50901.real_time.数据分析_EPS电压.tag": "Напруга Eps",
  "50901.real_time.数据分析_混逆光伏电流.tag": "Струм Фотоелектрики Гібридного Інвертора",
  "50901..数据分析_单体SOC.tag": "Soc Окремого Елемента",
  "50901..数据分析_发电机功率.tag": "Сила генератора",
  "50901..数据分析_混逆光伏功率.tag": "Потужність Фотоелектрики Гібридного Інвертора",
  "50901..数据分析_电池包.tag": "батарея",
  "50901..数据分析_电网电压.tag": "Напруга Мережі",
  "50901..数据分析_电网电流.tag": "Поток мережі",
  "50901.Backup": "Резерв",
  "50901.Battery": "Акумулятор",
  "50901.ClockSetting": "Налаштування Годинника",
  "50901.Connection": "Комунікаційне Підключення",
  "50901.ctrl_Config": "Керування Комунікаційним Підключенням",
  "50901.ctrl_Config.Device.networkingType.1": "Wifi",
  "50901.ctrl_Config.Device.networkingType.2": "Ethernet",
  "50901.ctrl_Dry_Contact": "Налаштування Сухого Контакту",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH.desc": "Опис Години Початку Заряду Керування Генератором - Година",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin.desc": "Опис Хвилини Початку Заряду Керування Генератором - Хвилина",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity.desc": "Опис Ємності Акумулятора Для Вимкнення Генератора",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity.desc": "Опис Ємності Акумулятора Для Запуску Генератора",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.desc": "Опис Частоти Режиму Тренування Генератора",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime.desc": "Опис Тривалості Роботи Режиму Тренування Генератора",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.desc": "Опис Часу Запуску Режиму Тренування Генератора",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable.desc": "Опис Увімкнення Часу Очікування",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.desc": "Режим Увімкнення Soc Для Батарей Теплового Насоса 0: Вимкнути 1: Увімкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc.desc": "Читати, писати та звітувати",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt.desc": "Читати, писати та звітувати",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower.desc": "Максимальна Потужність Мережевого Живлення Теплового Насоса",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay.desc": "Читати, писати та звітувати",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable.desc": "Читати, писати та звітувати",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce.desc": "Коли Одноразовий Час Роботи Досягає Цього Значення, Режим Керування Тепловим Насосом Вимикається",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower.desc": "Читати, писати та звітувати",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc.desc": "Коли Soc Батареї Досягає Цього Значення, Режим Керування Тепловим Насосом Увімкнюється",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower.desc": "Читати, писати та звітувати",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts.desc": "Можна Встановити До 4 Періодів Роботи",
  "50901.ctrl_ESS_Advanced_Config": "Розширена Конфігурація",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak.desc": "Опис Максимальної Потужності Розряду Акумулятора В Піковий Період",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak.desc": "Опис Потужності Видачі В Мережу В Піковий Період",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower.desc": "Опис Максимальної Потужності Заряду Акумулятора",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower.desc": "Опис Максимальної Потужності Розряду Акумулятора",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime.desc": "Опис Часу Технічного Обслуговування Свинцево-Кислотного Акумулятора",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc.desc": "Опис Максимального Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc.desc": "Опис Мінімального Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower.desc": "Опис Компенсації Потужності",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower.desc": "Опис Резервної Потужності Rsvd",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.desc": "Опис Вимкнення Обходу",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.desc": "Опис Режиму Eps",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.desc": "Опис Увімкнення Фотоелектричного Режиму",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.desc": "Опис Режиму Порта Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.desc": "Опис Розташування Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay.desc": "Опис Затримки Вимкнення Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time.desc": "Опис Часу Синхронізації Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.desc": "Опис Типу Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time.desc": "Опис Максимального Часу Роботи",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time.desc": "Опис Мінімального Часу Роботи",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold.desc": "Опис Інтервалу Захисту Роботи",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.desc": "Опис Увімкнення Глобального Сканування",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.desc": "Опис Увімкнення Реверсу Мережевого Струмового Трансформатора",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio.desc": "Опис Налаштування Коефіцієнта Трансформації Мережевого Струмового Трансформатора",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley.desc": "Опис Обмеження Мережевої Потужності",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.desc": "Опис Моделі Лічильника",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.desc": "Опис Увімкнення Mid/Шлюзу",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.desc": "Опис Увімкнення Реверсу Фотоелектричного Струмового Трансформатора",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio.desc": "Опис Налаштування Коефіцієнта Трансформації Фотоелектричного Струмового Трансформатора",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.desc": "Опис Увімкнення Трифазного Дисбалансу",
  "50901.ctrl_Safety": "Правила Безпеки",
  "50901.DCI": "Ізоляція Постійного Струму",
  "50901.Device": "Пристрій",
  "50901.economic": "Економний Режим",
  "50901.EPS": "Джерело Аварійного Живлення",
  "50901.Fault": "Несправність",
  "50901.Fault.arcFault.0": "Вимкнути",
  "50901.Fault.arcFault.1": "Увімкнути",
  "50901.Fault.arcSelfTestFault.0": "Вимкнути",
  "50901.Fault.arcSelfTestFault.1": "Увімкнути",
  "50901.Fault.batteryCapacityAbnormality.0": "Вимкнути",
  "50901.Fault.batteryCapacityAbnormality.1": "увімкнути",
  "50901.Fault.batteryForceChargeRequest.0": "відключити",
  "50901.Fault.batteryForceChargeRequest.1": "увімкнути",
  "50901.Fault.bmsCanCommunicationAbnormality.0": "Вимкнути",
  "50901.Fault.bmsCanCommunicationAbnormality.1": "Увімкнути",
  "50901.Fault.busbarAbnormality.0": "Вимкнути",
  "50901.Fault.busbarAbnormality.1": "Увімкнути",
  "50901.Fault.cmpssBiasCalculationError.0": "Вимкнути",
  "50901.Fault.cmpssBiasCalculationError.1": "Увімкнути",
  "50901.Fault.driveAbnormality.0": "Вимкнути",
  "50901.Fault.driveAbnormality.1": "Увімкнути",
  "50901.Fault.dspPwrCommunicationAbnormality.0": "відключити",
  "50901.Fault.dspPwrCommunicationAbnormality.1": "Увімкнути",
  "50901.Fault.dspSafCommunicationAbnormality.0": "Вимкнути",
  "50901.Fault.dspSafCommunicationAbnormality.1": "увімкнути",
  "50901.Fault.dtsCommunicationAbnormality.0": "Вимкнути",
  "50901.Fault.dtsCommunicationAbnormality.1": "Увімкнути",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.0": "Вимкнути",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.1": "увімкнути",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.0": "відключити",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.1": "Ввімкнути",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.0": "відключити",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.1": "Ввімкнути",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.0": "відключити",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.1": "увімкнути",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.0": "Вимкнути",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.1": "увімкнути",
  "50901.Fault.e2rpomFault.0": "Вимкнути",
  "50901.Fault.e2rpomFault.1": "Увімкнути",
  "50901.Fault.epsOverload.0": "Вимкнути",
  "50901.Fault.epsOverload.1": "Увімкнути",
  "50901.Fault.epsRelayProtection.0": "Вимкнути",
  "50901.Fault.epsRelayProtection.1": "Увімкнути",
  "50901.Fault.epsVoltageAbnormality.0": "Вимкнути",
  "50901.Fault.epsVoltageAbnormality.1": "Увімкнути",
  "50901.Fault.evCharger1CommunicationAbnormality.0": "Вимкнути",
  "50901.Fault.evCharger1CommunicationAbnormality.1": "увімкнути",
  "50901.Fault.evCharger1Fault.0": "відключити",
  "50901.Fault.evCharger1Fault.1": "увімкнути",
  "50901.Fault.evCharger2CommunicationAbnormality.0": "відключити",
  "50901.Fault.evCharger2CommunicationAbnormality.1": "Ввімкнути",
  "50901.Fault.evCharger2Fault.0": "Вимкнути",
  "50901.Fault.evCharger2Fault.1": "увімкнути",
  "50901.Fault.fanSpeedAbnormality.0": "Вимкнути",
  "50901.Fault.fanSpeedAbnormality.1": "Ввімкнути",
  "50901.Fault.flashCommunicationFault.0": "Вимкнути",
  "50901.Fault.flashCommunicationFault.1": "Увімкнути",
  "50901.Fault.frequencyVariationRateOutOfRange.0": "Вимкнути",
  "50901.Fault.frequencyVariationRateOutOfRange.1": "Увімкнути",
  "50901.Fault.genAbnormality.0": "Вимкнути",
  "50901.Fault.genAbnormality.1": "Увімкнути",
  "50901.Fault.genOverload.0": "Вимкнути",
  "50901.Fault.genOverload.1": "Увімкнути",
  "50901.fault.genRelayAFault.0": "відключити",
  "50901.fault.genRelayAFault.1": "Ввімкнути",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.0": "Вимкнути",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.1": "Увімкнути",
  "50901.Fault.gridMeterCommunicationAbnormality.0": "Вимкнути",
  "50901.Fault.gridMeterCommunicationAbnormality.1": "Увімкнути",
  "50901.Fault.gridMeterTypeError.0": "відключити",
  "50901.Fault.gridMeterTypeError.1": "Ввімкнути",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.0": "Вимкнути",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.1": "Увімкнути",
  "50901.Fault.gridOverfrequency.0": "Вимкнути",
  "50901.Fault.gridOverfrequency.1": "Увімкнути",
  "50901.Fault.gridOvervoltage.0": "Вимкнути",
  "50901.Fault.gridOvervoltage.1": "Увімкнути",
  "50901.fault.gridPortOvercurrent.0": "Вимкнути",
  "50901.fault.gridPortOvercurrent.1": "увімкнути",
  "50901.Fault.gridPowerOutage.0": "Вимкнути",
  "50901.Fault.gridPowerOutage.1": "Увімкнути",
  "50901.Fault.gridUnderfrequency.0": "Вимкнути",
  "50901.Fault.gridUnderfrequency.1": "Увімкнути",
  "50901.Fault.gridUndervoltage.0": "Вимкнути",
  "50901.Fault.gridUndervoltage.1": "Увімкнути",
  "50901.Fault.gridVoltageAbnormality.0": "Вимкнути",
  "50901.Fault.gridVoltageAbnormality.1": "Увімкнути",
  "50901.Fault.hmidCommunicationAbnormality.0": "Вимкнути",
  "50901.Fault.hmidCommunicationAbnormality.1": "увімкнути",
  "50901.Fault.hmidMachineFault.0": "відключити",
  "50901.Fault.hmidMachineFault.1": "Ввімкнути",
  "50901.Fault.insulationFault.0": "Вимкнути",
  "50901.Fault.insulationFault.1": "Увімкнути",
  "50901.Fault.interruptOverflow.0": "Вимкнути",
  "50901.Fault.interruptOverflow.1": "Увімкнути",
  "50901.fault.inverterCanCommunicationFailed.0": "Вимкнути",
  "50901.fault.inverterCanCommunicationFailed.1": "увімкнути",
  "50901.Fault.lineToEarthFault.0": "Вимкнути",
  "50901.Fault.lineToEarthFault.1": "Увімкнути",
  "50901.fault.loadRelayAFault.0": "відключити",
  "50901.fault.loadRelayAFault.1": "Увімкнути",
  "50901.fault.loadRelayBFault.0": "Вимкнути",
  "50901.fault.loadRelayBFault.1": "увімкнути",
  "50901.Fault.lowAmbientTemperature.0": "Вимкнути",
  "50901.Fault.lowAmbientTemperature.1": "Увімкнути",
  "50901.Fault.lowDtuVersion.0": "Вимкнути",
  "50901.Fault.lowDtuVersion.1": "Увімкнути",
  "50901.Fault.masterSlaveCommunicationAbnormality.0": "Вимкнути",
  "50901.Fault.masterSlaveCommunicationAbnormality.1": "увімкнути",
  "50901.Fault.meterWiringAbnormality.0": "Вимкнути",
  "50901.Fault.meterWiringAbnormality.1": "Увімкнути",
  "50901.Fault.microelectronicFault.0": "Вимкнути",
  "50901.Fault.microelectronicFault.1": "Увімкнути",
  "50901.Fault.neutralWireNotConnected.0": "Вимкнути",
  "50901.Fault.neutralWireNotConnected.1": "Увімкнути",
  "50901.Fault.neutralWireToEarthFault.0": "Вимкнути",
  "50901.Fault.neutralWireToEarthFault.1": "Увімкнути",
  "50901.Fault.overTemperature.0": "Вимкнути",
  "50901.Fault.overTemperature.1": "Увімкнути",
  "50901.fault.overtemperatureAlarm.0": "відключити",
  "50901.fault.overtemperatureAlarm.1": "Ввімкнути",
  "50901.Fault.pllLockFailed.0": "Вимкнути",
  "50901.Fault.pllLockFailed.1": "Увімкнути",
  "50901.Fault.preSynchronizationFailed.0": "Вимкнути",
  "50901.Fault.preSynchronizationFailed.1": "Увімкнути",
  "50901.Fault.pvFault.0": "Вимкнути",
  "50901.Fault.pvFault.1": "Увімкнути",
  "50901.Fault.pvMeterCommunicationAbnormality.0": "Вимкнути",
  "50901.Fault.pvMeterCommunicationAbnormality.1": "увімкнути",
  "50901.Fault.pvMeterTypeError.0": "відключити",
  "50901.Fault.pvMeterTypeError.1": "Ввімкнути",
  "50901.fault.pvRelayAbFault.0": "Вимкнути",
  "50901.fault.pvRelayAbFault.1": "увімкнути",
  "50901.Fault.pvVoltageExceedingBusVoltage.0": "Вимкнути",
  "50901.Fault.pvVoltageExceedingBusVoltage.1": "Увімкнути",
  "50901.Fault.rcdFault.0": "Вимкнути",
  "50901.Fault.rcdFault.1": "Увімкнути",
  "50901.Fault.rcdSelfTestFault.0": "Вимкнути",
  "50901.Fault.rcdSelfTestFault.1": "Увімкнути",
  "50901.Fault.reconnectionFailed.0": "Вимкнути",
  "50901.Fault.reconnectionFailed.1": "Увімкнути",
  "50901.Fault.shutDown.0": "Вимкнути",
  "50901.Fault.shutDown.1": "Увімкнути",
  "50901.Fault.slaveWrongBatteryConnection.0": "Вимкнути",
  "50901.Fault.slaveWrongBatteryConnection.1": "увімкнути",
  "50901.fault.smartloadPortOvercurrent.0": "відключити",
  "50901.fault.smartloadPortOvercurrent.1": "Ввімкнути",
  "50901.Fault.sustainedNegativeLoad.0": "Вимкнути",
  "50901.Fault.sustainedNegativeLoad.1": "Увімкнути",
  "50901.Fault.temperatureAbnormality.0": "Вимкнути",
  "50901.Fault.temperatureAbnormality.1": "Увімкнути",
  "50901.Fault.tenMinuteOvervoltage.0": "Вимкнути",
  "50901.Fault.tenMinuteOvervoltage.1": "Увімкнути",
  "50901.fault.threePointThreeVoltPowerSupplyFault.0": "відключити",
  "50901.fault.threePointThreeVoltPowerSupplyFault.1": "увімкнути",
  "50901.Fault.wiringAbnormality.0": "Вимкнути",
  "50901.Fault.wiringAbnormality.1": "Увімкнути",
  "50901.forceCharge": "Примусовий Заряд",
  "50901.forceDischarge": "Примусовий Розряд",
  "50901.FRT": "Провал Частоти",
  "50901.FW": "Дрейф Частоти",
  "50901.Gateway": "Шлюз",
  "50901.Generator": "Генератор",
  "50901.Grid Profile": "Параметри Мережі",
  "50901.HeatPump": "Керування Тепловим Насосом",
  "50901.peakMeter": "Вимірювання Піків",
  "50901.PV": "Chint Однофазний",
  "50901.RCD": "Захист Від Струму Вигоку",
  "50901.real_time": "Значення Переліку 0",
  "50901.real_time.copy_dspVersionMainUVersion.desc": "Опис Версії Dsp (Основна Версія U)",
  "50901.real_time.数据分析_AC光伏无功功率.tag": "Реактивна Потужність Фотоелектрики Змінного Струму",
  "50901.real_time.数据分析_AC光伏电压.tag": "Напруга Фотоелектрики Змінного Струму",
  "50901.real_time.数据分析_AC光伏电流.tag": "Струм Фотоелектрики Змінного Струму",
  "50901.real_time.数据分析_EPS功率.tag": "Потужність Eps",
  "50901.real_time.数据分析_EPS电流.tag": "Струм Eps",
  "50901.real_time.数据分析_发电机电压.tag": "Напруга Генератора",
  "50901.real_time.数据分析_发电机电流.tag": "Струм Генератора",
  "50901.real_time.数据分析_混逆光伏功率.tag": "Потужність Фотоелектрики Гібридного Інвертора",
  "50901.real_time.数据分析_混逆光伏电压.tag": "Напруга Фотоелектрики Гібридного Інвертора",
  "50901.RPC": "Ні",
  "50901.RR": "Швидкість Зміни",
  "50901.RT": "Значення Переліку 0",
  "50901.Settings": "Робочий Режим",
  "50901.Settings-Load_Control": "Керування Навантаженням",
  "50901.Settings-Manual_Control": "Значення Переліку 0",
  "50901.Switch": "Перемикання Режиму",
  "50901.System": "Значення Переліку 0",
  "50901.VRT": "Значення Переліку 0",
  "50901.VW": "Дрейф Напруги",
  "50901.warning": "Керування Тепловим Насосом",
  "50901.warning.batteryHighVoltageAlarm.0": "Вимкнути",
  "50901.warning.batteryHighVoltageAlarm.1": "Увімкнути",
  "50901.warning.batteryLowVoltageAlarm.0": "відключити",
  "50901.warning.batteryLowVoltageAlarm.1": "Ввімкнути",
  "50901.warning.batteryPackChargeHighVoltageAlarm.0": "відключити",
  "50901.warning.batteryPackChargeHighVoltageAlarm.1": "увімкнути",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.0": "Вимкнути",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.1": "увімкнути",
  "50901.warning.chargeHighTemperatureAlarm.0": "відключити",
  "50901.warning.chargeHighTemperatureAlarm.1": "Ввімкнути",
  "50901.warning.chargeLowTemperatureAlarm.0": "відключити",
  "50901.warning.chargeLowTemperatureAlarm.1": "Ввімкнути",
  "50901.warning.dischargeHighTemperatureAlarm.0": "Вимкнути",
  "50901.warning.dischargeHighTemperatureAlarm.1": "Ввімкнути",
  "50901.warning.dischargeLowTemperatureAlarm.0": "відключити",
  "50901.warning.dischargeLowTemperatureAlarm.1": "увімкнути",
  "50901.warning.inputOvervoltageAlarm.0": "відключити",
  "50901.warning.inputOvervoltageAlarm.1": "Ввімкнути",
  "50901..cfgMultPcsBmsFlag.0": "Ні",
  "50901..cfgMultPcsBmsFlag.1": "Так",
  "50901..connectionRouterStatus.0": "Не Підключено",
  "50901..connectionRouterStatus.1": "Підключено",
  "50901..connectionRouterStatus.3": "Не Підключено",
  "50901..connectionServerStatus.0": "Не Підключено",
  "50901..connectionServerStatus.1": "Підключено",
  "50901..connectionServerStatus.2": "Підключено",
  "50901..connectionServerStatus.3": "Не Підключено",
  "50901..hpTime2WeekRange1.0": "Вимкнути",
  "50901..hpTime2WeekRange1.1": "увімкнути",
  "50901..hpTime2WeekRange2.0": "відключити",
  "50901..hpTime2WeekRange2.1": "Ввімкнути",
  "50901..hpTime2WeekRange3.0": "відключити",
  "50901..hpTime2WeekRange3.1": "Увімкнути",
  "50901..hpTime2WeekRange4.0": "Вимкнути",
  "50901..hpTime2WeekRange4.1": "Ввімкнути",
  "50901..hpTime2WeekRange5.0": "відключити",
  "50901..hpTime2WeekRange5.1": "увімкнути",
  "50901..hpTime2WeekRange6.0": "Вимкнути",
  "50901..hpTime2WeekRange6.1": "Увімкнути",
  "50901..hpTime2WeekRange7.0": "Вимкнути",
  "50901..hpTime2WeekRange7.1": "Ввімкнути",
  "50901..hpTime3WeekRange1.0": "відключити",
  "50901..hpTime3WeekRange1.1": "увімкнути",
  "50901..hpTime3WeekRange2.0": "Вимкнути",
  "50901..hpTime3WeekRange2.1": "Увімкнути",
  "50901..hpTime3WeekRange3.0": "Вимкнути",
  "50901..hpTime3WeekRange3.1": "Ввімкнути",
  "50901..hpTime3WeekRange4.0": "відключити",
  "50901..hpTime3WeekRange4.1": "увімкнути",
  "50901..hpTime3WeekRange5.0": "Вимкнути",
  "50901..hpTime3WeekRange5.1": "Увімкнути",
  "50901..hpTime3WeekRange6.0": "Вимкнути",
  "50901..hpTime3WeekRange6.1": "Ввімкнути",
  "50901..hpTime3WeekRange7.0": "відключити",
  "50901..hpTime3WeekRange7.1": "Ввімкнути",
  "50901..hpTime4WeekRange1.0": "відключити",
  "50901..hpTime4WeekRange1.1": "Увімкнути",
  "50901..hpTime4WeekRange2.0": "Вимкнути",
  "50901..hpTime4WeekRange2.1": "Ввімкнути",
  "50901..hpTime4WeekRange3.0": "відключити",
  "50901..hpTime4WeekRange3.1": "увімкнути",
  "50901..hpTime4WeekRange4.0": "Вимкнути",
  "50901..hpTime4WeekRange4.1": "Увімкнути",
  "50901..hpTime4WeekRange5.0": "Вимкнути",
  "50901..hpTime4WeekRange5.1": "увімкнути",
  "50901..hpTime4WeekRange6.0": "Вимкнути",
  "50901..hpTime4WeekRange6.1": "увімкнути",
  "50901..hpTime4WeekRange7.0": "Вимкнути",
  "50901..hpTime4WeekRange7.1": "Увімкнути",
  "50901..materType.0": "Відсутній Мережевий Лічильник",
  "50901..materType.1": "Чжэнтай однофазний",
  "50901..materType.2": "Chint Однофазний",
  "50901..materType.3": "Zhengtai розділення фази",
  "50901..materType.5": "Модуль Обліку",
  "50901..materType.6": "Анкеруї єдина дорога",
  "50901..materType.7": "Анкеруї Подвійна дорога",
  "50901..section1WeekRange1.0": "Понеділок",
  "50901..section1WeekRange1.1": "Вівторок",
  "50901..section1WeekRange1.2": "Середа",
  "50901..section1WeekRange1.3": "Четвер",
  "50901..section1WeekRange1.4": "П'ятниця",
  "50901..section1WeekRange1.5": "Субота",
  "50901..section1WeekRange1.6": "Неділя",
  "50901..section1WeekRange2.0": "Значення Переліку 0",
  "50901..section1WeekRange2.1": "Значення Переліку 1",
  "50901..section2WeekRange1.0": "Значення Переліку 0",
  "50901..section2WeekRange1.1": "Значення Переліку 2",
  "50901..section3WeekRange1.0": "Значення Переліку 0",
  "50901..section3WeekRange1.1": "Значення Переліку 2",
  "50901..section4WeekRange1.0": "Значення Переліку 0",
  "50901..section4WeekRange1.1": "Значення значення переліку 2",
  "50901.ctrl_Config.Battery.equalizationEnable.0": "Ні",
  "50901.ctrl_Config.Battery.equalizationEnable.1": "Так",
  "50901.ctrl_Config.Device.masterSlave.0": "Одиночний Блок",
  "50901.ctrl_Config.Device.masterSlave.1": "Основний",
  "50901.ctrl_Config.Device.masterSlave.2": "Відомий",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.0": "Вимкнено",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.1": "Вручну",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.2": "Авто",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.0": "Немає",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.1": "Щотижня",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.2": "Кожні 2 Тижні",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.3": "Кожні 3 Тижні",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.4": "Кожні 4 Тижні",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.0": "Ні",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.1": "Так",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.0": "Ні",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.1": "Так",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.1": "увімкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.0": "відключити",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.1": "Ввімкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.0": "відключити",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.1": "Ввімкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.0": "відключити",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.1": "увімкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.0": "відключити",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.1": "Ввімкнути",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.0": "Ні",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.1": "Так",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.1": "Вручну",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.2": "Часовий Режим",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.3": "Розумне Навантаження",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.4": "Розумне Навантаження Офлайн-Режиму",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.5": "Зарядна Колонка Для Електромобілів",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.6": "Управління тепловим насосом",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.0": "Ні",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.1": "Так",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.1": "увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.0": "Немає",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.1": "Замикання На Землю",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.2": "Керування Навантаженням",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.3": "Генератор",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.0": "відключити",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.1": "Ввімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.0": "відключити",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.0": "відключити",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.1": "Ввімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.0": "відключити",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.0": "відключити",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.1": "Ввімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.0": "відключити",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.0": "відключити",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.1": "Ввімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.0": "відключити",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.0": "відключити",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.0": "відключити",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.0": "відключити",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.1": "Ввімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.0": "відключити",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.1": "Ввімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.0": "відключити",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.1": "Ввімкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.0": "відключити",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.1": "Ввімкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.0": "відключити",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.0": "Значення значення переліку 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.1": "Значення Переліку 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.0": "відключити",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.1": "Ввімкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.0": "відключити",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.0": "Вимкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.1": "увімкнути",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.0": "Значення значення переліку 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.1": "Значення Переліку 1",
  "50901.fault.emergencyStopSwitchStatus.0": "Вимкнути",
  "50901.fault.emergencyStopSwitchStatus.1": "Увімкнути",
  "50901.fault.fiveVoltPowerSupplyFault.0": "Вимкнути",
  "50901.fault.fiveVoltPowerSupplyFault.1": "увімкнути",
  "50901.fault.genPortOvercurrent.0": "відключити",
  "50901.fault.genPortOvercurrent.1": "Ввімкнути",
  "50901.fault.genRelayBFault.0": "відключити",
  "50901.fault.genRelayBFault.1": "Увімкнути",
  "50901.fault.gridMeter.0": "Вимкнути",
  "50901.fault.gridMeter.1": "увімкнути",
  "50901.fault.inverterCommunicationFailed.0": "відключити",
  "50901.fault.inverterCommunicationFailed.1": "Ввімкнути",
  "50901.fault.kmRelayFault.0": "відключити",
  "50901.fault.kmRelayFault.1": "Увімкнути",
  "50901.fault.pvPortOvercurrent.0": "Вимкнути",
  "50901.fault.pvPortOvercurrent.1": "увімкнути",
  "50901.fault.twelveVoltPowerSupplyFault.0": "Вимкнути",
  "50901.fault.twelveVoltPowerSupplyFault.1": "увімкнути",
  "50901.real_time.batteryConnectionStatus.0": "Ні",
  "50901.real_time.batteryConnectionStatus.1": "Так",
  "50901.real_time.BatteryModel.20": "Weineng Hv",
  "50901.real_time.BatteryModel.21": "Gsl Lv",
  "50901.real_time.BatteryModel.5": "Sunwoda Lv",
  "50901.real_time.BatteryModel.6": "Uz Lv",
  "50901.real_time.BatteryModel.7": "Soluna Hv",
  "50901.real_time.BatteryModel.8": "Soluna Lv",
  "50901.real_time.BatteryModel.9": "Steltec Lv",
  "50901.real_time.batteryType_04.0": "Без Акумулятора",
  "50901.real_time.batteryType_04.1": "літієва батарея",
  "50901.real_time.batteryType_04.2": "Свинцево-Кислотна Батарея",
  "50901.real_time.batteryWorkingStatus.00": "Режим Очікування",
  "50901.real_time.batteryWorkingStatus.01": "Зарядка",
  "50901.real_time.batteryWorkingStatus.02": "Розрядка",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.00": "Ліміт Потужності Знято, Режим За Замовчуванням",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.01": "Потужність Інвертора 0, Офлайн-Режим",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.02": "Потужність Заряду Pc=0, Не Офлайн-Режим",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.03": "Потужність Заряду Pc<50%Pn Номінальної Потужності",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.04": "Потужність Заряду Pc<75%Pn Номінальної Потужності && Реактивна Потужність Q=Qmax ±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.05": "Потужність Заряду Pc, Без Ліміту",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.06": "Потужність Розряду P=0, Не Офлайн-Режим",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.07": "Потужність Розряду P<50%Pn Номінальної Потужності",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.08": "Потужність Розряду P<75%Pn Номінальної Потужності && Q= -Qmax±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.09": "Потужність Розряду P, Без Ліміту",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.10": "Потужність Заряду Pc<50%Pn Номінальної Потужності --> Потужність Заряду Знижено До 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.11": "Потужність Заряду Pc<50%Pn Номінальної Потужності && Q=Qmax",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.12": "Потужність Розряду P<50%Pn Номінальної Потужності --> Потужність Розряду Знижено До 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.13": "Потужність Заряду Pc<50%Pn Номінальної Потужності && Q=-Qmax",
  "50901.real_time.meterFlag.0": "Не В Мережі",
  "50901.real_time.meterFlag.1": "В Мережі",
  "50901.real_time.meterFlag.3": "Зв’язок Зі Шлюзом Нормальний",
  "50901.real_time.meterFlag.4": "Зв’язок Зі Шлюзом Розірвано",
  "50901.real_time.packNum.0": "0",
  "50901.real_time.packNum.1": "1",
  "50901.real_time.packNum.1023": "10",
  "50901.real_time.packNum.127": "сім",
  "50901.real_time.packNum.15": "чотири",
  "50901.real_time.packNum.16383": "чотирнадцять",
  "50901.real_time.packNum.2047": "одинадцять",
  "50901.real_time.packNum.255": "8",
  "50901.real_time.packNum.3": "дві",
  "50901.real_time.packNum.31": "5",
  "50901.real_time.packNum.32767": "п'ятнадцять",
  "50901.real_time.packNum.4095": "дванадцять",
  "50901.real_time.packNum.511": "9",
  "50901.real_time.packNum.63": "шість",
  "50901.real_time.packNum.65535": "шістнадцять",
  "50901.real_time.packNum.7": "3",
  "50901.real_time.packNum.8191": "тринадцять",
  "50901.real_time.relayStatus.00": "Живлення Km1",
  "50901.real_time.relayStatus.01": "Живлення Km1",
  "50901.real_time.relayStatus.02": "Живлення Генератора A",
  "50901.real_time.relayStatus.03": "Живлення Генератора A",
  "50901.real_time.relayStatus.04": "Живлення Генератора B",
  "50901.real_time.relayStatus.05": "Живлення Генератора B",
  "50901.real_time.relayStatus.06": "Живлення Генератора Ab",
  "50901.real_time.relayStatus.07": "Живлення Генератора Ab",
  "50901.real_time.relayStatus.08": "Живлення Критичного Навантаження A",
  "50901.real_time.relayStatus.09": "Живлення Критичного Навантаження A",
  "50901.real_time.relayStatus.10": "Живлення Критичного Навантаження B",
  "50901.real_time.relayStatus.11": "Живлення Критичного Навантаження B",
  "50901.real_time.relayStatus.12": "Зарезервовано",
  "50901.real_time.relayStatus.13": "Зарезервовано",
  "50901.real_time.relayStatus.14": "Зарезервовано",
  "50901.real_time.relayStatus.15": "Зарезервовано",
  "50901.real_time.workStatus.00": "Ініціалізація Живлення",
  "50901.real_time.workStatus.01": "Режим Очікування",
  "50901.real_time.workStatus.02": "Тест Підключення До Мережі",
  "50901.real_time.workStatus.03": "Режим Підключення До Мережі",
  "50901.real_time.workStatus.04": "Режим Несправності",
  "50901.real_time.workStatus.05": "Офлайн-Режим",
  "50901.real_time.workStatus.06": "Режим Обходу",
  "50901..antiIslandingEnable.0": "Вимкнути",
  "50901..antiIslandingEnable.1": "Увімкнути",
  "50901..apcEn.0": "Вимкнути",
  "50901..apcEn.1": "Увімкнути",
  "50901..drmEnable.0": "Вимкнути",
  "50901..drmEnable.1": "Увімкнути",
  "50901..parallelNetworking.0": "Недійсний",
  "50901..parallelNetworking.1": "Мережа В Процесі",
  "50901..parallelNetworking.2": "Розпустити Мережу",
  "50901..permitEnable.0": "Вимкнути",
  "50901..permitEnable.1": "Увімкнути",
  "50901..phaseOrderInverseDisable.0": "відключити",
  "50901..phaseOrderInverseDisable.1": "увімкнути",
  "50901..relayU16NlineRlyTestDis.0": "Вимкнути",
  "50901..relayU16NlineRlyTestDis.1": "увімкнути",
  "50901.ctrl_Config.ClockSetting.clockSet": "Період встановлення годинника",
  "50901.ctrl_Config.Connection.dtu_comm_enable.0": "Вимкнути",
  "50901.ctrl_Config.Connection.dtu_comm_enable.1": "Увімкнути",
  "50901.ctrl_Config.Device.arcfaultClear.0": "Ні",
  "50901.ctrl_Config.Device.arcfaultClear.1": "Так",
  "50901.ctrl_Config.Device.batActivate.0": "Ні",
  "50901.ctrl_Config.Device.batActivate.1": "Так",
  "50901.ctrl_Config.Device.batteryBalancing.0": "Ні",
  "50901.ctrl_Config.Device.batteryBalancing.1": "Так",
  "50901.ctrl_Config.Device.checkTime": "Час Пристрою",
  "50901.ctrl_Config.Device.clearfault.0": "Ні",
  "50901.ctrl_Config.Device.clearfault.1": "Так",
  "50901.ctrl_Config.Device.networkingType": "Тип Підключення До Мережі",
  "50901.ctrl_Config.Device.restartSystem.0": "Ні",
  "50901.ctrl_Config.Device.restartSystem.1": "Так",
  "50901.ctrl_Config.Device.restoreDefault.0": "Ні",
  "50901.ctrl_Config.Device.restoreDefault.1": "Так",
  "50901.ctrl_Config.Device.selfTest.0": "Ні",
  "50901.ctrl_Config.Device.selfTest.1": "Так",
  "50901.ctrl_Config.Device.systemPowerOnOff.0": "Зупинити Систему",
  "50901.ctrl_Config.Device.systemPowerOnOff.1": "Запустити Систему",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeCharge": "Зарядка генератора сухого вузла",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait1": "Генератор сухого вузла в режимі очікування 1",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait2": "Резерв Генератора Сухим Контактом 2",
  "50901.ctrl_Dry_Contact.Generator.dryContactPracticeTime": "Час початку режиму практики генератора",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump1": "Період часу теплового насосу 1",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump2": "Період Часу Теплового Насоса 2",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump3": "Період часу теплового насосу 3",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump4": "Період часу теплового насосу 4",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer1": "Таймер Сухого Контакту 1 Період 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer2": "Час сухого вузла 1 Період часу 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer1": "Час сухого вузла 2 Період часу 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer2": "Таймер Сухого Контакту 2 Період 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer1": "Період сухого вузла 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer2": "Період сухого вузла 2",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.0": "Ні",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.1": "Так",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.0": "Вимкнено",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.1": "Джерело Аварійного Живлення",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.2": "Джерело Безперебійного Живлення",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.0": "Ні",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.1": "Так",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.0": "Заборонити",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.1": "Зовнішня Фотоелектрика",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.2": "Зовнішній Генератор",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.3": "Примусовий Запуск",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.4": "Локальне Керування",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.0": "Немає",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.1": "Сторона Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.2": "Сторона Мережі",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.0": "Вручну",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.1": "Di/Do",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.0": "Вимкнути",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.1": "Увімкнути",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.0": "Лічильник Не Використовується",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.1": "Однофазний Лічильник",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.2": "Двофазний Лічильник",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.3": "Трифазний Лічильник",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.4": "Розумний Лічильник (Hmid)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.5": "Трансформатор Струму (Ct)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.6": "Однофазний Лічильник Acrel",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.7": "Двофазний Лічильник Acrel",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.0": "Вимкнути",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.1": "Увімкнути",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.0": "Вимкнути",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.1": "Увімкнути",
  "50901.ctrl_Safety.DCI.dciEnable.0": "Вимкнути",
  "50901.ctrl_Safety.DCI.dciEnable.1": "Увімкнути",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.0": "Вимкнути",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.1": "Увімкнути",
  "50901.ctrl_Safety.FW.fwEnable.0": "Вимкнути",
  "50901.ctrl_Safety.FW.fwEnable.1": "Увімкнути",
  "50901.ctrl_Safety.RCD.rcdEnable.0": "Вимкнути",
  "50901.ctrl_Safety.RCD.rcdEnable.1": "Увімкнути",
  "50901.ctrl_Safety.RPC.gcfEn.0": "Вимкнути",
  "50901.ctrl_Safety.RPC.gcfEn.1": "Увімкнути",
  "50901.ctrl_Safety.RPC.rpcMode.0": "Вимкнути",
  "50901.ctrl_Safety.RPC.rpcMode.1": "Фіксований фактор потужності, режим PF",
  "50901.ctrl_Safety.RPC.rpcMode.2": "Фіксована реактивна потужність, режим Q",
  "50901.ctrl_Safety.RPC.rpcMode.3": "Крива Pf(P), Режим Pf(P)",
  "50901.ctrl_Safety.RPC.rpcMode.4": "W",
  "50901.ctrl_Safety.RPC.rpcMode.5": "ПК",
  "50901.ctrl_Safety.VRT.vrtEn.0": "Вимкнути",
  "50901.ctrl_Safety.VRT.vrtEn.1": "Увімкнути",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.0": "Вимкнути",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.1": "Увімкнути",
  "50901.ctrl_Safety.VW.vwEnable.0": "Вимкнути",
  "50901.ctrl_Safety.VW.vwEnable.1": "Увімкнути",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down1": "Вузол Режиму Період 1 Западина 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down2": "Режим вузла Період 1 Низька долина 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak1": "Режим вузла Період 1 Пік 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak2": "Вузол Режиму Період 1 Пік 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down1": "Режим вузла Період 2 Низька долина 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down2": "Режим вузла Період 2 Низька долина 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak1": "Вузол Режиму Період 2 Пік 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak2": "Режим вузла Період 2 Пік 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down1": "Вузол Режиму Період 3 Западина 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down2": "Режим вузла Період 3 Низька долина 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak1": "Режим вузла Період 3 Пік 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak2": "Вузол Режиму Період 3 Пік 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down1": "Режим вузла Період 4 Низька долина 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down2": "Вузол Режиму Період 4 Западина 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak1": "Режим вузла Період 4 Пік 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak2": "Режим вузла Період 4 Пік 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer1": "Вузол Режиму Період 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer2": "Період вузла режиму 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer3": "Вузол Режиму Період 3",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer4": "Режим вузла Період 4",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Chag": "Період розподілу часу вузла 1 зарядка",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Out": "Вузол Тарифного Періоду 1 Розряд",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Chag": "Часовий розділ вузла період 2 зарядки",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Out": "Період розряду вузла розділу часу 2",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Chag": "Вузол Тарифного Періоду 3 Заряд",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Out": "Період розряду 3 вузла розділу часу",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Chag": "Час розподілу вузла період 4 зарядки",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Out": "Вузол Тарифного Періоду 4 Розряд",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Chag": "Час розподілу вузла період 5 зарядки",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Out": "Вузол Тарифного Періоду 5 Розряд",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Chag": "Час розподілу вузла період 6 зарядки",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Out": "Період розряду вузла розділу часу 6",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Chag": "Вузол Тарифного Періоду 7 Заряд",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Out": "Період розділу часу вузла 7 розряд",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Chag": "Період розділу часу вузла 8 зарядки",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Out": "Вузол Тарифного Періоду 8 Розряд",
  "50901.Fault.arcFault": "Дугове Замикання",
  "50901.Fault.arcSelfTestFault": "Помилка Самоперевірки Дугового Замикання",
  "50901.Fault.batteryCapacityAbnormality": "Аномалія Ємності Акумулятора",
  "50901.Fault.batteryForceChargeRequest": "Запит Примусового Заряду Акумулятора",
  "50901.Fault.bmsCanCommunicationAbnormality": "Аномалія Зв’язку Can Bms",
  "50901.Fault.busbarAbnormality": "Аномалія Шини Постійного Струму",
  "50901.Fault.cmpssBiasCalculationError": "Помилка Розрахунку Зсуву Cmpss",
  "50901.Fault.driveAbnormality": "Аномалія Приводу",
  "50901.Fault.dspPwrCommunicationAbnormality": "Аномалія Зв’язку Живлення Dsp",
  "50901.Fault.dspSafCommunicationAbnormality": "Аномалія Безпечного Зв’язку Dsp",
  "50901.Fault.dtsCommunicationAbnormality": "Аномалія Зв’язку Dts",
  "50901.Fault.dtu1Rs485CommunicationAbnormality": "Аномалія Зв’язку Dtu1 Rs485",
  "50901.Fault.dtu2Rs485CommunicationAbnormality": "Аномалія Зв’язку Dtu2 Rs485",
  "50901.Fault.dtu3Rs485CommunicationAbnormality": "Аномалія Зв’язку Dtu3 Rs485",
  "50901.Fault.dtu4Rs485CommunicationAbnormality": "Аномалія Зв’язку Dtu4 Rs485",
  "50901.Fault.dtu5Rs485CommunicationAbnormality": "Аномалія Зв’язку Dtu5 Rs485",
  "50901.Fault.e2rpomFault": "Несправність Eeprom",
  "50901.Fault.epsOverload": "Перевантаження Eps",
  "50901.Fault.epsRelayProtection": "Захист Реле Eps",
  "50901.Fault.epsVoltageAbnormality": "Аномалія Напруги Eps",
  "50901.Fault.evCharger1CommunicationAbnormality": "Аномалія Зв’язку Зарядної Колонки Електромобіля 1",
  "50901.Fault.evCharger1Fault": "Несправність Зарядної Колонки 1",
  "50901.Fault.evCharger2CommunicationAbnormality": "Аномалія Зв’язку Зарядної Колонки Електромобіля 2",
  "50901.Fault.evCharger2Fault": "Несправність Зарядної Колонки 2",
  "50901.Fault.fanSpeedAbnormality": "Аномалія Швидкості Вентилятора",
  "50901.Fault.flashCommunicationFault": "Несправність Зв'язку З Флеш-Пам'яттю",
  "50901.Fault.frequencyVariationRateOutOfRange": "Перевищення Ліміту Швидкості Зміни Частоти",
  "50901.Fault.genAbnormality": "Аномалія Генератора",
  "50901.Fault.genOverload": "Перевантаження Генератора",
  "50901.Fault.gridCurrentDcOffsetOutOfRange": "Перевищення Ліміту Зсуву Постійного Струму Мережі",
  "50901.Fault.gridMeterCommunicationAbnormality": "Аномалія Зв’язку Мережевого Лічильника",
  "50901.Fault.gridMeterTypeError": "Помилка Типу Мережевого Лічильника",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange": "Перевищення Ліміту Зсуву Постійної Напруги Офлайн-Режиму",
  "50901.Fault.gridOverfrequency": "Перевищення Частоти В Мережі",
  "50901.Fault.gridOvervoltage": "Перенапруга В Мережі",
  "50901.Fault.gridPowerOutage": "Зникнення Напруги В Мережі",
  "50901.Fault.gridUnderfrequency": "Зниження Частоти В Мережі",
  "50901.Fault.gridUndervoltage": "Зниження Напруги В Мережі",
  "50901.Fault.gridVoltageAbnormality": "Аномалія Напруги В Мережі",
  "50901.Fault.hmidCommunicationAbnormality": "Аномалія Зв’язку Інтерфейсу Користувача",
  "50901.Fault.hmidMachineFault": "Несправність Пристрою Інтерфейсу Користувача",
  "50901.Fault.insulationFault": "Порушення Ізоляції",
  "50901.Fault.interruptOverflow": "Переповнення Переривання",
  "50901.Fault.lineToEarthFault": "Замикання На Землю (Фаза-Земля)",
  "50901.Fault.lowAmbientTemperature": "Занадто Низька Температура Навколишнього Середовища",
  "50901.Fault.lowDtuVersion": "Занадто Низька Версія Dtu",
  "50901.Fault.masterSlaveCommunicationAbnormality": "Аномалія Зв’язку Master-Slave",
  "50901.Fault.meterWiringAbnormality": "Аномалія Підключення Лічильника",
  "50901.Fault.microelectronicFault": "Несправність Мікроелектроніки",
  "50901.Fault.neutralWireNotConnected": "Нейтральна Лінія Не Підключена",
  "50901.Fault.neutralWireToEarthFault": "Замикання Нейтралі На Землю",
  "50901.Fault.overTemperature": "Перевищення Температури",
  "50901.Fault.pllLockFailed": "Помилка Фазового Автопідстроювання Частоти",
  "50901.Fault.preSynchronizationFailed": "Помилка Попередньої Синхронізації",
  "50901.Fault.pvFault": "Несправність Фотоелектрики",
  "50901.Fault.pvMeterCommunicationAbnormality": "Аномалія Зв’язку Фотоелектричного Лічильника",
  "50901.Fault.pvMeterTypeError": "Помилка Типу Фотоелектричного Лічильника",
  "50901.Fault.pvVoltageExceedingBusVoltage": "Перевищення Фотоелектричною Напругою Напруги Шини",
  "50901.Fault.rcdFault": "Несправність Пристрою Захисного Відключення",
  "50901.Fault.rcdSelfTestFault": "Помилка Самоперевірки Пристрою Захисного Відключення",
  "50901.Fault.reconnectionFailed": "Помилка Повторного Підключення",
  "50901.Fault.shutDown": "Вимкнення Системи",
  "50901.Fault.slaveWrongBatteryConnection": "Помилка Підключення Акумулятора Веденого Пристрою",
  "50901.Fault.sustainedNegativeLoad": "Тривала Негативна Нагрузка",
  "50901.Fault.temperatureAbnormality": "Аномалія Температури",
  "50901.Fault.tenMinuteOvervoltage": "Перенапруга Протягом 10 Хвилин",
  "50901.Fault.wiringAbnormality": "Аномалія Підключення",
  "50901.real_time.BatteryModel.1": "Haier HV",
  "50901.real_time.BatteryModel.10": "Xin Yi Lv",
  "50901.real_time.BatteryModel.11": "Vestwoods Lv",
  "50901.real_time.BatteryModel.12": "Jk Hv",
  "50901.real_time.BatteryModel.13": "Byd Lv",
  "50901.real_time.BatteryModel.14": "Uz Hv",
  "50901.real_time.BatteryModel.15": "Zetara Lv",
  "50901.real_time.BatteryModel.16": "Feb Hv",
  "50901.real_time.BatteryModel.17": "Pytes Lv",
  "50901.real_time.BatteryModel.18": "Dmegc Lv",
  "50901.real_time.BatteryModel.19": "Weineng Lv",
  "50901.real_time.BatteryModel.2": "Pylon Hv",
  "50901.real_time.BatteryModel.22": "Hoy Lv",
  "50901.real_time.BatteryModel.23": "Hoy Hv",
  "50901.real_time.BatteryModel.24": "Feb Lv",
  "50901.real_time.BatteryModel.25": "Uhhome Lv",
  "50901.real_time.BatteryModel.26": "Uhhome Hv",
  "50901.real_time.BatteryModel.27": "Byd Hv",
  "50901.real_time.BatteryModel.28": "Vestwoods Hv",
  "50901.real_time.BatteryModel.29": "Phylion Hv",
  "50901.real_time.BatteryModel.3": "Dyness Lv",
  "50901.real_time.BatteryModel.30": "Hoymiles Lv",
  "50901.real_time.BatteryModel.31": "Pholion Lv",
  "50901.real_time.BatteryModel.32": "Wattsonic Lv",
  "50901.real_time.BatteryModel.33": "Enershare Hv",
  "50901.real_time.BatteryModel.34": "Beghelli Lv",
  "50901.real_time.BatteryModel.35": "Lvtopsun Lv",
  "50901.real_time.BatteryModel.36": "Pytes Hv",
  "50901.real_time.BatteryModel.37": "Lvtopsun Hv",
  "50901.real_time.BatteryModel.38": "Raja Hv",
  "50901.real_time.BatteryModel.39": "Felicity Lv",
  "50901.real_time.BatteryModel.4": "Dyness Hv",
  "50901.real_time.communicationStickHardwareVersion": "Версія Апаратного Забезпечення Ключа Зв’язку",
  "50901.real_time.communicationStickSn": "Серійний Номер Ключа Зв’язку",
  "50901.real_time.copy_communicationStickSoftwareVersion": "Версія програмного забезпечення Communication Stick",
  "50901.real_time.dTSReset": "Скидання Накопичувача Даних",
  "50901.real_time.inverterHardwareVersion": "Версія Апаратного Забезпечення Інвертора",
  "50901.real_time.inverterModelNumber": "Номер Моделі Інвертора",
  "50901.real_time.macAddr": "Mac-Адреса",
  "50901.real_time.rssi": "Рівень Сигналу",
  "50901.real_time.ssid": "Ssid",
  "50901.warning.batteryLowVoltageAlarm": "Зниження Напруги Акумулятора",
  "50901.warning.batteryPackChargeHighVoltageAlarm": "Сигналізація Перенапруги Заряду Акумуляторного Блока",
  "50901.warning.chargeHighTemperatureAlarm": "Сигналізація Високої Температури Заряду",
  "50901.warning.chargeLowTemperatureAlarm": "Сигналізація Низької Температури Заряду",
  "50901.warning.dischargeHighTemperatureAlarm": "Сигналізація Високої Температури Розряду",
  "50901.warning.dischargeLowTemperatureAlarm": "Сигналізація Низької Температури Розряду",
  "50901.ctrl_Config.ClockSetting.ClockSetting": "Налаштування Годинника",
  "50901.ctrl_Config.ClockSetting.clockSetting_day": "Налаштування Годинника - День",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour": "Налаштування Годинника - Година",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute": "Налаштування Годинника - Хвилина",
  "50901.ctrl_Config.ClockSetting.clockSetting_month": "Налаштування Годинника - Місяць",
  "50901.ctrl_Config.ClockSetting.clockSetting_second": "Налаштування Годинника - Секунда",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday": "Налаштування Годинника - День Тижня",
  "50901.ctrl_Config.ClockSetting.clockSetting_year": "Налаштування Годинника - Рік",
  "50901.ctrl_Config.Device.masterSlave": "Master/Slave",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold": "Поріг Температури Навколишнього Середовища",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold": "Поріг Температури Навколишнього Середовища Плати",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress": "Адреса Зв’язку Шлюзу",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode": "Режим виявлення BattSoc для теплового насосу",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc": "Вимкнення теплового насосу Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt": "Ліміт Часу Затримки Виявлення Теплового Насоса",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower": "Максимальна зворотна потужність теплового насосу",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay": "Максимальний добовий час роботи теплового насосу",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable": "Увімкнення Виявлення Максимального Часу Теплового Насоса",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce": "Мінімальний термін роботи теплових насосів",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower": "Пускова Потужність Теплового Насоса",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc": "Запуск теплового насосу Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower": "Тепловий насос живлення",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndDay": "Час Теплового Насоса 1 Закінчення - День",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndMonth": "Час теплового насосу 1 закінчується-",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartDay": "Час Теплового Насоса 1 Початок - День",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartMonth": "Час запуску теплового насосу 1 місяць",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1": "Час теплового насосу 1 тиждень 1",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2": "Час Теплового Насоса 1 Тиждень 2",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3": "Час теплового насосу 1 тиждень 3",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4": "Час теплового насосу 1 тиждень 4",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5": "Час Теплового Насоса 1 Тиждень 5",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6": "Час теплового насосу 1 тиждень 6",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7": "Час теплового насосу 1 тиждень 7",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode": "Режим роботи теплового насосу",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts": "Час Роботи Теплового Насоса",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2": "Хвилина 2 Початку Позапікового Періоду Секції 3 - Хвилина",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2": "Година 2 Закінчення Позапікового Періоду Секції 3 - Година",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2": "Хвилина 2 Закінчення Позапікового Періоду Секції 3 - Хвилина",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1": "Година 1 Початку Піку Секції 4 - Година",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2": "Година 2 Початку Піку Секції 4 - Година",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1": "Хвилина 1 Початку Піку Секції 4 - Хвилина",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2": "Хвилина 2 Початку Піку Секції 4 - Хвилина",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1": "Година 1 Закінчення Піку Секції 4 - Година",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2": "Година 2 Закінчення Піку Секції 4 - Година",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1": "Хвилина 1 Закінчення Піку Секції 4 - Хвилина",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2": "Хвилина 2 Закінчення Піку Секції 4 - Хвилина",
  "50901.ctrl_WorkMode.economic.section4StartDay": "День Початку Секції 4",
  "50901.ctrl_WorkMode.economic.section4StartMonth": "Місяць Початку Секції 4",
  "50901.ctrl_WorkMode.economic.section4StopDay": "День Закінчення Секції 4",
  "50901.ctrl_WorkMode.economic.section4StopMonth": "Місяць Закінчення Секції 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1": "Година 1 Початку Позапікового Періоду Секції 4 - Година",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2": "Година 2 Початку Позапікового Періоду Секції 4 - Година",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1": "Хвилина 1 Початку Позапікового Періоду Секції 4 - Хвилина",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2": "Хвилина 2 Початку Позапікового Періоду Секції 4 - Хвилина",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1": "Година 1 Закінчення Позапікового Періоду Секції 4 - Година",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2": "Година 2 Закінчення Позапікового Періоду Секції 4 - Година",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1": "Хвилина 1 Закінчення Позапікового Періоду Секції 4 - Хвилина",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2": "Хвилина 2 Закінчення Позапікового Періоду Секції 4 - Хвилина",
  "50901.ctrl_WorkMode.economic.section4WeekRange11": "Період 4, група 1, понеділок",
  "50901.ctrl_WorkMode.economic.section4WeekRange12": "Часовий слот 4, група 1, вівторок",
  "50901.ctrl_WorkMode.economic.section4WeekRange13": "Період 4 Група 1 Середа",
  "50901.ctrl_WorkMode.economic.section4WeekRange14": "Часовий проміжок 4, група 1, четвер",
  "50901.ctrl_WorkMode.economic.section4WeekRange15": "Часовий слот 4, група 1, п'ятниця",
  "50901.ctrl_WorkMode.economic.section4WeekRange16": "Період 4 Група 1 Субота",
  "50901.ctrl_WorkMode.economic.section4WeekRange17": "Часовий слот 4, група 1, понеділок",
  "50901.ctrl_WorkMode.economic.section4WeekRange2": "Діапазон Тижня 2 Секції 4",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower": "Потужність Пікового Лічильника",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc": "Soc Пікового Лічильника",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange": "Діапазон Часу Режиму Tou",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH": "Година Закінчення Заряду Період Використання 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin": "Хвилина Закінчення Заряду Період Використання 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower": "Потужність Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin": "Хвилина Початку Заряду Період Використання 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc": "Ємність Відключення Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH": "Година Закінчення Розряду Період Використання 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin": "Хвилина Закінчення Розряду Період Використання 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower": "Потужність Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin": "Хвилина Початку Розряду Період Використання 1",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc": "Ємність Відключення Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH": "Година Закінчення Заряду Період Використання 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin": "Хвилина Закінчення Заряду Період Використання 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower": "Потужність Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin": "Хвилина Початку Заряду Період Використання 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc": "Ємність Відключення Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH": "Година Закінчення Розряду Період Використання 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin": "Хвилина Закінчення Розряду Період Використання 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower": "Потужність Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin": "Хвилина Початку Розряду Період Використання 2",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc": "Ємність Відключення Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH": "Година Закінчення Заряду Період Використання 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin": "Хвилина Закінчення Заряду Період Використання 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower": "Потужність Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin": "Хвилина Початку Заряду Період Використання 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc": "Ємність Відключення Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH": "Година Закінчення Розряду Період Використання 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin": "Хвилина Закінчення Розряду Період Використання 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower": "Потужність Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin": "Хвилина Початку Розряду Період Використання 3",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc": "Ємність Відключення Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH": "Година Закінчення Заряду Період Використання 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin": "Хвилина Закінчення Заряду Період Використання 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower": "Потужність Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin": "Хвилина Початку Заряду Період Використання 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc": "Ємність Відключення Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH": "Година Закінчення Розряду Період Використання 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin": "Хвилина Закінчення Розряду Період Використання 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower": "Потужність Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin": "Хвилина Початку Розряду Період Використання 4",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc": "Потужність Відключення Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH": "Година Закінчення Заряду Період Використання 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin": "Хвилина Закінчення Заряду Період Використання 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower": "Потужність Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH": "Година Початку Заряду Період Використання 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin": "Хвилина Початку Заряду Період Використання 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc": "Ємність Відключення Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH": "Година Закінчення Розряду Період Використання 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin": "Хвилина Закінчення Розряду Період Використання 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower": "Потужність Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH": "Година Початку Розряду Період Використання 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin": "Хвилина Початку Розряду Період Використання 5",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc": "Ємність Відключення Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH": "Година Закінчення Заряду Період Використання 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin": "Хвилина Закінчення Заряду Період Використання 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower": "Потужність Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH": "Година Початку Заряду Період Використання 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin": "Хвилина Початку Заряду Період Використання 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc": "Ємність Відключення Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH": "Година Закінчення Розряду Період Використання 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin": "Хвилина Закінчення Розряду Період Використання 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower": "Потужність Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH": "Година Початку Розряду Період Використання 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin": "Хвилина Початку Розряду Період Використання 6",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc": "Ємність Відключення Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH": "Година Закінчення Заряду Період Використання 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin": "Хвилина Закінчення Заряду Період Використання 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower": "Потужність Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH": "Година Початку Заряду Період Використання 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin": "Хвилина Початку Заряду Період Використання 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc": "Ємність Відключення Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH": "Година Закінчення Розряду Період Використання 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin": "Хвилина Закінчення Розряду Період Використання 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower": "Потужність Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH": "Година Початку Розряду Період Використання 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin": "Хвилина Початку Розряду Період Використання 7",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc": "Ємність Відключення Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH": "Година Закінчення Заряду Період Використання 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin": "Хвилина Закінчення Заряду Період Використання 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower": "Потужність Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH": "Година Початку Заряду Період Використання 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin": "Хвилина Початку Заряду Період Використання 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc": "Ємність Відключення Заряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH": "Година Закінчення Розряду Період Використання 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin": "Хвилина Закінчення Розряду Період Використання 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower": "Потужність Розряду",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH": "Година Початку Розряду Період Використання 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin": "Хвилина Початку Розряду Період Використання 8",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc": "Ємність Відключення Розряду",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc": "Режим Tou - Резервний Soc",
  "50901.fault.emergencyStopSwitchStatus": "Аварійна Зупинка",
  "50901.fault.fiveVoltPowerSupplyFault": "Несправність Джерела Живлення 5В",
  "50901.fault.genPortOvercurrent": "Перевищення Струму На Порті Генератора",
  "50901.fault.genRelayAFault": "Несправність Реле A Генератора",
  "50901.fault.genRelayBFault": "Несправність Реле B Генератора",
  "50901.fault.gridMeter": "Помилка Зв’язку Мережевого Лічильника",
  "50901.fault.gridPortOvercurrent": "Перевищення Струму На Мережевому Порті",
  "50901.fault.inverterCanCommunicationFailed": "Помилка Зв’язку Can Інвертора",
  "50901.fault.inverterCommunicationFailed": "Помилка Зв’язку Інвертора",
  "50901.fault.kmRelayFault": "Несправність Реле Km",
  "50901.fault.loadRelayAFault": "Несправність Реле Навантаження A",
  "50901.fault.loadRelayBFault": "Несправність Реле Навантаження B",
  "50901.fault.overtemperatureAlarm": "Сигналізація Перегріву",
  "50901.fault.pvPortOvercurrent": "Перевищення Струму На Фотоелектричному Порті",
  "50901.fault.pvRelayAbFault": "Несправність Реле Ab Фотоелектрики",
  "50901.fault.smartloadPortOvercurrent": "Перевищення Струму На Порті Розумного Навантаження",
  "50901.fault.threePointThreeVoltPowerSupplyFault": "Несправність Джерела Живлення 3.3В",
  "50901.fault.twelveVoltPowerSupplyFault": "Несправність Джерела Живлення 12В",
  "50901.real_time.12vAuxiliaryVoltageSampling": "Вимірювання Допоміжної Напруги 12В",
  "50901.real_time.12vOutputVoltageSampling": "Вимірювання Вихідної Напруги 12В",
  "50901.real_time.3_3vAuxiliaryVoltageSampling": "Вимірювання Допоміжної Напруги 3.3В",
  "50901.real_time.5vAuxiliaryVoltageSampling": "Вимірювання Допоміжної Напруги 5В",
  "50901.real_time.afciVersion": "Версія Afci",
  "50901.real_time.ambientTemperatureSampling": "Вимірювання Температури Навколишнього Середовища",
  "50901.real_time.appSoftwareVersion": "Версія Програмного Забезпечення Додатку",
  "50901.real_time.batteryChargePower": "Сумарна Ємність Заряду Акумулятора",
  "50901.real_time.batteryConnectionStatus": "Стан Підключення Акумулятора",
  "50901.real_time.batteryCurrent": "Струм Акумулятора",
  "50901.real_time.batteryDailyChargeEnergy": "Добова Ємність Заряду Акумулятора",
  "50901.real_time.batteryDailyDischargeEnergy": "Добова Ємність Розряду Акумулятора",
  "50901.real_time.batteryDischargePower": "Сумарна Ємність Розряду Акумулятора",
  "50901.real_time.batteryPower": "Потужність Акумулятора (Заряд/Розряд)",
  "50901.real_time.batterySoc": "Soc Акумулятора",
  "50901.real_time.batteryType_04": "Тип Акумулятора",
  "50901.real_time.batteryVoltage": "Напруга Акумулятора",
  "50901.real_time.batteryWorkingStatus": "Стан Акумулятора",
  "50901.real_time.bootSoftwareVersion": "Версія Програмного Забезпечення Завантажувача",
  "50901.real_time.commAddress10Slave9": "Адреса Зв’язку 10 (Відоме 9)",
  "50901.real_time.commAddress1Master": "Адреса Зв’язку 1 (Основний)",
  "50901.real_time.commAddress2Slave1": "Адреса Зв’язку 2 (Відоме 1)",
  "50901.real_time.commAddress3Slave2": "Адреса Зв’язку 3 (Відоме 2)",
  "50901.real_time.commAddress3Slave3": "Адреса Зв’язку 4 (Відоме 3)",
  "50901.real_time.commAddress4Slave4": "Адреса Зв’язку 5 (Відоме 4)",
  "50901.real_time.commAddress6Slave6": "Адреса Зв’язку 6 (Відоме 5)",
  "50901.real_time.commAddress7Slave6": "Адреса Зв’язку 7 (Відоме 6)",
  "50901.real_time.commAddress8Slave7": "Адреса Зв’язку 8 (Відоме 7)",
  "50901.real_time.commAddress9Slave8": "Адреса Зв’язку 9 (Відоме 8)",
  "50901.real_time.copy_bmsSoftwareVersion": "Версія BMS - Програмне забезпечення",
  "50901.real_time.copy_controllerarmFirmwareVersion": "Версія Arm Інвертора",
  "50901.real_time.copy_dspVersionMainUVersion": "Версія Dsp (Основна Версія U)",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria": "Стан Drm (Для Австралії/Німеччини/Австрії)",
  "50901.real_time.dspVersionAuxiliaryUVersion": "Версія Dsp (Допоміжна Версія U)",
  "50901.real_time.epsCurrentA": "Струм Фази A На Стороні Eps",
  "50901.real_time.epsCurrentB": "Струм Фази B На Стороні Eps",
  "50901.real_time.epsCurrentC": "Струм Фази C На Стороні Eps",
  "50901.real_time.epsPower": "Потужність На Стороні Eps",
  "50901.real_time.epsPowerA": "Потужність Фази A На Стороні Eps",
  "50901.real_time.epsPowerB": "Потужність Фази B На Стороні Eps",
  "50901.real_time.epsPowerC": "Потужність Фази C На Стороні Eps",
  "50901.real_time.epsVoltageA": "Напруга Фази A На Стороні Eps",
  "50901.real_time.epsVoltageB": "Напруга Фази B На Стороні Eps",
  "50901.real_time.epsVoltageC": "Напруга Фази C На Стороні Eps",
  "50901.real_time.essAccessPoint": "Точка Доступу Ess",
  "50901.real_time.externalFanSpeed1": "Швидкість Зовнішнього Вентилятора 1",
  "50901.real_time.externalFanSpeed2": "Швидкість Зовнішнього Вентилятора 2",
  "50901.real_time.externalFanSpeed3": "Швидкість Зовнішнього Вентилятора 3",
  "50901.real_time.externalFanSpeed4": "Швидкість Зовнішнього Вентилятора 4",
  "50901.real_time.firmwareBuildTimeDateHour": "Час Збірки Мікропрограми (День/Година)",
  "50901.real_time.firmwareBuildTimeYearMonth": "Час Збірки Мікропрограми (Рік Та Місяць)",
  "50901.real_time.firmwareCrc": "Crc Мікропрограми",
  "50901.real_time.firmwareEndAddressHigh": "Висока Адреса Закінчення Мікропрограми",
  "50901.real_time.firmwareEndAddressLow": "Низька Адреса Закінчення Мікропрограми",
  "50901.real_time.firmwareInformationCrc": "Crc Інформації Мікропрограми",
  "50901.real_time.firmwareStartAddressHigh": "Висока Адреса Початку Мікропрограми",
  "50901.real_time.firmwareStartAddressLow": "Низька Адреса Початку Мікропрограми",
  "50901.real_time.generatorConnectionStatus": "Стан Підключення Генератора",
  "50901.real_time.generatorCurrentA": "Струм Фази A Генератора",
  "50901.real_time.generatorCurrentB": "Струм Фази B Генератора",
  "50901.real_time.generatorCurrentC": "Струм Фази C Генератора",
  "50901.real_time.generatorPower": "Потужність Генератора",
  "50901.real_time.generatorVoltageA": "Напруга Фази A Генератора",
  "50901.real_time.generatorVoltageB": "Напруга Фази B Генератора",
  "50901.real_time.generatorVoltageC": "Напруга Фази C Генератора",
  "50901.real_time.gridCurrentA": "Струм Фази A На Стороні Мережі",
  "50901.real_time.gridCurrentB": "Струм Фази B На Стороні Мережі",
  "50901.real_time.gridCurrentC": "Струм Фази C На Стороні Мережі",
  "50901.real_time.gridMeasurementOfRadiatorTemperature": "Температура Радіатора На Стороні Мережі",
  "50901.real_time.gridMeterSerialNumber": "Серійний Номер Лічильника На Стороні Мережі",
  "50901.real_time.gridPower": "Потужність На Стороні Мережі",
  "50901.real_time.gridPowerA": "Потужність Фази A На Стороні Мережі",
  "50901.real_time.gridPowerB": "Потужність Фази B На Стороні Мережі",
  "50901.real_time.gridPowerC": "Потужність Фази C На Стороні Мережі",
  "50901.real_time.gridPowerFactor": "Коефіцієнт Потужності На Стороні Мережі",
  "50901.real_time.gridPowerFactorA": "Коефіцієнт Потужності Фази A На Стороні Мережі",
  "50901.real_time.gridPowerFactorB": "Коефіцієнт Потужності Фази B На Стороні Мережі",
  "50901.real_time.gridPowerFactorC": "Коефіцієнт Потужності Фази C На Стороні Мережі",
  "50901.real_time.gridReactivePower": "Реактивна Потужність На Стороні Мережі",
  "50901.real_time.gridReactivePowerA": "Реактивна Потужність Фази A На Стороні Мережі",
  "50901.real_time.gridReactivePowerB": "Реактивна Потужність Фази B На Стороні Мережі",
  "50901.real_time.gridReactivePowerC": "Реактивна Потужність Фази C На Стороні Мережі",
  "50901.real_time.gridTotalFrequency": "Частота На Стороні Мережі",
  "50901.real_time.gridVoltageA": "Напруга Фази A На Стороні Мережі",
  "50901.real_time.gridVoltageB": "Напруга Фази B На Стороні Мережі",
  "50901.real_time.gridVoltageC": "Напруга Фази C На Стороні Мережі",
  "50901.real_time.hoymilesSerialNumber": "Серійний Номер Hoymiles",
  "50901.real_time.internalFanSpeed1": "Швидкість Внутрішнього Вентилятора 1",
  "50901.real_time.internalFanSpeed2": "Швидкість Внутрішнього Вентилятора 2",
  "50901.real_time.internalFanSpeed3": "Швидкість Внутрішнього Вентилятора 3",
  "50901.real_time.inverterSideRadiatorTemperature": "Температура Радіатора Зі Сторони Інвертора",
  "50901.real_time.inverterTemp": "Внутрішня Робоча Температура Інвертора",
  "50901.real_time.invRatedPower": "Номінальна Потужність",
  "50901.real_time.invRunningtime": "Час Роботи Інвертора (Hoymiles: Нормальний Час Роботи)",
  "50901.real_time.machineSnMaster": "Серійний Номер Основного Блоку",
  "50901.real_time.machineSnSlave1": "Серійний Номер Відомого Блоку 1",
  "50901.real_time.machineSnSlave2": "Серійний Номер Відомого Блоку 2",
  "50901.real_time.machineSnSlave3": "Серійний Номер Відомого Блоку 3",
  "50901.real_time.machineSnSlave4": "Серійний Номер Відомого Блоку 4",
  "50901.real_time.machineSnSlave5": "Серійний Номер Відомого Блоку 5",
  "50901.real_time.machineSnSlave6": "Серійний Номер Відомого Блоку 6",
  "50901.real_time.machineSnSlave7": "Серійний Номер Відомого Блоку 7",
  "50901.real_time.machineSnSlave8": "Серійний Номер Відомого Блоку 8",
  "50901.real_time.machineSnSlave9": "Серійний Номер Відомого Блоку 9",
  "50901.real_time.maxCellTemperature": "Максимальна Температура Елемента",
  "50901.real_time.maxCellVoltage": "Максимальна Напруга Елемента",
  "50901.real_time.MaxChargeCurrent": "Максимальний Струм Заряду",
  "50901.real_time.MaxDisChargeCurrent": "Максимальний Струм Розряду",
  "50901.real_time.meterFlag": "Прапорець Лічильника",
  "50901.real_time.minCellTemperature": "Мінімальна Температура Елемента",
  "50901.real_time.minCellVoltage": "Мінімальна Напруга Елемента",
  "50901.real_time.mpptTemp": "Температура Радіатора Зі Сторони Фотоелектрики",
  "50901.real_time.numberOfUnits": "Кількість Блоків",
  "50901.real_time.oemModelName": "Назва Моделі Oem",
  "50901.real_time.oemSerialNumber": "Серійний Номер Oem",
  "50901.real_time.packNum": "Кількість Паралельних З’єднань (Кількість Акумуляторних Блоків)",
  "50901.real_time.previous_gridPower": "Потужність На Стороні Мережі",
  "50901.real_time.pv1Current": "Струм Pv1",
  "50901.real_time.pv1Power": "Потужність Pv1",
  "50901.real_time.pv1Voltage": "Напруга Pv1",
  "50901.real_time.pv2Current": "Струм Pv2",
  "50901.real_time.pv2Power": "Потужність Pv2",
  "50901.real_time.pv2Voltage": "Напруга Pv2",
  "50901.real_time.pv3Current": "Струм Pv3",
  "50901.real_time.pv3Power": "Потужність Pv3",
  "50901.real_time.pv3Voltage": "Напруга Pv3",
  "50901.real_time.pv4Current": "Струм Pv4",
  "50901.real_time.pv4Power": "Потужність Pv4",
  "50901.real_time.pv4Voltage": "Напруга Pv4",
  "50901.real_time.pvConnectionStatus": "Стан Підключення Фотоелектрики",
  "50901.real_time.pvDailyYield": "Добова Виробітка Фотоелектрики",
  "50901.real_time.pvMeterConnectionStatus": "Стан Підключення Фотоелектричного Лічильника",
  "50901.real_time.pvMeterCurrentA": "Струм Фази A Фотоелектричного Лічильника",
  "50901.real_time.pvMeterCurrentB": "Струм Фази B Фотоелектричного Лічильника",
  "50901.real_time.pvMeterCurrentC": "Струм Фази C Фотоелектричного Лічильника",
  "50901.real_time.pvMeterFrequency": "Частота Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPhaseAActivePower": "Активна Потужність Фази A Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPhaseAPowerFactor": "Коефіцієнт Потужності Фази A Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPhaseAReactivePower": "Реактивна Потужність Фази A Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPhaseBActivePower": "Активна Потужність Фази B Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPhaseBPowerFactor": "Коефіцієнт Потужності Фази B Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPhaseBReactivePower": "Реактивна Потужність Фази B Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPhaseCActivePower": "Активна Потужність Фази C Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPhaseCPowerFactor": "Коефіцієнт Потужності Фази C Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPhaseCReactivePower": "Реактивна Потужність Фази C Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPower": "Потужність Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPowerA": "Потужність Фази A Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPowerB": "Потужність Фази B Фотоелектричного Лічильника",
  "50901.real_time.pvMeterPowerC": "Потужність Фази C Фотоелектричного Лічильника",
  "50901.real_time.pvMeterSerialNumber": "Серійний Номер Фотоелектричного Лічильника",
  "50901.real_time.pvMeterVoltageA": "Напруга Фази A Фотоелектричного Лічильника",
  "50901.real_time.pvMeterVoltageB": "Напруга Фази B Фотоелектричного Лічильника",
  "50901.real_time.pvMeterVoltageC": "Напруга Фази C Фотоелектричного Лічильника",
  "50901.real_time.pvPower": "Потужність Фотоелектрики",
  "50901.real_time.relayStatus": "Стан Реле",
  "50901.real_time.relaySupplyVoltageSampling": "Вимірювання Напруги Живлення Реле",
  "50901.real_time.serviceEntranceBreakerCurrent": "Струм Автоматичного Вимикача Вхідної Лінії",
  "50901.real_time.soh": "Soh",
  "50901.real_time.workStatus": "Робочий Стан",
  "50901.warning.batteryHighVoltageAlarm": "Сигналізація Перенапруги Акумулятора",
  "50901.warning.batteryPackDischargeLowVoltageAlarm": "Сигналізація Зниження Напруги Розряду Акумуляторного Блока",
  "50901.warning.inputOvervoltageAlarm": "Сигналізація Вхідної Перенапруги",
  "50901.ctrl_Config.Battery.absorptionVoltage": "Напруга Абсорбції",
  "50901.ctrl_Config.Battery.endChargeVoltage": "Напруга Завершення Заряду",
  "50901.ctrl_Config.Battery.endOfChargeCurrent": "Струм Завершення Заряду",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout": "Тайм-Аут Заряду Вирівнювання",
  "50901.ctrl_Config.Battery.equalizationEnable": "Увімкнення Вирівнювання",
  "50901.ctrl_Config.Battery.equalizationIntervalDays": "Днів Інтервалу Вирівнювання",
  "50901.ctrl_Config.Battery.equalizationTime": "Час Вирівнювання",
  "50901.ctrl_Config.Battery.equalizationVoltage": "Напруга Вирівнювання",
  "50901.ctrl_Config.Battery.floatVoltage": "Напруга Підтримки",
  "50901.ctrl_Config.Battery.initialResistance": "Початковий Опір",
  "50901.ctrl_Config.Battery.maximumChargeLimit": "Ліміт Максимального Заряду",
  "50901.ctrl_Config.Battery.maximumDischargeLimit": "Ліміт Максимального Розряду",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor": "Коефіцієнт Корекції Температури",
  "50901.ctrl_Config.Connection.dtu_comm_enable": "Увімкнення Зв’язку Dtu",
  "50901.ctrl_Config.Device.arcfaultClear": "Очищення Дугових Несправностей",
  "50901.ctrl_Config.Device.batActivate": "Активація Акумулятора",
  "50901.ctrl_Config.Device.batteryBalancing": "Балансування Акумулятора",
  "50901.ctrl_Config.Device.clearfault": "Очистити Несправність",
  "50901.ctrl_Config.Device.restartSystem": "Перезапуск Системи",
  "50901.ctrl_Config.Device.restoreDefault": "Відновлення Стандартних Налаштувань",
  "50901.ctrl_Config.Device.selfTest": "Самоперевірка",
  "50901.ctrl_Config.Device.systemPowerOnOff": "Увімкнення/Вимкнення Системи",
  "50901.ctrl_Config.Grid Profile.country": "Країна/Стандарт Підключення До Мережі",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH": "Година Закінчення Заряду Керування Генератором - Година",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin": "Хвилина Закінчення Заряду Керування Генератором - Хвилина",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH": "Година Початку Заряду Керування Генератором - Година",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin": "Хвилина Початку Заряду Керування Генератором - Хвилина",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity": "Ємність Акумулятора Для Вимкнення Генератора",
  "50901.ctrl_Dry_Contact.Generator.generatorMode": "Режим Генератора",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity": "Ємність Акумулятора Для Запуску Генератора",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq": "Частота Режиму Тренування Генератора",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn": "Режим Тренування Генератора",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime": "Тривалість Роботи Режиму Тренування Генератора",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH": "Година Запуску Режиму Тренування Генератора - Година",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin": "Хвилина Запуску Режиму Тренування Генератора - Хвилина",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek": "Час Запуску Режиму Тренування Генератора",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH": "Година Закінчення Часу Очікування 1 - Година",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin": "Хвилина Закінчення Часу Очікування 1 - Хвилина",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH": "Година Початку Часу Очікування 1 - Година",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin": "Хвилина Початку Часу Очікування 1 - Хвилина",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH": "Година Закінчення Часу Очікування 2 - Година",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin": "Хвилина Закінчення Часу Очікування 2 - Хвилина",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH": "Година Початку Часу Очікування 2 - Година",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin": "Хвилина Початку Часу Очікування 2 - Хвилина",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable": "Увімкнення Часу Очікування",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode": "Режим Керування Навантаженням",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent": "Номінальний Струм Зарядної Колонки",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1": "Керування Навантаженням Понеділок",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2": "Керування Навантаженням Вівторок",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3": "Керування Навантаженням Середа",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4": "Керування Навантаженням Четвер",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5": "Керування Навантаженням П’ятниця",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6": "Керування Навантаженням Субота",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7": "Керування Навантаженням Неділя",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent": "Номінальний Струм Головного Автоматичного Вимикача",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch": "Перемикач Ручного Режиму",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower": "Поріг Потужності Навантаження В Режимі Навантаження",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime": "Мінімальний Час Ввімкнення Керування Навантаженням",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc": "Soc Захисту Офлайн-Режиму",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1": "Діапазон Часу 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21": "Вівторок",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22": "Середа",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23": "Четвер",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24": "П’ятниця",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25": "Субота",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26": "Неділя",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27": "Неділя",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour": "Година Закінчення Таймера 1 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2": "Година Закінчення Таймера 1_2 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3": "Година Закінчення Часового Слоту 1 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute": "Хвилина Закінчення Таймера 1 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2": "Хвилина Закінчення Таймера 1_2 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3": "Хвилина Закінчення Часового Слоту 1 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min": "Хвилина Початку Таймера 1 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2": "Хвилина Початку Таймера 1_2 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3": "Хвилина Початку Часового Слоту 1 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour": "Година Закінчення Таймера 2 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2": "Година Закінчення Таймера 2_2 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3": "Година Закінчення Часового Слоту 2 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes": "Хвилина Закінчення Таймера 2 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2": "Хвилина Закінчення Таймера 2_2 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3": "Хвилина Закінчення Часового Слоту 2 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes": "Хвилина Початку Таймера 2 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2": "Хвилина Початку Таймера 2_2 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3": "Хвилина Початку Часового Слоту 2 - Хвилина",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour": "Година Початку Таймера 1 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2": "Година Початку Таймера 1_2 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3": "Година Початку Часового Слоту 1 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour": "Година Початку Таймера 2 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2": "Година Початку Таймера 2_2 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3": "Година Початку Часового Слоту 2 - Година",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable": "Таймерний Режим - Увімкнення Soc Акумулятора",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc": "Таймерний Режим - Стартовий Soc Акумулятора",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc": "Таймерний Режим - Кінцевий Soc Акумулятора",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1": "Понеділок",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2": "Вівторок",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3": "Середа",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4": "Четвер",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5": "П’ятниця",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6": "Субота",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7": "Неділя",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode": "Режим Роботи Сухих Контактів",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak": "Максимальна Потужність Розряду Акумулятора В Піковий Період",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak": "Потужність Видачі В Мережу В Піковий Період",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower": "Максимальна Потужність Заряду Акумулятора",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower": "Максимальна Потужність Розряду Акумулятора",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime": "Час Технічного Обслуговування Свинцево-Кислотного Акумулятора",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc": "Максимальний Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc": "Мінімальний Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower": "Компенсація Потужності",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower": "Резервна Потужність Rsvd",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable": "Вимкнення Обходу",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode": "Режим Eps",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn": "Увімкнення Фотоелектричного Режиму",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq": "Верхня Межа Частоти Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt": "Верхня Межа Напруги Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq": "Нижня Межа Частоти Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt": "Нижня Межа Напруги Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power": "Потужність Заряду Акумулятора Від Генератора При Паралельному З’єднанні Кількох Блоків",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay": "Затримка Вимкнення Генератора",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable": "Увімкнення Глобального Сканування",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley": "Обмеження Мережевої Потужності",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable": "Увімкнення Mid/Шлюзу",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable": "Увімкнення Трифазного Дисбалансу",
  "50901.ctrl_Safety.DCI.dciEnable": "Увімкнення Dci",
  "50901.ctrl_Safety.DCI.lowerLimit": "Струм Нижньої Межі Dci",
  "50901.ctrl_Safety.DCI.lowerTime": "Час Нижньої Межі Dci",
  "50901.ctrl_Safety.DCI.upperLimit": "Струм Верхньої Межі Dci",
  "50901.ctrl_Safety.DCI.upperTime": "Час Верхньої Межі Dci",
  "50901.ctrl_Safety.FRT.frtFuncCode": "Функціональний Код Frt",
  "50901.ctrl_Safety.FRT.frtHighLimit1": "Верхня Межа Частоти 1",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time": "Тривалість Верхньої Межі Частоти 1",
  "50901.ctrl_Safety.FRT.frtHighLimit2": "Верхня Межа Частоти 2",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time": "Тривалість Верхньої Межі Частоти 2",
  "50901.ctrl_Safety.FRT.frtHighLimit3": "Верхня Межа Частоти 3",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time": "Тривалість Верхньої Межі Частоти 3",
  "50901.ctrl_Safety.FRT.frtLowLimit1": "Нижня Межа Частоти 1",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time": "Тривалість Нижньої Межі Частоти 1",
  "50901.ctrl_Safety.FRT.frtLowLimit2": "Нижня Межа Частоти 2",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time": "Тривалість Нижньої Межі Частоти 2",
  "50901.ctrl_Safety.FRT.frtLowLimit3": "Нижня Межа Частоти 3",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time": "Тривалість Нижньої Межі Частоти 3",
  "50901.ctrl_Safety.FW.fwDiffInBatMode": "Увімкнення Різниці Режимів Акумулятора Fw",
  "50901.ctrl_Safety.FW.fwEnable": "Увімкнення Fw",
  "50901.ctrl_Safety.FW.fwFuncCode": "Функціональний Код Fw",
  "50901.ctrl_Safety.FW.fwOverEndFreq": "Кінцева Частота При Перевищенні Частоти Fw",
  "50901.ctrl_Safety.FW.fwOverStartFreq": "Початкова Частота При Перевищенні Частоти Fw",
  "50901.ctrl_Safety.FW.fwOverTransFreq": "Частота Переходу При Перевищенні Частоти Fw",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency": "Нижня Межа Частоти Відновлення Fw",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime": "Час Стабілізації Відновлення Fw",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency": "Верхня Межа Частоти Відновлення Fw",
  "50901.ctrl_Safety.FW.fwTr": "Час Fw_Tr",
  "50901.ctrl_Safety.FW.fwUnderEndFreq": "Кінцева Частота При Зниженні Частоти Fw",
  "50901.ctrl_Safety.FW.fwUnderStartFreq": "Початкова Частота При Зниженні Частоти Fw",
  "50901.ctrl_Safety.FW.fwUnderStopFreq": "Частота Зупинки При Зниженні Частоти Fw",
  "50901.ctrl_Safety.RCD.continueLimitTime": "Час Безперервного Ліміту Пзв",
  "50901.ctrl_Safety.RCD.continueLimitValue": "Струм Безперервного Ліміту Пзв",
  "50901.ctrl_Safety.RCD.rcdEnable": "Увімкнення Пзв",
  "50901.ctrl_Safety.RCD.step1LimitTime": "Час Ліміту Сходинки 1 Пзв",
  "50901.ctrl_Safety.RCD.step1LimitValue": "Струм Ліміту Сходинки 1 Пзв",
  "50901.ctrl_Safety.RCD.step2LimitTime": "Час Ліміту Сходинки 2 Пзв",
  "50901.ctrl_Safety.RCD.step2LimitValue": "Струм Ліміту Сходинки 2 Пзв",
  "50901.ctrl_Safety.RCD.step3LimitTime": "Час Ліміту Сходинки 3 Пзв",
  "50901.ctrl_Safety.RCD.step3LimitValue": "Струм Ліміту Сходинки 3 Пзв",
  "50901.ctrl_Safety.RPC.gcfEn": "Увімкнення Gcf",
  "50901.ctrl_Safety.RPC.gcfExportHardLimitRatio": "Жорстке Лімітне Співвідношення Експорту Gcf",
  "50901.ctrl_Safety.RPC.gcfExportSoftLimitRatio": "М’яке Лімітне Співвідношення Експорту Gcf",
  "50901.ctrl_Safety.RPC.gcfFuncCode": "Функціональний Код Gcf",
  "50901.ctrl_Safety.RPC.rpcMode": "Режим Rp",
  "50901.ctrl_Safety.RPC.rpcPf": "Коефіцієнт Потужності Pf Rpc",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio": "Коефіцієнт Реактивної Потужності Rpc",
  "50901.ctrl_Safety.RPC.rpcTr": "Час Rpc_Tr",
  "50901.ctrl_Safety.RPC.vvFuncCode": "Функціональний Код Volt-Var",
  "50901.ctrl_Safety.RPC.vvLockIn": "Значення Блокування Vv",
  "50901.ctrl_Safety.RPC.vvLockOut": "Значення Розблокування Vv",
  "50901.ctrl_Safety.RPC.vvQ1": "Уставка Реактивної Потужності_Q1",
  "50901.ctrl_Safety.RPC.vvQ2": "Уставка Реактивної Потужності_Q2",
  "50901.ctrl_Safety.RPC.vvQ3": "Уставка Реактивної Потужності_Q3",
  "50901.ctrl_Safety.RPC.vvQ4": "Уставка Реактивної Потужності_Q4",
  "50901.ctrl_Safety.RPC.vvV1": "Уставка Напруги_V1",
  "50901.ctrl_Safety.RPC.vvV2": "Уставка Напруги_V2",
  "50901.ctrl_Safety.RPC.vvV3": "Уставка Напруги_V3",
  "50901.ctrl_Safety.RPC.vvV4": "Уставка Напруги_V4",
  "50901.ctrl_Safety.RPC.vvVref": "Еталонне Значення Volt-Var (Vref)",
  "50901.ctrl_Safety.RPC.vvVrefTr": "Час Tr Еталонного Значення Volt-Var",
  "50901.ctrl_Safety.RPC.wpfFuncCode": "Функціональний Код Wpf",
  "50901.ctrl_Safety.RPC.wpfLockIn": "Значення Блокування Wpf",
  "50901.ctrl_Safety.RPC.wpfLockOut": "Значення Розблокування Wpf",
  "50901.ctrl_Safety.RPC.wpfMinPFOver": "Мінімальний Коефіцієнт Потужності При Перевищенні Потужності Wpf",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder": "Мінімальний Коефіцієнт Потужності При Зниженні Потужності Wpf",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio": "Коефіцієнт Закінчення Потужності Wpf",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio": "Коефіцієнт Початку Потужності Wpf",
  "50901.ctrl_Safety.RR.rrFuncCode": "Функціональний Код Rr",
  "50901.ctrl_Safety.RR.rrRurNm": "Rr_Rur_Nm",
  "50901.ctrl_Safety.RR.rrRurSs": "Rr_Rur_Ss",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue": "Верхня Межа Відновлення Частоти Rt",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue": "Нижня Межа Відновлення Частоти Rt",
  "50901.ctrl_Safety.RT.rtFuncCode": "Функціональний Код Rt",
  "50901.ctrl_Safety.RT.rtNMTime": "Час Rt_Nm",
  "50901.ctrl_Safety.RT.rtSRTTime": "Час Rt_Srt",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue": "Верхня Межа Відновлення Напруги Rt",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue": "Нижня Межа Відновлення Напруги Rt",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage": "Середня Напруга За 10 Хвилин",
  "50901.ctrl_Safety.VRT.vrtEn": "Увімкнення Vrt",
  "50901.ctrl_Safety.VRT.vrtFuncCode": "Функціональний Код Vrt",
  "50901.ctrl_Safety.VRT.vrtHighLimit": "Поріг Високої Напруги Vrt",
  "50901.ctrl_Safety.VRT.vrtLowLimit": "Поріг Низької Напруги Vrt",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime": "Час Стабілізації Відновлення Vrt",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime": "Тривалість Перехідної Перенапруги",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage": "Поріг Перехідної Перенапруги",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1": "Верхня Межа Напруги 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time": "Тривалість Верхньої Межі Напруги 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2": "Верхня Межа Напруги 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time": "Тривалість Верхньої Межі Напруги 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3": "Верхня Межа Напруги 3",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time": "Тривалість Верхньої Межі Напруги 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1": "Нижня Межа Напруги 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time": "Тривалість Нижньої Межі Напруги 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2": "Нижня Межа Напруги 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time": "Тривалість Нижньої Межі Напруги 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3": "Нижня Межа Напруги 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time": "Тривалість Нижньої Межі Напруги 3",
  "50901.ctrl_Safety.VW.vwDiffInBatMode": "Увімкнення Різниці Режимів Акумулятора Vw",
  "50901.ctrl_Safety.VW.vwEnable": "Увімкнення Vw",
  "50901.ctrl_Safety.VW.vwFuncCode": "Функціональний Код Vw",
  "50901.ctrl_Safety.VW.vwOverEndVolt": "Кінцева Напруга При Перенапрузі Vw",
  "50901.ctrl_Safety.VW.vwOverKPVolt": "Напруга Kp / Коефіцієнта Напруги При Перенапрузі Vw",
  "50901.ctrl_Safety.VW.vwOverStartVolt": "Початкова Напруга При Перенапрузі Vw",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage": "Нижня Межа Напруги Відновлення Vw",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime": "Час Стабілізації Відновлення Vw",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage": "Верхня Межа Напруги Відновлення Vw",
  "50901.ctrl_Safety.VW.vwTr": "Час Vw_Tr",
  "50901.ctrl_Safety.VW.vwUnderEndVolt": "Кінцева Напруга При Зниженні Напруги Vw",
  "50901.ctrl_Safety.VW.vwUnderKPVolt": "Напруга Kp / Коефіцієнта Напруги При Зниженні Напруги Vw",
  "50901.ctrl_Safety.VW.vwUnderStartVolt": "Початкова Напруга При Зниженні Напруги Vw",
  "50901.ctrl_WorkMode.Backup.backupSoc": "Резервний Soc",
  "50901.ctrl_WorkMode.economic.economicModeSoc": "Soc Економного Режиму",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber": "Індекс Дати Економного Режиму",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1": "Година 1 Початку Піку Секції 1 - Година",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2": "Година 2 Початку Піку Секції 1 - Година",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1": "Хвилина 1 Початку Піку Секції 1 - Хвилина",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2": "Хвилина 2 Початку Піку Секції 1 - Хвилина",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1": "Година 1 Закінчення Піку Секції 1 - Година",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2": "Година 2 Закінчення Піку Секції 1 - Година",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1": "Хвилина 1 Закінчення Піку Секції 1 - Хвилина",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2": "Хвилина 2 Закінчення Піку Секції 1 - Хвилина",
  "50901.ctrl_WorkMode.economic.section1StartDay": "День Початку Секції 1",
  "50901.ctrl_WorkMode.economic.section1StartMonth": "Місяць Початку Секції 1",
  "50901.ctrl_WorkMode.economic.section1StopDay": "День Закінчення Секції 1",
  "50901.ctrl_WorkMode.economic.section1StopMonth": "Місяць Закінчення Секції 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1": "Година 1 Початку Позапікового Періоду Секції 1 - Година",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2": "Година 2 Початку Позапікового Періоду Секції 1 - Година",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1": "Хвилина 1 Початку Позапікового Періоду Секції 1 - Хвилина",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2": "Хвилина 2 Початку Позапікового Періоду Секції 1 - Хвилина",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1": "Година 1 Закінчення Позапікового Періоду Секції 1 - Година",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2": "Година 2 Закінчення Позапікового Періоду Секції 1 - Година",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1": "Хвилина 1 Закінчення Позапікового Періоду Секції 1 - Хвилина",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2": "Хвилина 2 Закінчення Позапікового Періоду Секції 1 - Хвилина",
  "50901.ctrl_WorkMode.economic.section1WeekRange11": "Період 1 Група 1 Понеділок",
  "50901.ctrl_WorkMode.economic.section1WeekRange12": "Період 1 Група 1 Вівторок",
  "50901.ctrl_WorkMode.economic.section1WeekRange13": "Період 1 Група 1 Середа",
  "50901.ctrl_WorkMode.economic.section1WeekRange14": "Період 1 Група 1 Четвер",
  "50901.ctrl_WorkMode.economic.section1WeekRange15": "Період 1 Група 1 П’ятниця",
  "50901.ctrl_WorkMode.economic.section1WeekRange16": "Період 1 Група 1 Субота",
  "50901.ctrl_WorkMode.economic.section1WeekRange17": "Період 1 Група 1 Неділя",
  "50901.ctrl_WorkMode.economic.section1WeekRange21": "Період 1 Група 2 Понеділок",
  "50901.ctrl_WorkMode.economic.section1WeekRange22": "Період 1 Група 2 Вівторок",
  "50901.ctrl_WorkMode.economic.section1WeekRange23": "Період 1 Група 2 Середа",
  "50901.ctrl_WorkMode.economic.section1WeekRange24": "Період 1 Група 2 Четвер",
  "50901.ctrl_WorkMode.economic.section1WeekRange25": "Період 1 Група 2 П’ятниця",
  "50901.ctrl_WorkMode.economic.section1WeekRange26": "Період 1 Група 2 Субота",
  "50901.ctrl_WorkMode.economic.section1WeekRange27": "Період 1 Група 2 Неділя",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1": "Година 1 Початку Піку Секції 2 - Година",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2": "Година 2 Початку Піку Секції 2 - Година",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1": "Хвилина 1 Початку Піку Секції 2 - Хвилина",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2": "Хвилина 1 Початку Піку Секції 2 - Хвилина",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1": "Година 1 Закінчення Піку Секції 2 - Година",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2": "Година 2 Закінчення Піку Секції 2 - Година",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1": "Хвилина 1 Закінчення Піку Секції 2 - Хвилина",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2": "Хвилина 2 Закінчення Піку Секції 2 - Хвилина",
  "50901.ctrl_WorkMode.economic.section2StartDay": "День Початку Секції 2",
  "50901.ctrl_WorkMode.economic.section2StartMonth": "Місяць Початку Секції 2",
  "50901.ctrl_WorkMode.economic.section2StopDay": "День Закінчення Секції 2",
  "50901.ctrl_WorkMode.economic.section2StopMonth": "Місяць Закінчення Секції 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1": "Година 1 Початку Позапікового Періоду Секції 2 - Година",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2": "Година 2 Початку Позапікового Періоду Секції 2 - Година",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1": "Хвилина 1 Початку Позапікового Періоду Секції 2 - Хвилина",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2": "Хвилина 2 Початку Позапікового Періоду Секції 2 - Хвилина",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1": "Година 1 Закінчення Позапікового Періоду Секції 2 - Година",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2": "Година 2 Закінчення Позапікового Періоду Секції 2 - Година",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1": "Хвилина 1 Закінчення Позапікового Періоду Секції 2 - Хвилина",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2": "Хвилина 2 Закінчення Позапікового Періоду Секції 2 - Хвилина",
  "50901.ctrl_WorkMode.economic.section2WeekRange11": "Період 2 Група 1 Понеділок",
  "50901.ctrl_WorkMode.economic.section2WeekRange12": "Період 2 Група 1 Вівторок",
  "50901.ctrl_WorkMode.economic.section2WeekRange13": "Період 2 Група 1 Середа",
  "50901.ctrl_WorkMode.economic.section2WeekRange14": "Період 2 Група 1 Четвер",
  "50901.ctrl_WorkMode.economic.section2WeekRange15": "Період 2 Група 1 П’ятниця",
  "50901.ctrl_WorkMode.economic.section2WeekRange16": "Період 2 Група 1 Субота",
  "50901.ctrl_WorkMode.economic.section2WeekRange17": "Період 2 Група 1 Неділя",
  "50901.ctrl_WorkMode.economic.section2WeekRange21": "Період 2 Група 2 Понеділок",
  "50901.ctrl_WorkMode.economic.section2WeekRange22": "Період 2 Група 2 Вівторок",
  "50901.ctrl_WorkMode.economic.section2WeekRange23": "Період 2 Група 2 Середа",
  "50901.ctrl_WorkMode.economic.section2WeekRange24": "Період 2 Група 2 Четвер",
  "50901.ctrl_WorkMode.economic.section2WeekRange25": "Період 2 Група 2 П’ятниця",
  "50901.ctrl_WorkMode.economic.section2WeekRange26": "Період 2 Група 2 Субота",
  "50901.ctrl_WorkMode.economic.section2WeekRange27": "Період 2 Група 2 Неділя",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1": "Година 1 Початку Піку Секції 3 - Година",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2": "Година 2 Початку Піку Секції 3 - Година",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1": "Хвилина 2 Початку Піку Секції 3 - Хвилина",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2": "Хвилина 1 Початку Піку Секції 3 - Хвилина",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1": "Година 1 Закінчення Піку Секції 3 - Година",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2": "Година 2 Закінчення Піку Секції 3 - Година",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1": "Хвилина 1 Закінчення Піку Секції 3 - Хвилина",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2": "Хвилина 2 Закінчення Піку Секції 3 - Хвилина",
  "50901.ctrl_WorkMode.economic.section3StartDay": "День Початку Секції 3",
  "50901.ctrl_WorkMode.economic.section3StartMonth": "Місяць Початку Секції 3",
  "50901.ctrl_WorkMode.economic.section3StopDay": "День Закінчення Секції 3",
  "50901.ctrl_WorkMode.economic.section3StopMonth": "Місяць Закінчення Секції 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1": "Година 1 Початку Позапікового Періоду Секції 3 - Година",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2": "Година 2 Початку Позапікового Періоду Секції 3 - Година",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1": "Хвилина 1 Початку Позапікового Періоду Секції 3 - Хвилина",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1": "Година 1 Закінчення Позапікового Періоду Секції 3 - Година",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1": "Хвилина 1 Закінчення Позапікового Періоду Секції 3 - Хвилина",
  "50901.ctrl_WorkMode.economic.section3WeekRange11": "Період 3 Група 1 Понеділок",
  "50901.ctrl_WorkMode.economic.section3WeekRange12": "Період 3 Група 1 Вівторок",
  "50901.ctrl_WorkMode.economic.section3WeekRange13": "Період 3 Група 1 Середа",
  "50901.ctrl_WorkMode.economic.section3WeekRange14": "Період 3 Група 1 Четвер",
  "50901.ctrl_WorkMode.economic.section3WeekRange15": "Період 3 Група 1 П’ятниця",
  "50901.ctrl_WorkMode.economic.section3WeekRange16": "Період 3 Група 1 Субота",
  "50901.ctrl_WorkMode.economic.section3WeekRange17": "Період 3 Група 1 Неділя",
  "50901.ctrl_WorkMode.economic.section3WeekRange2": "Діапазон Тижня 2 Секції 3",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc": "Soc Примусового Заряду",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower": "Максимальна Потужність Заряду",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc": "Soc Примусового Розряду",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower": "Максимальна Потужність Розряду",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc": "Soc Самоспоживання",
  "50901.ctrl_WorkMode.Switch.workMode": "Робочий Режим Ems",
  "50901.real_time.batteryCapacity": "Встановлена Місткість Батареї",
  "50901.real_time.BatteryModel": "Модель Акумулятора",
  "50901.real_time.inverterSn": "Серійний Номер Інвертора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode": "Режим Порта Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position": "Розташування Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time": "Час Синхронізації Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type": "Тип Генератора",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time": "Максимальний Час Роботи",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time": "Мінімальний Час Роботи",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold": "Інтервал Захисту Роботи",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model": "Модель Лічильника",
  "50901.real_time.batteryWorkingStatus.desc": "Опис Стану Акумулятора",
  "50901.real_time.batteryWorkingStatus.1": "Очікування",
  "org.aiMessage.charge.fail": "",
  "org.aiMessage.charge.success": "",
  "org.aiMessage.discharge.fail": "",
  "org.aiMessage.discharge.success": "",
  "ai.message.charge.title.success": "Команду заряджання успішно виконано",
  "ai.message.charge.title.fail": "Помилка виконання команди заряджання",
  "ai.message.charge.content.success": "Команду заряджання успішно виконано. Стратегія ШІ працює в нормальному режимі.",
  "ai.message.charge.content.fail": "Помилка заряджання (3 автоматичні спроби). ШІ повторить спробу пізніше. Ручне керування можливе після вимкнення режиму ШІ.",
  "ai.message.discharge.title.success": "Команду розряджання успішно виконано",
  "ai.message.discharge.title.fail": "Помилка виконання команди розряджання",
  "ai.message.discharge.content.success": "Команду розряджання успішно виконано. Стратегія ШІ працює в нормальному режимі.",
  "ai.message.discharge.content.fail": "Помилка розряджання (3 автоматичні спроби). ШІ повторить спробу пізніше. Ручне керування можливе після вимкнення режиму ШІ.",
  "50901.fault.evCharger1CommunicationAbnormality": "Аномалія Зв’язку Зарядної Колонки Електромобіля 1",
  "50901.fault.bmsCanCommunicationAbnormality": "Аномалія Зв’язку Can Bms",
  "50901.fault.dtu3Rs485CommunicationAbnormality": "Аномалія Зв’язку Dtu3 Rs485",
  "50901.fault.gridMeterTypeError": "Помилка Типу Мережевого Лічильника",
  "50901.fault.lowDtuVersion": "Занадто Низька Версія Dtu",
  "50901.fault.gridMeterCommunicationAbnormality": "Аномалія Зв’язку Мережевого Лічильника",
  "50901.fault.pvMeterTypeError": "Помилка Типу Фотоелектричного Лічильника",
  "50901.fault.dspPwrCommunicationAbnormality": "Аномалія Зв’язку Живлення Dsp",
  "50901.fault.evCharger2CommunicationAbnormality": "Аномалія Зв’язку Зарядної Колонки Електромобіля 2",
  "50901.fault.dtu5Rs485CommunicationAbnormality": "Аномалія Зв’язку Dtu5 Rs485",
  "50901.fault.dtsCommunicationAbnormality": "Аномалія Зв’язку Dts",
  "50901.fault.dtu4Rs485CommunicationAbnormality": "Аномалія Зв’язку Dtu4 Rs485",
  "50901.fault.dtu1Rs485CommunicationAbnormality": "Аномалія Зв’язку Dtu1 Rs485",
  "50901.fault.pvMeterCommunicationAbnormality": "Аномалія Зв’язку Фотоелектричного Лічильника",
  "50901.fault.slaveWrongBatteryConnection": "Помилка Підключення Акумулятора Веденого Пристрою",
  "50901.fault.dtu2Rs485CommunicationAbnormality": "Аномалія Зв’язку Dtu2 Rs485",
  "50901.fault.dspSafCommunicationAbnormality": "Аномалія Безпечного Зв’язку Dsp",
  "50901.fault.sustainedNegativeLoad": "Тривала Негативна Нагрузка",
  "50901.fault.hmidMachineFault": "Несправність Пристрою Інтерфейсу Користувача",
  "50901.fault.evCharger1Fault": "Несправність Зарядної Колонки 1",
  "50901.fault.evCharger2Fault": "Несправність Зарядної Колонки 2",
  "50901.fault.fanSpeedAbnormality": "Аномалія Швидкості Вентилятора",
  "50901.fault.masterSlaveCommunicationAbnormality": "Аномалія Зв’язку Master-Slave",
  "50901.fault.batteryCapacityAbnormality": "Аномалія Ємності Акумулятора",
  "50901.fault.batteryForceChargeRequest": "Запит Примусового Заряду Акумулятора",
  "50901.fault.hmidCommunicationAbnormality": "Аномалія Зв’язку Інтерфейсу Користувача",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.desc": "Генератор періодично запускається в цей час",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.desc": "Генератор періодично запускається в цей час",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.desc": "Генератор періодично запускається в цей час",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.desc": "Генератор періодично запускається в цей час",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.desc": "Генератор періодично запускається в цей час",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.desc": "Генератор періодично запускається в цей час",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.desc": "Генератор періодично запускається в цей час",
  "50901.fault.loadRelayAfault.0": "Вимкнути",
  "50901.fault.fiveVoltPowerSupplyfault.0": "Вимкнути",
  "50901.fault.fiveVoltPowerSupplyfault.1": "Увімкнути",
  "50901.fault.genRelayAfault.0": "Вимкнути",
  "50901.fault.genRelayAfault.1": "Увімкнути",
  "50901.fault.genRelayBfault.0": "Вимкнути",
  "50901.fault.genRelayBfault.1": "Увімкнути",
  "50901.fault.kmRelayfault.0": "Вимкнути",
  "50901.fault.kmRelayfault.1": "Увімкнути",
  "50901.fault.twelveVoltPowerSupplyfault.1": "Увімкнути",
  "50901.fault.loadRelayAfault.1": "Увімкнути",
  "50901.fault.loadRelayBfault.0": "Вимкнути",
  "50901.fault.loadRelayBfault.1": "Увімкнути",
  "50901.fault.pvRelayAbfault.0": "Вимкнути",
  "50901.fault.pvRelayAbfault.1": "Увімкнути",
  "50901.fault.threePointThreeVoltPowerSupplyfault.0": "Вимкнути",
  "50901.fault.threePointThreeVoltPowerSupplyfault.1": "Увімкнути",
  "50901.fault.twelveVoltPowerSupplyfault.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.0": "Увімкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.1": "Увімкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.0": "Вимкнути",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.1": "Увімкнути",
  "50901.fault.loadRelayAfault": "Відмова реле навантаження A",
  "50901.fault.threePointThreeVoltPowerSupplyfault": "Несправність джерела живлення 3,3 В",
  "50901.fault.pvRelayAbfault": "Несправність реле PV AB",
  "50901.fault.twelveVoltPowerSupplyfault": "Несправність джерела живлення 12 В",
  "50901.fault.loadRelayBfault": "Відмова реле навантаження B",
  "50901.fault.kmRelayfault": "Несправність реле KM",
  "50901.fault.genRelayBfault": "Несправність реле генератора B",
  "50901.fault.genRelayAfault": "Несправність реле генератора A",
  "50901.fault.fiveVoltPowerSupplyfault": "Несправність джерела живлення 5 В",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4": "Час запуску режиму тренування генератора четвер",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3": "Час запуску режиму тренування генератора середа",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5": "Час запуску режиму тренування генератора п'ятниця",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6": "Час запуску режиму тренування генератора субота",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2": "Час запуску режиму тренування генератора вівторок",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7": "Час запуску режиму тренування генератора неділя",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1": "Час запуску режиму тренування генератора понеділок",
  "50901.fault.evCharger1CommunicationAbnormality.0": "Вимкнути",
  "50901.fault.evCharger1CommunicationAbnormality.1": "Увімкнути",
  "50901.fault.bmsCanCommunicationAbnormality.0": "Вимкнути",
  "50901.fault.bmsCanCommunicationAbnormality.1": "Увімкнути",
  "50901.fault.dtu3Rs485CommunicationAbnormality.0": "Вимкнути",
  "50901.fault.dtu3Rs485CommunicationAbnormality.1": "Увімкнути",
  "50901.fault.gridMeterTypeError.0": "Вимкнути",
  "50901.fault.gridMeterTypeError.1": "Увімкнути",
  "50901.fault.lowDtuVersion.0": "Вимкнути",
  "50901.fault.lowDtuVersion.1": "Увімкнути",
  "50901.fault.gridMeterCommunicationAbnormality.0": "Вимкнути",
  "50901.fault.gridMeterCommunicationAbnormality.1": "Увімкнути",
  "50901.fault.pvMeterTypeError.0": "Вимкнути",
  "50901.fault.pvMeterTypeError.1": "Увімкнути",
  "50901.fault.dspPwrCommunicationAbnormality.0": "Вимкнути",
  "50901.fault.dspPwrCommunicationAbnormality.1": "Увімкнути",
  "50901.fault.evCharger2CommunicationAbnormality.0": "Вимкнути",
  "50901.fault.evCharger2CommunicationAbnormality.1": "Увімкнути",
  "50901.fault.dtu5Rs485CommunicationAbnormality.0": "Вимкнути",
  "50901.fault.dtu5Rs485CommunicationAbnormality.1": "Увімкнути",
  "50901.fault.dtsCommunicationAbnormality.0": "Вимкнути",
  "50901.fault.dtsCommunicationAbnormality.1": "Увімкнути",
  "50901.fault.dtu4Rs485CommunicationAbnormality.0": "Вимкнути",
  "50901.fault.dtu4Rs485CommunicationAbnormality.1": "Увімкнути",
  "50901.fault.dtu1Rs485CommunicationAbnormality.0": "Вимкнути",
  "50901.fault.dtu1Rs485CommunicationAbnormality.1": "Увімкнути",
  "50901.fault.pvMeterCommunicationAbnormality.0": "Вимкнути",
  "50901.fault.pvMeterCommunicationAbnormality.1": "Увімкнути",
  "50901.fault.slaveWrongBatteryConnection.0": "Вимкнути",
  "50901.fault.slaveWrongBatteryConnection.1": "Увімкнути",
  "50901.fault.dtu2Rs485CommunicationAbnormality.0": "Вимкнути",
  "50901.fault.dtu2Rs485CommunicationAbnormality.1": "Увімкнути",
  "50901.fault.dspSafCommunicationAbnormality.0": "Вимкнути",
  "50901.fault.dspSafCommunicationAbnormality.1": "Увімкнути",
  "50901.fault.sustainedNegativeLoad.0": "Вимкнути",
  "50901.fault.sustainedNegativeLoad.1": "Увімкнути",
  "50901.fault.hmidMachineFault.0": "Вимкнути",
  "50901.fault.hmidMachineFault.1": "Увімкнути",
  "50901.fault.evCharger1Fault.0": "Вимкнути",
  "50901.fault.evCharger1Fault.1": "Увімкнути",
  "50901.fault.evCharger2Fault.0": "Вимкнути",
  "50901.fault.evCharger2Fault.1": "Увімкнути",
  "50901.fault.fanSpeedAbnormality.0": "Вимкнути",
  "50901.fault.fanSpeedAbnormality.1": "Увімкнути",
  "50901.fault.masterSlaveCommunicationAbnormality.0": "Вимкнути",
  "50901.fault.masterSlaveCommunicationAbnormality.1": "Увімкнути",
  "50901.fault.batteryCapacityAbnormality.0": "Вимкнути",
  "50901.fault.batteryCapacityAbnormality.1": "Увімкнути",
  "50901.fault.batteryForceChargeRequest.0": "Вимкнути",
  "50901.fault.batteryForceChargeRequest.1": "Увімкнути",
  "50901.fault.hmidCommunicationAbnormality.0": "Вимкнути",
  "50901.fault.hmidCommunicationAbnormality.1": "Увімкнути",
  "50901.fault.batteryFault": "Несправність Акумулятора",
  "50901.fault.fanFault.0": "Вимкнути",
  "50901.fault.armCommunicationFault.1": "Увімкнути",
  "50901.fault.batteryFault.0": "Вимкнути",
  "50901.fault.batteryFault.1": "Увімкнути",
  "50901.fault.evCharger1CommunicationAbnormality.desc": "Опис Аномалії Зв’язку Зарядної Колонки Електромобіля 1",
  "50901.fault.bmsCanCommunicationAbnormality.desc": "Опис Аномалії Зв’язку Can Bms",
  "50901.fault.dtu3Rs485CommunicationAbnormality.desc": "Опис Аномалії Зв’язку Dtu3 Rs485",
  "50901.fault.gridMeterTypeError.desc": "Опис Помилки Типу Мережевого Лічильника",
  "50901.fault.lowDtuVersion.desc": "Опис Занадто Низької Версії Dtu",
  "50901.fault.gridMeterCommunicationAbnormality.desc": "Опис Аномалії Зв’язку Мережевого Лічильника",
  "50901.fault.pvMeterTypeError.desc": "Опис Помилки Типу Фотоелектричного Лічильника",
  "50901.fault.dspPwrCommunicationAbnormality.desc": "Опис Аномалії Зв’язку Живлення Dsp",
  "50901.fault.evCharger2CommunicationAbnormality.desc": "Опис Аномалії Зв’язку Зарядної Колонки Електромобіля 2",
  "50901.fault.dtu5Rs485CommunicationAbnormality.desc": "Опис Аномалії Зв’язку Dtu5 Rs485",
  "50901.fault.dtsCommunicationAbnormality.desc": "Опис Аномалії Зв’язку Dts",
  "50901.fault.dtu4Rs485CommunicationAbnormality.desc": "Опис Аномалії Зв’язку Dtu4 Rs485",
  "50901.fault.dtu1Rs485CommunicationAbnormality.desc": "Опис Аномалії Зв’язку Dtu1 Rs485",
  "50901.fault.pvMeterCommunicationAbnormality.desc": "Опис Аномалії Зв’язку Фотоелектричного Лічильника",
  "50901.fault.slaveWrongBatteryConnection.desc": "Опис Помилки Підключення Акумулятора Веденого Пристрою",
  "50901.fault.dtu2Rs485CommunicationAbnormality.desc": "Опис Аномалії Зв’язку Dtu2 Rs485",
  "50901.fault.dspSafCommunicationAbnormality.desc": "Опис Аномалії Безпечного Зв’язку Dsp",
  "50901.fault.sustainedNegativeLoad.desc": "Опис Тривалої Негативної Нагрузки",
  "50901.fault.hmidMachineFault.desc": "Опис Несправності Пристрою Інтерфейсу Користувача",
  "50901.fault.evCharger1Fault.desc": "Опис Несправності Зарядної Колонки 1",
  "50901.fault.evCharger2Fault.desc": "Опис Несправності Зарядної Колонки 2",
  "50901.fault.fanSpeedAbnormality.desc": "Опис Аномалії Швидкості Вентилятора",
  "50901.fault.batteryFault.desc": "Опис Несправності Акумулятора",
  "50901.fault.masterSlaveCommunicationAbnormality.desc": "Опис Аномалії Зв’язку Master-Slave",
  "50901.fault.batteryCapacityAbnormality.desc": "Опис Аномалії Ємності Акумулятора",
  "50901.fault.batteryForceChargeRequest.desc": "Опис Запиту Примусового Заряду Акумулятора",
  "50901.fault.hmidCommunicationAbnormality.desc": "Опис Аномалії Зв’язку Інтерфейсу Користувача",
  "50901.fault.evCharger1CommunicationAbnormality.00": "Вимкнути",
  "50901.fault.evCharger1CommunicationAbnormality.01": "Увімкнути",
  "50901.fault.bmsCanCommunicationAbnormality.00": "Вимкнути",
  "50901.fault.bmsCanCommunicationAbnormality.01": "Увімкнути",
  "50901.fault.dtu3Rs485CommunicationAbnormality.00": "Вимкнути",
  "50901.fault.dtu3Rs485CommunicationAbnormality.01": "Увімкнути",
  "50901.fault.gridMeterTypeError.00": "Вимкнути",
  "50901.fault.gridMeterTypeError.01": "Увімкнути",
  "50901.fault.lowDtuVersion.00": "Вимкнути",
  "50901.fault.lowDtuVersion.01": "Увімкнути",
  "50901.fault.gridMeterCommunicationAbnormality.00": "Вимкнути",
  "50901.fault.gridMeterCommunicationAbnormality.01": "Увімкнути",
  "50901.fault.pvMeterTypeError.00": "Вимкнути",
  "50901.fault.pvMeterTypeError.01": "Увімкнути",
  "50901.fault.dspPwrCommunicationAbnormality.00": "Вимкнути",
  "50901.fault.dspPwrCommunicationAbnormality.01": "Увімкнути",
  "50901.fault.evCharger2CommunicationAbnormality.00": "Вимкнути",
  "50901.fault.evCharger2CommunicationAbnormality.01": "Увімкнути",
  "50901.fault.dtu5Rs485CommunicationAbnormality.00": "Вимкнути",
  "50901.fault.dtu5Rs485CommunicationAbnormality.01": "Увімкнути",
  "50901.fault.dtsCommunicationAbnormality.00": "Вимкнути",
  "50901.fault.dtsCommunicationAbnormality.01": "Увімкнути",
  "50901.fault.dtu4Rs485CommunicationAbnormality.00": "Вимкнути",
  "50901.fault.dtu4Rs485CommunicationAbnormality.01": "Увімкнути",
  "50901.fault.dtu1Rs485CommunicationAbnormality.00": "Вимкнути",
  "50901.fault.dtu1Rs485CommunicationAbnormality.01": "Увімкнути",
  "50901.fault.pvMeterCommunicationAbnormality.00": "Вимкнути",
  "50901.fault.pvMeterCommunicationAbnormality.01": "Увімкнути",
  "50901.fault.slaveWrongBatteryConnection.00": "Вимкнути",
  "50901.fault.slaveWrongBatteryConnection.01": "Увімкнути",
  "50901.fault.dtu2Rs485CommunicationAbnormality.00": "Вимкнути",
  "50901.fault.dtu2Rs485CommunicationAbnormality.01": "Увімкнути",
  "50901.fault.dspSafCommunicationAbnormality.00": "Вимкнути",
  "50901.fault.dspSafCommunicationAbnormality.01": "Увімкнути",
  "50901.fault.sustainedNegativeLoad.00": "Вимкнути",
  "50901.fault.sustainedNegativeLoad.01": "Увімкнути",
  "50901.fault.hmidMachineFault.00": "Вимкнути",
  "50901.fault.hmidMachineFault.01": "Увімкнути",
  "50901.fault.evCharger1Fault.00": "Вимкнути",
  "50901.fault.evCharger1Fault.01": "Увімкнути",
  "50901.fault.evCharger2Fault.00": "Вимкнути",
  "50901.fault.evCharger2Fault.01": "Увімкнути",
  "50901.fault.fanSpeedAbnormality.00": "Вимкнути",
  "50901.fault.fanSpeedAbnormality.01": "Увімкнути",
  "50901.fault.batteryFault.00": "Вимкнути",
  "50901.fault.batteryFault.01": "Увімкнути",
  "50901.fault.masterSlaveCommunicationAbnormality.00": "Вимкнути",
  "50901.fault.masterSlaveCommunicationAbnormality.01": "Увімкнути",
  "50901.fault.batteryCapacityAbnormality.00": "Вимкнути",
  "50901.fault.batteryCapacityAbnormality.01": "Увімкнути",
  "50901.fault.batteryForceChargeRequest.00": "Вимкнути",
  "50901.fault.batteryForceChargeRequest.01": "Увімкнути",
  "50901.fault.hmidCommunicationAbnormality.00": "Вимкнути",
  "50901.fault.hmidCommunicationAbnormality.01": "Увімкнути",
  "alarm.excDesc.2047494139783155712": "Несправність зв'язку ARM",
  "alarm.name.2047494139783155712": "Несправність зв'язку ARM",
  "plant.create.type.0": "Установник",
  "plant.create.type.1": "Кінцевий користувач",
  "not.configured": "Не налаштовано",
  "10001.quickset.note1": "1. Режим самоспоживання: Рекомендованим налаштуванням є режим самоспоживання. Цей режим максимізує використання фотоелектричної генерації для домашнього споживання або накопичує її в акумуляторах для використання вдома. 2. Режим пріоритету подачі в мережу: У цьому режимі енергія спочатку подається в мережу після задоволення навантаження; використовується в регіонах із субсидіями на подачу електроенергії в мережу. 3. Режим згладжування піків: Після встановлення режиму самоспоживання або пріоритету подачі в мережу можна також вибрати згладжування піків мережі, якщо місцева енергокомпанія тарифікує електроенергію на основі пікової потужності системи. Клієнти можуть увімкнути це згладжування, щоб уникнути пікового споживання в точці підключення до мережі. 4. Автономний режим: Цей режим використовується лише для повністю автономної роботи і не рекомендується для стандартних систем накопичення енергії. Зверніть увагу: якщо цей режим увімкнено в стані підключення до мережі, робоча логіка пристрою порушиться, і відобразиться \"Автономний режим\". 5. Використання за часом: Якщо вам потрібно вручну керувати заряджанням і розряджанням акумулятора за часом у режимах самоспоживання, пріоритету подачі в мережу або згладжування піків, використовуйте перемикач використання за часом та наступні контрольні точки. Параметр \"Дозволити заряджання від мережі\" в цих трьох режимах рекомендується ввімкненим (якщо вимкнено, інвертор не буде примусово заряджати акумулятор, і акумулятор може перейти в режим сну).",
  "10001.quickset.note2": "1. Режим самостійного використання: Рекомендованим налаштуванням є режим самостійного використання. Цей режим може максимізувати використання фотоелектричної енергії для побутової електроенергії або зберігати її в батареях і використовувати її для побутової електроенергії;\n2. Подача в пріоритетному режимі: цей режим може переважно відправляти енергію до мережі, коли навантаження задоволено, використовується в районах з субсидією на енергію до мережі;\n3. Режим голення піку: після встановлення режиму самовикористання або подачі в пріоритетному режимі, голення піку мережі також може бути обрано, коли місцева мережева компанія стягує ціну на електроенергію на основі пікового споживання енергії системи. Клієнти можуть вибрати цей пік гоління, щоб уникнути піку споживання потужності в точкі grid.connection;\n4. Режим поза мережею: цей режим використовується тільки для чистого поза мережею і не рекомендується для стандартних систем зберігання. Зверніть увагу, що якщо цей режим увімкнений у стані підключеної до мережі, робота логіки машини буде заплутана, і буде відображено \"Off-Grid\";\n5. Час використання: Якщо вам потрібно вручну керувати зарядкою та розрядкою батареї щодо часу при самостійному використанні або подачі в режимі пріоритетного або пікового голення, будь ласка, використовуйте вимикач часу використання та наступні встановлені точки. І \"Дозволити зарядку мережі\" в цих 3 режимах є або рекомендується включити (якщо вимкнуто, інвертор не змусить зарядити батарею, і батарея потенційно може заснути).",
  "10001.quickset.note3": "1. Режим самостійного використання: Рекомендованим налаштуванням є режим самостійного використання. Цей режим може максимізувати використання фотоелектричної енергії для побутової електроенергії або зберігати її в батареях і використовувати її для побутової електроенергії;\n2. Подача в пріоритетному режимі: цей режим може переважно відправляти енергію до мережі, коли навантаження задоволено, використовується в районах з субсидією на енергію до мережі;\n3. Режим поза мережею: цей режим використовується тільки для чистого поза мережею і не рекомендується для стандартних систем зберігання. Зверніть увагу, що якщо цей режим увімкнений у стані підключеної до мережі, робота логіки машини буде заплутана, і буде відображено \"Off-Grid\";\n4. Час використання: Якщо вам потрібно вручну керувати зарядкою та розрядкою батареї щодо часу при самостійному використанні або подачі в режимі пріоритетного або пікового голення, будь ласка, використовуйте вимикач часу використання та наступні встановлені точки. І \"Дозволити зарядку мережі\" в цих 3 режимах є або рекомендується включити (якщо вимкнуто, інвертор не змусить зарядити батарею, і батарея потенційно може заснути).",
  "chinaAreas.Shandong": "Shandong",
  "country.China": "Китай",
  "json.50901.workmode.timeSection": "Часовий відрізок",
  "json.device.dryWorking": "Суха робота",
  "device.dryWorking": "Суха робота",
  "51002.ctrl_antireverse": "Контроль протизворотного потоку",
  "51002.ctrl_inverter": "Контроль",
  "51002.null.数据分析_实时监控_PV.tag": "Моніторинг у реальному часі_PV",
  "51002.real_time": "Моніторинг у реальному часі",
  "51002.real_time.Energy_PV1.desc": "Накопичена енергія PV1",
  "51002.real_time.Energy_PV2.desc": "Накопичена енергія PV2",
  "51002.real_time.Energy_PV3.desc": "Накопичена енергія PV3",
  "51002.real_time.Energy_PV4.desc": "Накопичена енергія PV4",
  "51002.real_time.gridTotalFrequency.desc": "Загальна частота мережі",
  "51002.real_time.inverterTemp.desc": "Температура інвертора",
  "51002.real_time.pvPower.desc": "Вихідна потужність PV",
  "51002.real_time.stRelayoN.desc": "Стан підключення реле",
  "51002.real_time.workStatus.desc": "Робочий стан",
  "51002.real_time.数据分析_实时监控_GRID.tag": "Дані мережі",
  "51002.real_time.数据分析_实时监控_P.tag": "Вихідна потужність PV",
  "51002.real_time.数据分析_实时监控_PV.tag": "ФЕП",
  "51002.real_time.数据分析_实时监控_TP.tag": "Температура інвертора",
  "51002.warning": "Тривога",
  "51002.warning.stAbnorm_Ris.desc": "Аномалія ізоляційного опору",
  "51002.warning.stErrAccess_EEPROM.desc": "Аномалія доступу до EEPROM",
  "51002.warning.stErrOP_Relay.desc": "Аномалія реле на стороні мережі",
  "51002.warning.stHW_Fault.desc": "Апаратний захист інвертора",
  "51002.warning.stOV_Fgrid.desc": "Захист від перевищення частоти на стороні мережі",
  "51002.warning.stOV_Temp.desc": "Захист від перегріву інвертора",
  "51002.warning.stOV_Vgrid.desc": "Захист від перенапруги на стороні мережі",
  "51002.warning.stPV1_OV.desc": "Перенапруга на вході PV 1",
  "51002.warning.stPV1_UV.desc": "Знижена напруга на вході PV 1",
  "51002.warning.stPV2_OV.desc": "Перенапруга на вході PV 2",
  "51002.warning.stPV2_UV.desc": "Знижена напруга на вході PV 2",
  "51002.warning.stPV3_OV.desc": "Перенапруга на вході PV 3",
  "51002.warning.stPV3_UV.desc": "Знижена напруга на вході PV 3",
  "51002.warning.stPV4_OV.desc": "Перенапруга на вході PV 4",
  "51002.warning.stPV4_UV.desc": "Знижена напруга на вході PV 4",
  "51002.warning.stUV_Fgrid.desc": "Захист від зниження частоти на стороні мережі",
  "51002.warning.stUV_Vgrid.desc": "Захист від зниження напруги на стороні мережі",
  "51002..gridtype.desc": "Стандарт мережі",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.0": "Вимкнути",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.1": "Увімкнути",
  "51002.ctrl_inverter.ena10mVs1Prot.0": "Вимкнути",
  "51002.ctrl_inverter.ena10mVs1Prot.1": "Увімкнути",
  "51002.ctrl_inverter.enaAPP_PWSET.0": "Вимкнути",
  "51002.ctrl_inverter.enaAPP_PWSET.1": "Увімкнути",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.0": "Вимкнути",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.1": "Увімкнути",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.0": "Вимкнути",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.1": "Увімкнути",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.0": "Вимкнути",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.1": "Увімкнути",
  "51002.ctrl_inverter.enaRestoretodefault.0": "Вимкнути",
  "51002.ctrl_inverter.enaRestoretodefault.1": "Увімкнути",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.0": "Вимкнути",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.1": "Увімкнути",
  "51002.real_time.stRelayoN.0": "Від’єднати",
  "51002.real_time.stRelayoN.1": "Закрити",
  "51002.real_time.workStatus.0": "Вимкнення",
  "51002.real_time.workStatus.1": "Увімкнення",
  "51002.warning.stAbnorm_Ris.0": "Нормальна робота",
  "51002.warning.stAbnorm_Ris.1": "Запуск тривоги",
  "51002.warning.stErrAccess_EEPROM.0": "Нормальна робота",
  "51002.warning.stErrAccess_EEPROM.1": "Запуск тривоги",
  "51002.warning.stErrOP_Relay.0": "Нормальна робота",
  "51002.warning.stErrOP_Relay.1": "Запуск тривоги",
  "51002.warning.stHW_Fault.0": "Нормальна робота",
  "51002.warning.stHW_Fault.1": "Запуск тривоги",
  "51002.warning.stOV_Fgrid.0": "Нормальна робота",
  "51002.warning.stOV_Fgrid.1": "Запуск тривоги",
  "51002.warning.stOV_Temp.0": "Нормальна робота",
  "51002.warning.stOV_Temp.1": "Запуск тривоги",
  "51002.warning.stOV_Vgrid.0": "Нормальна робота",
  "51002.warning.stOV_Vgrid.1": "Запуск тривоги",
  "51002.warning.stPV1_OV.0": "Нормальна робота",
  "51002.warning.stPV1_OV.1": "Запуск тривоги",
  "51002.warning.stPV1_UV.0": "Нормальна робота",
  "51002.warning.stPV1_UV.1": "Запуск тривоги",
  "51002.warning.stPV2_OV.0": "Нормальна робота",
  "51002.warning.stPV2_OV.1": "Запуск тривоги",
  "51002.warning.stPV2_UV.0": "Нормальна робота",
  "51002.warning.stPV2_UV.1": "Запуск тривоги",
  "51002.warning.stPV3_OV.0": "Нормальна робота",
  "51002.warning.stPV3_OV.1": "Запуск тривоги",
  "51002.warning.stPV3_UV.0": "Нормальна робота",
  "51002.warning.stPV3_UV.1": "Запуск тривоги",
  "51002.warning.stPV4_OV.0": "Нормальна робота",
  "51002.warning.stPV4_OV.1": "Запуск тривоги",
  "51002.warning.stPV4_UV.0": "Нормальна робота",
  "51002.warning.stPV4_UV.1": "Запуск тривоги",
  "51002.warning.stUV_Fgrid.0": "Нормальна робота",
  "51002.warning.stUV_Fgrid.1": "Запуск тривоги",
  "51002.warning.stUV_Vgrid.0": "Нормальна робота",
  "51002.warning.stUV_Vgrid.1": "Запуск тривоги",
  "51002.ctrl_inverter.ena10mVs1Prot": "Увімкнення захисту від середнього перенапруги рівня 1 на стороні мережі за 10 хвилин",
  "51002.ctrl_inverter.enaINVTR.0": "Вимкнення",
  "51002.ctrl_inverter.enaINVTR.1": "Увімкнення",
  "51002.ctrl_inverter.enaOVTPWDN.0": "Вимкнути",
  "51002.ctrl_inverter.enaOVTPWDN.1": "Увімкнути",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck": "Перемикач функції самотестування інтерфейсу захисту системи",
  "51002.real_time.Energy_PV1": "Накопичена генерація електроенергії PV1",
  "51002.real_time.Energy_PV2": "Накопичена генерація електроенергії PV2",
  "51002.real_time.Energy_PV3": "Накопичена генерація електроенергії PV3",
  "51002.real_time.Energy_PV4": "Накопичена генерація електроенергії PV4",
  "51002.real_time.Firmware_ver": "Номер версії прошивки",
  "51002.real_time.Fn": "Номінальна частота мережі, підключеної до мережі",
  "51002.real_time.gridTotalFrequency": "Загальна частота",
  "51002.real_time.Iacrms": "Середньоквадратичне значення струму на стороні мережі",
  "51002.real_time.inverterTemp": "Температура інвертора",
  "51002.real_time.Ipv1": "Вхідний струм PV1",
  "51002.real_time.Ipv2": "Вхідний струм PV2",
  "51002.real_time.Ipv3": "Вхідний струм PV3",
  "51002.real_time.Ipv4": "Вхідний струм PV4",
  "51002.real_time.Ipvmax": "Максимальний вхідний струм PV",
  "51002.real_time.Irmsmax": "Максимальне середньоквадратичне значення струму підключення до мережі",
  "51002.real_time.Pn": "Максимальна активна потужність підключення до мережі",
  "51002.real_time.powerGeneration": "Загальна генерація електроенергії",
  "51002.real_time.Powpvmax": "Максимальна вхідна потужність PV",
  "51002.real_time.pvPower": "Вихідна потужність PV",
  "51002.real_time.stRelayoN": "Стан підключення реле",
  "51002.real_time.Tempmax": "Максимальна робоча температура",
  "51002.real_time.Un": "Середньоквадратичне значення номінальної напруги підключення до мережі",
  "51002.real_time.Vacrms": "Середньоквадратичне значення напруги на стороні мережі",
  "51002.real_time.Vmpptmax": "Максимальна напруга MPPT",
  "51002.real_time.Vmpptmin": "Мінімальна напруга MPPT",
  "51002.real_time.Vpv1": "Вхідна напруга PV1",
  "51002.real_time.Vpv2": "Вхідна напруга PV2",
  "51002.real_time.Vpv3": "Вхідна напруга PV3",
  "51002.real_time.Vpv4": "Вхідна напруга PV4",
  "51002.real_time.workStatus": "Робочий стан",
  "51002.warning.stAbnorm_Ris": "Аномалія ізоляційного опору",
  "51002.warning.stErrAccess_EEPROM": "Аномалія доступу до EEPROM",
  "51002.warning.stErrOP_Relay": "Захист від аномалії реле на стороні мережі",
  "51002.warning.stHW_Fault": "Апаратний захист інвертора",
  "51002.warning.stOV_Fgrid": "Захист від перевищення частоти на стороні мережі",
  "51002.warning.stOV_Temp": "Захист від перегріву інвертора",
  "51002.warning.stOV_Vgrid": "Захист від перенапруги на стороні мережі",
  "51002.warning.stPV1_OV": "Перенапруга на вході PV 1",
  "51002.warning.stPV1_UV": "Знижена напруга на вході PV 1",
  "51002.warning.stPV2_OV": "Перенапруга на вході PV 2",
  "51002.warning.stPV2_UV": "Знижена напруга на вході PV 2",
  "51002.warning.stPV3_OV": "Перенапруга на вході PV 3",
  "51002.warning.stPV3_UV": "Знижена напруга на вході PV 3",
  "51002.warning.stPV4_OV": "Перенапруга на вході PV 4",
  "51002.warning.stPV4_UV": "Знижена напруга на вході PV 4",
  "51002.warning.stUV_Fgrid": "Захист від зниження частоти на стороні мережі",
  "51002.warning.stUV_Vgrid": "Захист від зниження напруги на стороні мережі",
  "51002.ctrl_antireverse.dynamicPowerLimit": "Значення відсотка обмеження потужності проти зворотного потоку",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT": "Увімкнення протизворотного потоку",
  "51002.ctrl_inverter.enaAPP_PWSET": "Увімкнення налаштування потужності користувача",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj": "Увімкнення регулювання потужності за відхиленням частоти",
  "51002.ctrl_inverter.enaINVTR": "Віддалене ввімкнення/вимкнення інвертора",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT": "Увімкнення захисту від аномалії ізоляційного опору",
  "51002.ctrl_inverter.enaOVs1_powerdownadj": "Увімкнення зниження номіналу при перенапрузі першого рівня",
  "51002.ctrl_inverter.enaOVTPWDN": "Увімкнення зниження номіналу при перегріві",
  "51002.ctrl_inverter.enaRestoretodefault": "Відновлення типових значень захисту та функціональних перемикачів",
  "51002.ctrl_inverter.powersetUserApp": "Відсоток обмеження потужності користувача",
  "bw_param_ctrl_option_BackupMode": "Режим резервного живлення",
  "bw_param_ctrl_option_ Feed-inPriorityMode": "Пріоритет подачі в мережу",
  "50657.fault.comStatus": "Стан зв'язку",
  "50657.fault.comStatus.00": "Відключено",
  "50657.fault.comStatus.01": " Підключено",
  "50657.realtime.FADE": "profonda direttaПряма активна енергія глибокої ночі",
  "50657.realtime.FAFE": "direttaПряма активна енергія середнього навантаження",
  "50657.realtime.FAFE_PSD": "Пряма активна енергія середнього навантаження (попередній розрахунковий день)",
  "50657.realtime.FAPE": "direttaПряма активна енергія піку",
  "50657.realtime.FAPE_PSD": "Пряма активна енергія піку (попередній розрахунковий день)",
  "50657.realtime.FAPVE": "direttaПряма активна енергія піку та ночі",
  "50657.realtime.FAPVE_PSD": "Пряма активна енергія піку та ночі (попередній розрахунковий день)",
  "50657.realtime.FASE": "massimo direttaПряма активна енергія надпіку",
  "50657.realtime.FASE_PSD": "Пряма активна енергія надпіку (попередній розрахунковий день)",
  "50657.realtime.FAVE": "Пряма активна енергія ночі",
  "50657.realtime.FAVE_PSD": "Пряма активна енергія ночі (попередній розрахунковий день)",
  "50657.realtime.FTAE": "Загальна пряма активна енергія",
  "50657.realtime.FTAE_PSD": "Загальна пряма активна енергія (попередній розрахунковий день)",
  "50657.realtime.Fr": "Частота",
  "50657.realtime.Ia": "Струм фази А",
  "50657.realtime.Ib": "Струм фази Б",
  "50657.realtime.Ic": "Струм фази С",
  "50657.realtime.P": "Загальна активна потужність",
  "50657.realtime.Pa": "Загальна активна потужність фази А",
  "50657.realtime.Pb": "Загальна активна потужність фази Б",
  "50657.realtime.Pc": "Загальна активна потужність фази С",
  "50657.realtime.Pf": " Загальний коефіцієнт потужності",
  "50657.realtime.Pfa": "Коефіцієнт потужності фази А",
  "50657.realtime.Pfb": "Коефіцієнт потужності фази",
  "50657.realtime.Pfc": "Коефіцієнт потужності фази С",
  "50657.realtime.Q": "Загальна реактивна потужність",
  "50657.realtime.Qa": "Загальна реактивна потужність фази А",
  "50657.realtime.Qb": "Загальна реактивна потужність фази Б",
  "50657.realtime.Qc": "Загальна реактивна потужність фази С",
  "50657.realtime.RADE": "Зворотна активна енергія глибокої ночі",
  "50657.realtime.RAFE": "Зворотна активна енергія середнього навантаження",
  "50657.realtime.RAPE": "Зворотна активна енергія піку",
  "50657.realtime.RASE": "Зворотна активна енергія надпіку",
  "50657.realtime.RAVE": "Зворотна активна енергія ночі",
  "50657.realtime.RTAE": "Загальна зворотна активна енергія",
  "50657.realtime.S": "Загальна повна потужність",
  "50657.realtime.Sa": "Повна потужність фази А",
  "50657.realtime.Sb": "Повна потужність фази Б",
  "50657.realtime.Sc": "Повна потужність фази С",
  "50657.realtime.T": "Температура",
  "50657.realtime.Ua": "Напруга фази А",
  "50657.realtime.Uab": "Лінійна напруга АБ",
  "50657.realtime.Ub": "Напруга фази Б",
  "50657.realtime.Ubc": "Лінійна напруга БС",
  "50657.realtime.Uc": "Напруга фази С",
  "50657.realtime.Uca": "Лінійна напруга СА",
  "50657.realtime.Z0": "Імпеданс нульової послідовності",
  "50657.realtime.Zf": "Прямий імпеданс",
  "bw_param_ctrl_note_DispatchActivepower": "Встановлення цього значення на додатне число вказує на необхідність розряджання, а встановлення на від'ємне число вказує на необхідність заряджання.",
  "bw_param_ctrl_option_Forcedcharginganddischarging": "Примусове заряджання/розряджання",
  "bw_param_ctrl_option_GridUseCT&PVUseMeter": "Використання мережі CT、PV використання лічильника",
  "bw_param_ctrl_option_GridUseMeter&PVUseCT": "Використання мережі Лічильник, використання фотоелектричного струму CT",
  "bw_param_ctrl_option_DisableTimePeriodControl": "Вимкнути керування часовими періодами",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiodcontrol": "Увімкнути лише керування періодами заряджання",
  "bw_RTparam_name_TotalApparentPower_Grid": "Повна потужність лічильника (Загальна)",
  "bw_param_ctrl_name_FactoryReset ": "Заводський скид",
  "bw_param_ctrl_option_FactoryReset ": "Перезавантажити",
  "bw_param_ctrl_note_DSPReset": "Коли інформація про несправність не відповідає фактичній ситуації, її можна відновити перезавантаженням DSP. Наприклад, якщо в додатку виникає помилка втрати заземлення, але провід заземлення, підключений до інвертора, не від'єднано, її можна усунути перезавантаженням DSP.",
  "bw_param_ctrl_note_EMSReset": "При виникненні аномального збору даних скиньте налаштування EMS для відновлення системи.",
  "bw_param_ctrl_note_FactoryReset": "Якщо ви хочете встановити всі параметри інвертора за замовчуванням, можете скористатися цією функцією.",
  "bw_param_ctrl_option_Grid&PVuseCT": "Мережа та PV використовують CT",
  "bw_param_outage_soc_setting": "Налаштування SOC при відключенні живлення",
  "netherland.areas": "The Netherlands",
  "paramSet.grouping.safetySetting": "Налаштування норм безпеки",
  "ice.robot.strategy.type.int.str.sta.rev.pri": "Пріоритет доходу станції",
  "networkEnum.code.1": "LAN",
  "networkEnum.code.2": "WiFi",
  "networkEnum.code.3": "2G",
  "networkEnum.code.63": "4G",
  "networkEnum.code.12": "WiFi + BLE",
  "networkEnum.code.23": "WiFi + 4G + BLE",
  "networkEnum.code.62": "LAN",
  "networkEnum.code.64": "WiFi + AP",
  "networkEnum.code.65": "4G + BLE",
  "networkEnum.code.12,62": "WiFi + BLE + LAN",
  "networkEnum.code.62,63": "LAN + 4G",
  "networkEnum.code.23,62": "WiFi + BLE + LAN + 4G",
  "isShowService.show": "show",
  "transfer.operation.success": "",
  "transfer.operation.fail": "",
  "transfer.operation.unbind": "",
  "transfer.operation.withdraw": "",
  "login.correctEmail": "Будь ласка, введіть діючу адресу електронної пошти",
  "login.passLength": "Пароль має містити від 8 до 20 цифр",
  "login.passType": "Пароль повинен містити принаймні три цифри, великі літери, малі літери та англійські символи",
  "placeholder.input": "Будь ласка, введіть",
  "placeholder.startTime": "початковий час",
  "placeholder.endTime": "Час завершення",
  "placeholder.startDate": "Дата початку",
  "placeholder.endDate": "Дата кінця",
  "upload.imageDetail": "Подробиці зображення",
  "upload.seeOrigin": "Натисніть, щоб переглянути файл джерела",
  "upload.needOpen": "Можливо, потрібно звантажити і переглянути цей файл",
  "upload.knowandSure": "Знати і підтвердити",
  "upload.fail": "Спроба вивантаження зазнала невдачі",
  "upload.uploadError": "Спроба вивантаження файла зазнала невдачі, будь ласка, зв’ яжіться з адміністратором",
  "upload.fielExceed": "Кількість файлів перевищує межу",
  "upload.fileSizeExceed": "Розмір вивантаженого зображення не може перевищити",
  "upload.fileTypeError": "Будь ласка, виберіть правильний формат файла",
  "upload.image": "зображення",
  "validator.bank": "Будь ласка, введіть правильний номер банкарти",
  "validator.phone": "Будь ласка, введіть правильний номер мобільного телефону або контурного рядка",
  "validator.email": "Будь ласка, введіть правильну адресу електронної пошти",
  "validator.password": "Пароль має бути довгим 8- 20 символів і містити принаймні три типи символів: числа, верхні літери, маленькі літери і англійські символи",
  "validator.greater": "Будь ласка, введіть число більше ніж нуль",
  "org.user": "Користувач",
  "org.role": "роль",
  "org.email": "поштова скринька",
  "org.editorginfo": "Змінити організаційну інформацію",
  "org.passwordResetTo": "Пароль буде перевстановлено до",
  "org.pleaseChooseOrg": "Будь ласка, спочатку виберіть організацію",
  "org.addDept": "Додати відділ",
  "org.editDept": "Редакторний відділ",
  "org.passwordResetSuccess": "Перезавантаження пароля успішно",
  "org.passwordResetFail": "Помилка перевстановлення пароля",
  "org.deleteTip": "Ця операція вилучить відділ. Хочете продовжити?",
  "org.deleteSuccess": "Вилучити успішно",
  "org.parent": "Вища організація",
  "org.orgName": "Назва організації",
  "org.area": "Країна/ Регіон",
  "org.leader": "відповідальна особа",
  "org.leaderPhone": "Інформація про контакт відповідальної особи",
  "org.logo": "Лого організації",
  "org.namenick": "Назва/псевдонім",
  "org.createTime": "Час створення",
  "org.status": "стан",
  "org.action": "операція",
  "login.password.not.blank": "Пароль входу не може бути порожнім",
  "token.invalid": "Некоректна позначка, будь ласка, знову входьте",
  "token.empty": "Позначка не може бути порожньою",
  "user.not.exist": "користувача не існує",
  "user.mail.password.not.correct": "Електронна пошта або пароль користувача неправильні",
  "user.email.exist": "Електронна пошта зареєстрована!",
  "dept.suspend": "Департамент призупинено, нових додатків не дозволено",
  "dept.not.exist": "Інформація про департамент не існує",
  "email.code.valid": "Код перевірки неправильний",
  "service.not.found": "Служба не знайдена",
  "service.internal.error": "Внутрішня помилка сервера",
  "login.email.length.error": "Довжина електронної пошти не може перевищити 50 символів.",
  "login.password.length.error": "Довжина пароля має бути між 8- 20 символами",
  "menu.edit.exist": "Не вдалося змінити меню «% s », назва меню вже існує",
  "menu.add.exist": "Не вдалося додати меню «% s », назва меню вже існує",
  "menu.edit.parent": "Не вдалося змінити меню «% s », меню вищого рівня не може вибрати сам",
  "menu.add.parent": "Не вдалося додати меню «% s », меню вищого рівня не може вибрати сам",
  "menu.child.exist": "Існує підменю, який неможливо вилучити",
  "menu.assign.error": "Призначено меню, вилучення не дозволено",
  "password.reset.success": "Перезавантаження пароля успішно",
  "user.register.success": "реєстровано успішно",
  "dept.add.exist": "Не вдалося додати відділ «% s », назва відділу вже існує",
  "dept.edit.exist": "Не вдалося змінити відділ «% s », назва відділу вже існує",
  "menu.show.status": "показ",
  "menu.hide.status": "сховати",
  "menu.category.name": "каталог",
  "menu.menu.name": "меню",
  "menu.button.name": "Кнопка",
  "menu.is.external": "так",
  "menu.not.external": "ні",
  "dev.type.oem": "OEM",
  "dev.type.odm": "ODM",
  "dev.type.self": "Саморозвинений",
  "supplier.type.hr": "Заліс",
  "supplier.type.jl": "Джінлангchina. kgm",
  "supplier.type.nt": "Натонгvietnam. kgm",
  "device.category.inverter": "інвертер",
  "device.category.pv": "фотоволтаїчний",
  "device.category.battery": "Батерія",
  "device.category.switch": "switch",
  "device.category.charging.pile": "Завантаження станції",
  "product.not.exist": "Продукт не існує",
  "product.binding.error": "Продукт вже прив’ язаний і неможливо вилучити",
  "ship.import.empty": "Імпорт даних не може бути порожнім",
  "mdn.exist": "Номер матеріалу mdn вже існує, не додавати його знову",
  "ship.mdn.not.empty": "Mdn не може бути порожнім",
  "ship.category.not.empty": "Категорія не може бути порожньою",
  "ship.hrSn.not.empty": "Серійний номер волосся не може бути порожнім",
  "ship.devType.not.empty": "Тип R&D не може бути порожнім",
  "ship.supplierSn.not.empty": "Серійне число постачальника не може бути порожнім",
  "ship.mdn.not.exist": "Продукт mdn не існує",
  "ship.add.data.error": "Ненормальне додавання даних щодо керування надсиланнями, будь ласка, зв’ яжіться з адміністратором",
  "plant.InstallationPlan": "Схема установки",
  "plant.owner": "Владелец",
  "plant.photovoltaicCapacity": "Мощность фотоэлектрической системы (кВтч)",
  "plant.batteryCapacity": "Емкость аккумулятора (кВтч)",
  "plant.electricityConsumptionToday": "Выработка электроэнергии за сегодня",
  "plant.electricityConsumptionMonth": "Выработка электроэнергии за текущий месяц",
  "plant.electricityConsumptionTotal": "Кумулятивная выработка электроэнергии",
  "plant.runningState": "Stan robi",
  "plant.buildState": "Статус строительства",
  "plant.plantNum": "Количество электростанций",
  "plant.totalPlantNum": "Итого",
  "plant.building": "В стадии строительства",
  "plant.delivered": "Сдано в эксплуатацию",
  "plant.electricEnergy": "Выработка электроэнергии",
  "plant.deleteSuccess": "Электростанция успешно удалена",
  "plant.life": "Срок службы",
  "plant.operatingData": "Данные о работе",
  "plant.dataReportingTime": "Время отправки данных",
  "plant.energyBalance": "Энергетический баланс (кВт*ч)",
  "plant.onGridEnergy": "Подача электроэнергии в сеть",
  "plant.purchaseElectricity": "Покупка электроэнергии",
  "plant.statisticalAnalysis": "Статистический анализ",
  "plant.energyAnalysis": "Анализ энергии",
  "plant.powerAnalysis": "Анализ мощности",
  "plant.updateTime": "Час оновлення метеоданих",
  "plant.stationInfo": "Информация об электростанции",
  "plant.userInfo": "Информация о пользователе",
  "plant.socialContribution": "Социальный вклад",
  "plant.equivalentIncome": "Эквивалентная выгода",
  "plant.priceSet": "Настройки тарифа на электроэнергию",
  "plant.photovoltaicPowerGenerations": "Выработка электроэнергии фотоэлектрической системой",
  "plant.weather": "Погода",
  "plant.sunriseSunset": "Восход/Закат",
  "plant.temperature": "Температура(℃)",
  "plant.humidity": "Влажность",
  "plant.windSpeed": "Скорость ветра",
  "plant.windDirection": "Направление ветра",
  "plant.primaryUser": "Основной пользователь",
  "plant.receiveMode": "Способ получения",
  "plant.dateOfReceipt": "Дата получения",
  "plant.familyName": "Название семьи",
  "plant.familyMembers": "Количество членов семьи",
  "plant.currency": "Валюта",
  "plant.purchasePrice": "Цена покупки",
  "plant.sellingPrice": "Тариф на продажу электроэнергии",
  "plant.noUserInfo": "Пользователи, еще не сданные в эксплуатацию",
  "plant.noIncomeTip": "Для лучшего расчета вашей эквивалентной выгоды, пожалуйста, введите цены на покупку и продажу электроэнергии",
  "subttile.week": "Неделя",
  "shipment.spread": "Развернуть",
  "shipment.packUp": "Свернуть",
  "device.empty": "Пристрій не існує",
  "deviceType.empty": "Тип пристрою не підтримується",
  "collector.params.error": "Помилка читання параметрів незбірника",
  "can.not.empty": "Не може бути порожнім",
  "shipment.supplierSN": "Серійний номер постачальника (SN)",
  "solis.10001.eToday": "Добовий об’єм генерації електроенергії",
  "solis.10001.eMonth": "Місячний об’єм генерації електроенергії",
  "solis.10001.eYear": "Річний об’єм генерації електроенергії",
  "solis.10001.eTotal": "Загальний об’єм генерації електроенергії",
  "solis.10001.fAc": "Частота у електричній мережі",
  "solis.10001.pac": "Потужність у реальному часі",
  "solis.10001.pacPec": "Процентне відношення потужності",
  "solis.10001.fullHour": "Кількість годин повної потужності",
  "solis.10001.power": "Ємність змонтованого пристрою",
  "solis.10001.iAc1": "Електричний струм на стороні змінного струму - R",
  "solis.10001.iAc2": "Електричний струм на стороні змінного струму - S",
  "solis.10001.iAc3": "Електричний струм на стороні змінного струму - T",
  "solis.10001.uAc1": "Електрична напруга на стороні змінного струму - R",
  "solis.10001.uAc2": "Електрична напруга на стороні змінного струму - S",
  "solis.10001.uAc3": "Електрична напруга на стороні змінного струму - T",
  "solis.10001.iPv1": "PV струм-1",
  "solis.10001.iPv2": "PV струм-2",
  "solis.10001.iPv3": "PV струм-3",
  "solis.10001.iPv4": "PV струм-4",
  "solis.10001.iPv5": "PV струм-5",
  "solis.10001.iPv6": "PV струм-6",
  "solis.10001.iPv7": "PV струм-7",
  "solis.10001.iPv8": "PV струм-8",
  "solis.10001.iPv9": "PV струм-9",
  "solis.10001.iPv10": "PV струм-10",
  "solis.10001.iPv11": "PV струм-11",
  "solis.10001.iPv12": "PV струм-12",
  "solis.10001.iPv13": "PV струм-13",
  "solis.10001.iPv14": "PV струм-14",
  "solis.10001.iPv15": "PV струм-15",
  "solis.10001.iPv16": "PV струм-16",
  "solis.10001.iPv17": "PV струм-17",
  "solis.10001.iPv18": "PV струм-18",
  "solis.10001.iPv19": "PV струм-19",
  "solis.10001.iPv20": "PV струм-20",
  "solis.10001.iPv21": "PV струм-21",
  "solis.10001.iPv22": "PV струм-22",
  "solis.10001.iPv23": "PV струм-23",
  "solis.10001.iPv24": "PV струм-24",
  "solis.10001.iPv25": "PV струм-25",
  "solis.10001.iPv26": "PV струм-26",
  "solis.10001.iPv27": "PV струм-27",
  "solis.10001.iPv28": "PV струм-28",
  "solis.10001.iPv29": "PV струм-29",
  "solis.10001.iPv30": "PV струм-30",
  "solis.10001.iPv31": "PV струм-31",
  "solis.10001.iPv32": "PV струм-32",
  "solis.10001.uPv1": "PV напруга -1",
  "solis.10001.uPv2": "PV напруга -2",
  "solis.10001.uPv3": "PV напруга -3",
  "solis.10001.uPv4": "PV напруга -4",
  "solis.10001.uPv5": "PV напруга -5",
  "solis.10001.uPv6": "PV напруга -6",
  "solis.10001.uPv7": "PV напруга -7",
  "solis.10001.uPv8": "PV напруга -8",
  "solis.10001.uPv9": "PV напруга -9",
  "solis.10001.uPv10": "PV напруга -10",
  "solis.10001.uPv11": "PV напруга -11",
  "solis.10001.uPv12": "PV напруга -12",
  "solis.10001.uPv13": "PV напруга -13",
  "solis.10001.uPv14": "PV напруга -14",
  "solis.10001.uPv15": "PV напруга -15",
  "solis.10001.uPv16": "PV напруга -16",
  "solis.10001.uPv17": "PV напруга -17",
  "solis.10001.uPv18": "PV напруга -18",
  "solis.10001.uPv19": "PV напруга -19",
  "solis.10001.uPv20": "PV напруга -20",
  "solis.10001.uPv21": "PV напруга -21",
  "solis.10001.uPv22": "PV напруга -22",
  "solis.10001.uPv23": "PV напруга -23",
  "solis.10001.uPv24": "PV напруга -24",
  "solis.10001.uPv25": "PV напруга -25",
  "solis.10001.uPv26": "PV напруга -26",
  "solis.10001.uPv27": "PV напруга -27",
  "solis.10001.uPv28": "PV напруга -28",
  "solis.10001.uPv29": "PV напруга -29",
  "solis.10001.uPv30": "PV напруга -30",
  "solis.10001.uPv31": "PV напруга -31",
  "solis.10001.uPv32": "PV напруга -32",
  "solis.10001.pow1": "PV Потужність -1",
  "solis.10001.pow2": "PV Потужність -2",
  "solis.10001.pow3": "PV Потужність -3",
  "solis.10001.pow4": "PV Потужність -4",
  "solis.10001.pow5": "PV Потужність -5",
  "solis.10001.pow6": "PV Потужність -6",
  "solis.10001.pow7": "PV Потужність -7",
  "solis.10001.pow8": "PV Потужність -8",
  "solis.10001.pow9": "PV Потужність -9",
  "solis.10001.pow10": "PV Потужність -10",
  "solis.10001.pow11": "PV Потужність -11",
  "solis.10001.pow12": "PV Потужність -12",
  "solis.10001.pow13": "PV Потужність -13",
  "solis.10001.pow14": "PV Потужність -14",
  "solis.10001.pow15": "PV Потужність -15",
  "solis.10001.pow16": "PV Потужність -16",
  "solis.10001.pow17": "PV Потужність -17",
  "solis.10001.pow18": "PV Потужність -18",
  "solis.10001.pow19": "PV Потужність -19",
  "solis.10001.pow20": "PV Потужність -20",
  "solis.10001.pow21": "PV Потужність -21",
  "solis.10001.pow22": "PV Потужність -22",
  "solis.10001.pow23": "PV Потужність -23",
  "solis.10001.pow24": "PV Потужність -24",
  "solis.10001.pow25": "PV Потужність -25",
  "solis.10001.pow26": "PV Потужність -26",
  "solis.10001.pow27": "PV Потужність -27",
  "solis.10001.pow28": "PV Потужність -28",
  "solis.10001.pow29": "PV Потужність -29",
  "solis.10001.pow30": "PV Потужність -30",
  "solis.10001.pow31": "PV Потужність -31",
  "solis.10001.pow32": "PV Потужність -32",
  "solis.10001.inverterTemperature": "Температура інвертора(℃)",
  "solis.10001.acOutputType": "Клас виводу змінного струму",
  "solis.10001.dcInputType": "Кількість каналів вводу постійного струму",
  "solis.10001.powerFactor": "Фактор потужності",
  "solis.10001.batteryPower": "Потужність електричної батареї",
  "solis.10001.batteryPowerPec": "Процентне відношення потужності електричної батареї потужність",
  "solis.10001.batteryCapacitySoc": "SOC (рівень заряду) електричної батареї ",
  "solis.10001.batteryHealthSoh": "SOH (стан справності) електричної батареї",
  "solis.10001.socDischargeSet": "Надто сильне розрядження SOC (рівня заряду)",
  "solis.10001.socChargingSet": "SOC (рівень заряду) при сильній електричній зарядці",
  "solis.10001.batteryType": "Модель електричної батареї",
  "solis.10001.batteryVoltage": "Електрична напруга електричної батареї",
  "solis.10001.batteryCurrent": "Електричний струм електричної батареї",
  "solis.10001.batteryTodayChargeEnergy": "Об’єм електричного заряджання електричної батареї за день",
  "solis.10001.batteryMonthChargeEnergy": "Об’єм електричного заряджання електричної батареї за місяць",
  "solis.10001.batteryYearChargeEnergy": "Об’єм електричного заряджання електричної батареї за рік",
  "solis.10001.batteryTotalChargeEnergy": "Загальний об’єм електричного заряджання електричної батареї",
  "solis.10001.batteryTodayDischargeEnergy": "Об’єм розряджання електричної батареї за день",
  "solis.10001.batteryMonthDischargeEnergy": "Об’єм розряджання електричної батареї за місяць",
  "solis.10001.batteryYearDischargeEnergy": "Об’єм розряджання електричної батареї за рік",
  "solis.10001.batteryTotalDischargeEnergy": "Загальний об’єм розряджання електричної батареї",
  "solis.10001.gridPurchasedTodayEnergy": "Об’єм закупленої електричної енергії для електричної мережі за день",
  "solis.10001.gridPurchasedMonthEnergy": "Об’єм закупленої електричної енергії для електричної мережі за місяць",
  "solis.10001.gridPurchasedYearEnergy": "Об’єм закупленої електричної енергії для електричної мережі за рік",
  "solis.10001.gridPurchasedTotalEnergy": "Загальний об’єм закупленої електричної енергії для електричної мережі",
  "solis.10001.gridSellTodayEnergy": "Об’єм проданої електричної енергії для електричної мережі за день",
  "solis.10001.gridSellMonthEnergy": "Об’єм проданої електричної енергії для електричної мережі за місяць",
  "solis.10001.gridSellYearEnergy": "Об’єм проданої електричної енергії для електричної мережі за рік",
  "solis.10001.gridSellTotalEnergy": "Загальний об’єм проданої електричної енергії для електричної мережі",
  "solis.10001.familyLoadPower": "Побутова домашня потужність при навантаженні",
  "solis.10001.bypassLoadPower": "Байпасна потужність при навантаженні",
  "solis.10001.pSum": "Загальна активна потужність електричної мережі",
  "solis.10001.psumPec": "Процентне відношення загальної активної потужності електричної мережі",
  "solis.10001.homeLoadTodayEnergy": "Об’єм споживання при навантаженні за день",
  "solis.10001.homeLoadTotalEnergy": "Загальний об’єм споживання при навантаженні",
  "solis.10001.model": "Модель інвертора",
  "solis.10001.type": "Тип інвертора",
  "solis.10001.stateExceptionFlag": "Стан вимкнення пристрою інвертора",
  "solis.10001.productModel": "Модель продукції",
  "solis.10001.nationalStandards": "Державний стандарт електричної мережі",
  "solis.10001.version": "Версія програмного забезпечення інвертора",
  "solis.10001.reactivePower": "Реактивна потужність інвертора",
  "solis.10001.apparentPower": "Здатна потужність інвертора",
  "solis.10001.dcPac": "Загальна потужність вводу постійного струму",
  "solis.10001.updateShelfEndTime": "Час завершення гарантійного ремонту",
  "solis.10001.iA": "Електричний струм лічильника електроенергії A",
  "solis.10001.uA": "Електрична напруга лічильника електроенергії A",
  "solis.10001.pA": "Потужність лічильника електроенергії A",
  "solis.10001.aLookedPower": "Здатна потужність лічильника електроенергії A",
  "solis.10001.aReactivePower": "Реактивна потужність лічильника електроенергії A",
  "solis.10001.aphasePowerFactor": "Активна потужність лічильника електроенергії A",
  "solis.10001.averagePowerFactor": "Фактор потужності лічильника електроенергії A",
  "solis.10001.iB": "Електричний струм лічильника електроенергії B",
  "solis.10001.uB": "Електрична напруга лічильника електроенергії B",
  "solis.10001.pB": "Потужність лічильника електроенергії B",
  "solis.10001.bLookedPower": "Здатна потужність лічильника електроенергії B",
  "solis.10001.bReactivePower": "Реактивна потужність лічильника електроенергії B",
  "solis.10001.bphasePowerFactor": "Активна потужність лічильника електроенергії B",
  "solis.10001.bveragePowerFactor": "Фактор потужності лічильника електроенергії B",
  "solis.10001.iC": "Електричний струм лічильника електроенергії C",
  "solis.10001.uC": "Електрична напруга лічильника електроенергії C",
  "solis.10001.pC": "Потужність лічильника електроенергії C",
  "solis.10001.cLookedPower": "Здатна потужність лічильника електроенергії C",
  "solis.10001.cReactivePower": "Реактивна потужність лічильника електроенергії C",
  "solis.10001.cphasePowerFactor": "Активна потужність лічильника електроенергії C",
  "solis.10001.cveragePowerFactor": "Фактор потужності лічильника електроенергії C",
  "jl_param_ctrl_name_ChargeTimeSlot1Switch": "Слот часу зарядки 1 перемикач",
  "jl_param_ctrl_name_ChargeTimeSlot1": "Слот часу зарядки 1",
  "jl_param_ctrl_name_SOC1": "СОК 1",
  "jl_param_ctrl_name_ChargeCurrent1": "Зарядний струм 1",
  "jl_param_ctrl_name_ChargeTimeSlot2Switch": "Час зарядки Слот 2 Перемикач",
  "jl_param_ctrl_name_ChargeTimeSlot2": "Слот часу зарядки 2",
  "jl_param_ctrl_name_SOC2": "СОК 2",
  "jl_param_ctrl_name_ChargeCurrent2": "Зарядний струм 2",
  "jl_param_ctrl_name_ChargeTimeSlot3Switch": "Час зарядки Слот 3 Перемикач",
  "jl_param_ctrl_name_ChargeTimeSlot3": "Слот часу зарядки 3",
  "jl_param_ctrl_name_SOC3": "СОК 3",
  "jl_param_ctrl_name_ChargeCurrent3": "Зарядний струм 3",
  "jl_param_ctrl_name_ChargeTimeSlot4Switch": "Час зарядки Слот 4 Перемикач",
  "jl_param_ctrl_name_ChargeTimeSlot4": "Слот часу зарядки 4",
  "jl_param_ctrl_name_SOC4": "СОК 4",
  "jl_param_ctrl_name_ChargeCurrent4": "Зарядний струм 4",
  "jl_param_ctrl_name_ChargeTimeSlot5Switch": "Час зарядки Слот 5 Перемикач",
  "jl_param_ctrl_name_ChargeTimeSlot5": "Слот часу зарядки 5",
  "jl_param_ctrl_name_SOC5": "СОК 5",
  "jl_param_ctrl_name_ChargeCurrent5": "Зарядний струм 5",
  "jl_param_ctrl_name_ChargeTimeSlot6Switch": "Час зарядки Слот 6 Перемикач",
  "jl_param_ctrl_name_ChargeTimeSlot6": "Слот часу зарядки 6",
  "jl_param_ctrl_name_SOC6": "СОК 6",
  "jl_param_ctrl_name_ChargeCurrent6": "Зарядний струм 6",
  "jl_param_ctrl_name_DischargeTimeSlot1Switch": "Слот часу розряду 1 перемикач",
  "jl_param_ctrl_name_DischargeTimeSlot1": "Слот часу розряду 1",
  "jl_param_ctrl_name_DischargeCurrent1": "Розрядний струм 1",
  "jl_param_ctrl_name_DischargeTimeSlot2Switch": "Слот часу розряду 2 Перемикач",
  "jl_param_ctrl_name_DischargeTimeSlot2": "Слот часу розряду 2",
  "jl_param_ctrl_name_DischargeCurrent2": "Розрядний струм 2",
  "jl_param_ctrl_name_DischargeTimeSlot3Switch": "Слот часу розряду 3 перемикач",
  "jl_param_ctrl_name_DischargeTimeSlot3": "Слот часу розряду 3",
  "jl_param_ctrl_name_DischargeCurrent3": "Розрядний струм 3",
  "jl_param_ctrl_name_DischargeTimeSlot4Switch": "Слот часу розряду 4 перемикач",
  "jl_param_ctrl_name_DischargeTimeSlot4": "Слот часу розряду 4",
  "jl_param_ctrl_name_DischargeCurrent4": "Розрядний струм 4",
  "jl_param_ctrl_name_DischargeTimeSlot5Switch": "Слот часу розряду 5 перемикача",
  "jl_param_ctrl_name_DischargeTimeSlot5": "Слот часу розряду 5",
  "jl_param_ctrl_name_DischargeCurrent5": "Розрядний струм 5",
  "jl_param_ctrl_name_DischargeTimeSlot6Switch": "Слот часу розряду 6 перемикача",
  "jl_param_ctrl_name_DischargeTimeSlot6": "Слот часу розряду 6",
  "jl_param_ctrl_name_DischargeCurrent6": "Розрядний струм 6",
  "jl_param_ctrl_note_ChargeTimeSlot1": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "jl_param_ctrl_note_SOC1": "Діапазон: За розрядом SOC ~ 100%",
  "jl_param_ctrl_note_ChargeTimeSlot2": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "jl_param_ctrl_note_SOC2": "Діапазон: За розрядом SOC ~ 100%",
  "jl_param_ctrl_note_ChargeTimeSlot3": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "jl_param_ctrl_note_SOC3": "Діапазон: За розрядом SOC ~ 100%",
  "jl_param_ctrl_note_ChargeTimeSlot4": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "jl_param_ctrl_note_SOC4": "Діапазон: За розрядом SOC ~ 100%",
  "jl_param_ctrl_note_ChargeTimeSlot5": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "jl_param_ctrl_note_SOC5": "Діапазон: За розрядом SOC ~ 100%",
  "jl_param_ctrl_note_ChargeTimeSlot6": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "jl_param_ctrl_note_SOC6": "Діапазон: За розрядом SOC ~ 100%",
  "jl_param_ctrl_note_DischargeTimeSlot1": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "jl_param_ctrl_note_DischargeTimeSlot2": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "jl_param_ctrl_note_DischargeTimeSlot3": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "jl_param_ctrl_note_DischargeTimeSlot4": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "jl_param_ctrl_note_DischargeTimeSlot5": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "jl_param_ctrl_note_DischargeTimeSlot6": "Не повинно бути перекриття з іншими сильними періодами зарядки та розрядки",
  "device.category.collecting.box": "Комбінаторний ксивер",
  "device.category.energy.storage": "Одновазовий керування енергією",
  "ywt.65323.runStatus": "Stan robi",
  "ywt.65323.faultStatus1": "",
  "ywt.65323.faultStatus2": "",
  "ywt.65323.warningStatus": "",
  "ywt.65323.relayStatus": "",
  "ywt.65323.inverterTemperature": "",
  "ywt.65323.dcTemperature": "",
  "ywt.65323.drmStatus": "",
  "ywt.65323.mpptTemperature": "",
  "ywt.65323.gridVoltageAB": "",
  "ywt.65323.gridVoltageBC": "",
  "ywt.65323.gridVoltageCA": "",
  "ywt.65323.gridCurrentA": "",
  "ywt.65323.gridCurrentB": "",
  "ywt.65323.gridCurrentC": "",
  "ywt.65323.gridFrequencyA": "",
  "ywt.65323.gridFrequencyB": "",
  "ywt.65323.gridFrequencyC": "",
  "ywt.65323.gridActivePower": "",
  "ywt.65323.gridAPhaseActivePower": "",
  "ywt.65323.gridBPhaseActivePower": "",
  "ywt.65323.gridCPhaseActivePower": "",
  "ywt.65323.gridReactivePower": "",
  "ywt.65323.gridApparentPower": "",
  "ywt.65323.powerFactor": "",
  "ywt.65323.dcComponentA": "",
  "ywt.65323.dcComponentB": "",
  "ywt.65323.dcComponentC": "",
  "ywt.65323.phaseOrder": "",
  "ywt.65323.leakageCurrent": "",
  "ywt.65323.clsStatus": "",
  "ywt.65323.clsLockNum": "",
  "ywt.65323.clsLockTime": "",
  "ywt.65323.returnFlowPortVoltageA": "",
  "ywt.65323.returnFlowPortVoltageB": "",
  "ywt.65323.returnFlowPortVoltageC": "",
  "ywt.65323.returnFlowPortCurrentA": "",
  "ywt.65323.returnFlowPortCurrentB": "",
  "ywt.65323.returnFlowPortCurrentC": "",
  "ywt.65323.returnFlowPortTotalActivePower": "",
  "ywt.65323.returnFlowPortAPhaseActivePower": "",
  "ywt.65323.returnFlowPortBPhaseActivePower": "",
  "ywt.65323.returnFlowPortCPhaseActivePower": "",
  "ywt.65323.returnFlowPortReactivePower": "",
  "ywt.65323.returnFlowPortApparentPower": "",
  "ywt.65323.returnFlowPortFrequency": "",
  "ywt.65323.returnFlowPortPowerFactor": "",
  "ywt.65323.todayFeedInGridEnergy": "",
  "ywt.65323.todayConsumeEnergy": "",
  "ywt.65323.totalFeedInGridEnergy": "",
  "ywt.65323.totalConsumeEnergy": "",
  "ywt.65323.ctStatus": "",
  "ywt.65323.ctVoltageA": "",
  "ywt.65323.ctVoltageB": "",
  "ywt.65323.ctVoltageC": "",
  "ywt.65323.ctCurrentA": "",
  "ywt.65323.ctCurrentB": "",
  "ywt.65323.ctCurrentC": "",
  "ywt.65323.ctTotalActivePower": "",
  "ywt.65323.ctAPhaseActivePower": "",
  "ywt.65323.ctBPhaseActivePower": "",
  "ywt.65323.ctCPhaseActivePower": "",
  "ywt.65323.ctReactivePower": "",
  "ywt.65323.ctApparentPower": "",
  "ywt.65323.ctFrequency": "",
  "ywt.65323.ctPowerFactor": "",
  "ywt.65323.loadVoltageA": "",
  "ywt.65323.loadVoltageB": "",
  "ywt.65323.loadVoltageC": "",
  "ywt.65323.loadCurrentA": "",
  "ywt.65323.loadCurrentB": "",
  "ywt.65323.loadCurrentC": "",
  "ywt.65323.loadFrequency": "",
  "ywt.65323.loadActivePower": "",
  "ywt.65323.loadAPhaseActivePower": "",
  "ywt.65323.loadBPhaseActivePower": "",
  "ywt.65323.loadCPhaseActivePower": "",
  "ywt.65323.loadReactivePower": "",
  "ywt.65323.loadTodayConsumeEnergy": "",
  "ywt.65323.loadTotalConsumeEnergy": "",
  "ywt.65323.pv1Voltage": "",
  "ywt.65323.pv2Voltage": "",
  "ywt.65323.pv3Voltage": "",
  "ywt.65323.pv4Voltage": "",
  "ywt.65323.pv5Voltage": "",
  "ywt.65323.pv6Voltage": "",
  "ywt.65323.pv1Current": "",
  "ywt.65323.pv2Current": "",
  "ywt.65323.pv3Current": "",
  "ywt.65323.pv4Current": "",
  "ywt.65323.pv5Current": "",
  "ywt.65323.pv6Current": "",
  "ywt.65323.pv1Power": "",
  "ywt.65323.pv2Power": "",
  "ywt.65323.pv3Power": "",
  "ywt.65323.pv4Power": "",
  "ywt.65323.pv5Power": "",
  "ywt.65323.pv6Power": "",
  "ywt.65323.pvTotalPower": "",
  "ywt.65323.busVoltage": "",
  "ywt.65323.pvTodayEnergy": "",
  "ywt.65323.pvMonthlyEnergy": "",
  "ywt.65323.pvAnnualEnergy": "",
  "ywt.65323.pvTotalEnergy": "",
  "ywt.65323.negativeElectrodeInsulationImpedance": "",
  "ywt.65323.positiveElectrodeInsulationImpedance1": "",
  "ywt.65323.positiveElectrodeInsulationImpedance2": "",
  "ywt.65323.positiveElectrodeInsulationImpedance3": "",
  "ywt.65323.positiveElectrodeInsulationImpedance4": "",
  "ywt.65323.positiveElectrodeInsulationImpedance5": "",
  "ywt.65323.positiveElectrodeInsulationImpedance6": "",
  "ywt.65323.batteryVoltage": "Напруга акумулятора",
  "ywt.65323.batteryCurrent": "Струм акумулятора",
  "ywt.65323.batteryPower": "Акумулятора",
  "ywt.65323.batterySOC": "Акумулятор SOC",
  "ywt.65323.batterySOH": "Акумулятор SOH",
  "ywt.65323.batteryStatus": "Стан батареї",
  "ywt.65323.batChargeVoltage": "Напруга зарядки",
  "ywt.65323.bmsBatteryVoltage": "Напруга акумулятора BMS",
  "ywt.65323.bmsBatteryCurrent": "Струм акумулятора BMS",
  "ywt.65323.bmsTemperature": "Температура БМС(℃)",
  "ywt.65323.bmsChargeCurrentLimit": "Обмеження зарядного струму BMS",
  "ywt.65323.bmsDischargeCurrentLimit": "Обмеження струму розряду BMS",
  "ywt.65323.batTodayChargeEnergy": "Кількість заряду акумулятора в той же день",
  "ywt.65323.batTodayDischargeEnergy": "Акумулятор розряджається в той же день",
  "ywt.65323.batTotalChargeEnergy": "Накопичувальний заряд акумулятора",
  "ywt.65323.batTotalDischargeEnergy": "Накопичувальний розряд акумулятора",
  "ywt.65323.bmsMaxVoltage": "Максимальна напруга BMS",
  "ywt.65323.bmsMinVoltage": "Мінімальна напруга BMS",
  "ywt.65323.batFaultFlag": "Прапорці несправності акумулятора",
  "ywt.65323.batAlarmFlag": "Прапорець сигналізації акумулятора",
  "ywt.65323.bmsRequestFlag": "Прапорець запиту BMS",
  "ywt.65323.generatorRelayStatus": "",
  "ywt.65323.load2GeneratorVoltageA": "",
  "ywt.65323.load2GeneratorVoltageB": "",
  "ywt.65323.load2GeneratorVoltageC": "",
  "ywt.65323.load2GeneratorCurrentA": "",
  "ywt.65323.load2GeneratorCurrentB": "",
  "ywt.65323.load2GeneratorCurrentC": "",
  "ywt.65323.load2GeneratorFrequency": "",
  "ywt.65323.load2GeneratorActivePower": "",
  "ywt.65323.load2GeneratorAPhaseActivePower": "",
  "ywt.65323.load2GeneratorBPhaseActivePower": "",
  "ywt.65323.load2GeneratorCPhaseActivePower": "",
  "ywt.65323.load2GeneratorReactivePower": "",
  "ywt.65323.load2GeneratorTodayConsumeEnergy": "",
  "ywt.65323.load2GeneratorTotalConsumeEnergy": "",
  "ywt.65323.load2GeneratorTodayGenerateEnergy": "",
  "ywt.65323.load2GeneratorTotalGenerateEnergy": "",
  "ywt.65323.spiAutoTestResult": "",
  "ywt.65323.spiAutoTestEndFlag": "",
  "ywt.65323.spiAutoTestThresholdAPhaseU1": "",
  "ywt.65323.spiAutoTestThresholdAPhaseU2": "",
  "ywt.65323.spiAutoTestThresholdAPhaseU3": "",
  "ywt.65323.spiAutoTestThresholdAPhaseU4": "",
  "ywt.65323.spiAutoTestThresholdBPhaseU1": "",
  "ywt.65323.spiAutoTestThresholdBPhaseU2": "",
  "ywt.65323.spiAutoTestThresholdBPhaseU3": "",
  "ywt.65323.spiAutoTestThresholdBPhaseU4": "",
  "ywt.65323.spiAutoTestThresholdCPhaseU1": "",
  "ywt.65323.spiAutoTestThresholdCPhaseU2": "",
  "ywt.65323.spiAutoTestThresholdCPhaseU3": "",
  "ywt.65323.spiAutoTestThresholdCPhaseU4": "",
  "ywt.65323.spiAutoTestThresholdF1": "",
  "ywt.65323.spiAutoTestThresholdF2": "",
  "ywt.65323.spiAutoTestThresholdF3": "",
  "ywt.65323.spiAutoTestThresholdF4": "",
  "ywt.65323.spiAutoTestTimeAPhaseU1": "",
  "ywt.65323.spiAutoTestTimeAPhaseU2": "",
  "ywt.65323.spiAutoTestTimeAPhaseU3": "",
  "ywt.65323.spiAutoTestTimeAPhaseU4": "",
  "ywt.65323.spiAutoTestTimeBPhaseU1": "",
  "ywt.65323.spiAutoTestTimeBPhaseU2": "",
  "ywt.65323.spiAutoTestTimeBPhaseU3": "",
  "ywt.65323.spiAutoTestTimeBPhaseU4": "",
  "ywt.65323.spiAutoTestTimeCPhaseU1": "",
  "ywt.65323.spiAutoTestTimeCPhaseU2": "",
  "ywt.65323.spiAutoTestTimeCPhaseU3": "",
  "ywt.65323.spiAutoTestTimeCPhaseU4": "",
  "ywt.65323.spiAutoTestTimeF1": "",
  "ywt.65323.spiAutoTestTimeF2": "",
  "ywt.65323.spiAutoTestTimeF3": "",
  "ywt.65323.spiAutoTestTimeF4": "",
  "mini.65290.stOV_Vgrid": "Сумарний об’єм генерації електроенергії PV3",
  "mini.65290.stUV_Vgrid": "Ввідна електрична напруга PV4",
  "mini.65290.stOV_Fgrid": "Ввідний електричний струм PV4",
  "mini.65290.stUV_Fgrid": "Резервний стан 4",
  "mini.65290.stOV_Temp": "Ввідна електрична напруга PV4",
  "mini.65290.stHW_Fault": "Ввідний електричний струм PV4",
  "mini.65290.stErrOP_Relay": "Сумарний об’єм генерації електроенергії PV4",
  "mini.65290.stErrAccess_EEPROM": "Ввідна електрична напруга PV5",
  "mini.65290.stAbnorm_Ris": "Ввідний електричний струм PV5",
  "mini.65290.Vacrms": "Резервний стан 5",
  "mini.65290.Iacrms": "Ввідна електрична напруга PV5",
  "mini.65290.Fgrid": "Ввідний електричний струм PV5",
  "mini.65290.Temperature": "Сумарний об’єм генерації електроенергії PV5(℃)",
  "mini.65290.stPV1_UV": "Ввідна електрична напруга PV6",
  "mini.65290.stPV1_OV": "Ввідний електричний струм PV6",
  "mini.65290.stRes1": "Резервний стан 6",
  "mini.65290.Vpv1": "Ввідна електрична напруга PV6",
  "mini.65290.Ipv1": "Ввідний електричний струм PV6",
  "mini.65290.Energy_PV1": "Сумарний об’єм генерації електроенергії PV6",
  "mini.65290.stPV2_UV": "Недостатня напруга вводу 2 фотогальванічної напруги PV",
  "mini.65290.stPV2_OV": "Перевищена напруга вводу 2 фотогальванічної напруги PV",
  "mini.65290.stRes2": "Резервний стан 2",
  "mini.65290.Vpv2": "Ввідна електрична напруга PV2",
  "mini.65290.Ipv2": "Ввідний електричний струм PV2",
  "mini.65290.Energy_PV2": "Сумарний об’єм генерації електроенергії PV2",
  "mini.65290.stPV3_UV": "Недостатня напруга вводу 3 фотогальванічної напруги PV",
  "mini.65290.stPV3_OV": "Перевищена напруга вводу 3 фотогальванічної напруги PV",
  "mini.65290.stRes3": "Резервний стан 3",
  "mini.65290.Vpv3": "Ввідна електрична напруга PV3",
  "mini.65290.Ipv3": "Ввідний електричний струм PV3",
  "mini.65290.Energy_PV3": "Сумарний об’єм генерації електроенергії PV3",
  "mini.65290.stPV4_UV": "Ввідна електрична напруга PV4",
  "mini.65290.stPV4_OV": "Ввідний електричний струм PV4",
  "mini.65290.stRes4": "Резервний стан 4",
  "mini.65290.Vpv4": "Ввідна електрична напруга PV4",
  "mini.65290.Ipv4": "Ввідний електричний струм PV4",
  "mini.65290.Energy_PV4": "Сумарний об’єм генерації електроенергії PV4",
  "mini.65290.stPV5_UV": "Ввідна електрична напруга PV5",
  "mini.65290.stPV5_OV": "Ввідний електричний струм PV5",
  "mini.65290.stRes5": "Резервний стан 5",
  "mini.65290.Vpv5": "Ввідна електрична напруга PV5",
  "mini.65290.Ipv5": "Ввідний електричний струм PV5",
  "mini.65290.Energy_PV5": "Сумарний об’єм генерації електроенергії PV5",
  "mini.65290.stPV6_UV": "Ввідна електрична напруга PV6",
  "mini.65290.stPV6_OV": "Ввідний електричний струм PV6",
  "mini.65290.stRes6": "Резервний стан 6",
  "mini.65290.Vpv6": "Ввідна електрична напруга PV6",
  "mini.65290.Ipv6": "Ввідний електричний струм PV6",
  "mini.65290.Energy_PV6": "Сумарний об’єм генерації електроенергії PV6",
  "mini.65290.StINVTPOWERON": "Стан функціонування інвертора ",
  "mini.65290.stRelayoN": "Стан з’єднувального підключення реле ",
  "mini.65290.activePower": "Активна потужність ",
  "mini.65290.Res10": "",
  "mini.65290.Res11": "",
  "mini.65290.Res12": "",
  "mini.65290.Res13": "",
  "mini.65290.Res14": "",
  "mini.65290.Res15": "",
  "mini.65290.Res16": "",
  "mini.65290.Res17": "",
  "mini.65290.Res18": "",
  "mini.65290.Res19": "",
  "mini.65290.Res20": "",
  "mini.65290.Un": "Ефективне значення номінальної електричної напруги з підключенням до електричної мережі",
  "mini.65290.Fn": "Номінальна частота з підключенням до електричної мережі",
  "mini.65290.Pn": "Максимальна активна потужність з підключенням до мережі",
  "mini.65290.Irmsmax": "Максимальне ефективне значення електричного струму з підключенням до мережі ",
  "mini.65290.Vmpptmin": "Мінімальна електрична напруга mppt (трасування точки максимальної потужності) ",
  "mini.65290.Vmpptmax": "Максимальна електрична напруга mppt (трасування точки максимальної потужності) ",
  "mini.65290.Powpvmax": "Максимальна ввідна потужність фотогальванічної напруги PV ",
  "mini.65290.Ipvmax": "Максимальний ввідній електричний струм фотогальванічної напруги PV ",
  "mini.65290.Tempmax": "Максимальна робоча температура(℃)",
  "mini.65290.Firmware_ver1": "Версія вбудованого програмного забезпечення 1",
  "mini.65290.Firmware_ver2": "Версія вбудованого програмного забезпечення 2",
  "mini.65290.Firmware_ver3": "Версія вбудованого програмного забезпечення 3",
  "mini.65290.UpdateProgress": "Прогрес модернізації ",
  "mini.65290.DeviceID": "Порядковий номер обладнання",
  "storage.v2.65284.pvInputVoltage": "Фотогальванічна ввідна електрична напруга ",
  "storage.v2.65284.pvGenerartion": "Поточна потужність генерації електроенергії за рахунок фотогальванічних сонячних елементів ",
  "storage.v2.65284.pvEnergyDay": "Сумарний об’єм генерації електроенергії за поточну добу за рахунок фотогальванічних сонячних елементів",
  "storage.v2.65284.pvEnergyTotal": "Сумарний об’єм генерації електроенергії за рахунок фотогальванічних сонячних елементів",
  "storage.v2.65284.batteryVoltage": "Електрична напруга електричної батареї ",
  "storage.v2.65284.batteryCurrent": "Електричний струм заряджання-розряджання електричної батареї ",
  "storage.v2.65284.dcOutputCurrent": "Електричний струм виводу постійного стуму",
  "storage.v2.65284.dcOutputPower": "Потужність виводу постійного стуму",
  "storage.v2.65284.ratedCapacity": "Номінальна ємність електричної батареї",
  "storage.v2.65284.batterySOC": "SOC (рівень заряду) для залишкової ємності електричної батареї",
  "storage.v2.65284.cycleNumber": "Число циклів заряджання-розряджання",
  "storage.v2.65284.internalTemp": "Системна внутрішня температура(℃)",
  "storage.v2.65284.heatsinkTemp": "Температура радіатора(℃)",
  "storage.v2.65284.batteryTemp1": "Температура блока електричних батарей 1(℃)",
  "storage.v2.65284.batteryTemp2": "Температура блока електричних батарей 2(℃)",
  "storage.v2.65284.BMSTemp": "Температура BMS (системи керування електричною батареєю)(℃)",
  "storage.v2.65284.cellVoltage1": "Електрична напруга елемента електроживлення 1",
  "storage.v2.65284.cellVoltage2": "Електрична напруга елемента електроживлення 2",
  "storage.v2.65284.cellVoltage3": "Електрична напруга елемента електроживлення 3",
  "storage.v2.65284.cellVoltage4": "Електрична напруга елемента електроживлення 4",
  "storage.v2.65284.cellVoltage5": "Електрична напруга елемента електроживлення 5",
  "storage.v2.65284.cellVoltage6": "Електрична напруга елемента електроживлення 6",
  "storage.v2.65284.cellVoltage7": "Електрична напруга елемента електроживлення 7",
  "storage.v2.65284.cellVoltage8": "Електрична напруга елемента електроживлення 8",
  "storage.v2.65284.cellVoltage9": "Електрична напруга елемента електроживлення 9",
  "storage.v2.65284.cellVoltage10": "Електрична напруга елемента електроживлення 10",
  "storage.v2.65284.cellVoltage11": "Електрична напруга елемента електроживлення 11",
  "storage.v2.65284.cellVoltage12": "Електрична напруга елемента електроживлення 12",
  "storage.v2.65284.cellVoltage13": "Електрична напруга елемента електроживлення 13",
  "storage.v2.65284.cellVoltage14": "Електрична напруга елемента електроживлення 14",
  "storage.v2.65284.cellVoltage15": "Електрична напруга елемента електроживлення 15",
  "storage.v2.65284.cellVoltage16": "Електрична напруга елемента електроживлення 16",
  "storage.v2.65284.BMSWorkingStatus": "Робочий стан BMS (системи керування електричною батареєю)",
  "storage.v2.65284.runningStatus": "Стан функціонування обладнання ",
  "storage.v2.65284.time": "Час у обладнанні",
  "storage.v2.65284.invPower": "Потужність мікро-інвертування ",
  "storage.s3.65292.batVoltage": "Електрична напруга електричної батареї ",
  "storage.s3.65292.batCurrent": "Електричний струм електричної батареї ",
  "storage.s3.65292.batChargePower": "Потужність при електричному заряджанні електричної батареї",
  "storage.s3.65292.mainsChargeCurrent": "Електричний струм при електричному заряджанні від міської електричної мережі",
  "storage.s3.65292.pvChargeCurrent": "Електричний струм при електричному заряджанні при фотогальванічній напрузі PV",
  "storage.s3.65292.pv1Voltage": "Електрична напруга фотогавальнічної панелі на ланцюгу №1",
  "storage.s3.65292.pv1Current": "Електричний струм фотогавальнічної панелі на ланцюгу №1",
  "storage.s3.65292.pv1Power": "Потужність виводу фотогавальнічної панелі на ланцюгу №1",
  "storage.s3.65292.pv2Voltage": "Електрична напруга фотогавальнічної панелі на ланцюгу №2",
  "storage.s3.65292.pv2Current": "Електричний струм фотогавальнічної панелі на ланцюгу №2",
  "storage.s3.65292.pv2Power": "Потужність виводу фотогавальнічної панелі на ланцюгу №2",
  "storage.s3.65292.aPhaseVoltage": "Електрична напруга виводу фази А",
  "storage.s3.65292.aPhaseCurrent": "Електричний струм виводу фази А",
  "storage.s3.65292.aPhaseActivePower": "Активна потужність виводу фази А",
  "storage.s3.65292.aPhaseApparentPower": "Здатна потужність виводу фази А",
  "storage.s3.65292.bPhaseVoltage": "Електрична напруга виводу фази B",
  "storage.s3.65292.bPhaseCurrent": "Електричний струм виводу фази B",
  "storage.s3.65292.bPhaseActivePower": "Активна потужність виводу фази B",
  "storage.s3.65292.bPhaseApparentPower": "Здатна потужність виводу фази B",
  "storage.s3.65292.cPhaseVoltage": "Електрична напруга виводу фази C",
  "storage.s3.65292.cPhaseCurrent": "Електричний струм виводу фази C",
  "storage.s3.65292.cPhaseActivePower": "Активна потужність виводу фази C",
  "storage.s3.65292.cPhaseApparentPower": "Здатна потужність виводу фази C",
  "storage.s3.65292.allActivePower": "Активна потужність виводу цілісного пристрою",
  "storage.s3.65292.allApparentPower": "Здатна потужність виводу цілісного пристрою",
  "storage.s3.65292.aChargeActivePower": "Активна потужність генерації електроенергії фази А",
  "storage.s3.65292.bChargeActivePower": "Активна потужність генерації електроенергії фази B",
  "storage.s3.65292.cChargeActivePower": "Активна потужність генерації електроенергії фази C",
  "storage.s3.65292.mainsApVoltage": "Електрична напруга фази А міської електричної мережі",
  "storage.s3.65292.mainsApCurrent": "Електричний струм фази А міської електричної мережі",
  "storage.s3.65292.mainsBpVoltage": "Електрична напруга фази B міської електричної мережі",
  "storage.s3.65292.mainsBpCurrent": "Електричний струм фази B міської електричної мережі",
  "storage.s3.65292.mainsCpVoltage": "Електрична напруга фази C міської електричної мережі",
  "storage.s3.65292.mainsCpCurrent": "Електричний струм фази C міської електричної мережі",
  "storage.s3.65292.mainsApPower": "Потужність фази A міської електричної мережі",
  "storage.s3.65292.mainsBpPower": "Потужність фази B міської електричної мережі",
  "storage.s3.65292.mainsCpPower": "Потужність фази C міської електричної мережі",
  "storage.s3.65292.onGridActivePower": "Активна потужність при паралельному підключенні до мережі",
  "storage.s3.65292.homeLoadPower": "Побутова домашня потужність при навантаженні",
  "storage.s3.65292.afterLoadPower": "Потужність при навантаженні на бекенд",
  "storage.s3.65292.totalLoadPower": "Загальне навантаження",
  "storage.s3.65292.batPower": "Потужність електричної батареї",
  "storage.s3.65292.girdDisplayPower": "Потужність з індикацією на стороні електричної мережі",
  "storage.s3.65292.invPower": "Інвертора потужність",
  "storage.s3.65292.beforeLoadMarker": "Позначення енергетичного потоку при навантаженні на фронтенд",
  "storage.s3.65292.gridMarker": "Позначення енергетичного потоку електричної мережі",
  "storage.s3.65292.mainsMarker": "Позначення енергетичного потоку міської електричної мережі",
  "storage.s3.65292.machineOnStatus": "Стан при увімкненні механічного пристрою",
  "storage.s3.65292.chargeStatus": "Стан при електричному заряджанні",
  "storage.s3.65292.outputStatus": "Стан виводу",
  "storage.s3.65292.acTodayEnergy": "Об’єм електричного заряду при генерації електроенергії змінного струму за поточну добу",
  "storage.s3.65292.batTodayChargeEnergy": "Об’єм електричного заряду при електричному заряджанні електричної батареї за поточну добу",
  "storage.s3.65292.batTodayDischargeEnergy": "Об’єм електричного заряду при генерації електроенергії для електричної батареї за поточну добу",
  "storage.s3.65292.pvTodayEnergy": "Об’єм генерації електроенергії при фотогальванічній напрузі PV за поточну добу",
  "storage.s3.65292.loadTodayEnergy": "Об’єм споживаної електроенергії при навантаженні за поточну добу",
  "storage.s3.65292.mainsTodayChargeEnergy": "Об’єм електричного заряду при електричному заряджанні від міської електричної мережі за поточну добу",
  "storage.s3.65292.loadTodayUseMainsEnergy": "Об’єм електричного заряду при навантаженні при споживанні від міської електричної мережі за поточну добу",
  "storage.s3.65292.batTotalChargeEnergy": "Накопичувальний об’єм при електричному заряджанні акумуляторної електричної батареї",
  "storage.s3.65292.batTotalDischargeEnergy": "Накопичувальний об’єм електричного розряду акумуляторної електричної батареї",
  "storage.s3.65292.pvTotalEnergy": "Накопичувальний об’єм генерації електроенергії при фотогальванічній напрузі PV",
  "storage.s3.65292.loadTotalEnergy": "Накопичувальний об’єм споживаної електроенергії при навантаженні",
  "storage.s3.65292.mainsTotalChargeEnergy": "Накопичувальний об’єм при електричному заряджанні від міської електричної мережі",
  "storage.s3.65292.loadTotalUseMainsEnergy": "Накопичувальний об’єм електричного заряду при навантаженні при споживанні від міської електричної мережі",
  "storage.s3.65292.acTotalEnergy": "Накопичувальний об’єм електричного заряду при генерації електроенергії змінного струму",
  "storage.s3.65292.mainsChargeTimerSet": "Активація електричної зарядки від міської електричної мережі у встановлений час",
  "storage.s3.65292.batChargeTimerSet": "Активація електричної батареї у встановлений час",
  "storage.s3.65292.softWareVersion3": "Номер версії програмного забезпечення 3",
  "storage.s3.65292.aPhaseOnGridPower": "Потужність, наявна на стороні електричної мережі фази A",
  "storage.s3.65292.bPhaseOnGridPower": "Потужність, наявна на стороні електричної мережі фази B",
  "storage.s3.65292.cPhaseOnGridPower": "Потужність, наявна на стороні електричної мережі фази C",
  "storage.s3.65292.aPhaseOnGridCurrent": "Електричний струм на стороні електричної мережі фази A",
  "storage.s3.65292.bPhaseOnGridCurrent": "Електричний струм на стороні електричної мережі фази B",
  "storage.s3.65292.cPhaseOnGridCurrent": "Електричний струм на стороні електричної мережі фази C",
  "storage.s3.65292.batTemp": "Температура  для електричної батареї (℃)",
  "storage.s3.65292.softWareVersion1": "Номер версії дошки інвертування",
  "storage.s3.65292.softWareVersion2": "Номер версії BMS батареї",
  "storage.s3.65292.softWareVersion4": "Номер версії головної дошки керування",
  "storage.s3.65292.batChargeCur": "Електричний струм при електричному заряджанні за запитом електричної батареї ",
  "storage.s3.65292.batSurplusCapacity": "Залишкова ємність електричної батареї ",
  "storage.s3.65292.batRatedCapacity": "Номінальна ємність електричної батареї",
  "storage.s3.65292.batMaxPressure": "Максимальний перепад напруги у окремій електричній батареї",
  "storage.s3.65292.batSoh": "SOH",
  "storage.s3.65292.batChargeLimitVol": "Значення граничної напруги при електричному заряджанні електричної батареї ",
  "storage.s3.65292.bat1CellVol": "Електрична напруга 1 у електропровідній серцевині ",
  "storage.s3.65292.bat2CellVol": "Електрична напруга 2 у електропровідній серцевині ",
  "storage.s3.65292.bat3CellVol": "Електрична напруга 3 у електропровідній серцевині ",
  "storage.s3.65292.bat4CellVol": "Електрична напруга 4 у електропровідній серцевині ",
  "storage.s3.65292.bat5CellVol": "Електрична напруга 5 у електропровідній серцевині ",
  "storage.s3.65292.bat6CellVol": "Електрична напруга 6 у електропровідній серцевині ",
  "storage.s3.65292.bat7CellVol": "Електрична напруга 7 у електропровідній серцевині ",
  "storage.s3.65292.bat8CellVol": "Електрична напруга 8 у електропровідній серцевині ",
  "storage.s3.65292.bat9CellVol": "Електрична напруга 9 у електропровідній серцевині ",
  "storage.s3.65292.bat10CellVol": "Електрична напруга 10 у електропровідній серцевині ",
  "storage.s3.65292.bat11CellVol": "Електрична напруга 11 у електропровідній серцевині ",
  "storage.s3.65292.bat12CellVol": "Електрична напруга 12 у електропровідній серцевині ",
  "storage.s3.65292.bat13CellVol": "Електрична напруга 13 у електропровідній серцевині ",
  "storage.s3.65292.bat14CellVol": "Електрична напруга 14 у електропровідній серцевині ",
  "storage.s3.65292.bat15CellVol": "Електрична напруга 15 у електропровідній серцевині ",
  "storage.s3.65292.bat16CellVol": "Електрична напруга 16 у електропровідній серцевині ",
  "storage.s3.65292.batStatus": "Стан електричної батареї ",
  "storage.s3.65292.pvVoltageLevel": "Подача попередження про від’єднанні від лінії ",
  "storage.s3.65292.pvRadiatorTemp": "Температура радіатора при фотогальванічній напрузі PV(℃)",
  "storage.s3.65292.invTemp": "Інверторна температура(℃)",
  "storage.s3.65292.transformerTemp": "Температура у трансформаторі(℃)",
  "storage.s3.65292.cellTemp1": "Температура 1 електропровідної серцевини(℃)",
  "storage.s3.65292.cellTemp2": "Температура 2 електропровідної серцевини(℃)",
  "storage.s3.65292.cellTemp3": "Температура 3 електропровідної серцевини(℃)",
  "storage.s3.65292.cellTemp4": "Температура 4 електропровідної серцевини(℃)",
  "storage.s3.65292.mosTemp": "Температура MOS(℃)",
  "storage.s3.65292.mcuTemp": "Температура MCU(℃)",
  "storage.s3.65292.msAvgTemp": "Середня температура головного і підпорядкованого пристрою (℃)",
  "storage.s3.65292.batSOC": "Залишковий об’єм електричного заряду SOC (рівень заряду) електричної батареї ",
  "storage.s3.65292.invSubBoardVersion": "Кількість версії двійкової інвертерної дошки",
  "storage.s3.65292.batDischargeCur": "Поточний вивод батареї",
  "storage.s3.65292.batWorkStatus": "Стан перемикача батареї",
  "storage.s3.65292.ctWorkStatus": "Стан бездротового компактного перемикача",
  "storage.s3.65292.socketPower1": "Сила сокету 1",
  "storage.s3.65292.socketPower2": "Сила сокету 2",
  "storage.s3.65292.socketPower3": "Сила сокету 3",
  "storage.s3.65292.socketPower4": "Сила сокету 4",
  "storage.s3.65292.socketPower5": "Сила сокету 5",
  "storage.s3.65292.socketPower6": "Сила сокету 6",
  "storage.s3.65292.socketPower7": "Сила сокету 7",
  "storage.s3.65292.socketPower8": "Сила сокету 8",
  "storage.s3.65292.socketPower9": "Сила сокету 9",
  "storage.s3.65292.socketPower10": "Сила сокету 10",
  "storage.s3.65292.socketPower11": "Сила сокету 11",
  "storage.s3.65292.socketPower12": "Сила сокету 12",
  "storage.s3.65292.socketPower13": "Сила сокету 13",
  "storage.s3.65292.socketPower14": "Сила сокету 14",
  "storage.s3.65292.socketPower15": "Сила сокету 15",
  "storage.s3.65292.socketPower16": "Сила сокету 16",
  "storage.s3.65292.outPutFreq": "частота виводу",
  "storage.s3.65292.mainsFreq": "Головна частота",
  "storage.s3.65292.socketWorkStatus": "Кількість сокетів",
  "storage.s3.65292.time": "Час у обладнанні",
  "datalog.sn": "Серійний номер збірки",
  "storage.s3.65292.offlineAlarm": "Подача попередження про від’єднанні від лінії ",
  "storage.s3.65292.pvPower": "Фотогальванічна потужність ",
  "storage.s3.65292.deviceSn": "Порядковий номер обладнання",
  "hipment.devType": "Тип розробки",
  "device.voltageV": "Напруга обладнання V",
  "device.electric.currentA": "Струм обладнання A",
  "device.return.port": "Порт оплавлення",
  "device.a.phase": "Фаза A",
  "device.b.phase": "Фаза B",
  "device.c.phase": "Фаза C",
  "device.electic.meter.data": "Дані лічильника",
  "device.voltage": "Напруги",
  "device.electric.current": "струм",
  "unc.65323.runStatus": "Stan robi",
  "bw_RTparam_name_TotalPower": "Загальна потужність",
  "bw_RTparam_name_TotalYield": "Сукупна вироблена енергія",
  "bw_RTparam_name_TotalRuntime": "Загальний час роботи (PV)",
  "bw_RTparam_name_PV1Voltage": "Напруга PV1 у реальному часі",
  "bw_RTparam_name_PV1Current": "Струм PV1 у реальному часі",
  "bw_RTparam_name_PV1Power": "Потужність PV1 у реальному часі",
  "bw_RTparam_name_PV2Voltage": "Напруга PV2 у реальному часі",
  "bw_RTparam_name_PV2Current": "Струм PV2 у реальному часі",
  "bw_RTparam_name_PV2Power": "Потужність PV2 у реальному часі",
  "bw_RTparam_name_PV3Voltage": "Напруга PV3 у реальному часі",
  "bw_RTparam_name_PV3Current": "Струм PV3 у реальному часі",
  "bw_RTparam_name_PV3Power": "Потужність PV3 у реальному часі",
  "bw_RTparam_name_GridVoltageL1": "Мережева напруга L1",
  "bw_RTparam_name_GridVoltageL2": "Мережева напруга L2",
  "bw_RTparam_name_GridVoltageL3": "Мережева напруга L3",
  "bw_RTparam_name_GridCurrentL1": "Мережевий струм L1",
  "bw_RTparam_name_GridCurrentL2": "Мережевий струм L2",
  "bw_RTparam_name_GridCurrentL3": "Мережевий струм L3",
  "bw_RTparam_name_GridPowerL1": "Активна потужність мережі L1",
  "bw_RTparam_name_GridPowerL2": "Активна потужність мережі L2",
  "bw_RTparam_name_GridPowerL3": "Активна потужність мережі L3",
  "bw_RTparam_name_GridTotalActivePower": "Загальна активна потужність мережі",
  "bw_RTparam_name_GridFrequency": "Частота мережі",
  "bw_RTparam_name_ApparentPOAP_Grid": "Повна потужність фази A (мережа)",
  "bw_RTparam_name_ApparentPOBP_Grid": "Повна потужність фази B (мережа)",
  "bw_RTparam_name_ApparentPOCP_Grid": "Повна потужність фази C (мережа)",
  "bw_RTparam_name_ReactivePOAP_Grid": "Реактивна потужність фази A (мережа)",
  "bw_RTparam_name_ReactivePOBP_Grid": "Реактивна потужність фази B (мережа)",
  "bw_RTparam_name_ReactivePOCP_Grid": "Реактивна потужність фази C (мережа)",
  "bw_RTparam_name_PFOA_Grid": "Коефіцієнт потужності фази A (мережа)",
  "bw_RTparam_name_PFOB_Grid": "Коефіцієнт потужності фази B (мережа)",
  "bw_RTparam_name_PFOC_Grid": "Коефіцієнт потужності фази C (мережа)",
  "bw_RTparam_name_DailyEnergytoGrid": "Добова енергія, віддана в мережу",
  "bw_RTparam_name_TotalEnergytoGrid": "Накопичена енергія, віддана в мережу",
  "bw_RTparam_name_DailyEnergyfromGrid": "Добова енергія, спожита з мережі",
  "bw_RTparam_name_TotalEnergyfromGrid": "Накопичена енергія, спожита з мережі",
  "bw_RTparam_name_BatteryVoltage": "Напруга акумулятора",
  "bw_RTparam_name_BatteryCurrent": "Струм акумулятора",
  "bw_RTparam_name_BatteryPower": "Потужність акумулятора",
  "bw_RTparam_name_TotalConsumption": "Загальне споживання",
  "bw_RTparam_name_TotalEnergyfromBattery": "Накопичена енергія розрядження",
  "bw_RTparam_name_BatteryChargeFromGrid_Every": "Енергія акумулятора, заряджена з мережі",
  "bw_RTparam_name_BatterySOC": "Стан заряду акумулятора (SOC)",
  "bw_RTparam_name_BatterySOH": "Стан здоров'я акумулятора (SOH)",
  "bw_RTparam_name_Maximumtemperatureofbattery": "Максимальна температура акумулятора",
  "bw_RTparam_name_Minimumtemperatureofbattery": "Мінімальна температура акумулятора",
  "bw_RTparam_name_Maximumcellvoltage": "Максимальна напруга комірки",
  "bw_RTparam_name_Minimumcellvoltage": "Мінімальна напруга комірки",
  "bw_RTparam_name_TotalConsumptionPower": "Загальна споживана потужність",
  "bw_RTparam_name_TodayConsumption": "Добове споживання",
  "bw_RTparam_name_TotalConsumptionEnergy": "Загальне енергоспоживання",
  "bw_RTparam_name_TotalEnergyFeedToGrid_PV": "Загальна енергія, віддана в мережу (PV)",
  "bw_RTparam_name_TotalEnergyConsumeFormGrid_PV": "Загальна енергія, спожита з мережі (PV)",
  "bw_RTparam_name_VoltageOfAPhase_PV": "Напруга фази A (PV)",
  "bw_RTparam_name_VoltageOfBPhase_PV": "Напруга B фази (PV)",
  "bw_RTparam_name_VoltageOfCPhase_PV": "Напруга C-фази (PV)",
  "bw_RTparam_name_CurrentOfAPhase_PV": "Струм фази (PV)",
  "bw_RTparam_name_CurrentOfBPhase_PV": "Струм B фази (PV)",
  "bw_RTparam_name_CurrentOfCPhase_PV": "Струм фази C (PV)",
  "bw_RTparam_name_Frequent_PV": "Частота (PV)",
  "bw_RTparam_name_TotalApparentPower_PV": "Загальна повна потужність (PV)",
  "bw_RTparam_name_TotalActivePower_PV": "Загальна активна потужність (PV)",
  "bw_RTparam_name_TotalReactivePower_PV": "Загальна реактивна потужність (PV)",
  "bw_RTparam_name_TotalPowerFactor_PV": "Загальний коефіцієнт потужності (PV)",
  "bw_RTparam_group_Inverter": "інвертер",
  "bw_RTparam_group_Grid": "мережа",
  "bw_RTparam_group_Battery": "акумулятор",
  "bw_RTparam_group_Load": "навантаження",
  "bw_RTparam_group_PVMeter": "фотоелектричний лічильник",
  "common.50100.pv1Voltage": "Напруга PV1",
  "common.50100.pv1Current": "Струм PV1",
  "common.50100.pv1Power": "Потужність PV1",
  "common.50100.pv2Voltage": "Напруга PV2",
  "common.50100.pv2Current": "Струм PV2",
  "common.50100.pv2Power": "Потужність PV2",
  "common.50100.pv3Voltage": "Напруга PV3",
  "common.50100.pv3Current": "Струм PV3",
  "common.50100.pv3Power": "Потужність PV3",
  "common.50100.pv4Voltage": "Напруга PV4",
  "common.50100.pv4Current": "Струм PV4",
  "common.50100.pv4Power": "Потужність PV4",
  "common.50100.temperature": "Температура(℃)",
  "common.50100.outputGridVoltage": "Напруга вихідної мережі",
  "common.50100.outputGridCurrent": "Струм вихідної мережі",
  "common.50100.outputGridPower": "Вихідна потужність мережі",
  "common.50100.pv1CumulativePowerGeneration": "Кумулятивне виробництво електроенергії PV1",
  "common.50100.pv2CumulativePowerGeneration": "Кумулятивне виробництво електроенергії PV2",
  "common.50100.pv3CumulativePowerGeneration": "Кумулятивне виробництво електроенергії PV3",
  "common.50100.pv4CumulativePowerGeneration": "Кумулятивне виробництво електроенергії PV4",
  "common.50100.totalPowerGeneration": "Загальне виробництво електроенергії",
  "common.50100.wnSn": "Реєстратор даних Сн",
  "common.50100.wnWifiVersion": "Версія Wifi реєстратора даних",
  "common.50100.wnHardwareVersion": "Версія апаратного забезпечення Datalogger",
  "common.50100.wnSoftwareVersion": "Версія програмного забезпечення Datalogger",
  "ltwn_RTparam_group_Inverter": "逆变器",
  "\nbw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "Тільки увімкнути контроль періоду розряду",
  "plant.already.deliver": "Електростанцію передали",
  "common.50100.totalPvEnergy": "Загальна об’єм генерації електроенергії",
  "ltcg_RTparam_name_name": "Ім'я пристрою",
  "ltcg_RTparam_name_out_pac": "Генерація електроенергії (кВт)",
  "ltcg_RTparam_name_eday": "Сьогоднішнє виробництво електроенергії (кВт·год)",
  "ltcg_RTparam_name_etotal": "Сукупне виробництво електроенергії (кВт·год)",
  "ltcg_RTparam_name_status": "Статус",
  "ltcg_RTparam_name_turnon_time": "Час доступу",
  "ltcg_RTparam_name_type": "Тип пристрою",
  "ltcg_RTparam_name_capacity": "Потужність, кВт",
  "ltcg_RTparam_name_tempperature": "Температура",
  "ltcg_RTparam_name_creationDate": "Час останніх даних",
  "ltcg_RTparam_name_pac": "Виробництво електроенергії",
  "ltcg_RTparam_name_hTotal": "Накопичувальні години генерації",
  "ltcg_RTparam_name_vpv1": "Напруга постійного струму 1",
  "ltcg_RTparam_name_vpv2": "Напруга постійного струму 2",
  "ltcg_RTparam_name_vpv3": "Напруга постійного струму 3",
  "ltcg_RTparam_name_vpv4": "Напруга постійного струму 4",
  "ltcg_RTparam_name_vpv5": "Напруга постійного струму 5",
  "ltcg_RTparam_name_vpv6": "Напруга постійного струму 6",
  "ltcg_RTparam_name_vpv7": "Напруга постійного струму 7",
  "ltcg_RTparam_name_vpv8": "Напруга постійного струму 8",
  "ltcg_RTparam_name_vpv9": "Напруга постійного струму 9",
  "ltcg_RTparam_name_vpv10": "Напруга постійного струму 10",
  "ltcg_RTparam_name_vpv11": "Напруга постійного струму 11",
  "ltcg_RTparam_name_vpv12": "Напруга постійного струму 12",
  "ltcg_RTparam_name_ipv1": "Постійний струм 1",
  "ltcg_RTparam_name_ipv2": "Постійний струм 2",
  "ltcg_RTparam_name_ipv3": "Постійний струм 3",
  "ltcg_RTparam_name_ipv4": "Постійний струм 4",
  "ltcg_RTparam_name_ipv5": "Постійний струм 5",
  "ltcg_RTparam_name_ipv6": "Постійний струм 6",
  "ltcg_RTparam_name_ipv7": "Постійний струм 7",
  "ltcg_RTparam_name_ipv8": "Постійний струм 8",
  "ltcg_RTparam_name_ipv9": "Постійний струм 9",
  "ltcg_RTparam_name_ipv10": "Постійний струм 10",
  "ltcg_RTparam_name_ipv11": "Постійний струм 11",
  "ltcg_RTparam_name_ipv12": "Постійний струм 12",
  "ltcg_RTparam_name_vac1": "Напруга змінного струму 1",
  "ltcg_RTparam_name_vac2": "Напруга змінного струму 2",
  "ltcg_RTparam_name_vac3": "Напруга змінного струму 3",
  "ltcg_RTparam_name_iac1": "Змінний струм 1",
  "ltcg_RTparam_name_iac2": "Змінний струм 2",
  "ltcg_RTparam_name_iac3": "Змінний струм 3",
  "ltcg_RTparam_name_fac1": "Частота зв'язку 1",
  "ltcg_RTparam_name_fac2": "Частота зв'язку 2",
  "ltcg_RTparam_name_fac3": "Частота зв'язку 3",
  "ltcg_RTparam_name_istr1": "Струм струни 1",
  "ltcg_RTparam_name_istr2": "Струм струни 2",
  "ltcg_RTparam_name_istr3": "Струм струни 3",
  "ltcg_RTparam_name_istr4": "Струм струни 4",
  "ltcg_RTparam_name_istr5": "Струм струни 5",
  "ltcg_RTparam_name_istr6": "Струм струни 6",
  "ltcg_RTparam_name_istr7": "Струм струни 7",
  "ltcg_RTparam_name_istr8": "Струм струни 8",
  "ltcg_RTparam_name_istr9": "Струм струни 9",
  "ltcg_RTparam_name_istr10": "Струм струни 10",
  "ltcg_RTparam_name_istr11": "Струм струни 11",
  "ltcg_RTparam_name_istr12": "Струм струни 12",
  "ltcg_RTparam_name_istr13": "Струм струни 13",
  "ltcg_RTparam_name_istr14": "Струм струни 14",
  "ltcg_RTparam_name_istr15": "Струм струни 15",
  "ltcg_RTparam_name_istr16": "Струм струни 16",
  "ltcg_RTparam_name_istr17": "Струм струни 17",
  "ltcg_RTparam_name_istr18": "Струм струни 18",
  "ltcg_RTparam_name_istr19": "Струм струни 19",
  "ltcg_RTparam_name_istr20": "Струм струни 20",
  "ltcg_RTparam_name_istr21": "Струм струни 21",
  "ltcg_RTparam_name_istr22": "Струм струни 22",
  "ltcg_RTparam_name_istr23": "Струм струни 23",
  "ltcg_RTparam_name_istr24": "Струм струни 24",
  "ltcg_RTparam_group_Inverter": "逆变器",
  "city.not.exist": "Міста не існує.",
  "bw_RTparam_name_BatterySN1": "батарея1 SN",
  "bw_RTparam_name_BatterySN2": "батарея2 SN",
  "bw_RTparam_name_BatterySN3": "батарея3 SN",
  "bw_RTparam_name_BatterySN4": "батарея4 SN",
  "bw_RTparam_name_BatterySN5": "батарея5 SN",
  "bw_RTparam_name_BatterySN6": "батарея6 SN",
  "supplier.type.tb": "особливе розмаїття",
  "common.50300.sn": "Серійний номер пристрою",
  "common.50300.name": "Ім'я пристрою",
  "common.50300.out_pac": "Генерація електроенергії (кВт)",
  "common.50300.eday": "Сьогоднішнє виробництво електроенергії (кВт·год)",
  "common.50300.etotal": "Сукупне виробництво електроенергії (кВт·год)",
  "common.50300.status": "Статус",
  "common.50300.turnon_time": "Час доступу",
  "common.50300.type": "Тип пристрою",
  "common.50300.capacity": "Потужність, кВт",
  "common.50300.tempperature": "Температура(℃)",
  "common.50300.creationDate": "Час останніх даних",
  "common.50300.pac": "Виробництво електроенергії",
  "common.50300.hTotal": "Накопичувальні години генерації",
  "common.50300.vpv1": "Напруга постійного струму 1",
  "common.50300.vpv2": "Напруга постійного струму 2",
  "common.50300.vpv3": "Напруга постійного струму 3",
  "common.50300.vpv4": "Напруга постійного струму 4",
  "common.50300.vpv5": "Напруга постійного струму 5",
  "common.50300.vpv6": "Напруга постійного струму 6",
  "common.50300.vpv7": "Напруга постійного струму 7",
  "common.50300.vpv8": "Напруга постійного струму 8",
  "common.50300.vpv9": "Напруга постійного струму 9",
  "common.50300.vpv10": "Напруга постійного струму 10",
  "common.50300.vpv11": "Напруга постійного струму 11",
  "common.50300.vpv12": "Напруга постійного струму 12",
  "common.50300.ipv1": "Постійний струм 1",
  "common.50300.ipv2": "Постійний струм 2",
  "common.50300.ipv3": "Постійний струм 3",
  "common.50300.ipv4": "Постійний струм 4",
  "common.50300.ipv5": "Постійний струм 5",
  "common.50300.ipv6": "Постійний струм 6",
  "common.50300.ipv7": "Постійний струм 7",
  "common.50300.ipv8": "Постійний струм 8",
  "common.50300.ipv9": "Постійний струм 9",
  "common.50300.ipv10": "Постійний струм 10",
  "common.50300.ipv11": "Постійний струм 11",
  "common.50300.ipv12": "Постійний струм 12",
  "common.50300.vac1": "Напруга змінного струму 1",
  "common.50300.vac2": "Напруга змінного струму 2",
  "common.50300.vac3": "Напруга змінного струму 3",
  "common.50300.iac1": "Змінний струм 1",
  "common.50300.iac2": "Змінний струм 2",
  "common.50300.iac3": "Змінний струм 3",
  "common.50300.fac1": "Частота зв'язку 1",
  "common.50300.fac2": "Частота зв'язку 2",
  "common.50300.fac3": "Частота зв'язку 3",
  "common.50300.istr1": "Струм струни 1",
  "common.50300.istr2": "Струм струни 2",
  "common.50300.istr3": "Струм струни 3",
  "common.50300.istr4": "Струм струни 4",
  "common.50300.istr5": "Струм струни 5",
  "common.50300.istr6": "Струм струни 6",
  "common.50300.istr7": "Струм струни 7",
  "common.50300.istr8": "Струм струни 8",
  "common.50300.istr9": "Струм струни 9",
  "common.50300.istr10": "Струм струни 10",
  "common.50300.istr11": "Струм струни 11",
  "common.50300.istr12": "Струм струни 12",
  "common.50300.istr13": "Струм струни 13",
  "common.50300.istr14": "Струм струни 14",
  "common.50300.istr15": "Струм струни 15",
  "common.50300.istr16": "Струм струни 16",
  "common.50300.istr17": "Струм струни 17",
  "common.50300.istr18": "Струм струни 18",
  "common.50300.istr19": "Струм струни 19",
  "common.50300.istr20": "Струм струни 20",
  "common.50300.istr21": "Струм струни 21",
  "common.50300.istr22": "Струм струни 22",
  "common.50300.istr23": "Струм струни 23",
  "common.50300.istr24": "Струм струни 24",
  "common.50402.sn": "Інвертор SN",
  "common.50402.ID": "Ідентифікатор інвертора",
  "common.50402.STATION_ID": "Ідентифікатор електростанції",
  "common.50402.INV_EG_DAY": "Добове вироблення електроенергії",
  "common.50402.INV_EG_TOTAL": "Кумулятивна генерація електроенергії інвертора",
  "common.50402.INV_I_AC": "Струм інвертора",
  "common.50402.INV_U_AC": "Напруга інвертора",
  "common.50402.PV1_I": "Струм PV1",
  "common.50402.PV2_I": "Струм PV2",
  "common.50402.PV3_I": "Струм PV3",
  "common.50402.PV4_I": "Струм PV4",
  "common.50402.PV5_I": "Струм PV5",
  "common.50402.PV6_I": "Струм PV6",
  "common.50402.PV7_I": "Струм PV7",
  "common.50402.PV8_I": "Струм PV8",
  "common.50402.PV9_I": "Струм PV9",
  "common.50402.PV10_I": "Струм PV10",
  "common.50402.PV11_I": "Струм PV11",
  "common.50402.PV12_I": "Струм PV12",
  "common.50402.PV13_I": "Струм PV13",
  "common.50402.PV14_I": "Струм PV14",
  "common.50402.PV15_I": "Струм PV15",
  "common.50402.PV16_I": "Струм PV16",
  "common.50402.PV17_I": "Струм PV17",
  "common.50402.PV18_I": "Струм PV18",
  "common.50402.PV19_I": "Струм PV19",
  "common.50402.PV20_I": "Струм PV20",
  "common.50402.PV21_I": "Струм PV21",
  "common.50402.PV22_I": "Струм PV22",
  "common.50402.PV23_I": "Струм PV23",
  "common.50402.PV24_I": "Струм PV24",
  "common.50402.PV25_I": "Струм PV25",
  "common.50402.PV26_I": "Струм PV26",
  "common.50402.PV27_I": "Струм PV27",
  "common.50402.PV28_I": "Струм PV28",
  "common.50402.PV29_I": "Струм PV29",
  "common.50402.PV30_I": "Струм PV30",
  "common.50402.PV1_V": "Напруга PV1",
  "common.50402.PV2_V": "Напруга PV2",
  "common.50402.PV3_V": "Напруга PV3",
  "common.50402.PV4_V": "Напруга PV4",
  "common.50402.PV5_V": "Напруга PV5",
  "common.50402.PV6_V": "Напруга PV6",
  "common.50402.PV7_V": "Напруга PV7",
  "common.50402.PV8_V": "Напруга PV8",
  "common.50402.PV9_V": "Напруга PV9",
  "common.50402.PV10_V": "Напруга PV10",
  "common.50402.PV11_V": "Напруга PV11",
  "common.50402.PV12_V": "Напруга PV12",
  "common.50402.PV13_V": "Напруга PV13",
  "common.50402.PV14_V": "Напруга PV14",
  "common.50402.PV15_V": "Напруга PV15",
  "common.50402.PV16_V": "Напруга PV16",
  "common.50402.PV17_V": "Напруга PV17",
  "common.50402.PV18_V": "Напруга PV18",
  "common.50402.PV19_V": "Напруга PV19",
  "common.50402.PV20_V": "Напруга PV20",
  "common.50402.PV21_V": "Напруга PV21",
  "common.50402.PV22_V": "Напруга PV22",
  "common.50402.PV23_V": "Напруга PV23",
  "common.50402.PV24_V": "Напруга PV24",
  "common.50402.PV25_V": "Напруга PV25",
  "common.50402.PV26_V": "Напруга PV26",
  "common.50402.PV27_V": "Напруга PV27",
  "common.50402.PV28_V": "Напруга PV28",
  "common.50402.PV29_V": "Напруга PV29",
  "common.50402.PV30_V": "Напруга PV30",
  "common.50402.INV_P_AC": "Активна потужність інвертора",
  "common.50402.CAPACITY": "Потужність, кВт",
  "common.50402.INV_RUN_STATE": "Робочий стан інвертора",
  "common.50402.DATA_TIME": "Час передачі даних",
  "common.50402.name": "Назва пристрою",
  "common.50402.out_pac": "Генерація електроенергії (кВт)",
  "common.50402.eday": "Сьогоднішнє виробництво електроенергії (кВт·год)",
  "common.50402.etotal": "Сукупне виробництво електроенергії (кВт·год)",
  "common.50402.status": "стан",
  "common.50402.turnon_time": "Час доступу",
  "common.50402.type": "Тип пристрою",
  "common.50402.tempperature": "температура(℃)",
  "common.50402.creationDate": "Час, коли дані були актуальними",
  "common.50402.pac": "Виробництво електроенергії",
  "common.50402.hTotal": "Сумарний час вироблення електроенергії",
  "common.50402.vpv1": "Напруга постійного струму 1",
  "common.50402.vpv2": "Напруга постійного струму 2",
  "common.50402.vpv3": "Напруга постійного струму 3",
  "common.50402.vpv4": "Напруга постійного струму 4",
  "common.50402.vpv5": "Напруга постійного струму 5",
  "common.50402.vpv6": "Напруга постійного струму 6",
  "common.50402.vpv7": "Напруга постійного струму 7",
  "common.50402.vpv8": "Напруга постійного струму 8",
  "common.50402.vpv9": "Напруга постійного струму 9",
  "common.50402.vpv10": "Напруга постійного струму 10",
  "common.50402.vpv11": "Напруга постійного струму 11",
  "common.50402.vpv12": "Напруга постійного струму 12",
  "common.50402.ipv1": "Постійний струм 1",
  "common.50402.ipv2": "Постійний струм 2",
  "common.50402.ipv3": "Постійний струм 3",
  "common.50402.ipv4": "Постійний струм 4",
  "common.50402.ipv5": "Постійний струм 5",
  "common.50402.ipv6": "Постійний струм 6",
  "common.50402.ipv7": "Постійний струм 7",
  "common.50402.ipv8": "Постійний струм 8",
  "common.50402.ipv9": "Постійний струм 9",
  "common.50402.ipv10": "Постійний струм 10",
  "common.50402.ipv11": "Постійний струм 11",
  "common.50402.ipv12": "Постійний струм 12",
  "common.50402.vac1": "Напруга змінного струму 1",
  "common.50402.vac2": "Напруга змінного струму 2",
  "common.50402.vac3": "Напруга змінного струму 3",
  "common.50402.iac1": "Змінний струм 1",
  "common.50402.iac2": "Змінний струм 2",
  "common.50402.iac3": "Змінний струм 3",
  "common.50402.fac1": "Частота змінного струму 1",
  "common.50402.fac2": "Частота змінного струму 2",
  "common.50402.fac3": "Частота змінного струму 3",
  "common.50402.istr1": "Струм струни 1",
  "common.50402.istr2": "Струм струни 2",
  "common.50402.istr3": "Струм струни 3",
  "common.50402.istr4": "Струм струни 4",
  "common.50402.istr5": "Струм струни 5",
  "common.50402.istr6": "Струм струни 6",
  "common.50402.istr7": "Струм струни 7",
  "common.50402.istr8": "Струм струни 8",
  "common.50402.istr9": "Струм струни 9",
  "common.50402.istr10": "Струм струни 10",
  "common.50402.istr11": "Струм струни 11",
  "common.50402.istr12": "Струм струни 12",
  "common.50402.istr13": "Струм струни 13",
  "common.50402.istr14": "Струм струни 14",
  "common.50402.istr15": "Струм струни 15",
  "common.50402.istr16": "Струм струни 16",
  "common.50402.istr17": "Струм струни 17",
  "common.50402.istr18": "Струм струни 18",
  "common.50402.istr19": "Струм струни 19",
  "common.50402.istr20": "Струм струни 20",
  "common.50402.istr21": "Струм струни 21",
  "common.50402.istr22": "Струм струни 22",
  "common.50402.istr23": "Струм струни 23",
  "common.50402.istr24": "Струм струни 24",
  "bw_RTparam_group_ Dongle": "Донгл",
  "bw_RTparam_name_DongleRssi": "RSSI",
  "bw_RTparam_group_Dongle": "Донгл",
  "common.50500.xnl_RTparam_name_FV_P": "Значення коефіцієнта потужності",
  "common.50500.xnl_RTparam_name_GVL": "Рівень напруги, підключений до мережі",
  "common.50500.xnl_RTparam_name_RS_D": "Статус виконання (за замовчуванням)",
  "common.50500.xnl_RTparam_name_Etdy_ge1": "Добова генерація електроенергії (активна)",
  "common.50500.xnl_RTparam_name_A_R_P_D": "Реактивна енергія змінного струму в день",
  "common.50500.xnl_RTparam_name_GEN_P_D": "Добова генераційна потужність генератора",
  "common.50500.xnl_RTparam_name_Et_ge0": "Кумулятивна вироблена електроенергія (активна)",
  "common.50500.xnl_RTparam_name_Emon1": "Щомісячна генерація електроенергії (активна)",
  "common.50500.xnl_RTparam_name_Etdy_use2": "Щомісячне споживання електроенергії",
  "common.50500.xnl_RTparam_name_t_gc_tdy2": "Місячна потужність, підключена до мережі",
  "common.50500.xnl_RTparam_name_Eyr1": "Річне виробництво електроенергії (активне)",
  "common.50500.xnl_RTparam_name_Etdy_cg1": "Сьогоднішній обсяг заряджання",
  "common.50500.xnl_RTparam_name_Etdy_dcg1": "Сьогоднішня сума розряду",
  "common.50500.xnl_RTparam_name_t_cg_n1": "Накопичувальна ємність заряду",
  "common.50500.xnl_RTparam_name_t_dcg_n1": "Кумулятивний розряд",
  "common.50500.xnl_RTparam_name_E_B_D": "Добовий обсяг закупівлі електроенергії",
  "common.50500.xnl_RTparam_name_GRID_C_D": "Приведена до мережі потужність електромережі на добу",
  "common.50500.xnl_RTparam_name_E_B_TO": "Всього придбаної електроенергії",
  "common.50500.xnl_RTparam_name_PG_F1": "Частота сітки",
  "common.50500.xnl_RTparam_name_t_gc1": "Сукупна потужність, підключена до мережі",
  "common.50500.xnl_RTparam_name_GDOH": "Добовий час роботи генератора",
  "common.50500.xnl_RTparam_name_Etdy_use1": "Сьогоднішнє споживання електроенергії",
  "common.50500.xnl_RTparam_name_Et_use1": "Сукупне споживання електроенергії",
  "common.50500.xnl_RTparam_name_Etdy_use3": "Річне споживання електроенергії",
  "common.50500.xnl_RTparam_name_T_TFM1": "Температура трансформатора",
  "common.50500.xnl_RTparam_name_T_RDT1": "Температура радіатора",
  "common.50500.xnl_RTparam_name_EG_t_ge1": "Сумарна генерація електроенергії генератором",
  "common.50500.xnl_RTparam_name_E_PVhis_ge1": "Історичне виробництво фотоелектричної енергії",
  "common.50500.xnl_RTparam_name_t_gc_tdy3": "Річна потужність підключених до мережі",
  "common.50500.xnl_RTparam_name_LCD": "Тестова прапорцева біта РК-дисплея",
  "common.50500.xnl_RTparam_name_CBAC": "Ємність після калібрування акумулятора",
  "common.50500.xnl_RTparam_name_PVDE": "Добове виробництво сонячної електроенергії",
  "common.50500.xnl_RTparam_name_DV1": "Напруга постійного струму PV1",
  "common.50500.xnl_RTparam_name_DC1": "Постійний струм PV1",
  "common.50500.xnl_RTparam_name_DV2": "Напруга постійного струму PV2",
  "common.50500.xnl_RTparam_name_DC2": "Постійний струм PV2",
  "common.50500.xnl_RTparam_name_DV3": "Напруга постійного струму PV3",
  "common.50500.xnl_RTparam_name_DC3": "Постійний струм PV3",
  "common.50500.xnl_RTparam_name_DV4": "Напруга постійного струму PV4",
  "common.50500.xnl_RTparam_name_DC4": "Постійний струм PV4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_1": "Налагоджувальна інформація INV DSP 1",
  "common.50500.xnl_RTparam_name_INV_DSP_D_2": "Налагоджувальна інформація INV DSP 2",
  "common.50500.xnl_RTparam_name_INV_DSP_D_3": "Налагоджувальна інформація INV DSP 3",
  "common.50500.xnl_RTparam_name_INV_DSP_D_4": "Налагоджувальна інформація INV DSP 4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_5": "Налагоджувальна інформація INV DSP 5",
  "common.50500.xnl_RTparam_name_INV_DSP_D_6": "Налагоджувальна інформація INV DSP 6",
  "common.50500.xnl_RTparam_name_INV_DSP_D_7": "Налагоджувальна інформація INV DSP 7",
  "common.50500.xnl_RTparam_name_INV_DSP_D_8": "Налагоджувальна інформація INV DSP 8",
  "common.50500.xnl_RTparam_name_INV_DSP_D_9": "Налагоджувальна інформація INV DSP 9",
  "common.50500.xnl_RTparam_name_INV_DSP_D_10": "Інформація про налагодження INV DSP 10",
  "common.50500.xnl_RTparam_name_INV_DSP_D_11": "Налагоджувальна інформація INV DSP 11",
  "common.50500.xnl_RTparam_name_INV_DSP_D_12": "Налагоджувальна інформація INV DSP 12",
  "common.50500.xnl_RTparam_name_INV_DSP_D_13": "Налагоджувальна інформація INV DSP 13",
  "common.50500.xnl_RTparam_name_INV_DSP_D_14": "Налагоджувальна інформація INV DSP 14",
  "common.50500.xnl_RTparam_name_INV_DSP_D_15": "Інформація про налагодження INV DSP 15",
  "common.50500.xnl_RTparam_name_INV_DSP_D_16": "Інформація про налагодження INV DSP 16",
  "common.50500.xnl_RTparam_name_INV_DSP_D_17": "Налагоджувальна інформація INV DSP 17",
  "common.50500.xnl_RTparam_name_INV_DSP_D_18": "Налагоджувальна інформація INV DSP 18",
  "common.50500.xnl_RTparam_name_INV_DSP_D_19": "Налагоджувальна інформація INV DSP 19",
  "common.50500.xnl_RTparam_name_INV_DSP_D_20": "Налагоджувальна інформація INV DSP 20",
  "common.50500.xnl_RTparam_name_INV_DSP_D_21": "Налагоджувальна інформація INV DSP 21",
  "common.50500.xnl_RTparam_name_INV_DSP_D_22": "Інформація про налагодження INV DSP 22",
  "common.50500.xnl_RTparam_name_INV_DSP_D_23": "Налагоджувальна інформація INV DSP 23",
  "common.50500.xnl_RTparam_name_INV_DSP_D_24": "Налагоджувальна інформація INV DSP 24",
  "common.50500.xnl_RTparam_name_INV_DSP_D_25": "Інформація про налагодження INV DSP 25",
  "common.50500.xnl_RTparam_name_INV_DSP_D_26": "Налагоджувальна інформація INV DSP 26",
  "common.50500.xnl_RTparam_name_INV_DSP_D_27": "Налагоджувальна інформація INV DSP 27",
  "common.50500.xnl_RTparam_name_INV_DSP_D_28": "Налагоджувальна інформація INV DSP 28",
  "common.50500.xnl_RTparam_name_G_V_L1_N": "Напруга на стороні мережі L1-N",
  "common.50500.xnl_RTparam_name_G_V_L2_N": "Напруга на стороні мережі L2-N",
  "common.50500.xnl_RTparam_name_G_V_L1_L2": "Напруга на стороні мережі L1-L2",
  "common.50500.xnl_RTparam_name_R_I_V_L1_L2": "Реле проміжної сторони напруги L1-L2",
  "common.50500.xnl_RTparam_name_AV1": "Напруга змінного струму R/U/A",
  "common.50500.xnl_RTparam_name_AV2": "Напруга змінного струму С/В/В",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L2": "Вихідна напруга інвертора L1-L2",
  "common.50500.xnl_RTparam_name_C_V_L1": "Напруга навантаження L1",
  "common.50500.xnl_RTparam_name_C_V_L2": "Напруга навантаження L2",
  "common.50500.xnl_RTparam_name_I_O_F2": "Вихідна частота інвертора L2",
  "common.50500.xnl_RTparam_name_G_C_L1": "Струм сітки L1",
  "common.50500.xnl_RTparam_name_G_C_L2": "Струм мережі L2",
  "common.50500.xnl_RTparam_name_G_C_A": "Струм мережі А",
  "common.50500.xnl_RTparam_name_G_C_B": "Струм мережі B",
  "common.50500.xnl_RTparam_name_AC1": "Змінний струм R/U/A",
  "common.50500.xnl_RTparam_name_AC2": "Змінний струм S/V/B",
  "common.50500.xnl_RTparam_name_GEN_P_T": "Сумарна потужність генератора",
  "common.50500.xnl_RTparam_name_G_P_L1": "Потужність мережі L1",
  "common.50500.xnl_RTparam_name_G_P_L2": "Електромережа L2",
  "common.50500.xnl_RTparam_name_PG_Pt1": "Загальна потужність мережі",
  "common.50500.xnl_RTparam_name_E_CT_P1": "Зовнішнє живлення CT1",
  "common.50500.xnl_RTparam_name_E_CT_P2": "Зовнішнє живлення CT2",
  "common.50500.xnl_RTparam_name_CT_P_T": "Сумарна потужність мережі КТ",
  "common.50500.xnl_RTparam_name_INV_O_P_L1": "Вихідна потужність інвертора L1",
  "common.50500.xnl_RTparam_name_INV_O_P_L2": "Вихідна потужність інвертора L2",
  "common.50500.xnl_RTparam_name_I_O_P_LN": "Вихідна потужність інвертора, л/шум",
  "common.50500.xnl_RTparam_name_C_P_L1": "Потужність навантаження L1",
  "common.50500.xnl_RTparam_name_C_P_L2": "Потужність навантаження L2",
  "common.50500.xnl_RTparam_name_E_Puse_t1": "Сумарна споживана електрична потужність",
  "common.50500.xnl_RTparam_name_E_Cuse1": "Електричний струм Р/У/А",
  "common.50500.xnl_RTparam_name_E_Cuse2": "Електричний струм S/V/B",
  "common.50500.xnl_RTparam_name_PVGP_A": "Фазна напруга A порту Gen",
  "common.50500.xnl_RTparam_name_B_T1": "Температура акумулятора",
  "common.50500.xnl_RTparam_name_B_V1": "Напруга акумулятора",
  "common.50500.xnl_RTparam_name_B_R_C": "Залишкова ємність акумулятора",
  "common.50500.xnl_RTparam_name_LF2": "Частота навантаження L2",
  "common.50500.xnl_RTparam_name_DP1": "Живлення постійного струму PV1",
  "common.50500.xnl_RTparam_name_DP2": "Живлення постійного струму PV2",
  "common.50500.xnl_RTparam_name_DP3": "Живлення постійного струму PV3",
  "common.50500.xnl_RTparam_name_DP4": "Живлення постійного струму PV4",
  "common.50500.xnl_RTparam_name_B_Pdcg1": "Потужність розряду акумулятора",
  "common.50500.xnl_RTparam_name_B_C1": "Струм акумулятора",
  "common.50500.xnl_RTparam_name_LF1": "Частота навантаження L1",
  "common.50500.xnl_RTparam_name_I_O_F1": "Вихідна частота інвертора L1",
  "common.50500.xnl_RTparam_name_GRID_RELAY_ST1": "Стан реле мережі",
  "common.50500.xnl_RTparam_name_ST_EG_RELAY1": "Стан реле на стороні генератора",
  "common.50500.xnl_RTparam_name_EG_F1": "Частота генератора",
  "common.50500.xnl_RTparam_name_BUS_VOL": "Напруга на шині",
  "common.50500.xnl_RTparam_name_H_B_V": "Напруга половини шини",
  "common.50500.xnl_RTparam_name_B_B_C": "Збалансований мостовий струм",
  "common.50500.xnl_RTparam_name_I_EARipa1": "Паралельний опір заземлення",
  "common.50500.xnl_RTparam_name_LBVN": "Номер версії літієвої батареї",
  "common.50500.xnl_RTparam_name_M_P": "Сумарна потужність лічильника електроенергії",
  "common.50500.xnl_RTparam_name_M_P_A": "Електролічильник Потужність А",
  "common.50500.xnl_RTparam_name_M_P_B": "Електролічильник Потужність В",
  "common.50500.xnl_RTparam_name_M_P_C": "Електролічильник потужності С",
  "common.50500.xnl_RTparam_name_t_gc_tdy1": "Сьогоднішня потужність, підключена до мережі",
  "common.50500.xnl_RTparam_name_Etdy_pu1": "Сьогоднішні обсяги закупівлі електроенергії",
  "common.50500.xnl_RTparam_name_Et_pu1": "Кумулятивно придбана електроенергія",
  "common.50500.xnl_RTparam_name_Vtr1_BAP1": "Загальна напруга акумуляторної батареї 1",
  "common.50500.xnl_RTparam_name_Cr1_BAP1": "Акумуляторна батарея 1 струм",
  "common.50500.xnl_RTparam_name_T_BAP1": "Акумуляторна батарея 1 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP1": "Акумуляторна батарея 1 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP1": "Залишкова ємність акумуляторної батареї 1",
  "common.50500.xnl_RTparam_name_T_cap_BAP1": "Загальна ємність акумуляторної батареї 1",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg1": "Акумуляторна батарея 1 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg1": "Струм запиту на зарядку акумуляторної батареї 1",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg1": "Акумуляторна батарея 1 Струм запиту розряду",
  "common.50500.xnl_RTparam_name_Max_V_BAP1": "Максимальна напруга акумуляторної батареї 1",
  "common.50500.xnl_RTparam_name_MIN_V_BAP1": "Мінімальна напруга акумулятора в акумуляторному блоці 1",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP1": "Кількість циклів роботи акумуляторної батареї 1",
  "common.50500.xnl_RTparam_name_Warn_BAP1": "Акумуляторна батарея 1 сигналізація",
  "common.50500.xnl_RTparam_name_Fault_BAP1": "Несправність акумуляторної батареї 1",
  "common.50500.xnl_RTparam_name_Vtr_BAP2": "Загальна напруга акумуляторної батареї 2",
  "common.50500.xnl_RTparam_name_Cr_BAP2": "Акумуляторна батарея 2 струму",
  "common.50500.xnl_RTparam_name_T_BAP2": "Акумуляторна батарея 2 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP2": "Акумуляторна батарея 2 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP2": "Залишкова ємність акумуляторної батареї 2",
  "common.50500.xnl_RTparam_name_T_cap_BAP2": "Загальна ємність акумуляторної батареї 2",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg2": "Акумуляторна батарея 2 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg2": "Акумуляторна батарея 2 Запит на зарядку Струм",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg2": "Струм запиту на розряд акумуляторної батареї 2",
  "common.50500.xnl_RTparam_name_Max_V_BAP2": "Максимальна напруга акумулятора 2 в акумуляторному блоці",
  "common.50500.xnl_RTparam_name_MIN_V_BAP2": "Мінімальна напруга батареї 2 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP2": "Кількість циклів акумуляторної батареї на 2 цикли",
  "common.50500.xnl_RTparam_name_Warn_BAP2": "Акумуляторна батарея 2 сигналізації",
  "common.50500.xnl_RTparam_name_Fault_BAP2": "Вихід з ладу акумуляторної батареї 2",
  "common.50500.xnl_RTparam_name_Vtr_BAP3": "Загальна напруга акумуляторної батареї 3",
  "common.50500.xnl_RTparam_name_Cr_BAP3": "Акумуляторна батарея 3 струму",
  "common.50500.xnl_RTparam_name_T_BAP3": "Акумуляторна батарея 3 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP3": "Акумуляторна батарея 3 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP3": "Залишкова ємність акумуляторної батареї 3",
  "common.50500.xnl_RTparam_name_T_cap_BAP3": "Загальна ємність акумуляторної батареї 3",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg3": "Акумуляторна батарея 3 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg3": "Акумуляторна батарея 3 Струм запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg3": "Акумуляторна батарея 3 струм запиту розряду",
  "common.50500.xnl_RTparam_name_Max_V_BAP3": "Максимальна напруга акумулятора 3 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_MIN_V_BAP3": "Мінімальна напруга акумулятора 3 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP3": "Кількість циклів роботи акумуляторної батареї 3",
  "common.50500.xnl_RTparam_name_Warn_BAP3": "Акумуляторна батарея 3 Сигналізація",
  "common.50500.xnl_RTparam_name_Fault_BAP3": "Несправність акумуляторної батареї 3",
  "common.50500.xnl_RTparam_name_Vtr_BAP4": "Загальна напруга акумуляторної батареї 4",
  "common.50500.xnl_RTparam_name_Cr_BAP4": "Акумуляторна батарея 4 струму",
  "common.50500.xnl_RTparam_name_T_BAP4": "Акумуляторна батарея 4 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP4": "Акумуляторна батарея 4 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP4": "Залишкова ємність акумуляторної батареї 4",
  "common.50500.xnl_RTparam_name_T_cap_BAP4": "Загальна ємність акумуляторної батареї 4",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg4": "Акумуляторна батарея 4 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg4": "Акумуляторна батарея 4 Струм запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg4": "Акумуляторна батарея 4 Струм запиту на розряд",
  "common.50500.xnl_RTparam_name_Max_V_BAP4": "Максимальна напруга акумулятора 4 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_MIN_V_BAP4": "Мінімальна напруга акумулятора 4 в акумуляторному блоці",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP4": "Кількість циклів акумуляторної батареї на 4 цикли",
  "common.50500.xnl_RTparam_name_Warn_BAP4": "Акумуляторна батарея 4 сигналізації",
  "common.50500.xnl_RTparam_name_Fault_BAP4": "Вихід з ладу акумуляторної батареї 4",
  "common.50500.xnl_RTparam_name_Vtr5_BAP5": "Загальна напруга акумуляторної батареї 5",
  "common.50500.xnl_RTparam_name_Cr5_BAP5": "Акумуляторна батарея 5 струму",
  "common.50500.xnl_RTparam_name_T_BAP5": "Акумуляторна батарея 5 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP5": "Акумуляторна батарея 5 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP5": "Залишкова ємність акумуляторної батареї 5",
  "common.50500.xnl_RTparam_name_T_cap_BAP5": "Загальна ємність акумуляторної батареї 5",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg5": "Акумуляторна батарея 5 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg5": "Акумуляторна батарея 5 Струм запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg5": "Струм запиту на розряд акумуляторної батареї 5",
  "common.50500.xnl_RTparam_name_Max_V_BAP5": "Максимальна напруга акумулятора 5 в акумуляторному блоці",
  "common.50500.xnl_RTparam_name_MIN_V_BAP5": "Мінімальна напруга батареї 5 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP5": "Кількість циклів акумуляторної батареї на 5 циклів",
  "common.50500.xnl_RTparam_name_Warn_BAP5": "Акумуляторна батарея 5 Сигналізація",
  "common.50500.xnl_RTparam_name_Fault_BAP5": "Вихід з ладу акумуляторної батареї 5",
  "common.50500.xnl_RTparam_name_Vtr6_BAP6": "Загальна напруга акумуляторної батареї 6",
  "common.50500.xnl_RTparam_name_Cr6_BAP6": "Акумуляторна батарея 6 струмів",
  "common.50500.xnl_RTparam_name_T_BAP6": "Акумуляторна батарея 6 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP6": "Акумуляторна батарея 6 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP6": "Залишкова ємність акумуляторної батареї 6",
  "common.50500.xnl_RTparam_name_T_cap_BAP6": "Загальна ємність акумуляторної батареї 6",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg6": "Акумуляторна батарея 6 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg6": "Струм запиту на зарядку акумуляторної батареї 6",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg6": "Акумуляторна батарея 6 струм запиту розряду",
  "common.50500.xnl_RTparam_name_Max_V_BAP6": "Акумуляторна батарея 6 Максимальна напруга батареї",
  "common.50500.xnl_RTparam_name_MIN_V_BAP6": "Мінімальна напруга батареї 6 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP6": "Кількість циклів акумуляторної батареї на 6 циклів",
  "common.50500.xnl_RTparam_name_Warn_BAP6": "Акумуляторна батарея 6 Сигналізація",
  "common.50500.xnl_RTparam_name_Fault_BAP6": "Вихід з ладу акумуляторної батареї 6",
  "common.50500.xnl_RTparam_name_Vtr7_BAP7": "Загальна напруга акумуляторної батареї 7",
  "common.50500.xnl_RTparam_name_Cr7_BAP7": "Акумуляторна батарея 7 струму",
  "common.50500.xnl_RTparam_name_T_BAP7": "Акумуляторна батарея 7 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP7": "Акумуляторна батарея 7 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP7": "Залишкова ємність акумуляторної батареї 7",
  "common.50500.xnl_RTparam_name_T_cap_BAP7": "Загальна ємність акумуляторної батареї 7",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg7": "Акумуляторна батарея 7 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg7": "Акумуляторна батарея 7 Запит на зарядку Струм",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg7": "Струм запиту на розряд акумуляторної батареї 7",
  "common.50500.xnl_RTparam_name_Max_V_BAP7": "Акумуляторна батарея 7 Максимальна напруга батареї",
  "common.50500.xnl_RTparam_name_MIN_V_BAP7": "Мінімальна напруга батареї 7 в акумуляторному блоці",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP7": "Акумуляторна батарея: 7 циклів підрахунку",
  "common.50500.xnl_RTparam_name_Warn_BAP7": "Акумуляторна батарея 7 сигналів",
  "common.50500.xnl_RTparam_name_Fault_BAP7": "Вихід з ладу акумуляторної батареї 7",
  "common.50500.xnl_RTparam_name_Vtr8_BAP8": "Загальна напруга акумуляторної батареї 8",
  "common.50500.xnl_RTparam_name_Cr8_BAP8": "Акумуляторна батарея 8 струмів",
  "common.50500.xnl_RTparam_name_T_BAP8": "Акумуляторна батарея 8 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP8": "Акумуляторна батарея 8 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP8": "Залишкова ємність акумуляторної батареї 8",
  "common.50500.xnl_RTparam_name_T_cap_BAP8": "Загальна ємність акумуляторної батареї 8",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg8": "Акумуляторна батарея 8 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg8": "Акумуляторна батарея 8 Струм запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg8": "Струм запиту на розряд акумуляторної батареї 8",
  "common.50500.xnl_RTparam_name_Max_V_BAP8": "Максимальна напруга акумулятора 8 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_MIN_V_BAP8": "Мінімальна напруга батареї 8 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP8": "Кількість циклів акумуляторної батареї на 8 циклів",
  "common.50500.xnl_RTparam_name_Warn_BAP8": "Акумуляторна батарея 8 Сигналізація",
  "common.50500.xnl_RTparam_name_Fault_BAP8": "Вихід з ладу акумуляторної батареї 8",
  "common.50500.xnl_RTparam_name_Vtr9_BAP9": "Загальна напруга акумуляторної батареї 9",
  "common.50500.xnl_RTparam_name_Cr9_BAP9": "Акумуляторна батарея 9 струмів",
  "common.50500.xnl_RTparam_name_T_BAP9": "Акумуляторна батарея 9 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP9": "Акумуляторна батарея 9 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP9": "Залишкова ємність акумуляторної батареї 9",
  "common.50500.xnl_RTparam_name_T_cap_BAP9": "Загальна ємність акумуляторної батареї 9",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg9": "Акумуляторна батарея 9 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg9": "Струм запиту на зарядку акумуляторної батареї 9",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg9": "Акумуляторна батарея 9 струм запиту розряду",
  "common.50500.xnl_RTparam_name_Max_V_BAP9": "Акумуляторна батарея 9 Максимальна напруга батареї",
  "common.50500.xnl_RTparam_name_MIN_V_BAP9": "Мінімальна напруга батареї 9 в акумуляторному блоці",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP9": "Акумуляторна батарея: 9 циклів підрахунку",
  "common.50500.xnl_RTparam_name_Warn_BAP9": "Акумуляторна батарея 9 сигналів тривоги",
  "common.50500.xnl_RTparam_name_Fault_BAP9": "Вихід з ладу акумуляторної батареї 9",
  "common.50500.xnl_RTparam_name_Vtr10_BAP10": "Загальна напруга акумуляторного блоку 10",
  "common.50500.xnl_RTparam_name_Cr10_BAP10": "Акумуляторна батарея 10 струму",
  "common.50500.xnl_RTparam_name_T_BAP10": "Акумуляторна батарея 10 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP10": "Акумуляторна батарея 10 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP10": "Залишкова ємність акумуляторної батареї 10",
  "common.50500.xnl_RTparam_name_T_cap_BAP10": "Загальна ємність акумуляторної батареї 10",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg10": "Акумуляторна батарея 10 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg10": "Струм запиту на зарядку акумуляторної батареї 10",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg10": "Струм запиту на розряд акумуляторної батареї 10",
  "common.50500.xnl_RTparam_name_Max_V_BAP10": "Максимальна напруга акумулятора 10 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_MIN_V_BAP10": "Мінімальна напруга акумулятора 10 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP10": "Кількість циклів роботи акумуляторної батареї 10",
  "common.50500.xnl_RTparam_name_Warn_BAP10": "Акумуляторна батарея 10 Сигналізація",
  "common.50500.xnl_RTparam_name_Fault_BAP10": "Вихід з ладу акумуляторної батареї 10",
  "common.50500.xnl_RTparam_name_Vtr11_BAP11": "Загальна напруга акумуляторної батареї 11",
  "common.50500.xnl_RTparam_name_Cr11_BAP11": "Акумуляторна батарея 11 струм",
  "common.50500.xnl_RTparam_name_T_BAP11": "Акумуляторна батарея 11 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP11": "Акумуляторна батарея 11 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP11": "Залишкова ємність акумуляторної батареї 11",
  "common.50500.xnl_RTparam_name_T_cap_BAP11": "Загальна ємність акумуляторної батареї 11",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg11": "Напруга запиту на зарядку акумуляторної батареї 11",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg11": "Акумуляторна батарея 11 Струм запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg11": "Струм запиту на розряд акумуляторної батареї 11",
  "common.50500.xnl_RTparam_name_Max_V_BAP11": "Максимальна напруга акумуляторної батареї 11 акумуляторів",
  "common.50500.xnl_RTparam_name_MIN_V_BAP11": "Мінімальна напруга акумулятора 11 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP11": "Кількість циклів роботи акумуляторної батареї 11",
  "common.50500.xnl_RTparam_name_Warn_BAP11": "Акумуляторна батарея 11 сигналізація",
  "common.50500.xnl_RTparam_name_Fault_BAP11": "Несправність акумуляторної батареї 11",
  "common.50500.xnl_RTparam_name_Vtr12_BAP12": "Загальна напруга акумуляторної батареї 12",
  "common.50500.xnl_RTparam_name_Cr12_BAP12": "Акумуляторна батарея 12 струму",
  "common.50500.xnl_RTparam_name_T_BAP12": "Акумуляторна батарея 12 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP12": "Акумуляторна батарея 12 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP12": "Залишкова ємність акумуляторної батареї 12",
  "common.50500.xnl_RTparam_name_T_cap_BAP12": "Загальна ємність акумуляторної батареї 12",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg12": "Акумуляторна батарея 12 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg12": "Акумуляторна батарея 12 Струм запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg12": "Акумуляторна батарея 12 струм запиту розряду",
  "common.50500.xnl_RTparam_name_Max_V_BAP12": "Максимальна напруга акумулятора 12 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_MIN_V_BAP12": "Мінімальна напруга акумулятора 12 в акумуляторному блоці",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP12": "Кількість циклів роботи акумуляторної батареї 12",
  "common.50500.xnl_RTparam_name_Warn_BAP12": "Акумуляторна батарея 12 сигналів тривоги",
  "common.50500.xnl_RTparam_name_Fault_BAP12": "Вихід з ладу акумуляторної батареї 12",
  "common.50500.xnl_RTparam_name_Vtr13_BAP13": "Загальна напруга акумуляторної батареї 13",
  "common.50500.xnl_RTparam_name_Cr13_BAP13": "Акумуляторна батарея 13 струму",
  "common.50500.xnl_RTparam_name_T_BAP13": "Акумуляторна батарея 13 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP13": "Акумуляторна батарея 13 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP13": "Залишкова ємність акумуляторної батареї 13",
  "common.50500.xnl_RTparam_name_T_cap_BAP13": "Загальна ємність акумуляторного блоку 13",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg13": "Напруга запиту на зарядку акумуляторної батареї 13",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg13": "Струм запиту на зарядку акумуляторної батареї 13",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg13": "Струм запиту на розряд акумуляторної батареї 13",
  "common.50500.xnl_RTparam_name_Max_V_BAP13": "Максимальна напруга акумулятора 13 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_MIN_V_BAP13": "Мінімальна напруга акумулятора 13 в акумуляторному блоці",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP13": "Кількість циклів роботи акумуляторної батареї 13",
  "common.50500.xnl_RTparam_name_Warn_BAP13": "Акумуляторна батарея 13 сигналізація",
  "common.50500.xnl_RTparam_name_Fault_BAP13": "Несправність акумуляторної батареї 13",
  "common.50500.xnl_RTparam_name_Vtr14_BAP14": "Загальна напруга акумуляторного блоку 14",
  "common.50500.xnl_RTparam_name_Cr14_BAP14": "Акумуляторна батарея 14 струму",
  "common.50500.xnl_RTparam_name_T_BAP14": "Акумуляторна батарея 14 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP14": "Акумуляторна батарея 14 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP14": "Залишкова ємність акумуляторної батареї 14",
  "common.50500.xnl_RTparam_name_T_cap_BAP14": "Загальна ємність акумуляторного блоку 14",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg14": "Акумуляторна батарея 14 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg14": "Струм запиту на зарядку акумуляторної батареї 14",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg14": "Струм запиту на розряд акумуляторної батареї 14",
  "common.50500.xnl_RTparam_name_Max_V_BAP14": "Максимальна напруга акумулятора 14 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_MIN_V_BAP14": "Мінімальна напруга акумулятора 14 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP14": "Кількість циклів роботи акумуляторної батареї 14",
  "common.50500.xnl_RTparam_name_Warn_BAP14": "Акумуляторна батарея 14 сигналізаторів",
  "common.50500.xnl_RTparam_name_Fault_BAP14": "Несправність акумуляторної батареї 14",
  "common.50500.xnl_RTparam_name_Vtr15_BAP15": "Загальна напруга акумуляторної батареї 15",
  "common.50500.xnl_RTparam_name_Cr15_BAP15": "Акумуляторна батарея 15 струму",
  "common.50500.xnl_RTparam_name_T_BAP15": "Акумуляторна батарея 15 Температура",
  "common.50500.xnl_RTparam_name_SOC_BAP15": "Акумуляторна батарея 15 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP15": "Залишкова ємність акумуляторної батареї 15",
  "common.50500.xnl_RTparam_name_T_cap_BAP15": "Загальна ємність акумуляторної батареї 15",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg15": "Акумуляторна батарея 15 Напруга запиту на зарядку",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg15": "Акумуляторна батарея 15 зарядний струм",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg15": "Акумуляторна батарея 15 струм запиту розряду",
  "common.50500.xnl_RTparam_name_Max_V_BAP15": "Максимальна напруга акумулятора 15 в акумуляторній батареї",
  "common.50500.xnl_RTparam_name_MIN_V_BAP15": "Мінімальна напруга акумулятора 15 в акумуляторному блоці",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP15": "Кількість циклів роботи акумуляторної батареї 15",
  "common.50500.xnl_RTparam_name_Warn_BAP15": "Акумуляторна батарея 15 сигналізаторів",
  "common.50500.xnl_RTparam_name_Fault_BAP15": "Несправність акумуляторної батареї 15",
  "common.50500.xnl_RTparam_name_yr1": "Рік",
  "common.50500.xnl_RTparam_name_mon1": "Місяць",
  "common.50500.xnl_RTparam_name_tdy1": "День",
  "common.50500.xnl_RTparam_name_hou1": "Коли",
  "common.50500.xnl_RTparam_name_min1": "Очок",
  "common.50500.xnl_RTparam_name_sec1": "Секунд",
  "common.50500.xnl_RTparam_name_BMS_D_V": "Напруга розряду BMS",
  "common.50500.xnl_RTparam_name_BMS_B_Ccg_thd1": "Ліміт на зарядку акумулятора BMS",
  "common.50500.xnl_RTparam_name_BMS_B_Cdcg_thd1": "Ліміт глядацької аудиторії на розряді акумулятора BMS",
  "common.50500.xnl_RTparam_name_B_R_P": "Залишок потужності BMS",
  "common.50500.xnl_RTparam_name_BMS_B_V1": "Напруга акумулятора BMS",
  "common.50500.xnl_RTparam_name_BMS_B_C1": "Струм батареї BMS",
  "common.50500.xnl_RTparam_name_BMST": "Температура BMS",
  "common.50500.xnl_RTparam_name_BCT": "Тип батареї",
  "common.50500.xnl_RTparam_name_HF_1": "Історичний розлом 1",
  "common.50500.xnl_RTparam_name_HF_2": "Історичний розлом 2",
  "common.50500.xnl_RTparam_name_HF_3": "Історичний розлом 3",
  "common.50500.xnl_RTparam_name_HF_4": "Історичний розлом 4",
  "common.50500.xnl_RTparam_name_HF_5": "Історичний розлом 5",
  "common.50500.xnl_RTparam_name_HF_6": "Історичний розлом 6",
  "common.50500.xnl_RTparam_name_HF_7": "Історичний розлом 7",
  "common.50500.xnl_RTparam_name_HF_8": "Історичний розлом 8",
  "common.50500.xnl_RTparam_name_HF_9": "Історичний розлом 9",
  "common.50500.xnl_RTparam_name_HF_10": "Історичний розлом 10",
  "common.50500.xnl_RTparam_name_HF_11": "Історичний розлом 11",
  "common.50500.xnl_RTparam_name_HF_12": "Історичний розлом 12",
  "common.50500.xnl_RTparam_name_HF_13": "Історичний розлом 13",
  "common.50500.xnl_RTparam_name_G_V_L3": "Напруга мережі L3",
  "common.50500.xnl_RTparam_name_G_V_L1_L3": "Напруга на стороні мережі L1-L3",
  "common.50500.xnl_RTparam_name_G_V_L2_L3": "Напруга на стороні мережі L2-L3",
  "common.50500.xnl_RTparam_name_AV3": "Напруга змінного струму Т/Вт/С",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L3": "Вихідна напруга інвертора L1-L3",
  "common.50500.xnl_RTparam_name_INV_O_P_L2_L3": "Вихідна напруга інвертора L2-L3",
  "common.50500.xnl_RTparam_name_C_V_L3": "Напруга навантаження L3",
  "common.50500.xnl_RTparam_name_NA": "Н.А.",
  "common.50500.xnl_RTparam_name_I_O_F3": "Вихідна частота інвертора L3",
  "common.50500.xnl_RTparam_name_G_C_L3": "Струм мережі L3",
  "common.50500.xnl_RTparam_name_G_C_C": "Струм мережі C",
  "common.50500.xnl_RTparam_name_AC3": "Змінний струм Т/Вт/С",
  "common.50500.xnl_RTparam_name_G_P_L3": "Електромережа L3",
  "common.50500.xnl_RTparam_name_CT3_P_E": "Зовнішнє живлення CT3",
  "common.50500.xnl_RTparam_name_INV_O_P_L3": "Вихідна потужність інвертора L3",
  "common.50500.xnl_RTparam_name_C_P_L3": "Потужність навантаження L3",
  "common.50500.xnl_RTparam_name_C_C_L3": "Струм навантаження L3",
  "common.50500.xnl_RTparam_name_BMS_C_V": "Зарядна напруга BMS",
  "common.50500.xnl_RTparam_name_INV_ADDR": "Адреса інвертора",
  "bw_RTparam_name_online": "Онлайн",
  "bw_RTparam_name_offline": "Автономних",
  "bw_RTparam_name_buy": "Купити електроенергію",
  "bw_RTparam_name_sell": "Продавати електроенергію",
  "bw_RTparam_name_dontBuy": "Не купуйте, не продавайте",
  "bw_RTparam_name_noCharging": "Без зарядки та розряду",
  "bw_RTparam_name_forbidden": "Забороняється заряджати і розряджати",
  "bw_RTparam_name_charging": "Заряджання та заборона на відпуск",
  "bw_RTparam_name_allowCharged": "Дозволяють заряджатися і відпускатися",
  "bw_RTparam_name_forcedCharging": "Примусова зарядка і заборона",
  "bw_RTparam_name_forcedCharge": "Примусовий заряд і розряд",
  "bw_RTparam_name_photovoltaics": "КТ використовується для електромереж та фотовольтаїки",
  "bw_RTparam_name_gridCT": "Мережа використовує КТ, а фотоелектрична – лічильники",
  "bw_RTparam_name_electricity": "Для електромереж використовуються електролічильники, а для фотовольтаїки – КТ",
  "bw_RTparam_name_grid": "Мережеві та фотоелектричні лічильники",
  "bw_RTparam_name_forced": "Примусова зарядка і розрядка",
  "bw_RTparam_name_charge": "Функція заряду/розряду не ввімкнена",
  "common.50100.Inverter": "逆变器",
  "supplier.type.tuobang": "Туобао",
  "supplier.type.gd": "GOODWE",
  "Ajouterbar.plant": "Додати завод",
  "ASNZ4777-N": "Australia_ASNZ4777-N",
  "CEI 0-21": "Italy_CEI 0-21",
  "custom50": "User defined_Custom50",
  "custom60": "User defined_Custom60",
  "EN50438L": "Cyprus,Finland,Czech,Slovenia,Jamaica_EN50438 L",
  "G83/1-A": "UK_G83/1-A",
  "G83/3": "UK_G83/3",
  "General50": "User defined_General 50",
  "General60": "User defined_General 60",
  "GN300V": "China_GN300V",
  "GNB": "China_GNB",
  "GNC": "China_GNC",
  "ISONE208": "USA_ISONE208",
  "ISONE208A": "USA_ISONE208A",
  "ISONE240": "USA_ISONE240",
  "ISONE240A": "USA_ISONE240A",
  "JAM-230": "Jamaica_JAM-230",
  "MEX": "China_MEX",
  "MEX-A": "Mexico_MEX-A",
  "MEX-N": "MEX-N_MEX-N",
  "NA-EEA-A": "Switzerland_NA-EEA-A",
  "R14-208": "USA_R14-208",
  "R14-208A": "USA_R14-208A",
  "R14-240": "USA_R14-240",
  "R14-240A": "USA_R14-240A",
  "R14H-208": "USA_R14H-208",
  "R14H-240": "USA_R14H-240",
  "R21-208": "USA_R21-208",
  "R21-240": "USA_R21-240",
  "R21P3-208": "USA_R21P3-208",
  "R21P3-20A": "USA_R21P3-20A",
  "R21P3-240": "USA_R21P3-240",
  "R21P3-24A": "USA_R21P3-24A",
  "UL-208V-13": "USA_UL-208V-13",
  "UL-208V-18": "USA_UL-208V-18",
  "UL-208V-A": "USA_UL-208V-A",
  "UL240-13": "USA_UL240-13",
  "UL-240V-18": "USA_UL-240V-18",
  "common.50402.Derating": "Зниження рейтингу",
  "common.50402.dispatch": "Розсилання",
  "common.50402.fault": "Вини",
  "common.50402.outages": "Нормування електроенергії та перебої з електроенергією",
  "common.50402.generation": "Виробництво електроенергії через мережу",
  "common.50402.Standby": "Режимі очікування",
  "common.50402.Planned": "Планові відключення",
  "common.50300.offline": "Автономних",
  "common.50300.Standby": "Режимі очікування",
  "common.50300.online": "Онлайн",
  "common.50300.fault": "Вини",
  "device.category.fox": "Fox",
  "bw_RTparam_name_TotalPowerFactor_PV1": "Загальний коефіцієнт потужності (PV)1",
  "CEI0-21": "Italy_CEI 0-21",
  "common.50700.xnl_RTparam_group_Load": "Навантаження",
  "common.50700.xnl_RTparam_group_Inverter": "Інвертор",
  "common.50700.xnl_RTparam_group_Grid": "Електромережа",
  "common.50700.170": "Незаконним",
  "common.50700.169": "Перевірено на заводі",
  "common.50700.168": "Оновлення",
  "common.50700.167": "Режимі очікування",
  "common.50700.166": "Постійні збої",
  "common.50700.165": "Вини",
  "common.50700.164": "Автономний",
  "common.50700.163": "Сітка",
  "common.50700.162": "Перевірка",
  "common.50700.161": "Чекають",
  "common.50700.160": "Самоперевірка",
  "common.50700.TFreq": "Частота Т-фази",
  "common.50700.TCurrent": "Струм Т-фази",
  "common.50700.SVolt": "S фазна напруга",
  "common.50700.SPower": "Живлення S-фази",
  "common.50700.SOH": "СОХ",
  "common.50700.SoC": "Зміст",
  "common.50700.SFreq": "Частота фази S",
  "common.50700.SCurrent": "Фазний струм S",
  "common.50700.RVolt": "R фазна напруга",
  "common.50700.runningState": "Робочий стан",
  "common.50700.RPower": "Потужність R-фази",
  "common.50700.RFreq": "Частота фази R",
  "common.50700.ResidualEnergy": "Акумулятора",
  "common.50700.ReactivePower": "Реактивна потужність",
  "common.50700.RCurrent": "R-фазний струм",
  "common.50700.pvPower": "Фотоелектрична потужність",
  "common.50700.pv9Volt": "Напруга PV9",
  "common.50700.pv9Power": "Потужність PV9",
  "common.50700.pv9Current": "Струм PV9",
  "common.50700.pv8Volt": "Напруга PV8",
  "common.50700.pv8Power": "Потужність PV8",
  "common.50700.pv8Current": "Струм PV8",
  "common.50700.pv7Volt": "Напруга PV7",
  "common.50700.pv7Power": "Потужність PV7",
  "common.50700.pv7Current": "Струм PV7",
  "common.50700.pv6Volt": "Напруга PV6",
  "common.50700.pv6Power": "Потужність PV6",
  "common.50700.pv6Current": "Струм PV6",
  "common.50700.pv5Volt": "Напруга PV5",
  "common.50700.pv5Power": "Потужність PV5",
  "common.50700.pv5Current": "Струм PV5",
  "common.50700.pv4Volt": "Напруга PV4",
  "common.50700.pv4Power": "Потужність PV4",
  "common.50700.pv4Current": "Струм PV4",
  "common.50700.pv3Volt": "Напруга PV3",
  "common.50700.pv3Power": "Потужність PV3",
  "common.50700.pv3Current": "Струм PV3",
  "common.50700.pv2Volt": "Напруга PV2",
  "common.50700.pv2Power": "Потужність PV2",
  "common.50700.pv2Current": "Струм PV2",
  "common.50700.pv1Volt": "Напруга PV1",
  "common.50700.pv1Power": "Потужність PV1",
  "common.50700.pv1Current": "Струм PV1",
  "common.50700.pv18Volt": "Напруга PV18",
  "common.50700.pv18Power": "Потужність PV18",
  "common.50700.pv18Current": "Струм PV18",
  "common.50700.pv17Volt": "Напруга PV17",
  "common.50700.pv17Power": "Потужність PV17",
  "common.50700.pv17Current": "Струм PV17",
  "common.50700.pv16Volt": "Напруга PV16",
  "common.50700.pv16Power": "Потужність PV16",
  "common.50700.pv16Current": "Струм PV16",
  "common.50700.pv15Volt": "Напруга PV15",
  "common.50700.pv15Power": "Потужність PV15",
  "common.50700.pv15Current": "Струм PV15",
  "common.50700.pv14Volt": "Напруга PV14",
  "common.50700.pv14Power": "Потужність PV14",
  "common.50700.pv14Current": "Струм PV14",
  "common.50700.pv13Volt": "Напруга PV13",
  "common.50700.pv13Power": "Потужність PV13",
  "common.50700.pv13Current": "Струм PV13",
  "common.50700.pv12Volt": "Напруга PV12",
  "common.50700.pv12Power": "Потужність PV12",
  "common.50700.pv12Current": "Струм PV12",
  "common.50700.pv11Volt": "Напруга PV11",
  "common.50700.pv11Power": "Потужність PV11",
  "common.50700.pv11Current": "Струм PV11",
  "common.50700.pv10Volt": "Напруга PV10",
  "common.50700.pv10Power": "Потужність PV10",
  "common.50700.pv10Current": "Струм PV10",
  "common.50700.PowerFactor": "Чинник",
  "common.50700.meterPowerT": "Потужність лічильника, Т",
  "common.50700.meterPowerS": "Потужність лічильника S",
  "common.50700.meterPowerR": "Потужність лічильника R",
  "common.50700.meterPower2": "Потужність лічильника 2",
  "common.50700.meterPower": "Потужність лічильника",
  "common.50700.loadsPowerT": "Потужність Т-фази навантаження",
  "common.50700.loadsPowerS": "Навантаження S-фазна потужність",
  "common.50700.loadsPowerR": "Потужність R-фази навантаження",
  "common.50700.loadsPower": "Потужність навантаження",
  "common.50700.loads": "Споживана потужність навантаження",
  "common.50700.invTemperation": "Температура інвертора",
  "common.50700.invBatVolt": "Напруга акумулятора на стороні інвертора",
  "common.50700.invBatPower": "Живлення від акумулятора на стороні інвертора",
  "common.50700.invBatCurrent": "Струм акумулятора на стороні інвертора",
  "common.50700.gridConsumptionPower": "У електромережі зникає електроенергія",
  "common.50700.gridConsumption": "Загальне споживання електроенергії в мережі",
  "common.50700.generationPower": "Виробництво електроенергії",
  "common.50700.generation": "Кумулятивне виробництво електроенергії",
  "common.50700.feedinPower": "Живлення, підключене до мережі",
  "common.50700.feedin": "Сумарна потужність живильника",
  "common.50700.epsVoltT": "Фазна напруга EPS-T",
  "common.50700.epsVoltS": "Фазна напруга EPS-S",
  "common.50700.epsVoltR": "Фазна напруга EPS-R",
  "common.50700.epsPowerT": "Фазна потужність EPS-T",
  "common.50700.epsPowerS": "Фазна потужність EPS-S",
  "common.50700.epsPowerR": "Фазна потужність EPS-R",
  "common.50700.epsPower": "Потужність EPS",
  "common.50700.epsCurrentT": "Фазний струм EPS-T",
  "common.50700.epsCurrentS": "Фазний струм EPS-S",
  "common.50700.epsCurrentR": "Фазний струм EPS-R",
  "common.50700.energyThroughput": "Пропускна здатність акумулятора",
  "common.50700.dspTemperature": "Температура DSP",
  "common.50700.dischargeEnergyToTal": "Загальний розряд",
  "common.50700.chargeTemperature": "Температура зарядки",
  "common.50700.chargeEnergyToTal": "Загальна зарядка",
  "common.50700.boostTemperation": "Температура зарядного пристрою",
  "common.50700.batVolt": "Напруга акумулятора",
  "common.50700.batTemperature": "Температура акумулятора",
  "common.50700.batStatusV2": "Стан батареї",
  "common.50700.batStatus": "Стан батареї",
  "common.50700.batDischargePower": "Потужність розряду акумулятора",
  "common.50700.batCurrent": "Струм акумулятора",
  "common.50700.batChargePower": "Потужність заряджання акумулятора",
  "common.50700.ambientTemperation": "Температура навколишнього середовища",
  "common.50700.xnl_RTparam_group_Battery": "Батерія",
  "common.50702.xnl_RTparam_group_Battery": "Батерія",
  "common.50698.TVolt": "Напруга фази T",
  "common.50700.TPower": "Потужність фази T",
  "common.50700.TVolt": "Напруга фази T",
  "supplier.type.ankerui": "ankerui",
  "subtype.collector.4g.meters": "лічильник 4G",
  "param_set.xnl_inverter_Factoryresetenable": " Відновлення заводських налаштувань  ",
  "param_set.xnl_inverter_GridMode": " Стандарти підключення до мережі  ",
  "param_set.xnl_inverter_GridType": " Налаштування типу електромережі  ",
  "param_set.xnl_inverter_GridFrequency": " Налаштування частоти мережі  ",
  "param_set.xnl_inverter_Restoreconnectiontime": " Час відновлення підключення до мережі  ",
  "param_set.xnl_inverter_PF": " Налаштування коефіцієнта потужності (PF) на виході  ",
  "param_set.xnl_inverter_GridFrequencyOver": " Крапка захисту від високої частоти мережі  ",
  "param_set.xnl_inverter_GridFrequencyUnder": " Крапка захисту від низької частоти мережі  ",
  "param_set.xnl_inverter_GridVoltageOver": " Крапка захисту від перенапруги в мережі  ",
  "param_set.xnl_inverter_GridVoltageUnder": " Крапка захисту від низької напруги в мережі  ",
  "param_set.xnl_inverter_Q(V)": " Увімкнення CA_QV (Каліфорнія)  ",
  "param_set.xnl_inverter_V1": " CA_QV_V1  ",
  "param_set.xnl_inverter_V2": " CA_QV_V2  ",
  "param_set.xnl_inverter_V3": " CA_QV_V3  ",
  "param_set.xnl_inverter_V4": " CA_QV_V4  ",
  "param_set.xnl_inverter_Q1": " CA_QV_Q1  ",
  "param_set.xnl_inverter_Q2": " CA_QV_Q2  ",
  "param_set.xnl_inverter_Q3": " CA_QV_Q3  ",
  "param_set.xnl_inverter_Q4": " CA_QV_Q4  ",
  "param_set.xnl_inverter_FW": " Увімкнення CA_FW (Каліфорнія)  ",
  "param_set.xnl_inverter_Fstart": " CA_Fstart  ",
  "param_set.xnl_inverter_Fstop": " CA_Fstop  ",
  "param_set.xnl_inverter_VW": " Увімкнення CA_VW (Каліфорнія)  ",
  "param_set.xnl_inverter_Vstart": " CA_Vstart  ",
  "param_set.xnl_inverter_Vstop": " CA_Vstop  ",
  "param_set.xnl_inverter_Normalupwardslope": " Нормальна швидкість наростання  ",
  "param_set.xnl_inverter_Softstartriserate": " Швидкість наростання при м'якому пуску  ",
  "param_set.xnl_inverter_LHVRT": " Увімкнення LVRT/HVRT (Каліфорнія)  ",
  "param_set.xnl_inverter_HV2": " CA_HV2  ",
  "param_set.xnl_inverter_HV1": " CA_HV1  ",
  "param_set.xnl_inverter_LV1": " CA_LV1  ",
  "param_set.xnl_inverter_LV2": " CA_LV2  ",
  "param_set.xnl_inverter_LV3": " CA_LV3  ",
  "param_set.xnl_inverter_CA_HV2_Time": " Час CA_HV2  ",
  "param_set.xnl_inverter_CA_HV1_Time": " Час CA_HV1  ",
  "param_set.xnl_inverter_CA_LV1_Time": " Час CA_LV1  ",
  "param_set.xnl_inverter_CA_LV2_Time": " Час CA_LV2  ",
  "param_set.xnl_inverter_CA_LV3_Time": " Час CA_LV3  ",
  "param_set.xnl_inverter_CA_LHFRT": " Увімкнення CA_LHFRT (Каліфорнія)  ",
  "param_set.xnl_inverter_CA_HF2": " CA_HF2  ",
  "param_set.xnl_inverter_CA_HF1": " CA_HF1  ",
  "param_set.xnl_inverter_CA_LF1": " CA_LF1  ",
  "param_set.xnl_inverter_CA_LF2": " CA_LF2  ",
  "param_set.xnl_inverter_CA_HF2_Time": " Час CA_HF2  ",
  "param_set.xnl_inverter_CA_HF1_Time": " Час CA_HF1  ",
  "param_set.xnl_inverter_CA_LF1_Time": " Час CA_LF1  ",
  "param_set.xnl_inverter_CA_LF2_Time": " Час CA_LF2  ",
  "param_set.xnl_inverter_GeneratorInputRatedPower": " Номінальна вхідна потужність генератора  ",
  "param_set.xnl_inverter_GENConnectToGridInput": " Підключення генератора до мережі  ",
  "param_set.xnl_inverter_SmartLoadOutput": " Потужність під навантаженням  ",
  "param_set.xnl_inverter_OnGridAlwayson00": " Умови ввімкнення мережі  ",
  "param_set.xnl_inverter_OFF1": " Напруга акумулятора для SmartLoad ВИМК  ",
  "param_set.xnl_inverter_ON1": " Напруга акумулятора для SmartLoad УВІМК  ",
  "param_set.xnl_inverter_OFF2": " Рівень заряду акумулятора для SmartLoad ВИМК  ",
  "param_set.xnl_inverter_ON2": " Рівень заряду акумулятора для SmartLoad УВІМК  ",
  "param_set.xnl_inverter_Battery_Type": " Тип акумулятора  ",
  "param_set.xnl_inverter_Battery_Mode": " Режим акумулятора  ",
  "param_set.xnl_inverter_Activate Battery": " Прапорець пробудження Li-ion акумулятора  ",
  "param_set.xnl_inverter_Batt Capacity": " Ємність акумулятора  ",
  "param_set.xnl_inverter_MaxACharge": " Максимальний струм заряду акумулятора  ",
  "param_set.xnl_inverter_MaxAdischarge": " Максимальний струм розряду акумулятора  ",
  "param_set.xnl_inverter_GenCharge1": " Увімкнення заряду від генератора  ",
  "param_set.xnl_inverter_GenSignal1": " Сигнал генератора (Gen)  ",
  "param_set.xnl_inverter_GenStartingCapacityPoint2": " Крапка запуску заряду від генератора за рівнем заряду  ",
  "param_set.xnl_inverter_GenMainsPowerBattery2": " Струм заряду акумулятора від генератора  ",
  "param_set.xnl_inverter_MaxRunTime": " Максимальний час роботи генератора  ",
  "param_set.xnl_inverter_CoolingTime": " Час охолодження генератора  ",
  "param_set.xnl_inverter_GridCharge": " Увімкнення заряду від мережі  ",
  "param_set.xnl_inverter_GridSignal": " Сигнал мережі (Grid)  ",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge1": " Крапка запуску заряду від мережі за рівнем заряду  ",
  "param_set.xnl_inverter_ChargeCurrentBatteryMains1": " Струм заряду акумулятора від мережі  ",
  "param_set.xnl_inverter_Lithium Protocol": " Вибір зв'язку з Li-ion акумулятором  ",
  "param_set.xnl_inverter_ShutDown": " Вимкнення акумулятора  ",
  "param_set.xnl_inverter_Restart": " Перезапуск акумулятора  ",
  "param_set.xnl_inverter_LowBatt": " Низька напруга акумулятора  ",
  "param_set.xnl_inverter_GenSignal ": " Сигнал мережі  ",
  "param_set.xnl_inverter_GenStartVoltageMainsPowerCharge": " Крапка запуску заряду від генератора за напругою  ",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge": " Крапка запуску заряду від мережі за напругою  ",
  "param_set.xnl_inverter_FloatVoltage": " Напруга плаваючого заряду  ",
  "param_set.xnl_inverter_AbsorptionVoltage": " Напруга абсорбційного заряду  ",
  "param_set.xnl_inverter_EqualizationVoltage": " Напруга вирівнювального заряду  ",
  "param_set.xnl_inverter_EqualizationdayS": " Періодичність вирівнювального заряду (днів)  ",
  "param_set.xnl_inverter_TEMPCO": " Коефіцієнт температурної компенсації  ",
  "param_set.xnl_inverter_Equalizationhours": " Час виконання вирівнювального заряду  ",
  "param_set.xnl_inverter_batteryresistancevalue": " Значення внутрішнього опору акумулятора  ",
  "param_set.xnl_inverter_GenStartingCapacityPoint": " Крапка запуску заряду від генератора за рівнем заряду  ",
  "param_set.xnl_inverter_SellingFirst": " Пріоритет продажу електроенергії  ",
  "param_set.xnl_inverter_Solarsell": " Потужність продажу від сонячних панелей  ",
  "param_set.xnl_inverter_MaxSolarPower": " Максимальна сонячна потужність  ",
  "param_set.xnl_inverter_MaxSellPower": " Максимальна потужність підключення до мережі  ",
  "param_set.xnl_inverter_Zero-Exportpower": " Мінімальна активна потужність  ",
  "param_set.xnl_inverter_EnergyPattern": " Режим керування енергією  ",
  "param_set.xnl_inverter_GridPeakShavingPower": " Згладжування пікового навантаження мережі  ",
  "param_set.xnl_inverter_GridGen10": " Увімкнення заряду від мережі 1  ",
  "param_set.xnl_inverter_GridGen20": " Увімкнення заряду від мережі 2  ",
  "param_set.xnl_inverter_GridGen30": " Увімкнення заряду від мережі 3  ",
  "param_set.xnl_inverter_GridGen40": " Увімкнення заряду від мережі 4  ",
  "param_set.xnl_inverter_GridGen50": " Увімкнення заряду від мережі 5  ",
  "param_set.xnl_inverter_GridGen60": " Увімкнення заряду від мережі 6  ",
  "param_set.xnl_inverter_Time1": " Часовий інтервал 1  ",
  "param_set.xnl_inverter_Time2": " Часовий інтервал 2  ",
  "param_set.xnl_inverter_Time3": " Часовий інтервал 3  ",
  "param_set.xnl_inverter_Time4": " Часовий інтервал 4  ",
  "param_set.xnl_inverter_Time5": " Часовий інтервал 5  ",
  "param_set.xnl_inverter_Time6": " Часовий інтервал 6  ",
  "param_set.xnl_inverter_Power1": " Потужність  ",
  "param_set.xnl_inverter_Power2": " Потужність 2  ",
  "param_set.xnl_inverter_Power3": " Потужність 3  ",
  "param_set.xnl_inverter_Power4": " Потужність 4  ",
  "param_set.xnl_inverter_Power5": " Потужність 5  ",
  "param_set.xnl_inverter_Power6": " Потужність 6  ",
  "param_set.xnl_inverter_BattV1": " Напруга акумулятора 1  ",
  "param_set.xnl_inverter_BattV2": " Напруга акумулятора 2  ",
  "param_set.xnl_inverter_BattV3": " Напруга акумулятора 3  ",
  "param_set.xnl_inverter_BattV4": " Напруга акумулятора 4  ",
  "param_set.xnl_inverter_BattV5": " Напруга акумулятора 5  ",
  "param_set.xnl_inverter_BattV6": " Напруга акумулятора 6  ",
  "param_set.xnl_inverter_Batt1": " Рівень заряду 1  ",
  "param_set.xnl_inverter_Batt2": " Рівень заряду 2  ",
  "param_set.xnl_inverter_Batt3": " Рівень заряду 3  ",
  "param_set.xnl_inverter_Batt4": " Рівень заряду 4  ",
  "param_set.xnl_inverter_Batt5": " Рівень заряду 5  ",
  "param_set.xnl_inverter_Batt6": " Рівень заряду 6  ",
  "param_set.xnl_inverter_SolarArcFaultON": " Режим виявлення дугового розряду (Arc Fault)  ",
  "param_set.xnl_inverter_CTRatio": " Коефіцієнт трансформації ТТ  ",
  "param_set.xnl_inverter_BackupDelay": " Час UPS  ",
  "param_set.xnl_inverter_Parallel1": " Паралельна робота (Parallel)  ",
  "param_set.xnl_inverter_3P1": " Увімкнення Meter CT для трифазного паралельного підключення  ",
  "param_set.xnl_inverter_GenCharge": " Увімкнення заряду від генератора  ",
  "param_set.xnl_inverter_GenChargeCurrentBatterMains": " Струм заряду акумулятора від генератора  ",
  "param_set.xnl_inverter_Down Time": " Час охолодження генератора  ",
  "param_set.xnl_inverter_Grid Charge": " Увімкнення заряду від мережі  ",
  "param_set.xnl_inverter_ChargeCurrentBatterMains": " Струм заряду акумулятора від мережі  ",
  "param_set.xnl_inverter_GenMainsPowerBattery": " Струм заряду акумулятора від генератора  ",
  "param_set.xnl_inverter_DownTime": " Час охолодження генератора  ",
  "param_set.xnl_inverter_StartingCapacityPoint": " Крапка запуску заряду від мережі за рівнем заряду  ",
  "param_set.xnl_inverter_MainsPowerBattery": " Струм заряду акумулятора від мережі  ",
  "param_set.xnl_inverter_Equalizationtime": " Час виконання вирівнювального заряду  ",
  "param_set.xnl_inverter_Parallel2": " Ведучий (Master)  ",
  "param_set.xnl_inverter_Parallel3": " Фаза  ",
  "param_set.xnl_inverter_Parallel4": " Modbus SN  ",
  "param_set.xnl_inverter_3P2": " Увімкнення фази А для трифазного паралельного підключення  ",
  "param_set.xnl_inverter_3P3": " Увімкнення фази В для трифазного паралельного підключення  ",
  "param_set.xnl_inverter_3P4": " Увімкнення фази С для трифазного паралельного підключення  ",
  "param_set.xnl_inverter_GridGen11": " Увімкнення заряду від генератора/мережі 1  ",
  "param_set.xnl_inverter_GridGen21": " Увімкнення заряду від генератора 2  ",
  "param_set.xnl_inverter_GridGen31": " Увімкнення заряду від генератора 3  ",
  "param_set.xnl_inverter_GridGen41": " Увімкнення заряду від генератора 4  ",
  "param_set.xnl_inverter_GridGen51": " Увімкнення заряду від генератора 5  ",
  "param_set.xnl_inverter_GridGen61": " Увімкнення заряду від генератора 6  ",
  "param_set.xnl_inverter_OnGridAlwayson04": " Умови ввімкнення мережі - Згладжування піків генератором  ",
  "param_set.xnl_inverter_OnGridAlwayson08": " Умови ввімкнення мережі - Згладжування піків мережі  ",
  "param_set.xnl_inverter_OnGridAlwayson12": " Умови ввімкнення мережі - Мережа завжди увімкнена (On Grid always on)  ",
  "param_set.xnl_inverter_OnGridAlwayson13": " Умови ввімкнення мережі - Зовнішнє реле (external relay)  ",
  "param_set.xnl_inverter_OnGridAlwayson14": " Умови ввімкнення мережі - Прапорець звітування про помилку відсутності Li-ion акумулятора  ",
  "param_set.xnl_inverter_OnGridAlwayson15": " Умови ввімкнення мережі - Прапорець DRM (DRM Enable Bit)",
  "param_set.xnl_inverterGroup_BasicSettings": "Базові Налаштування",
  "param_set.xnl_inverterGroup_GridSettings": "Налаштування Мережі",
  "param_set.xnl_inverterGroup_GeneratorSettings": "Налаштування Генератора",
  "param_set.xnl_inverterGroup_BatterySettings": "Налаштування Акумулятора",
  "param_set.xnl_inverterGroup_SystemOperatingMode": "Режим Роботи Системи",
  "param_set.xnl_inverterGroup_AdvancedSettings": "Paramètres Avancés",
  "param_set.xnl_inverter_GenSignal_fdj": "сигнал генератора",
  "param_set.xnl_inverter_GenSignal_charge": " Сигнал мережі  ",
  "param_set.xnl_inverter_GenSignal_fdj_1": "сигнал генератора1",
  "param_set.xnl_inverter_GenSignal_charge_1": " Сигнал мережі1",
  "param_set.xnl_inverter_GenSignal_fdj_2": "сигнал генератора2",
  "param_set.xnl_inverter_GenSignal_charge_2": " Сигнал мережі2",
  "param_set.xnl_inverter_TimeOfUse": "Time of Use",
  "param_set.xnl_inverter_GenPortUsedFor": "Порт генератора, який використовується для",
  "bw_RTparam_name_InverterMasterSoftwareVersion": "Версія основного програмного забезпечення інвертора",
  "bw_RTparam_name_TotalReactivePower_Grid": "Реактивна загальна потужність (мережа)",
  "bw_RTparam_name_TotalApparent Power_Grid": "Scheinleistung (мережа)",
  "bw_RTparam_name_TotalPowerFactor_Grid": "Загальний коефіцієнт потужності (мережа)",
  "bw_RTparam_name_BatteryRelayStatus": "Статус батареї-реле",
  "bw_RTparam_name_BatWarnningPack": "Пакет попередження",
  "bw_RTparam_name_PvBoostTemperature": "Pv-Boost-Температура",
  "bw_RTparam_name_InvModuleTemperature": "Інв-модульна температура",
  "bw_RTparam_name_PowerBoardTemperature": "Температура місця роботи",
  "bw_RTparam_name_InvApparentPower": "Інв Scheinleistung",
  "bw_RTparam_name_InvActivePower": "Inv Активна продуктивність",
  "bw_RTparam_name_InvReactivePower": "Inv реактивна потужність",
  "bw_RTparam_name_InvPowerFactor": "Інв фактор потужності",
  "bw_RTparam_name_BackupFrequency": "Частота резервного копіювання",
  "bw_RTparam_name_InvCurrentR": "Inv Актуальний R",
  "bw_RTparam_name_InvCurrentS": "Inv Aktuell S",
  "bw_RTparam_name_InvCurrentT": "Inv Актуальний T",
  "bw_RTparam_name_BatteryMaxChargePower": "Максимальна потужність зарядження батареї",
  "bw_RTparam_name_BatteryMaxDischargePower": "Максимальна потужність розряду батареї",
  "bw_RTparam_name_TotalEnergyInvInput": "Загальна енергія Inv Input",
  "bw_RTparam_name_BackupVoltageR": "Резервове напруження R",
  "bw_RTparam_name_BackupVoltageS": "Резервове напруження S",
  "bw_RTparam_name_BackupVoltageT": "Резервове напруження T",
  "bw_RTparam_name_BackupCurrentR": "Резервове копіювання потоку R",
  "bw_RTparam_name_BackupCurrentS": "Резервовий поток S",
  "bw_RTparam_name_BackupCurrentT": "Резервове копіювання потоку T",
  "bw_RTparam_name_BackupPower": "Нотстром",
  "common.50300.Ia": "Strum фази A",
  "common.50300.Pa": "Діяльна потужність фази A",
  "common.50300.Ib": "Strum фази B",
  "common.50300.Pb": "Діяльна потужність фази B",
  "common.50300.Ic": "Strum фази C",
  "common.50300.Pc": "Діяльна потужність фази ",
  "common.50300.ctTotalActivePower": "Gesamte Wirkleistung",
  "bw_value_ChargeDischargeRelaysAreDisconnected": "Реле заряду та розряду відключені",
  "bw_value_OnlyDischargeRelayIsClosed": "Тільки розрядне реле закрито",
  "bw_value_OnlyChargeRelayIsClosed": "Тільки зарядне реле закрито",
  "bw_value_ChargeAndDischargeRelaysAreClosed": "Реле заряду та розряду закриті",
  "bw_value_Single-Phase5KwModel": "Однофазна модель 5Kw",
  "bw_value_SinglePhaseEnergyStorage5KwModel": "Модель однофазного зберігання енергії 5Kw",
  "bw_value_Single-PhaseEnergyStorage3KwModel": "Модель однофазного зберігання енергії 3Kw",
  "bw_value_Single-PhaseEnergyStorage6KwModel": "Модель однофазного зберігання енергії 6Kw",
  "bw_value_SinglePhaseEnergyStorage8KwModel": "Модель однофазного зберігання енергії 8 кВт",
  "bw_value_Three-Phase4KwModel": "Тріхфазна модель 4Kw",
  "bw_value_Three-Phase5KwModel": "Трифазна модель 5Kw",
  "bw_value_Three-Phase6KwModel": "Трифазна модель 6Kw",
  "bw_value_Three-Phase8KwModel": "Трифазна модель 8Kw",
  "bw_value_ThreePhase10KwModel": "Трифазна модель 10 кВт",
  "bw_RTparam_name_TheSystemTotalPVEnergy": "Система Загальна фотоенергія (включаючи фотоенергію лічильника)",
  "bw_RTparam_name_GridFrequencyINV": "Частота мережі (форма INV)",
  "device.category.heatpump": "тепловий насос",
  "device.category.collector": "dongle",
  "jl_RTparam_name_powerAmmeter2": "Потужність лічильника 2",
  "jl_RTparam_name_dayEnergyAmmeter2": "Денна споживана електрика лічильника 2",
  "jl_RTparam_name_monthEnergyAmmeter2": "Місячна споживана електрика лічильника 2",
  "jl_RTparam_name_yearEnergyAmmeter2": "Річна споживана електрика лічильника 2",
  "jl_RTparam_name_totalEnergyAmmeter2": "Загальна споживана електрика лічильника 2",
  "jl_RTparam_group_Ammeter": "Електричний лічильник",
  "ai.robot.manage.family": "Привіт, робот AI керує споживанням електроенергії у вашому домі.",
  "ai.robot.predicted.price": "Ціну на електроенергію на сьогодні отримано, прогнозується виробництво {###}kWh сьогодні.",
  "ai.robot.regulating.heat.pump": "Буде регулюватися робота теплового насоса за належних обставин.",
  "bw_RTparam_name_PV_ActivePowerOfAPhase": "Активна потужність фази (PV)",
  "bw_RTparam_name_PV_ActivePowerOfBPhase": "Активна потужність B-фази (PV)",
  "bw_RTparam_name_PV_ActivePowerOfCPhase": "Активна потужність C-фази (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfAPhase": "Очевидна потужність фази (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfBPhase": "Очевидна потужність B-фази (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfCPhase": "Очевидна потужність C-фази (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfAPhase": "Реактивна потужність фази (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfBPhase": "Реактивна потужність B-фази (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfCPhase": "Реактивна потужність C-фази (PV)",
  "bw_RTparam_name_PV_PowerFactorOfAPhase": "Фактор потужності фази (PV)",
  "bw_RTparam_name_PV_PowerFactorOfBPhase": "Фактор потужності B-фази (PV)",
  "bw_RTparam_name_PV_PowerFactorOfCPhase": "Фактор потужності C-фази (PV)",
  "bw_RTparam_name_PVConnectState": "Work Operate Status",
  "bw_RTparam_name_PVMeterNegate": "Напрямок доступу до PV-лічильника",
  "bw_RTparam_Option_NoPV": "Немає PV",
  "bw_RTparam_Option_HasPV": "Має PV",
  "bw_RTparam_Option_PVMeterNormal": "PV лічильник нормальний",
  "bw_RTparam_Option_PVMeterReversed": "PV лічильник зворотний",
  "bw_RTparam_name_TotalPVEnergy_includePVMeter": "Загальне PV-генерація (всередині + зовні INV)",
  "bw_RTparam_name_TodayYield": "Всередині INV щоденне фотоенергетичне покоління",
  "bw_RTparam_name_TotalDevicePower": "Загальна фотоенергія",
  "bw_RTparam_name_DailyDeviceEnergy": "Загальна щоденна генерація фотоенергії",
  "device.category.module": "Компонент",
  "bw_RTparam_name_TotalEnergyInvOutput": "Загальна енергія INV",
  "common.device.check.tab.collector": "Коммунікаційний стрічка",
  "common.device.check.tab.grid": "Електромережева мережа",
  "common.device.check.tab.meterselect": "Вибір електричного лічильника",
  "common.device.check.tab.meterYes": "Стан з'єднання електричного лічильника",
  "common.device.check.tab.gridmeter": "Електричний лічильник з боку мережі",
  "common.device.check.tab.pvmeter": "Електричний лічильник з боку ПВ",
  "common.device.check.tab.battery": "Батарея",
  "common.check.field.collectorSn": "SN комунікаційної стрічки",
  "common.check.field.dongleRSSI": "Сила сигналу",
  "common.check.field.inverterHardwareVersion": "Версія апаратного забезпечення комунікаційної стрічки",
  "common.check.field.dongleSoftwareVersion": "Версія програмного забезпечення комунікаційної стрічки",
  "common.check.field.gridVoltageR": "Напруга фази R мережі",
  "common.check.field.gridVoltageS": "Напруга фази S мережі",
  "common.check.field.gridVoltageT": "Напруга фази T мережі",
  "common.check.field.meterCTSelect": "Стан з'єднання електричного лічильника (З'єднано/Не з'єднано)",
  "common.check.field.gridVoltageOfAPhase": "Напруга фази А електричного лічильника",
  "common.check.field.gridCurrentOfAPhaseV2": "струм фази А електричного лічильника",
  "common.check.field.gridVoltageOfBPhase": "Напруга фази В електричного лічильника",
  "common.check.field.gridCurrentOfBPhaseV2": "струм фази В електричного лічильника",
  "common.check.field.gridVoltageOfCPhase": "Напруга фази С електричного лічильника",
  "common.check.field.gridCurrentOfCPhaseV2": "струм фази С електричного лічильника",
  "common.check.field.gridFrequent": "Частота електричного лічильника",
  "common.check.field.pvVoltageOfAPhase": "Напруга фази А електричного лічильника",
  "common.check.field.pvCurrentOfAPhase": "струм фази А електричного лічильника",
  "common.check.field.pvVoltageOfBPhase": "Напруга фази В електричного лічильника",
  "common.check.field.pvCurrentOfBPhase": "струм фази В електричного лічильника",
  "common.check.field.pvVoltageOfCPhase": "Напруга фази С електричного лічильника",
  "common.check.field.pvCurrentOfCPhase": "струм фази С електричного лічильника",
  "common.check.field.pvFrequent": "Частота електричного лічильника",
  "common.check.field.pvTotalApparentPower": "Зовнішня потужність електричного лічильника (Загальна)",
  "common.check.field.pvMeterTotalActivePower": "Керуюча потужність електричного лічильника (Загальна)",
  "common.check.field.pvTotalReactivePower": "Реактивна потужність електричного лічильника (Загальна)",
  "common.check.field.pvTotalPowerFactor": "Коефіцієнт потужності електричного лічильника (Загальний)",
  "common.check.field.batteryOnlineStatus": "Ефективний стан з'єднання батареї (З'єднано/Не з'єднано)",
  "50000_0X561-M-12": "Фаза мережі непослідовна",
  "50000_0X561-M-13": "Збірка DCV аномальна",
  "50000_0X561-M-14": "Blackbox Flash Помилка",
  "50000_0X561-M-15": "Помилка RTC",
  "bw.content.alarm.0X55E-M-60": "Фаза мережі непослідовна",
  "bw.content.alarm.0X55E-M-61": "Збірка DCV аномальна",
  "bw.content.alarm.0X55E-M-62": "Blackbox Flash Помилка",
  "bw.content.alarm.0X55E-M-63": "Помилка RTC",
  "plant.deliver.type.zj": "Haier Smart Home",
  "deliver.type.energy": "Haier Energy",
  "deliver.type.smart": "Haier Smart Home",
  "VDE0126-50Hz": "France--VDE0126-50Hz",
  "VDE4105/11.18": "Germany--VDE4105/11.18",
  "AS4777.2": "Australia--AS4777.2",
  "G83_2": "G83_2",
  "C10/C11": "Belgium--C10/C11",
  "TOR Erzeuger": "Austria--TOR Erzeuger",
  "EN50549-NL": "Netherlands--EN50549-NL",
  "EN50549-DK": "EN50549-DK",
  "CEB": "CEB",
  "CEI-021": "Italy--CEI-021",
  "NRS097-2-1": "South Africa--NRS097-2-1",
  "EN50549-GR": "EN50549-GR",
  "UTE_C15_712": "UTE_C15_712",
  "IEC61727": "IEC61727",
  "G59_3": "G59_3",
  "RD1699": "Spain--RD1699",
  "G99": "UK--G99",
  "NA": "NA",
  "VDE0126-60Hz": "VDE0126-60Hz",
  "AS4777.2-SA": "Australia--AS4777.2-SA",
  "G98": "UK--G98",
  "EN50549-CZ": "EN50549-CZ",
  "PEA": "Thailand--PEA",
  "MEA": "Thailand--MEA",
  "BISI": "BISI",
  "JET-GR Series": "JET-GR Series",
  "50Hz Default": "50Hz Default",
  "60Hz Default": "60Hz Default",
  "WAREHOUSE": "WAREHOUSE",
  "AS4777.2-NZ": "Australia--AS4777.2-NZ",
  "Korea": "Korea",
  "G98/G99-IE": "UK--G98/G99-IE",
  "NCRfg": "NCRfg",
  "UL1741": "UL1741",
  "UL1741-Rule21": "UL1741-Rule21",
  "UL1741-Hawaiian": "UL1741-Hawaiian",
  "EN50549": "EU--EN50549",
  "common.50800.defrosting": "відтайка",
  "common.50800.antiFreezing": "захист від замерзання",
  "common.50800.sterilization": "стерилізація",
  "common.50800.antiRust": "захист від корозії",
  "common.50800.auto": "автоматичний",
  "common.50800.cool": "охолодження",
  "common.50800.heat": "опалення",
  "common.50800.dhw": "гаряча вода",
  "common.50800.pool": "басейн",
  "common.50800.heat+pool": "опалення + басейн",
  "common.50800.auto+dhw": "автоматичний + гаряча вода",
  "common.50800.cool+dhw": "охолодження + гаряча вода",
  "common.50800.heat+dhw": "опалення + гаряча вода",
  "bw_RTparam_name_deviceRunningState": "Work Operate Status",
  "person.confirmPassword": "Підтвердіть пароль",
  "supplier.type.lg": "LIGOO",
  "plant.not.delivered": "Електростанція не здана",
  "plant.not.exist": "Електростанція не існує",
  "device.agent.admin.can.operate": "У вас немає дозволу відкликати доставку",
  "plant.pure.light": "Нульовий вуглецевий дім - чисте сонце",
  "ywt.60419.meterTPower\n": "Leistung des Stromzählers Phase T",
  "ywt.60419.loadPower\n": "Lastleistung",
  "param_set.lg_inverterGroup_LithiumBattery": "Літієвабатарея",
  "param_set.lg_inverterGroup_AdvancedSettings": "Розширеніналаштування",
  "param_set.lg_inverterGroup_SystemOperationMode": "Робочийрежимсистеми",
  "param_set.lg_inverterGroup_GeneratorSettings": "Налаштуваннягенератора",
  "param_set.lg_inverterGroup_ParallelOperationSettings": "Налаштуванняпаралельноїроботи",
  "param_set.lg_inverterGroup_PeakShavingandValleyFillingSettings": "Налаштуваннязгладжуваннянавантаження",
  "param_set.lg_inverterGroup_GeneratorInputEnable": "Активаціявведеннягенератора",
  "param_set.lg_inverterGroup_SmartLoadEnable": "Активаціярозумногонавантаження",
  "param_set.lg_inverterGroup_MicroinverterEnable": "Активаціямікроінверторів",
  "param_set.lg_inverterGroup_Battery(Shared)": "Акумулятор(спільний)",
  "param_set.lg_inverterGroup_Lead-AcidBattery": "Свинцево-кислотнийакумулятор",
  "param_set.lg_inverter_SystemOn": "Увімкнення/вимкненнясистеми",
  "param_set.lg_inverter_ClearFault": "Очиститипомилки",
  "param_set.lg_inverter_ManualActivation": "Ручнаактивація",
  "param_set.lg_inverter_InverterRated（%）": "Налаштуваннявідсоткапотужностіінвертора",
  "param_set.lg_inverter_PVActivePowerSetting": "НалаштуванняактивноїпотужностіPV(%)",
  "param_set.lg_inverter_PVConnectorMode": "НалаштуванняпідключенняPV",
  "param_set.lg_inverter_PVStarupEnable": "АктиваціязапускувідодногоPV",
  "param_set.lg_inverter_ZeroGroundVoltFaultDetectionEnable": "Активаціявиявленняпомилкинапругинуль-земля",
  "param_set.lg_inverter_GFCIEnable": "Активаціявиявленнявитокуструму",
  "param_set.lg_inverter_AllowGridCharging": "Дозволитизарядкувідмережі",
  "param_set.lg_inverter_PVISOEnable": "АктиваціяперевіркиізоляціїPV",
  "param_set.lg_inverter_CT/MeterOptional": "БітактиваціїлічильникаCT",
  "param_set.lg_inverter_PhaseType": "Типпослідовностіфаз",
  "param_set.lg_inverter_CTRatio": "КоефіцієнтCT",
  "param_set.lg_inverter_PVOperationMode": "РежимроботиPV",
  "param_set.lg_inverter_CVT1CurrentLimit": "ОбмеженняструмуCVT1",
  "param_set.lg_inverter_CVT2CurrentLimit": "ОбмеженняструмуCVT2",
  "param_set.lg_inverter_ChargingCurrent": "Заряднийструм",
  "param_set.lg_inverter_DischargingCurrent": "Струмрозряду",
  "param_set.lg_inverter_FloatChargingVoltage": "Напругаплаваючогозаряду",
  "param_set.lg_inverter_EqualChargingVoltage": "Напругавирівнювальногозаряду",
  "param_set.lg_inverter_CT/MeterAccessDirection": "НапрямокпідключенняCT/лічильника",
  "param_set.lg_inverter_HomeloadUnbalancedCurrentEnable": "Активаціянерівномірногострумудомашньогонавантаження",
  "param_set.lg_inverter_BMSClearFault": "ОчищенняпомилокBMS",
  "param_set.lg_inverter_AFCIReset": "СкиданняAFCI",
  "param_set.lg_inverter_HMIBrightness": "ЯскравістьHMI",
  "param_set.lg_inverter_HMIRestTime": "ЧасзатемненняекранаHMI",
  "param_set.lg_inverter_StatisticClear": "Очиститистатистику",
  "param_set.lg_inverter_EnergyPattern": "Режимкеруванняенергією",
  "param_set.lg_inverter_SyncTimeEnable": "Активаціясинхронізаціїчасу",
  "param_set.lg_inverter_RSDEnable": "АктиваціяRSD",
  "param_set.lg_inverter_Startuptimesetbytheinstaller": "Часзапуску,встановленийінсталятором",
  "param_set.lg_inverter_DynamicPassword": "Динамічнийпароль",
  "param_set.lg_inverter_ACType": "Типзмінногоструму",
  "param_set.lg_inverter_ChargingPriorityMode": "Режимпріоритетузаряджання",
  "param_set.lg_inverter_SellPowerLimit": "Обмежитимакс.потужністьподачівмережу",
  "param_set.lg_inverter_BuzzerEnable": "Звуковийсигнал",
  "param_set.lg_inverter_MeterType": "Типлічильника",
  "param_set.lg_inverter_Specialfeatures": "Спеціальніфункції",
  "param_set.lg_inverter_NLineNotGrounded": "Нульовийпровіднезаземлений",
  "param_set.lg_inverter_AFCIEnable": "Активаціявиявленнядуги",
  "param_set.lg_inverter_FactoryReset": "Відновитизаводськіналаштування",
  "param_set.lg_inverter_AsymmetricPhaseFeeding": "Асиметричнаподачафази",
  "param_set.lg_inverter_ParamsChangeLock": "Блокуваннязмінипараметрів",
  "param_set.lg_inverter_SystemWorkMode": "Робочийрежимсистеми",
  "param_set.lg_inverter_SolarSell": "ПродажелектроенергіїPV",
  "param_set.lg_inverter_SignalIslandMode": "Вхідсигналуавтономногорежиму",
  "param_set.lg_inverter_GridTOUEnable": "Активаціячасовогоінтервалуобмеженняпіківмережі",
  "param_set.lg_inverter_AutoRunEnable": "Активаціяавтоматичноїроботи",
  "param_set.lg_inverter_DRMEnable": "АктиваціяDRM",
  "param_set.lg_inverter_Password": "Парользазамовчуванням",
  "param_set.lg_inverter_PasswordValidityTime": "Терміндіїпароля",
  "param_set.lg_inverter_GeneratorStartMode": "Режимзапускугенератора",
  "param_set.lg_inverter_GeneratorManualStartMode": "Ручнийзапускгенератора",
  "param_set.lg_inverter_Generatorpriority": "Пріоритетгенератора",
  "param_set.lg_inverter_GeneratorInputPort": "Вхіднийпортгенератора",
  "param_set.lg_inverter_GeneratorPower": "Потужністьгенератора",
  "param_set.lg_inverter_GeneratorStartupVoltage": "Напругазапускугенератора",
  "param_set.lg_inverter_GeneratorShutdownVoltage": "Напругавимкненнягенератора",
  "param_set.lg_inverter_GeneratorStartupSOC": "SOCзапускугенератора",
  "param_set.lg_inverter_GeneratorShutdownSOC": "SOCзавершеннягенератора(режимавтоматичногозапуску)",
  "param_set.lg_inverter_GeneratorStartSignal": "Сигналзапускугенератора",
  "param_set.lg_inverter_GeneratorChargeCurrent": "Заряднийструмгенератора",
  "param_set.lg_inverter_GeneratorOperatingTimeLimit": "Макс.часроботигенератора",
  "param_set.lg_inverter_GeneratorCutOffTime": "Часвідключеннягенератора",
  "param_set.lg_inverter_GeneratorTOUEnable": "Активаціяобмеженняпіківгенератора",
  "param_set.lg_inverter_ParallelEnable": "Активаціяпаралельноїроботи",
  "param_set.lg_inverter_ParallelAddress": "Адресапаралельнихпристроїв",
  "param_set.lg_inverter_ParallelNumber": "Кількістьпаралельнихпристроїв",
  "param_set.lg_inverter_ParallelBatterySharingEnable": "Активаціяспільноговикористанняакумуляторавпаралельномурежимі",
  "param_set.lg_inverter_ParallelPhase": "Порядокфазпаралельнихпристроїв",
  "param_set.lg_inverter_ParallelMode": "Режимпаралельноїроботи",
  "param_set.lg_inverter_Year/Month": "Рік/Місяць",
  "param_set.lg_inverter_Day/Reserve": "День/Резерв",
  "param_set.lg_inverter_Hour/Minute": "Година/Хвилина",
  "param_set.lg_inverter_Second/Week": "Секунда/Тиждень",
  "param_set.lg_inverter_TOUStartTime1": "Часпочаткузарядки/розряду1(згладжування)",
  "param_set.lg_inverter_TOUEndTime1": "Часзавершеннязарядки/розряду1(згладжування)",
  "param_set.lg_inverter_Time1TOUPower": "Потужністьзарядки/розрядумережіЧас1",
  "param_set.lg_inverter_TOUStartTime2": "Часпочаткузарядки/розряду2(згладжування)",
  "param_set.lg_inverter_TOUEndTime2": "Часзавершеннязарядки/розряду2(згладжування)",
  "param_set.lg_inverter_Time2TOUPower": "Потужністьзарядки/розрядумережіЧас2",
  "param_set.lg_inverter_TOUStartTime3": "Часпочаткузарядки/розряду3(згладжування)",
  "param_set.lg_inverter_TOUEndTime3": "Часзавершеннязарядки/розряду3(згладжування)",
  "param_set.lg_inverter_Time3TOUPower": "Потужністьзарядки/розрядумережіЧас3",
  "param_set.lg_inverter_TOUStartTime4": "Часпочаткузарядки/розряду4(згладжування)",
  "param_set.lg_inverter_TOUEndTime4": "Часзавершеннязарядки/розряду4(згладжування)",
  "param_set.lg_inverter_Time4TOUPower": "Потужністьзарядки/розрядумережіЧас4",
  "param_set.lg_inverter_TOUStartTime5": "Часпочаткузарядки/розряду5(згладжування)",
  "param_set.lg_inverter_TOUEndTime5": "Часзавершеннязарядки/розряду5(згладжування)",
  "param_set.lg_inverter_Time5TOUPower": "Потужністьзарядки/розрядумережіЧас5",
  "param_set.lg_inverter_TOUStartTime6": "Часпочаткузарядки/розряду6(згладжування)",
  "param_set.lg_inverter_TOUEndTime6": "Часзавершеннязарядки/розряду6(згладжування)",
  "param_set.lg_inverter_Time6TOUPower": "Потужністьзарядки/розрядумережіЧас5",
  "param_set.lg_inverter_Time1TOUSOC": "SOCакумуляторадляобмеженняпіківЧас1",
  "param_set.lg_inverter_Time2TOUSOC": "SOCакумуляторадляобмеженняпіківЧас2",
  "param_set.lg_inverter_Time3TOUSOC": "SOCакумуляторадляобмеженняпіківЧас3",
  "param_set.lg_inverter_Time4TOUSOC": "SOCакумуляторадляобмеженняпіківЧас4",
  "param_set.lg_inverter_Time5TOUSOC": "SOCакумуляторадляобмеженняпіківЧас5",
  "param_set.lg_inverter_Time6TOUSOC": "SOCакумуляторадляобмеженняпіківЧас6",
  "param_set.lg_inverter_Time1TOUVoltage": "НапругаобмеженняпіківЧас1",
  "param_set.lg_inverter_Time2TOUVoltage": "НапругаобмеженняпіківЧас2",
  "param_set.lg_inverter_Time3TOUVoltage": "НапругаобмеженняпіківЧас3",
  "param_set.lg_inverter_Time4TOUVoltage": "НапругаобмеженняпіківЧас4",
  "param_set.lg_inverter_Time5TOUVoltage": "НапругаобмеженняпіківЧас5",
  "param_set.lg_inverter_Time6TOUVoltage": "НапругаобмеженняпіківЧас6",
  "param_set.lg_inverter_TOUWeek": "Параметритижнядляобмеженняпіків",
  "param_set.lg_inverter_GENTOUEnable": "Активаціячасовогоінтервалуобмеженняпіківгенератора",
  "param_set.lg_inverter_SmartLoadSetting": "НалаштуванняSmartLoad",
  "param_set.lg_inverter_SmartLoadStopVoltage": "Напругавимкненнярозумногонавантаження",
  "param_set.lg_inverter_GeneratorLinktoInput": "Генераторпідключенодомережевоговходу",
  "param_set.lg_inverter_MicroINVLinkLoad": "Мікроінверторпідключенодосторонинавантаження",
  "param_set.lg_inverter_MicroINVLinkGrid": "Мікроінверторпідключенодосторонимережі",
  "param_set.lg_inverter_SolarPower": "Сонячнапотужність",
  "param_set.lg_inverter_GridAlwaysOn": "Мережазавждиувімкнена",
  "param_set.lg_inverter_OffGridDisconnection": "Негайневідключеннявавтономномурежимі",
  "param_set.lg_inverter_SmartLoadONSOC": "SOCзапускурозумногонавантаження",
  "param_set.lg_inverter_SmartLoadOFFSOC": "SOCвимкненнярозумногонавантаження",
  "param_set.lg_inverter_ACCoupleFreqUpperLimit": "НалаштуванняверхньоїмежічастотиACCouple",
  "param_set.lg_inverter_MicroINVOutputtoGrid": "Відключеннявиходумікроінверторавмережу",
  "param_set.lg_inverter_MicroINVOFFSOC": "SOCвимкненнямікроінверторів",
  "param_set.lg_inverter_MicroINVONSOC": "SOCзапускумікроінверторів",
  "param_set.lg_inverter_SmartLoadStartVoltage": "Напругавмиканнярозумногонавантаження",
  "param_set.lg_inverter_SmartLoadDuration": "Тривалістьрозумногонавантаження",
  "param_set.lg_inverter_SmartLoadStartTime": "Часпочаткурозумногонавантаження",
  "param_set.lg_inverter_SmartLoadEndTime": "Часзавершеннярозумногонавантаження",
  "param_set.lg_inverter_BatteryType": "Типакумулятора",
  "param_set.lg_inverter_BatteryInputMode": "Режимпідключенняакумулятора",
  "param_set.lg_inverter_BatteryFailureShutdown": "Зупинкачерезпомилкузв'язкузакумулятором",
  "param_set.lg_inverter_GridChargeEnable": "Активаціязаряджаннявідмережі",
  "param_set.lg_inverter_GridSignal": "Мережевийсигнал",
  "param_set.lg_inverter_GridChargeCurrent": "Заряднийструмвідмережі",
  "param_set.lg_inverter_GridStartupSOC": "SOCзапускумережі",
  "param_set.lg_inverter_BatteryLowCostMode": "Режимнизькогоспоживанняакумулятора",
  "param_set.lg_inverter_LowNoiseMode": "Тихийрежимакумулятора",
  "param_set.lg_inverter_StrongchargeSOC": "ТочкаSOCфорсованогозаряду",
  "param_set.lg_inverter_StrongchargeStopSOC": "ТочкаSOCзавершенняфорсованогозаряду",
  "param_set.lg_inverter_StrongchargeSOCEN": "АктиваціяSOCфорсованогозаряду",
  "param_set.lg_inverter_LithiumBatteryManufacturers": "Виробниклітієвогоакумулятора",
  "param_set.lg_inverter_ChargingVoltage": "Напругазаряджання",
  "param_set.lg_inverter_ChargingCurrentLimit": "Максимальнийзаряднийструм",
  "param_set.lg_inverter_DischargingCurrentLimit": "Максимальнийструмрозряду",
  "param_set.lg_inverter_DischargingShutdownVoltage": "Точкавідсіченнянапругирозрядуакумулятора",
  "param_set.lg_inverter_BatteryLowVoltage": "Точканизькоїнапругирозрядуакумулятора",
  "param_set.lg_inverter_DischargingShutdownSOC": "SOCвідсіченнярозрядуакумулятора",
  "param_set.lg_inverter_ChargingEndSOC": "SOCвідсіченнязарядуакумулятора",
  "param_set.lg_inverter_BatteryLowSOC": "SOCнизькогозарядуакумулятора",
  "param_set.lg_inverter_BatteryRestartSOC": "SOCперезапускуакумулятора",
  "param_set.lg_inverter_AutoForced-chargeEnable": "Активаціяавтоматичногофорсованогозаряду",
  "param_set.lg_inverter_AutoActivationEnable": "Активаціяавтоматичноїактиваціїакумулятора",
  "param_set.lg_inverter_BatteryTriggerVoltage": "Напругаактиваціїакумулятора",
  "param_set.lg_inverter_BatteryTriggerTime": "Тривалістьактиваціїакумулятора",
  "param_set.lg_inverter_DisableFloatCharge": "Вимкнутиплаваючийзаряд",
  "param_set.lg_inverter_CV-CCChargingTime": "Часпереходувідпостійноїнапругидопостійногоструму",
  "param_set.lg_inverter_CC-CVChargingTime": "Часпереходувідпостійногострумудопостійноїнапруги",
  "param_set.lg_inverter_CC-FCChargingTime": "Часпереходувідвирівнювальногодоплаваючогозаряду",
  "param_set.lg_inverter_LeadAcidOvervolt": "Точкаперенапругисвинцево-кислотногоакумулятора",
  "param_set.lg_inverter_LeadAcidBatteryType": "Типсвинцево-кислотногоакумулятора",
  "param_set.lg_inverter_BatteryRatedCapacity": "Номінальнаємністьакумулятора",
  "param_set.lg_inverter_BatteryOverTempVoltage": "Точказахистувідперегрівуакумулятора",
  "param_set.lg_inverter_TempCompensationFactor": "Коефіцієнттемпературноїкомпенсаціїакумулятора",
  "param_set.lg_inverter_BatteryRestartVoltage": "Точканапругивідновленняакумулятора",
  "param_set.lg_inverter_EC-FCChargeCurrent": "Заряднийструмпереходувідвирівнювальногодоплаваючогозаряду",
  "param_set.lg_inverter_FC-ECChargeCurrent": "Заряднийструмпереходувідплаваючогодовирівнювальногозаряду",
  "param_set.lg_inverter_CCChargingTimeLimit": "Максимальнийчасвирівнювальногозарядупостійнимструмом",
  "param_set.lg_inverter_CVChargingTimeLimit": "Максимальнийчасвирівнювальногозарядупостійноюнапругою",
  "status.enable": "увімкнути",
  "status.disable": "відключити",
  "end.app": "додаток",
  "end.backend": "бекенд",
  "module.product_management": "Управління Продуктами",
  "module.plant_management": "Управління Заводом",
  "module.shipment_management": "Управління Відправками",
  "module.device_management": "Управління Пристроями",
  "module.device_detail": "Деталі Пристрою",
  "module.org_management": "Управління Організацією",
  "module.login_register": "Вхід Реєстрація",
  "module.user_management": "Управління Користувачами",
  "module.family_management": "Управління Родиною",
  "module.physical_model": "Фізична Модель",
  "module.dictionary_value": "Значення Словника",
  "param.name.dongle.reset.returnTip": "Донгл успішно скинуто. Будь ласка, підключіть його знову.",
  "bw_RTparam_name_AFCI_Version": "Версійний номер AFCI",
  "bw_RTparam_name_BB_Version": "Backup Box Version Number",
  "setting.type22.allowCounterCurrentPower": "Potenza di ritorno consentita",
  "test.code": "",
  "test.code1": "",
  "test.code3": "",
  "test.code.222": "",
  "dict.sttaus.not.normal": "fa",
  "dict.status.normal": "wu",
  "dict..status.not.normal": "wu",
  "org.keyFilter": "Введіть ключове слово для фільтрації",
  "dict.status.not.normal": "wu-normal",
  "test": "",
  "role.status.abnormal": "Нормальний",
  "filter.all.blank.null": "всі переклади порожні",
  "shipment.confirmDownload": "Завантажити список",
  "shipment.updateCustomer": "Оновити клієнта відправлення",
  "shipment.invalidEquipmentList": "Бажаєте завантажити список пристроїв, які не пройшли перевірку? (Дійсно протягом 10 хвилин) Кількість пристроїв, що не пройшли перевірку:",
  "plant.smart.investment": "Нульові вуглецеві інвестиції",
  "module.oversea": "Керування заявами",
  "income.unit.cny.pkr": "PKR",
  "alarmInfo.time": "Час попередження",
  "alarmInfo.duration": "Тривалість попередження",
  "alarmInfo.level": "Рівень попередження",
  "alarmInfo.triggerCondition": "Умови запуску",
  "alarmInfo.reason": "Причини попередження",
  "alarmInfo.handleTime": "Час обробки",
  "alarmInfo.handleType": "Тип обробки",
  "common.maintain": "Будь ласка, спочатку підтримайте",
  "device.robotChannel": "робот",
  "device.communicationChannel": "палиця зв'язку",
  "device.channelType": "канал зв'язку",
  "device.switchChannelFailed": "Не вдалося перемкнути канал зв'язку",
  "test.chuneng": "chuneng",
  "Manual": "Ручний",
  "System": "Системний",
  "Processed": "Оброблено",
  "Critical": "Критично",
  "Urgent": "Терміново",
  "Severe": "Серйозно",
  "General": "Загальний",
  "Reminder": "Нагадування",
  "common.cropper": "Кадрування зображення",
  "common.confirmCropper": "Підтвердити кадрування",
  "welcome": "",
  "device.operatingDataInfoTip": "Примітка: якщо це поле порожнє, зверніться до адміністратора платформи IoT для налаштування.",
  "dynamic.price.not.exist": "Не вдалося отримати динамічну ціну електроенергії",
  "product.pleaseUploadAtLeastOneImage": "Будь ласка, завантажте принаймні одне зображення.",
  "device.importTemplateDownload": "Завантажити шаблон імпорту",
  "device.snNumber": "Номер SN",
  "device.enterSnCode": "Введіть код SN",
  "device.enterSupplierSN": "Введіть SN постачальника",
  "device.deviceModelLabel": "Модель пристрою",
  "device.importTip": "Імпортуйте відповідний код електростанції, назву пристрою, номер SN та код MDM",
  "device.importTip2": "Імпортуйте відповідну назву пристрою, номер SN та код MDM",
  "device.keepAtLeastOneRow": "Залиште принаймні один рядок",
  "device.importSuccessWithCount": "Успішно імпортовано {count} записів даних пристроїв",
  "device.fillAllRequiredFields": "Заповніть всі обов'язкові поля",
  "device.enterPlantCode": "Введіть код електростанції",
  "device.plantCodeLabel": "Код електростанції",
  "device.supplierSNLabel": "SN постачальника",
  "device.importTemplateEmpty": "Шаблон імпорту порожній",
  "plant.plantCategory": "Тип електростанції",
  "plant.plantCode": "Кодування електростанції",
  "plant.energyStorageCapacity": "Можливість зберігання енергії",
  "plant.energyStoragePower": "Потужність системи накопичення",
  "plant.gridConnectionMode": "Спосіб Інтернету",
  "plant.img": "Фотографії електростанції",
  "device.realTimeMonitoring": "Моніторинг в реальному часі",
  "device.propertyName": "Назва властивості",
  "device.issueCommand": "Відправити",
  "device.history": "Історія",
  "device.properName": "Ім'я",
  "device.daterange": "Налаштування",
  "device.near24h": "Майже 24 години",
  "device.date": "Сьогодні",
  "device.near3d": "Майже 3 дні",
  "device.chartModule": "Модуль діаграми",
  "device.lineChart": "Діаграма кривих",
  "device.barChart": "Стівковий діаграма",
  "device.dateRangeDayError": "Диапазон дати повинен бути в {scope} днів",
  "device.SOCHistoryData": "Історичні дані",
  "device.paramSave": "Параметри",
  "common.deleteTip": "Підтвердити видалення {scope}?",
  "product.deleteConfirm": "Ви впевнені, що хочете видалити продукт {productName}?",
  "upgrade.upgradeSN": "Оновлення SN",
  "upgrade.datalogSN": "Журнал даних SN",
  "upgrade.upgradeType": "Тип оновлення",
  "upgrade.fileAddress": "Адреса файла",
  "upgrade.plantTime": "Час електростанції",
  "upgrade.timeUTC8": "Час (UTC+8)",
  "upgrade.timeServer": "Час (сервер)",
  "upgrade.content": "Зміст",
  "upgrade.account": "рахунок",
  "upgrade.devicesSN": "обладнання SN",
  "firmware.secretType": "Секретний тип",
  "product.ratedPowerOnTheACSide": "Номінальна потужність з АС сторони (kW)",
  "product.ratedPowerOnTheDCSide": "Номінальна потужність з ДС сторони (kW)",
  "product.energyStoragePower": "Потужність енергозберігання (kW)",
  "product.energyStorageCapacity": "Ємність енергозберігання (kWh)",
  "iot.device.register.failed": "Не вдалося зареєструвати пристрій IoT",
  "common.title": "Налаштування відображення стовпців",
  "common.fixedLeft": "Зафіксовано ліворуч",
  "common.fixedRight": "Зафіксовано праворуч",
  "common.notFixed": "Не фіксовано",
  "common.unfix": "Відкріпити",
  "common.resetSuccess": "Налаштування стовпців успшно скинуто",
  "alarmInfo.exceptionDesc": "Опис винятку",
  "alarmInfo.suggestion": "Рекомендація щодо обробки",
  "language.syncIot": "Синхронізувати сповіщення IoT",
  "language.syncSuccess": "Синхронізацію конфігурації сповіщень IoT Qingluo успішно завершено",
  "plant.saveTimezoneTip": "Зміна часового поясу може спричинити:\nРозриви або накладання на графіках даних пристрою (триває кілька годин)\nЛокальні завдання пристрою можуть порушитися, можливе короткочасне відключення",
  "plant.deviceCount": "Кількість встановлених пристроїв",
  "common.rangeErrorTip": "Помилка діапазону {scope}, будь ласка, підтвердьте",
  "expired": "закінчено термін дії",
  "due.today": "на сьогодні",
  "sidebar.bulletinBoard": "Встановлення",
  "sidebar.dataQuery": "Запит даних",
  "plant.electrovalence": "Налаштування тарифів",
  "plant.energy_management": "Управління енергією",
  "plant.energy_todayStrategy": "Сьогоднішня стратегія",
  "plant.energy_PeakShavingAndValleyFilling": "Скорочення піків та заповнення провалів",
  "plant.energy_ValidTime": "Чинний час",
  "plant.energy_Charging": "Зарядка",
  "plant.energy_Discharging": "Розрядка",
  "plant.energy_SelectStartTime": "Вибрати час початку",
  "plant.energy_StrategyName": "Назва стратегії",
  "plant.energy_StrategyType": "Тип стратегії",
  "plant.energy_Status": "Статус",
  "plant.energy_No": "№",
  "plant.energy_StartDate": "Дата початку",
  "plant.energy_EndDate": "Дата закінчення",
  "plant.energy_AddStrategy": "Додати стратегію",
  "plant.energy_EffectiveTime": "Час набрання чинності",
  "plant.energy_SelectStrategy": "Вибрати стратегію",
  "plant.energy_SelectCorrespondingStrategy": "Вибрати відповідну стратегію",
  "plant.energy_ConfirmAndDeploy": "Підтвердити та впровадити",
  "plant.energy_PleaseConfirmSaveAndDeployTheStrategy": "Будь ласка, підтвердіть, збережіть та впровадьте стратегію.",
  "plant.energy_Cancel": "Скасувати",
  "plant.energy_PleaseConfirmStrategyDeletion": "Будь ласка, підтвердіть видалення стратегії.",
  "plant.energy_IfNoOtherStrategyExistsExecuteManualStrategy": "Якщо інших стратегій немає, виконайте ручну стратегію.",
  "plant.energy_PriorityChargingTime": "Пріоритетний час зарядки",
  "plant.energy_PriorityDischargingTime": "Пріоритетний час розрядки",
  "plant.energy_PVConsumptionPeriod": "Період споживання PV",
  "plant.energy_StartTime": "Час початку",
  "plant.energy_EndTime": "Час закінчення",
  "plant.energy_ChargingPower": "Потужність зарядки",
  "plant.energy_DischargingPower": "Потужність розрядки",
  "plant.energy_SOCUpperLimit": "Верхня межа SOC",
  "plant.energy_SOCLowerLimit": "Нижня межа SOC",
  "plant.energy_Action": "Дія",
  "plant.energy_AddTimePeriod": "Додати часовий проміжок",
  "plant.energy_ChargingStatus": "Статус зарядки",
  "plant.energy_DischargingPower_kW": "Потужність розрядки (кВт)",
  "plant.energy_copyStrategy": "Копіювати стратегію",
  "plant.energy_examine": "Переглянути",
  "plant.energy_delete": "Видалити",
  "plant.energy_edit": "Редагувати",
  "plant.energy_basicInfo": "Основна інформація",
  "plant.energy_PriorityChargingDischargingTime": "Пріоритетний час зарядки та розрядки",
  "plant.energy_PeakShavingAtLeastOne": "Залиште принаймні один запис.",
  "plant.energy_overlapTime": "Не перекривайте часові проміжки.",
  "plant.energy_cover24hour": "Часові проміжки мають охоплювати 24 години.",
  "plant.energy_PleaseConfirmStrategyModification": "Підтвердіть зміну стратегії.",
  "plant.energy_Strategy": "Стратегія",
  "plant.energy_cutOff_SOC": "SOC зупинки",
  "plant.energy_EditStrategy": "Редагувати стратегію",
  "plant.energy_ExamineStrategy": "Переглянути стратегію",
  "plant.energy_photovoltaic_storage_peak_valley_explain1": "1) Пріоритетний період зарядки: Заряджає акумулятор за допомогою надлишку PV та електроенергії мережі (позапіковий час), щоб досягти заданого значення SOC; акумулятор не розряджається.",
  "plant.energy_photovoltaic_storage_peak_valley_explain2": "2) Пріоритетний період розрядки: Надлишок PV заряджає акумулятор. За недостатності PV акумулятор розряджається першим, до встановленої межі SOC; живлення від мережі є додатковим.",
  "plant.energy_photovoltaic_storage_peak_valley_explain3": "3) Період споживання PV: Енергія PV пріоритетно використовується для навантаження, потім для заряджання акумулятора (до верхньої межі SOC), і нарешті, надлишок обмежується або експортується в мережу. За недостатності PV акумулятор розряджається першим (до нижньої межі SOC), потім живиться від мережі.",
  "plant.energy_photovoltaic_storage_peak_valley_explain4": "4) Інші періоди: Енергія PV пріоритетно використовується для навантаження, потім для заряджання акумулятора (до верхньої межі SOC), і нарешті, надлишок обмежується або експортується в мережу. Акумулятор не розряджається.",
  "plant.energy_peak_shaving_valley_filling_explain": "Стратегія, яка планує заряджання/розряджання акумулятора для згладжування пікового навантаження та заповнення провалів попиту, щоб досягти збалансованого використання ресурсів.",
  "plant.energy_photovoltaic_consumption_self_consumption_explain": "Енергія PV пріоритетно використовується для навантаження, потім споживається акумулятором, і нарешті, виробництво PV обмежується, щоб запобігти зворотному потоку. За недостатності PV акумулятор розряджається першим, потім живиться від мережі.",
  "plant.energy_photovoltaic_consumptionsurplus_power_grid_feed_in_explain": "Енергія PV пріоритетно використовується для навантаження, потім споживається акумулятором, і нарешті, надлишок експортується в мережу. За недостатності PV акумулятор розряджається першим, потім живиться від мережі.",
  "plant.energy_smart_strategy_station_profit_priority_explain": "Інтегрує багатовимірні цілі, такі як покрокові тарифи, споживання PV, арбітраж пік-долина, прогнозування PV та навантаження та управління попитом. За умови забезпечення стабільної роботи мікромережі, штучний інтелект інтелектуально обчислює та визначає оптимальне планування для акумулятора та регульованих навантажень, максимізуючи загальний дохід майданчика.",
  "plant.energy_manual_mode_explain": "Наразі немає стратегії диспетчеризації для PV та акумулятора. Перейдіть на сторінку пристрою для ручного керування.",
  "plant.energy_SOCUpperLowerLimits": "Верхня та нижня межі SOC",
  "plant.energy_ChargeDischargePower": "Потужність заряду та розряду",
  "plant.energy_ChargeDischargeStatus": "Статус заряду та розряду",
  "system.physicalModels": "Керування моделями речей",
  "subtitle.physicalModelsDetail": "Деталі моделі речі",
  "physicalModels.functionSet": "Набір функцій",
  "physicalModels.minItemsTip": "Необхідно зберегти принаймні {scope} елемент(ів)",
  "physicalModels.conflictTip": "Період конфлікту: {scope}",
  "physicalModels.name": "Назва конфігурації",
  "physicalModels.jsonCorrect": "Формат JSON правильний",
  "physicalModels.jsonCorrectTip": "Формат JSON правильний (службу перевірки не підключено)",
  "physicalModels.jsonInCorrect": "Формат JSON неправильний",
  "physicalModels.deleteFailed": "Видалення не вдалося",
  "physicalModels.loadPreviewFailed": "Не вдалося завантажити попередню конфігурацію",
  "physicalModels.configEditor": "Редактор конфігурацій",
  "physicalModels.selectTemplate": "Вибрати попередньо встановлений шаблон",
  "physicalModels.jsonConfig": "Конфігурація JSON",
  "physicalModels.realTimePreview": "Попередній перегляд у реальному часі",
  "physicalModels.checkJsonFormat": "Будь ласка, перевірте правильність формату JSON",
  "physicalModels.readDataStructure": "Зчитати структуру даних",
  "physicalModels.userBehaviorData": "Сирі дані поведінки користувача",
  "physicalModels.actualDataData": "Фактично надіслані дані",
  "physicalModels.ready": "Готово",
  "physicalModels.previewConfigLoaded": "Попередню конфігурацію завантажено",
  "physicalModels.pasteFromClipboard": "Вставлено з буфера обміну",
  "physicalModels.pasteFromClipboardTip": "Будь ласка, додайте SN пристрою після шляху в браузері, наприклад:",
  "physicalModels.error": "Помилка",
  "plant.createType": "Створено",
  "physicalModels.jsonComplete": "Доповнення JSON",
  "physicalModels.jsonCompleteTip": "Якщо JSON було збережено, повторне доповнення може спричинити проблеми у виробництві. Будь ласка, дійте обережно.",
  "physicalModels.maxItemsTip": "Максимум дозволено {scope} елемент(ів)",
  "physicalModels.Empty": "{scope} не може бути порожнім",
  "Setting.timeSet": "",
  "plantScreen.singleSiteScree.PVPower": "Потужність ФЕП",
  "plantScreen.singleSiteScree.GridImportPower": "Потужність імпорту з мережі",
  "plantScreen.singleSiteScree.GridExportPower": "Потужність експорту в мережу",
  "plantScreen.singleSiteScree.ChargingPower": "Потужність заряду",
  "plantScreen.singleSiteScree.DischargingPower": "Потужність розряду",
  "plantScreen.singleSiteScree.LoadPower": "Потужність навантаження",
  "plantScreen.singleSiteScree.SelfConsumptionRate": "Коефіцієнт самоспоживання",
  "plantScreen.ChartSet.GenerationPower": "Потужність генерації",
  "plantScreen.ChartSet.DayAheadForecast": "Добовий прогноз",
  "plantScreen.ChartSet.RealTimeForecast": "Прогноз у реальному часі",
  "plantScreen.ChartSet.RealTimeScheduling": "Планування в реальному часі",
  "plantScreen.ChartSet.DayAheadScheduling": "Добове планування",
  "plantScreen.PlantInfo": "Інформація про станцію",
  "plantScreen.PhotovoltaicCapacity": "Встановлена потужність ФЕП",
  "plantScreen.StorageCapacity": "Ємність акумулятора",
  "plantScreen.EnergyDispatch": "Енергетичне планування",
  "plantScreen.SelfGenerationRate": "Коефіцієнт самогенерації",
  "plantScreen.DailyStorageCharging": "Енергія, заряджена за день",
  "plantScreen.DailyStorageDischarging": "Енергія, розряджена за день",
  "plantScreen.DailyElectricitySold2": "Електроенергія, продана за день",
  "plantScreen.ChartSet.Storage": "Накопичувач енергії",
  "plantScreen.ChartSet.Solar": "ФЕП",
  "plantScreen.ChartSet.Load": "Навантаження",
  "plantScreen.ChartSet.ChargeDischargePower": "Потужність заряду/розряду",
  "plantScreen.coal": "Вугілля",
  "physicalModels.missingIoTIdTip": "Відсутній IoTId або virtualId, будь ласка, перевірте",
  "org.authCompanyName": "Назва сертифікованої компанії",
  "org.serviceAddress": "Адреса служби",
  "org.servicePhone": "Телефон служби",
  "org.serviceEmail": "Електронна пошта служби",
  "org.companyLogo": "Логотип компанії",
  "org.websiteUrl": "URL веб-сайту",
  "org.partnerId": "ID партнера",
  "org.serviceAgreement": "Угода про обслуговування",
  "org.serviceCertificate": "Сертифікат",
  "physicalModels.slotId": "Ідентифікатор реклами",
  "report.dataQuery.maxDevicesWarning": "Можна вибрати не більше 10 пристроїв",
  "report.dataQuery.maxParamsWarning": "Можна вибрати не більше 10 параметрів",
  "report.dataQuery.selectDeviceAndParamsFirst": "Спочатку виберіть пристрої та параметри",
  "report.dataQuery.chartTitle": "Порівняння трендів роботи кількох наборів даних",
  "report.dataQuery.selectDevice": "Вибір пристрою",
  "report.dataQuery.placeholderSelectDevice": "Виберіть пристрій",
  "report.dataQuery.tabByModel": "За моделлю",
  "report.dataQuery.tabByStation": "За електростанцією",
  "report.dataQuery.modelGroupName": "Назва моделі",
  "report.dataQuery.noMore": "Більше немає",
  "report.dataQuery.selectedDevicesFooter": "Обрано {current} / 10 пристроїв",
  "report.dataQuery.selectedDevicesShort": "Обрані пристрої",
  "report.dataQuery.clear": "Очистити",
  "report.dataQuery.noDeviceSelectedYet": "Пристрої ще не вибрано",
  "report.dataQuery.selectParamsTitle": "Вибір параметрів (до 10)",
  "report.dataQuery.maxParamsHint": "Одночасно не більше 10 параметрів",
  "report.dataQuery.searchParamsPlaceholder": "Пошук параметрів",
  "report.dataQuery.noMatchingParams": "Немає відповідних параметрів",
  "report.dataQuery.selectDeviceFirst": "Спочатку виберіть пристрій",
  "report.dataQuery.placeholderDeviceSn": "Введіть серійний номер пристрою",
  "report.dataQuery.placeholderModelName": "Введіть назву моделі",
  "report.dataQuery.placeholderStationName": "Введіть назву електростанції",
  "report.dataQuery.selectedDevicesSummary": "Обрано пристроїв: {count}",
  "report.dataQuery.startAnalysis": "Почати аналіз",
  "report.dataQuery.emptyGuide": "Натисніть «Вибір пристрою» зліва вгорі, оберіть до 10 пристроїв для аналізу, потім параметри та діапазон часу",
  "report.dataQuery.noDataHint": "За поточними умовами запиту немає даних для відображення. Змініть пристрої, параметри або діапазон часу й спробуйте знову",
  "report.dataQuery.tableTitle": "Порівняння експлуатаційних даних кількох пристроїв",
  "report.dataQuery.peakLabel": "Пік:",
  "report.dataQuery.peakColor": "Червоний",
  "report.dataQuery.valleyLabel": "Мінімум:",
  "report.dataQuery.valleyColor": "Синій",
  "report.dataQuery.timeByDay": "За день",
  "report.dataQuery.timeByWeek": "За тиждень",
  "report.dataQuery.timeByMonth": "За місяць",
  "report.dataQuery.timeByCustom": "Довільний період",
  "report.dataQuery.highlightNone": "Без підсвічування",
  "report.dataQuery.highlightCol": "Підсвітка різниць за стовпцями",
  "report.dataQuery.highlightRow": "Підсвітка різниць за рядками",
  "report.dataQuery.weekdayMon": "Пн",
  "report.dataQuery.weekdayTue": "Вт",
  "report.dataQuery.weekdayWed": "Ср",
  "report.dataQuery.weekdayThu": "Чт",
  "report.dataQuery.weekdayFri": "Пт",
  "report.dataQuery.weekdaySat": "Сб",
  "report.dataQuery.weekdaySun": "Нд",
  "report.dataQuery.axisMonthDay": "{n}",
  "plant.statisticalCycle": "Статистичний цикл",
  "plant.stationTopology": "Топологія станції",
  "plant.topologyConfig": "Конфігурація топології",
  "plant.projectName": "Назва проекту",
  "plant.topologyUrl": "URL топології",
  "plant.topologyMap": "Карта топології",
  "plant.topologyPlaceholder": "Будь ласка, введіть URL топології",
  "plant.addScopeSuccess": "{scope} успішно додано",
  "plant.updateScopeSuccess": "{scope} успішно відредаговано",
  "plant.topologyUrlFormatError": "Помилка формату URL топології",
  "report.dataQuery.maxCurvesWarning": "Поточний вибір перевищує 10 кривих",
  "report.dataQuery.maxCurvesLimitHint": "Можна вибрати не більше 10 кривих",
  "report.dataQuery.selectParamsHeading": "Вибір параметрів",
  "ota.don.upgrade": "Оновлення донгла",
  "device.ota.tip.newversion": "Поточна версія є найновішою і не потребує оновлення.",
  "device.button.cancel": "OK",
  "org.accountNumber": "Номер облікового запису користувача",
  "org.accountName": "Ім'я облікового запису користувача",
  "org.description": "Опис користувача електроенергією",
  "org.creditCode": "Код соціального кредиту",
  "plant.deptName": "Назва організації",
  "plant.businessScope": "Промисловий та комерційний",
  "plant.withdrawBusinessDeliveryTip": "Після відкликання доставки користувачі {scope} більше не зможуть керувати цією станцією. Будь ласка, дійте обережно.",
  "mapScreen.RevenueInfo": "Інформація про доходи",
  "mapScreen.MonthlyRevenue": "Місячний дохід",
  "mapScreen.YearlyRevenue": "Річний дохід",
  "mapScreen.CumulativeRevenue": "Сукупний дохід",
  "mapScreen.CarbonIndicator": "Вуглецеві показники",
  "mapScreen.StorageInfo": "Інформація про зберігання",
  "mapScreen.MonthlyChargeDischarge": "Місячна зарядка/розрядка",
  "mapScreen.YearlyChargeDischarge": "Річна зарядка/розрядка",
  "mapScreen.TotalPlants": "Кількість електростанцій",
  "mapScreen.PvInstalledCapacity": "Встановлена потужність ФЕ",
  "mapScreen.StorageInstalledCapacity": "Встановлена потужність зберігання",
  "mapScreen.ChargingPileCapacity": "Потужність зарядних станцій",
  "mapScreen.Residential": "Побутові",
  "mapScreen.Commercial": "Комерційні",
  "mapScreen.PlantCount": "Всього {count} електростанцій",
  "mapScreen.NewEnergyPower": "Потужність відновлюваної енергії",
  "mapScreen.GenerationInfo": "Інформація про генерацію",
  "mapScreen.MonthlyGeneration": "Місячна генерація",
  "mapScreen.YearlyGeneration": "Річна генерація",
  "mapScreen.ChargingPileInfo": "Інформація про зарядні станції",
  "mapScreen.MonthlyConsumption": "Місячне споживання",
  "mapScreen.YearlyConsumption": "Річне споживання",
  "mapScreen.GridConnectionInfo": "Інформація про підключення до мережі",
  "mapScreen.MonthlyPurchaseFeedin": "Місячна купівля/подача в мережу",
  "mapScreen.YearlyPurchaseFeedin": "Річна купівля/подача в мережу",
  "mapScreen.CO2Reduction": "Зменшення CO2",
  "mapScreen.SaveCoal": "Заощаджено вугілля",
  "mapScreen.TreePlanting": "Посаджено дерев",
  "mapScreen.SelectCountry": "Виберіть країну",
  "mapScreen.BackToPrev": "Повернутися на попередній рівень",
  "mapScreen.Revenue": "Дохід",
  "mapScreen.ChargeAmount": "Обсяг зарядки",
  "mapScreen.DischargeAmount": "Обсяг розрядки",
  "mapScreen.GenerationAmount": "Обсяг виробництва",
  "mapScreen.ConsumptionAmount": "Обсяг споживання",
  "mapScreen.PowerGeneration": "Потужність генерації",
  "mapScreen.PurchaseAmount": "Обсяг закупівлі",
  "mapScreen.GridSellAmount": "Обсяг відпуску в мережу",
  "mapScreen.title": "Платформа управління енергією",
  "mapScreen.PlantMonthlyRevenue": "Місячний дохід",
  "mapScreen.PlantYearlyRevenue": "Річний дохід",
  "mapScreen.PlantCumulativeRevenue": "Сукупний дохід",
  "physicalModels.tagGroup": "Група тегів",
  "device.expandAll": "Розгорнути все",
  "device.collapseAll": "Згорнути все",
  "common.deleteSuccess": "Успішно видалено",
  "device.systemTime": "Системний час",
  "device.traceId": "ID трасування",
  "device.collectorSn": "SN колектора",
  "device.functionCode": "Код функції",
  "device.encryptedStr": "Зашифроване повідомлення",
  "device.decryptedStr": "Розшифроване повідомлення",
  "device.dateRangeErrorScope": "Діапазон дат має бути в межах {scope} днів",
  "common.noMore": "Більше немає",
  "common.unloginOrExpired": "Не авторизовано або термін дії сесії закінчився",
  "common.serverError": "Виняток на сервері, будь ласка, спробуйте пізніше",
  "common.requestFailed": "Запит не вдався",
  "common.backendError": "Помилка підключення до інтерфейсу бекенду",
  "common.timeout": "Тайм-аут запиту до системного інтерфейсу",
  "common.systemInterface": "Системний інтерфейс",
  "common.contains": "Містить",
  "common.columnSetting": "Налаштування стовпців",
  "product.skipShipmentCheck": "Пропустити перевірку відвантаження",
  "system.mapScreen": "Великий панорамний екран",
  "settingDrawer.title": "Налаштування макету",
  "settingDrawer.themeMode": "Режим теми",
  "settingDrawer.darkTheme": "Темна тема",
  "settingDrawer.lightTheme": "Світла тема",
  "settingDrawer.themeColor": "Колір теми",
  "settingDrawer.navMode": "Режим навігації",
  "settingDrawer.sideMenu": "Макет бічного меню",
  "settingDrawer.topMenu": "Макет верхнього меню",
  "settingDrawer.mixMenu": "Змішаний макет",
  "settingDrawer.columnMenu": "Колонковий макет",
  "settingDrawer.drawerMenu": "Висувний макет",
  "settingDrawer.layoutSetting": "Налаштування макету",
  "settingDrawer.contentWidth": "Ширина вмісту",
  "settingDrawer.contentWidthFixed": "Фіксований",
  "settingDrawer.contentWidthFluid": "Плинний",
  "settingDrawer.fixedHeader": "Фіксований заголовок",
  "settingDrawer.fixedSidebar": "Фіксована бічна панель",
  "settingDrawer.hideFooter": "Приховати нижній колонтитул",
  "settingDrawer.multiTab": "Багатовкладковий режим",
  "settingDrawer.sidebarColorfulIcon": "Кольорові іконки бічної панелі",
  "settingDrawer.searchMode": "Режим компонента пошуку",
  "settingDrawer.searchModeHeader": "Нова версія",
  "settingDrawer.searchModeForm": "Стара версія",
  "settingDrawer.systemConfig": "Конфігурація системи",
  "settingDrawer.systemTitle": "Назва системи",
  "settingDrawer.systemCopyright": "Інформація про авторські права",
  "settingDrawer.systemVersion": "Версія системи",
  "settingDrawer.systemVersionPlaceholder": "Номер версії",
  "settingDrawer.tableStyle": "Стиль таблиці",
  "settingDrawer.tableSize": "Розмір таблиці",
  "settingDrawer.tableSizeDefault": "За замовчуванням",
  "settingDrawer.tableSizeMiddle": "Середній",
  "settingDrawer.tableSizeSmall": "Компактний",
  "settingDrawer.tableBordered": "Показати рамку",
  "settingDrawer.tableFixHeader": "Фіксувати заголовок",
  "settingDrawer.tableHeaderBold": "Жирний заголовок",
  "settingDrawer.tableResizable": "Змінювані стовпці",
  "settingDrawer.tableRowSelection": "Вибір рядків",
  "settingDrawer.tableHeaderBgColor": "Колір фону заголовка",
  "settingDrawer.tableHeight": "Висота таблиці",
  "settingDrawer.pageSize": "Розмір сторінки",
  "settingDrawer.pageSizeUnit": "Елементів/сторінку",
  "settingDrawer.showTotal": "Показати загальну кількість",
  "settingDrawer.showSizeChanger": "Показати вибір розміру",
  "settingDrawer.showQuickJumper": "Показати швидкий перехід",
  "settingDrawer.tableStripe": "Смугасті рядки",
  "settingDrawer.tableShowHeader": "Показати заголовок",
  "settingDrawer.saveTableConfig": "Зберегти конфігурацію таблиці",
  "settingDrawer.reset": "Скинути",
  "settingDrawer.configManagement": "Керування конфігурацією",
  "settingDrawer.saveAll": "Зберегти всі конфігурації",
  "settingDrawer.exportConfig": "Експортувати конфігурацію",
  "settingDrawer.importConfig": "Імпортувати конфігурацію",
  "settingDrawer.resetAll": "Скинути всі конфігурації",
  "settingDrawer.msg.initFail": "Не вдалося ініціалізувати систему, будь ласка, оновіть сторінку та спробуйте ще раз",
  "settingDrawer.msg.configInitFail": "Не вдалося ініціалізувати конфігурацію",
  "settingDrawer.msg.themeChangeFail": "Не вдалося змінити тему",
  "settingDrawer.msg.colorChangeFail": "Не вдалося змінити колір теми",
  "settingDrawer.msg.searchModeSwitched": "Переключено на пошук {mode}",
  "settingDrawer.msg.searchModeSwitchFail": "Не вдалося перемкнути компонент пошуку",
  "settingDrawer.msg.navModeSwitched": "Переключено в режим {mode}",
  "settingDrawer.msg.navSide": "Бічна панель",
  "settingDrawer.msg.navTop": "Верхнє меню",
  "settingDrawer.msg.navMix": "Змішаний",
  "settingDrawer.msg.navModeSwitchFail": "Не вдалося перемкнути режим навігації",
  "settingDrawer.msg.layoutSwitchFail": "Не вдалося змінити макет",
  "settingDrawer.msg.settingUpdateFail": "Не вдалося оновити налаштування",
  "settingDrawer.msg.tableStoreNotInit": "Сховище конфігурації таблиці не ініціалізовано",
  "settingDrawer.msg.tableConfigSaved": "Конфігурацію таблиці збережено",
  "settingDrawer.msg.tableConfigSaveFail": "Не вдалося зберегти конфігурацію таблиці",
  "settingDrawer.msg.tableConfigReset": "Конфігурацію таблиці скинуто",
  "settingDrawer.msg.tableConfigResetFail": "Не вдалося скинути конфігурацію таблиці",
  "settingDrawer.msg.systemConfigUpdated": "Конфігурацію системи оновлено",
  "settingDrawer.msg.systemConfigUpdateFailStore": "Не вдалося оновити конфігурацію системи: Сховище не ініціалізовано",
  "settingDrawer.msg.systemConfigUpdateFail": "Не вдалося оновити конфігурацію системи",
  "settingDrawer.msg.allConfigSaved": "Всі конфігурації збережено",
  "settingDrawer.msg.configSaveFail": "Не вдалося зберегти конфігурацію",
  "settingDrawer.msg.configExported": "Конфігурацію експортовано",
  "settingDrawer.msg.configExportFail": "Не вдалося експортувати конфігурацію",
  "settingDrawer.msg.configImportConfirmTitle": "Підтвердити імпорт конфігурації",
  "settingDrawer.msg.configImportConfirmContent": "Імпорт конфігурації перезапише всі поточні налаштування. Продовжити?",
  "settingDrawer.msg.confirm": "Підтвердити",
  "settingDrawer.msg.cancel": "Скасувати",
  "settingDrawer.msg.configImported": "Конфігурацію імпортовано успішно",
  "settingDrawer.msg.configFileInvalid": "Недійсний формат файлу конфігурації",
  "settingDrawer.msg.resetConfirmTitle": "Підтвердити скидання",
  "settingDrawer.msg.resetConfirmContent": "Скидання очистить усі користувацькі конфігурації та відновить стан за замовчуванням. Продовжити?",
  "settingDrawer.msg.allConfigReset": "Всі конфігурації скинуто"
}
